(function() {
  window.App || (window.App = {});

  App.Base = (function() {
    function Base() {
      if (window.jQuery) {
        RailsScript.setClearEventHandlers();
      }
      Turbo.StreamActions.scroll_to = function() {
        var target;
        target = this.targetElements[0];
        return target.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      };
      new PublicUtility.Layout();
      return this;
    }

    return Base;

  })();

}).call(this);
(function() {
  window.Mzkr || (window.Mzkr = {});

  Mzkr.Accordion = (function() {
    function Accordion(scope) {
      if (scope == null) {
        scope = document;
      }
      this.init();
    }

    Accordion.prototype.init = function() {
      var mzkrAccordionToggle;
      mzkrAccordionToggle = document.querySelectorAll('.js-mzkr-accordion-toggle');
      return mzkrAccordionToggle.forEach(function(accordion) {
        return accordion.addEventListener('click', function() {
          var content;
          accordion.parentElement.classList.toggle('mzkr-accordion__item--active');
          content = accordion.nextElementSibling;
          if (content.style.maxHeight) {
            return content.style.maxHeight = null;
          } else {
            return content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      });
    };

    return Accordion;

  })();

}).call(this);
(function() {
  window.Mzkr || (window.Mzkr = {});

  Mzkr.Breadcrumb = (function() {
    function Breadcrumb() {}

    Breadcrumb.init = function() {
      var $breadcrumbWrapper, breadcrumbItemsWidth, updateBreadcrumb;
      $breadcrumbWrapper = $('.mzkr-breadcrumb');
      if ($breadcrumbWrapper.length) {
        breadcrumbItemsWidth = 0;
        $.each($breadcrumbWrapper.children(), function(i, item) {
          return breadcrumbItemsWidth += $(item).outerWidth(true);
        });
        updateBreadcrumb = function() {
          var $breadcrumbButton, $breadcrumbItem, breadcrumbWrapperWidth;
          breadcrumbWrapperWidth = $breadcrumbWrapper.outerWidth();
          $breadcrumbButton = $('.mzkr-breadcrumb__button');
          $breadcrumbItem = $('.mzkr-breadcrumb__item');
          if (breadcrumbItemsWidth > breadcrumbWrapperWidth) {
            $breadcrumbWrapper.addClass('mzkr-breadcrumb--shrinked');
            $('.mzkr-breadcrumb__item:not(:last-of-type), .mzkr-breadcrumb__current-item').addClass('mzkr-d-none');
            $breadcrumbButton.removeClass('mzkr-d-none');
          } else {
            $breadcrumbWrapper.removeClass('mzkr-breadcrumb--shrinked');
            $breadcrumbItem.removeClass('mzkr-d-none');
            $breadcrumbButton.addClass('mzkr-d-none');
          }
          return $breadcrumbButton.on('click', function() {
            $breadcrumbItem.removeClass('mzkr-d-none');
            $(this).addClass('mzkr-d-none');
            return $breadcrumbWrapper.removeClass('mzkr-flex-nowrap mzkr-breadcrumb--shrinked');
          });
        };
        updateBreadcrumb();
        return $(window).resize(function() {
          return updateBreadcrumb();
        });
      }
    };

    return Breadcrumb;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  window.Mzkr || (window.Mzkr = {});

  Mzkr.HorizontalScroll = (function() {
    function HorizontalScroll(scrollWrapper, scrollToEnd) {
      this.resizeHandler = bind(this.resizeHandler, this);
      this.scrollHandler = bind(this.scrollHandler, this);
      this.scrollRightHandler = bind(this.scrollRightHandler, this);
      this.scrollLeftHandler = bind(this.scrollLeftHandler, this);
      var $scrollInner;
      this.scrollWrapper = $(scrollWrapper);
      this.scrollWrapper.find('.btn-scroll-left').on('click', this.scrollLeftHandler.bind(this));
      this.scrollWrapper.find('.btn-scroll-right').on('click', this.scrollRightHandler.bind(this));
      this.scrollWrapper.find('.mzkr-horizontal-scroll__inner').on('scroll', this.scrollHandler.bind(this));
      $(window).resize(this.resizeHandler.bind(this));
      this.updateHorizontalScroll();
      if (scrollToEnd) {
        $scrollInner = $('.mzkr-horizontal-scroll__inner', this.scrollWrapper);
        $scrollInner[0].scrollLeft = $scrollInner[0].scrollWidth - $scrollInner.outerWidth();
      }
    }

    HorizontalScroll.prototype.updateHorizontalScroll = function() {
      var $btnScrollLeft, $btnScrollRight, $scrollInner, scrollHiddenWidth, scrollPosition, scrollWrapperWidth, scrollbarWidth;
      $btnScrollLeft = this.scrollWrapper.find('.btn-scroll-left');
      $btnScrollRight = this.scrollWrapper.find('.btn-scroll-right');
      $scrollInner = this.scrollWrapper.find('.mzkr-horizontal-scroll__inner');
      scrollWrapperWidth = this.scrollWrapper.outerWidth();
      scrollbarWidth = 0;
      $.each($($scrollInner).children(), function(i, item) {
        return scrollbarWidth += $(item).outerWidth(true);
      });
      scrollHiddenWidth = scrollbarWidth - scrollWrapperWidth;
      scrollPosition = $scrollInner.scrollLeft();
      if (scrollWrapperWidth < scrollbarWidth) {
        if (scrollPosition <= 0) {
          $btnScrollLeft.addClass('mzkr-d-none');
          return $btnScrollRight.removeClass('mzkr-d-none');
        } else if (scrollPosition < (scrollHiddenWidth - 4)) {
          $btnScrollLeft.removeClass('mzkr-d-none');
          return $btnScrollRight.removeClass('mzkr-d-none');
        } else if (scrollPosition >= (scrollHiddenWidth - 4)) {
          $btnScrollLeft.removeClass('mzkr-d-none');
          return $btnScrollRight.addClass('mzkr-d-none');
        }
      } else {
        $btnScrollLeft.addClass('mzkr-d-none');
        return $btnScrollRight.addClass('mzkr-d-none');
      }
    };

    HorizontalScroll.prototype.scrollLeftHandler = function(event) {
      return this.scrollWrapper.find('.mzkr-horizontal-scroll__inner').animate({
        scrollLeft: this.scrollWrapper.find('.mzkr-horizontal-scroll__inner').scrollLeft() - 400
      }, 100);
    };

    HorizontalScroll.prototype.scrollRightHandler = function(event) {
      return this.scrollWrapper.find('.mzkr-horizontal-scroll__inner').animate({
        scrollLeft: this.scrollWrapper.find('.mzkr-horizontal-scroll__inner').scrollLeft() + 400
      }, 100);
    };

    HorizontalScroll.prototype.scrollHandler = function(event) {
      return this.updateHorizontalScroll();
    };

    HorizontalScroll.prototype.resizeHandler = function() {
      return this.updateHorizontalScroll();
    };

    HorizontalScroll.init = function(scrollWrapper, scrollToEnd) {
      return new Mzkr.HorizontalScroll(scrollWrapper, scrollToEnd);
    };

    return HorizontalScroll;

  })();

}).call(this);
(function() {
  window.Mzkr || (window.Mzkr = {});

  Mzkr.Modal = (function() {
    function Modal(scope) {
      if (scope == null) {
        scope = document;
      }
      this.focusTrap = null;
      scope.addEventListener('click', function(event) {
        var modalId, modalSelector, scrollTo, targetModal;
        if (event.target.closest('.mzkr-modal-open-trigger')) {
          event.preventDefault();
          targetModal = event.target.closest('.mzkr-modal-open-trigger').getAttribute('href');
          scrollTo = event.target.closest('.mzkr-modal-open-trigger').dataset.scrollTo;
          Modal.show(targetModal, scrollTo);
        }
        if ((event.target.closest('.mzkr-modal-close-trigger') || event.target.matches('.mzkr-modal')) && !event.target.closest('.mzkr-modal-custom')) {
          event.preventDefault();
          modalId = event.target.closest('.mzkr-modal').getAttribute('id');
          modalSelector = modalId ? "#" + modalId : '.mzkr-modal';
          return Modal.hide(modalSelector);
        }
      });
    }

    Modal.show = function(modal, scrollTo) {
      var modalInner, mzkrModalShowEvent, scrollbarWidth, targetModal;
      scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      targetModal = document.querySelector(modal);
      modalInner = targetModal.querySelector('.mzkr-modal__inner');
      targetModal.style.display = 'block';
      document.body.classList.add('mzkr-modal-is-open');
      document.body.style.paddingRight = scrollbarWidth + 'px';
      document.querySelector('.mzkr-nav-wrap').style.paddingRight = scrollbarWidth + 'px';
      mzkrModalShowEvent = new Event('onMzkrModalShow');
      targetModal.dispatchEvent(mzkrModalShowEvent);
      setTimeout((function() {
        var targetSection;
        targetModal.classList.add('mzkr-modal--open');
        if (scrollTo) {
          targetSection = targetModal.querySelector(scrollTo);
          if (targetSection) {
            targetSection.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
      }), 50);
      this.focusTrap = PublicUtility.Layout.focusTrap(targetModal);
      this.focusTrap.activate();
      return modalInner.ontransitionend = function(e) {
        var mzkrModalShownEvent;
        if (e.propertyName === 'opacity') {
          mzkrModalShownEvent = new Event('onMzkrModalShown');
          targetModal.dispatchEvent(mzkrModalShownEvent);
        }
      };
    };

    Modal.hide = function(modal) {
      var ref, targetModals;
      targetModals = document.querySelectorAll(modal);
      targetModals.forEach(function(targetModal) {
        var modalInner, mzkrModalHideEvent;
        modalInner = targetModal.querySelector('.mzkr-modal__inner');
        targetModal.classList.remove('mzkr-modal--open');
        document.body.classList.remove('mzkr-modal-is-open');
        document.body.style.paddingRight = '0';
        document.querySelector('.mzkr-nav-wrap').style.paddingRight = '0';
        mzkrModalHideEvent = new Event('onMzkrModalHide');
        targetModal.dispatchEvent(mzkrModalHideEvent);
        return modalInner.ontransitionend = function(e) {
          var mzkrModalHiddenEvent;
          if (e.propertyName === 'opacity') {
            mzkrModalHiddenEvent = new Event('onMzkrModalHidden');
            targetModal.dispatchEvent(mzkrModalHiddenEvent);
            return targetModal.style.display = 'none';
          }
        };
      });
      if ((ref = this.focusTrap) != null) {
        ref.deactivate();
      }
      return this.focusTrap = null;
    };

    return Modal;

  })();

}).call(this);
(function() {
  window.Mzkr || (window.Mzkr = {});

  Mzkr.ScrollSpy = (function() {
    function ScrollSpy() {}

    ScrollSpy.init = function(sectionSelector, menuItemSelector, itemActiveClass, offset) {
      var menuItems, sections;
      if (offset == null) {
        offset = 0;
      }
      menuItems = document.querySelectorAll(menuItemSelector);
      sections = document.querySelectorAll(sectionSelector);
      return window.addEventListener('scroll', function() {
        return sections.forEach(function(section) {
          var targetMenuItem;
          if (window.scrollY > section.offsetTop - offset && window.scrollY < section.offsetTop + section.offsetHeight) {
            if (document.querySelectorAll(menuItemSelector + (" a[href='#" + section.id + "']")).length) {
              targetMenuItem = document.querySelector(menuItemSelector + (" a[href='#" + section.id + "']")).parentElement;
              menuItems.forEach(function(item) {
                if (!item.contains(targetMenuItem)) {
                  return item.classList.remove(itemActiveClass);
                }
              });
              return targetMenuItem.classList.add(itemActiveClass);
            }
          }
        });
      });
    };

    return ScrollSpy;

  })();

}).call(this);
(function() {
  window.Mzkr || (window.Mzkr = {});

  Mzkr.Tabs = (function() {
    function Tabs(scope) {
      if (scope == null) {
        scope = document;
      }
      this.init();
    }

    Tabs.prototype.init = function() {
      var mzkrTabs;
      mzkrTabs = document.querySelectorAll('.mzkr-tabs .mzkr-tab-link');
      return mzkrTabs.forEach(function(tab) {
        return tab.addEventListener('click', function(e) {
          var currentTab, currentTabElement, targetTab, targetTabId;
          e.preventDefault();
          if (tab.classList.contains('mzkr-tab-link--active') && window.innerWidth < 992) {
            tab.classList.toggle('mzkr-tab-link--active');
          } else {
            mzkrTabs.forEach(function(link) {
              link.classList.remove('mzkr-tab-link--active');
              return tab.classList.add('mzkr-tab-link--active');
            });
          }
          targetTabId = tab.getAttribute('href');
          targetTab = document.querySelector(targetTabId);
          currentTabElement = document.getElementsByClassName('mzkr-tab-content--active');
          currentTab = null;
          if (currentTabElement.length > 0) {
            currentTab = document.getElementById(currentTabElement[0].getAttribute('id'));
          }
          if (targetTab === currentTab) {
            if (window.innerWidth < 992) {
              currentTab.classList.remove('mzkr-tab-content--active');
              return currentTab.style.maxHeight = null;
            }
          } else {
            if (currentTabElement.length > 0) {
              currentTab.classList.remove('mzkr-tab-content--active');
              currentTab.style.maxHeight = null;
              if (window.innerWidth < 992) {
                setTimeout((function() {
                  return currentTab.style.display = 'none';
                }), 200);
              } else {
                currentTab.style.display = 'none';
              }
            }
            targetTab.style.display = 'block';
            targetTab.style.maxHeight = targetTab.scrollHeight + 'px';
            return setTimeout((function() {
              return targetTab.classList.add('mzkr-tab-content--active');
            }), 200);
          }
        });
      });
    };

    return Tabs;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Analytics = (function() {
    function Analytics(scope) {
      var $bodyElement;
      if (scope == null) {
        scope = document;
      }
      this.tracking_scope = scope;
      $bodyElement = $('body');
      this.tracking_gtm = $bodyElement.is('[data-analytics-gtm]');
      this.locale = $bodyElement.data('locale');
      this.legal = $bodyElement.data('legal');
      this.enable_debug = $bodyElement.hasClass('google-analytics-debug');
      if (!this.tracking_gtm) {
        return null;
      }
      this.initAnalytics();
      this.debugGtmEvent();
    }

    Analytics.prototype.initAnalytics = function() {
      var pageData, that;
      that = this;
      $(this.tracking_scope).find('[data-analytics-actions]').each(function() {
        var $trackedElement, action, actions, i, len, results;
        $trackedElement = $(this);
        actions = $trackedElement.data('analytics-actions') ? $trackedElement.data('analytics-actions') : [];
        results = [];
        for (i = 0, len = actions.length; i < len; i++) {
          action = actions[i];
          if (that[action]) {
            results.push(that[action]($trackedElement));
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
      if (!window.isPushedPageData) {
        pageData = {
          event: 'page_data'
        };
        dataLayer.push(pageData);
        return window.isPushedPageData = true;
      }
    };

    Analytics.prototype.removeFromBasket = function(element) {
      var that;
      that = this;
      return element.find('[data-analytics-remove-from-basket]').click(function() {
        that.pushData(element);
        return true;
      });
    };

    Analytics.prototype.pushDataClick = function(element) {
      var that;
      that = this;
      return element.click(function() {
        that.pushData(element);
        return true;
      });
    };

    Analytics.prototype.pushData = function(element) {
      var dataObj;
      if (!this.tracking_gtm) {
        return null;
      }
      dataObj = JSON.parse(element.attr('data-analytics-data-layer'));
      if (dataObj.event === 'page_data') {
        window.isPushedPageData = true;
      }
      if (dataObj.items) {
        dataLayer.push({
          items: null
        });
      }
      return dataLayer.push(dataObj);
    };

    Analytics.prototype.debugGtmEvent = function() {
      var that;
      if (!this.enable_debug) {
        return null;
      }
      that = this;
      return $(this.tracking_scope).find('[data-gtmevent-click]').each(function() {
        var $this;
        $this = $(this);
        return that.addDebugTooltip($this, "data-gtmevent-click=" + ($this.attr('data-gtmevent-click')));
      });
    };

    Analytics.prototype.addDebugTooltip = function($element, gaText) {
      var originalTitle, that;
      that = this;
      originalTitle = $element.data('original-title') ? $element.data('original-title') + '<br>' : '';
      if ($element.css('display') === 'inline') {
        $element.parent().addClass('ga-debug-enabled');
      } else {
        $element.addClass('ga-debug-enabled');
      }
      if ($element.not('.js-personal-take-radio-button').attr('disabled')) {
        $element.removeAttr('disabled');
        $element.addClass('disabled');
      }
      if ($element.attr('title')) {
        $element.removeAttr('title');
      }
      $element.data('original-title', originalTitle + " " + gaText).attr('data-html', 'true').data('toggle', 'tooltip');
      $element.attr('data-original-title', $element.data('original-title'));
      $element.tooltip({
        template: "<div class='tooltip p-mid opacity-1' role='tooltip'>\n  <div class='arrow arrow-white'></div>\n  <div class='tooltip-inner text-left tooltip-fw py-2 rounded px-3 bg-white text-dark-gray border border-light-gray'></div>\n</div>",
        container: $(that.tracking_scope).hasClass('.mzkr-modal') ? '.mzkr-modal' : 'body'
      });
      return $element.tooltip('update');
    };

    return Analytics;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Basket = (function() {
    function Basket() {
      this.validateEmail();
    }

    Basket.prototype.validateEmail = function() {
      var emailFields, that;
      that = this;
      emailFields = $('[data-validate-email]');
      return emailFields.each(function(index, element) {
        var $field;
        $field = $(element);
        if (!$field.data('validation-initialized')) {
          $field.data('validation-initialized', true);
          if ($field.val().length) {
            that.initEmailInfo($field);
          }
          return $field.change(function() {
            return that.initEmailInfo($(this));
          });
        }
      });
    };

    Basket.prototype.initEmailInfo = function(field) {
      var email, path, that;
      that = this;
      email = field.val();
      if (that.checkEmailAddress(email)) {
        path = field.data('validate-email');
        return $.ajax({
          data: {
            email: email
          },
          type: 'GET',
          dataType: 'script',
          url: path
        });
      } else {
        $('#email-exists, #email-exists-registration').empty();
        if ($('.js-registration-benefits-banner').length) {
          return $('.js-registration-benefits-banner').slideDown();
        }
      }
    };

    Basket.prototype.checkEmailAddress = function(email) {
      var regex;
      regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    };

    return Basket;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.BasketItem = (function() {
    function BasketItem() {
      return this;
    }

    BasketItem.quantityChange = function() {
      var currentQuantitity, disableQuantityBtn, updateDelay;
      updateDelay = setTimeout((function() {
        return form.submit();
      }), 1000);
      currentQuantitity = 0;
      clearTimeout(updateDelay);
      App.PublicProducts.disableQuantityBtn();
      $('.quantity-remove').click(function() {
        var currentQuantity, form, updateQuantity;
        clearTimeout(updateDelay);
        form = $(this).next();
        currentQuantity = form.find('.input-quantity').val();
        if (currentQuantity > 1) {
          updateQuantity = parseInt(currentQuantity) - 1;
          form.find('.input-quantity').val(updateQuantity);
          App.PublicProducts.disableQuantityBtn();
          updateDelay = setTimeout((function() {
            return form.submit();
          }), 500);
        }
        return disableQuantityBtn();
      });
      $('.quantity-add').click(function() {
        var currentQuantity, form, updateQuantity;
        clearTimeout(updateDelay);
        form = $(this).prev();
        currentQuantity = form.find('.input-quantity').val();
        updateQuantity = parseInt(currentQuantity) + 1;
        form.find('.input-quantity').val(updateQuantity);
        App.PublicProducts.disableQuantityBtn();
        updateDelay = setTimeout((function() {
          return form.submit();
        }), 500);
        return disableQuantityBtn();
      });
      $('.input-quantity').focusin(function() {
        return currentQuantitity = parseInt($(this).val());
      });
      $('.input-quantity').focusout(function() {
        var newQuantity;
        newQuantity = parseInt($(this).val());
        if (currentQuantitity < newQuantity || currentQuantitity > newQuantity) {
          if (newQuantity <= 0) {
            $(this).val(1);
          }
          if (!(currentQuantitity === 1 && newQuantity <= 1)) {
            return $(this).closest('form').submit();
          }
        }
      });
      disableQuantityBtn = function() {
        return $('.mzkr-quantity-selector').each(function() {
          var $quantityAdd, $quantityRemove, $this, currentVal, maxVal, minVal;
          $this = $(this);
          currentVal = parseInt($('.input-quantity', $this).val());
          minVal = parseInt($('.input-quantity', $this).attr('min') + 1);
          maxVal = parseInt($('.input-quantity', $this).attr('max'));
          $quantityRemove = $('.quantity-remove', $this);
          $quantityAdd = $('.quantity-add', $this);
          if (currentVal === minVal) {
            $quantityRemove.addClass('disabled');
          } else {
            $quantityRemove.removeClass('disabled');
          }
          if (currentVal === maxVal) {
            return $quantityAdd.addClass('disabled');
          } else {
            return $quantityAdd.removeClass('disabled');
          }
        });
      };
      return disableQuantityBtn();
    };

    BasketItem.addItemsButton = function() {
      var $addItemsBtn, $addItemsInput;
      $addItemsBtn = $('.add-items-form .btn-input');
      $addItemsInput = $('.add-items-form div textarea');
      if ($addItemsInput.val()) {
        $addItemsBtn.addClass('btn-success');
        $addItemsBtn.prop('disabled', false);
      } else {
        $addItemsBtn.removeClass('btn-success');
        $addItemsBtn.prop('disabled', true);
      }
      return $addItemsInput.keyup(function() {
        if ($(this).val()) {
          $addItemsBtn.addClass('btn-success');
          return $addItemsBtn.prop('disabled', false);
        } else {
          $addItemsBtn.removeClass('btn-success');
          return $addItemsBtn.prop('disabled', true);
        }
      });
    };

    BasketItem.couponButton = function() {
      var $couponBoxInput, $couponCodeBtn, couponCodeBtnInterval;
      $couponCodeBtn = $('.coupon-box').find('.coupon-submit');
      $couponBoxInput = $('.coupon-box input[type="text"]');
      if (!$couponBoxInput.length) {
        return;
      }
      couponCodeBtnInterval = setInterval((function() {
        if ($couponBoxInput.val()) {
          $couponCodeBtn.removeClass('disabled');
          return $couponBoxInput.css('padding-right', '120px');
        } else {
          $couponCodeBtn.addClass('disabled');
          return $couponBoxInput.css('padding-right', '20px');
        }
      }), 300);
      $couponBoxInput.on('keyup paste', function() {
        if ($(this).val()) {
          $couponCodeBtn.removeClass('disabled');
          return $couponBoxInput.css('padding-right', '120px');
        } else {
          $couponCodeBtn.addClass('disabled');
          return $couponBoxInput.css('padding-right', '20px');
        }
      });
      return $couponCodeBtn.click(function() {
        $couponBoxInput.val($couponBoxInput.val().trim());
        clearInterval(couponCodeBtnInterval);
        return $couponCodeBtn.closest('form').submit(function() {
          return $couponCodeBtn.prop('disabled', true);
        });
      });
    };

    return BasketItem;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Carousel = (function() {
    function Carousel(scope) {
      if (scope == null) {
        scope = document;
      }
      this.scope = scope;
      this.init(scope);
    }

    Carousel.prototype.init = function(scope) {
      if (scope == null) {
        scope = document;
      }
      PublicUtility.Carousel.initRecomendedCarousel(scope);
      return PublicUtility.Carousel.initDefaultCarousel(scope);
    };

    Carousel.initRecomendedCarousel = function(scope) {
      var $swiperEl, hasOffsetBefore;
      if (scope == null) {
        scope = document;
      }
      $swiperEl = $(scope).find('.swiper-recommended');
      hasOffsetBefore = !$swiperEl.closest('.js-order-widget-wrapper, #product-accessories-recommended, .product-banner-widget').length;
      return new Swiper($swiperEl[0], {
        navigation: {
          enabled: false,
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerGroupAuto: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        centerInsufficientSlides: hasOffsetBefore ? true : false,
        lazyPreloadPrevNext: 0,
        breakpoints: {
          0: {
            slidesOffsetBefore: hasOffsetBefore ? 16 : 0,
            centeredSlidesBounds: true,
            navigation: {
              enabled: false
            },
            lazyPreloadPrevNext: 1
          },
          576: {
            slidesOffsetBefore: hasOffsetBefore ? 24 : 0,
            centeredSlidesBounds: true,
            navigation: {
              enabled: false
            },
            lazyPreloadPrevNext: 1
          },
          768: {
            slidesOffsetBefore: hasOffsetBefore ? 24 : 0,
            navigation: {
              enabled: true
            }
          },
          992: {
            slidesOffsetBefore: hasOffsetBefore ? 32 : 0,
            navigation: {
              enabled: true
            }
          },
          1200: {
            slidesOffsetBefore: hasOffsetBefore ? 56 : 0,
            navigation: {
              enabled: true
            }
          },
          1400: {
            slidesOffsetBefore: hasOffsetBefore ? 80 : 0,
            navigation: {
              enabled: true
            }
          },
          1848: {
            slidesOffsetBefore: 0,
            navigation: {
              enabled: true
            }
          }
        },
        on: {
          sliderFirstMove: function(swiper) {
            if (window.innerWidth < 768 && hasOffsetBefore) {
              swiper.params.centeredSlides = true;
              return swiper.update();
            }
          }
        },
        a11y: {
          prevSlideMessage: I18n.t('js.public.shared.previous'),
          nextSlideMessage: I18n.t('js.public.shared.next')
        }
      });
    };

    Carousel.initBasketRecomendedCarousel = function(elem) {
      return new Swiper($(elem)[0], {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        updateOnWindowResize: true,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1.3,
            spaceBetween: 4,
            navigation: {
              enabled: false
            },
            pagination: {
              enabled: true
            }
          },
          576: {
            slidesPerView: 2.3,
            spaceBetween: 4,
            navigation: {
              enabled: false
            },
            pagination: {
              enabled: true
            }
          },
          768: {
            slidesPerView: 1.3,
            spaceBetween: 8,
            navigation: {
              enabled: true
            },
            pagination: {
              enabled: false
            }
          },
          992: {
            spaceBetween: 8,
            navigation: {
              enabled: true
            },
            pagination: {
              enabled: false
            }
          },
          1200: {
            slidesPerView: 1.8,
            spaceBetween: 8,
            navigation: {
              enabled: true
            },
            pagination: {
              enabled: false
            }
          },
          1400: {
            slidesPerView: 2.3,
            spaceBetween: 8,
            navigation: {
              enabled: true
            },
            pagination: {
              enabled: false
            }
          }
        },
        a11y: {
          prevSlideMessage: I18n.t('js.public.shared.previous'),
          nextSlideMessage: I18n.t('js.public.shared.next')
        }
      });
    };

    Carousel.initDefaultCarousel = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return $(scope).find('.swiper-default').each(function(i, swiperEl) {
        return new Swiper(swiperEl, {
          navigation: {
            enabled: false,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerGroupAuto: true,
          slidesPerView: 'auto',
          watchOverflow: true,
          watchSlidesProgress: true,
          centerInsufficientSlides: true,
          updateOnWindowResize: true,
          breakpoints: {
            0: {
              slidesOffsetBefore: 16,
              centeredSlidesBounds: true,
              navigation: {
                enabled: false
              }
            },
            576: {
              slidesOffsetBefore: 24,
              centeredSlidesBounds: true,
              navigation: {
                enabled: false
              }
            },
            768: {
              slidesOffsetBefore: 24,
              navigation: {
                enabled: true
              }
            },
            992: {
              slidesOffsetBefore: 32,
              navigation: {
                enabled: true
              }
            },
            1200: {
              slidesOffsetBefore: 56,
              navigation: {
                enabled: true
              }
            },
            1400: {
              slidesOffsetBefore: 80,
              navigation: {
                enabled: true
              }
            },
            1848: {
              slidesOffsetBefore: 0,
              navigation: {
                enabled: true
              }
            }
          },
          on: {
            sliderFirstMove: function(swiper) {
              if (window.innerWidth < 768) {
                swiper.params.centeredSlides = true;
                return swiper.update();
              }
            }
          },
          a11y: {
            prevSlideMessage: I18n.t('js.public.shared.previous'),
            nextSlideMessage: I18n.t('js.public.shared.next')
          }
        });
      });
    };

    Carousel.initTestimonialCarousel = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return new Swiper($(scope).find('.swiper-testimonial')[0], {
        navigation: {
          enabled: true,
          nextEl: '.swiper-testimonial-button-next',
          prevEl: '.swiper-testimonial-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        updateOnWindowResize: true,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 15
          },
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15
          },
          769: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 25
          },
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 25
          }
        },
        a11y: {
          prevSlideMessage: I18n.t('js.public.shared.previous'),
          nextSlideMessage: I18n.t('js.public.shared.next')
        }
      });
    };

    Carousel.initWidgetCarousel = function($wrapper) {
      return new Swiper($wrapper.find('.swiper-widget')[0], {
        updateOnWindowResize: true,
        navigation: {
          enabled: false,
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerGroupAuto: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        lazyPreloadPrevNext: 0,
        breakpoints: {
          0: {
            slidesOffsetBefore: 16,
            centeredSlidesBounds: true,
            navigation: {
              enabled: false
            },
            lazyPreloadPrevNext: 1
          },
          576: {
            slidesOffsetBefore: 24,
            centeredSlidesBounds: true,
            navigation: {
              enabled: false
            },
            lazyPreloadPrevNext: 1
          },
          768: {
            slidesOffsetBefore: 24,
            navigation: {
              enabled: true
            }
          },
          992: {
            slidesOffsetBefore: 32,
            navigation: {
              enabled: true
            }
          },
          1200: {
            slidesOffsetBefore: 56,
            navigation: {
              enabled: true
            }
          },
          1400: {
            slidesOffsetBefore: 80,
            navigation: {
              enabled: true
            }
          },
          1848: {
            slidesOffsetBefore: 0,
            navigation: {
              enabled: true
            }
          }
        },
        a11y: {
          prevSlideMessage: I18n.t('js.public.shared.previous'),
          nextSlideMessage: I18n.t('js.public.shared.next')
        },
        on: {
          init: function(swiper) {
            return PublicUtility.Widgets.widgetCarouselEvent(swiper, $wrapper, 'init');
          },
          slideChange: function(swiper) {
            return PublicUtility.Widgets.widgetCarouselEvent(swiper, $wrapper, 'slideChange');
          },
          sliderFirstMove: function(swiper) {
            if (window.innerWidth < 768) {
              swiper.params.centeredSlides = true;
              return swiper.update();
            }
          }
        }
      });
    };

    return Carousel;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.CookiesConsent = (function() {
    function CookiesConsent(scope) {
      if (scope == null) {
        scope = document;
      }
      if ($('[data-muziker-consent]', scope).length) {
        this.initAcceptAllButton(scope);
        this.initDeclineAllButton(scope);
        this.initAcceptCurrentSetting(scope);
        this.initSwitchChange(scope);
        this.initSettingsBtn();
      }
    }

    CookiesConsent.prototype.initAcceptAllButton = function(scope) {
      var allButton, that;
      that = this;
      allButton = $('[data-cookies-accept-all-button]', scope);
      if (allButton.length) {
        return allButton.click(function() {
          $('[data-marketing-cookies]', scope).prop('checked', true).trigger('change');
          $('[data-analytics-cookies]', scope).prop('checked', true).trigger('change');
          that.setCookiesConsent(true, true, scope);
          return that.hideCookies();
        });
      }
    };

    CookiesConsent.prototype.initDeclineAllButton = function(scope) {
      var allButton, that;
      that = this;
      allButton = $('.cookies-decline-all', scope);
      if (allButton.length) {
        return allButton.click(function() {
          $('[data-marketing-cookies]', scope).prop('checked', false).trigger('change');
          $('[data-analytics-cookies]', scope).prop('checked', false).trigger('change');
          that.setCookiesConsent(false, false, scope);
          return that.hideCookies();
        });
      }
    };

    CookiesConsent.prototype.initAcceptCurrentSetting = function(scope) {
      var currentSettingButton, that;
      that = this;
      currentSettingButton = $('[data-cookies-accept-current-setting-button]', scope);
      return currentSettingButton.click(function() {
        that.setCookiesConsent($('[data-marketing-cookies]', scope).is(':checked'), $('[data-analytics-cookies]', scope).is(':checked'), scope);
        return that.hideCookies();
      });
    };

    CookiesConsent.prototype.hideCookies = function() {
      $('[data-muziker-consent]').addClass('d-none');
      $('body').removeAttr('style');
      return PublicUtility.WebpushNotification.initServiceWorker();
    };

    CookiesConsent.prototype.setCookiesConsent = function(marketing, analytics, scope) {
      var $cookiesSavedText, cookieExpireDays, cookies, cookiesString, fiveYearsInDays, monthInDays;
      if (marketing == null) {
        marketing = false;
      }
      if (analytics == null) {
        analytics = false;
      }
      cookies = {
        marketingCookie: marketing,
        analyticsCookie: analytics
      };
      cookiesString = JSON.stringify(cookies);
      fiveYearsInDays = 1826;
      monthInDays = 30;
      cookieExpireDays = cookies.marketingCookie && cookies.analyticsCookie ? fiveYearsInDays : monthInDays;
      Cookies.set('muziker_consent', cookiesString, {
        expires: cookieExpireDays,
        secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
      });
      $cookiesSavedText = $('.cookies-saved');
      if ($cookiesSavedText.length) {
        $('.cookies-saved').removeClass('d-none');
        window.location.reload();
      }
      return this.handleCookies('muziker_consent', cookies, scope);
    };

    CookiesConsent.prototype.handleCookies = function(cookie_name, cookies, scope) {
      var cookieExpireDays, fiveYearsInDays, monthInDays, path;
      path = $('[data-cookies-accept-current-setting-button], [data-cookies-accept-all-button]', scope).data('update-cookies-path');
      fiveYearsInDays = 1826;
      monthInDays = 30;
      cookieExpireDays = cookies.marketingCookie && cookies.analyticsCookie ? fiveYearsInDays : monthInDays;
      if (path != null ? path.length : void 0) {
        return $.ajax({
          data: {
            cookies_name: cookie_name,
            cookies_value: JSON.stringify(cookies),
            cookies_expires: cookieExpireDays
          },
          type: 'POST',
          url: path
        });
      }
    };

    CookiesConsent.prototype.initSwitchChange = function(scope) {
      return $('.cookies-switch input', scope).on('change', function() {
        var switchElement, switchWrap;
        switchElement = $(this);
        switchWrap = switchElement.parents('.js-cookies-section-wrap');
        if (switchElement.is(':checked')) {
          switchWrap.prev('.cookies-icon').removeClass('fa-times light-gray').addClass('fa-check green');
          return $('.cookies-change-text', switchWrap).removeClass('mzkr-text-light').addClass('mzkr-text-success').text(I18n.t('js.public.cookies.info.allowed'));
        } else {
          switchWrap.prev('.cookies-icon').addClass('fa-times light-gray').removeClass('fa-check green');
          return $('.cookies-change-text', switchWrap).removeClass('mzkr-text-success').addClass('mzkr-text-light').text(I18n.t('js.public.cookies.info.not_allowed'));
        }
      });
    };

    CookiesConsent.prototype.initSettingsBtn = function() {
      return $('.js-consent-settings-close').on('click', function() {
        return $('.consent-box').removeClass('consent-box-settings-active');
      });
    };

    return CookiesConsent;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.CookiesWrapper = (function() {
    function CookiesWrapper(scope) {
      if (scope == null) {
        scope = document;
      }
      this.scope = scope;
    }

    CookiesWrapper.prototype.shouldBeSecureCookie = function() {
      return window.location.protocol === 'https:';
    };

    return CookiesWrapper;

  })();

}).call(this);
(function() {
  PublicUtility.CurrencyFormatManager = (function() {
    function CurrencyFormatManager() {}

    CurrencyFormatManager.number_to_currency = function(number, unit) {
      var currencyOptions, precision;
      if (unit == null) {
        unit = I18n.currency;
      }
      currencyOptions = I18n.t('js.number.currency.format');
      currencyOptions.unit = unit;
      number || (number = 0);
      if (number < 0 && Math.abs(number) < 1e-3) {
        number = 0;
      }
      if (this.round(number, 2) % 1 === 0) {
        precision = 0;
      } else {
        precision = 2;
      }
      currencyOptions.precision = precision;
      return I18n.toCurrency(number, currencyOptions);
    };

    CurrencyFormatManager.round = function(number, decimals) {
      return Number(Math.round(number + ("e" + decimals)) + ("e" + (-decimals)));
    };

    return CurrencyFormatManager;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.CustomerNavigation = (function() {
    function CustomerNavigation() {
      this.initListeners();
      if (!PublicUtility.CustomerNavigation.sidebarInitialized) {
        PublicUtility.CustomerNavigation.initCustomerStickySidebar();
        PublicUtility.CustomerNavigation.sidebarInitialized = true;
      }
    }

    CustomerNavigation.prototype.initListeners = function() {
      var $clientHeader, $customerNavigation, $customerNavigationIdentifiers, $navItem, $navItemHasChildren, $navItemIdentifiers, customerEmailText, customerInitialsText, customerNameText, i, itemIdentifier, len, ref, that;
      $customerNavigationIdentifiers = $('.js-customer-navigation-identifiers');
      $customerNavigation = $('.js-customer-navigation');
      if ($customerNavigationIdentifiers.length && $customerNavigation.length) {
        $('.js-customer-navigation-wrapper').removeClass('customer-navigation-hidden');
        if (PublicUtility.CustomerNavigation.sidebarInitialized) {
          PublicUtility.CustomerNavigation.userStickySidebar.updateSticky();
        } else {
          PublicUtility.CustomerNavigation.initCustomerStickySidebar();
          PublicUtility.CustomerNavigation.sidebarInitialized = true;
        }
        that = this;
        $navItemIdentifiers = $customerNavigationIdentifiers.data('nav-item-identifiers');
        ref = $navItemIdentifiers.split(" ");
        for (i = 0, len = ref.length; i < len; i++) {
          itemIdentifier = ref[i];
          $navItem = $customerNavigation.find('li[data-nav-item-identifier=' + itemIdentifier + ']');
          $navItemHasChildren = $navItem.data('nav-item-has-children');
          $navItem.addClass('active');
          if ($navItemHasChildren) {
            $navItem.find('ul.sub-menu').addClass('mzkr-d-block');
            if (window.innerWidth > 767 && PublicUtility.CustomerNavigation.sidebarInitialized) {
              PublicUtility.CustomerNavigation.userStickySidebar.updateSticky();
            }
          }
        }
      }
      $clientHeader = $('.js-client-header-dynamic');
      if ($clientHeader.length) {
        customerInitialsText = $('.js-customer-initials-source').text();
        customerNameText = $('.js-customer-name-source').text();
        customerEmailText = $('.js-customer-email-source').text();
        $clientHeader.find('.js-customer-initials').text(customerInitialsText);
        $clientHeader.find('.js-customer-name').text(customerNameText);
        return $clientHeader.find('.js-customer-email').text(customerEmailText);
      }
    };

    CustomerNavigation.initCustomerStickySidebar = function() {
      var menuTrigger, setupStickySidebar, that, windowWidth;
      that = this;
      if (!document.body.contains(document.querySelector('.user-sticky-sidebar-menu'))) {
        return;
      }
      setupStickySidebar = function() {
        var scrollspyOffset, sidebarOffset, topSpacing, windowWidth;
        windowWidth = window.innerWidth;
        topSpacing = windowWidth < 768 ? 48 : windowWidth < 992 ? 80 : 90;
        sidebarOffset = windowWidth < 1400 ? 156 : 0;
        scrollspyOffset = 200;
        return PublicUtility.CustomerNavigation.userStickySidebar = new StickySidebar('.user-sticky-sidebar', {
          topSpacing: topSpacing,
          containerSelector: '.user-sticky-sidebar-container',
          innerWrapperSelector: '.user-sticky-sidebar__inner',
          resizeSensor: false
        });
      };
      menuTrigger = document.querySelectorAll('.user-sticky-sidebar-menu__trigger');
      menuTrigger.forEach(function(trigger) {
        return trigger.addEventListener('click', function(e) {
          e.preventDefault();
          return trigger.parentElement.classList.toggle('user-sticky-sidebar-menu--open');
        });
      });
      setupStickySidebar();
      windowWidth = window.innerWidth;
      return window.addEventListener('resize', function() {
        var resizedWidth;
        resizedWidth = window.innerWidth;
        if (windowWidth !== resizedWidth) {
          if (PublicUtility.CustomerNavigation.userStickySidebar != null) {
            PublicUtility.CustomerNavigation.userStickySidebar.destroy();
            setupStickySidebar();
          }
          return windowWidth = resizedWidth;
        }
      });
    };

    return CustomerNavigation;

  })();

}).call(this);
(function() {
  PublicUtility.DeliveryAndPaymentMethodPriceCalculator = (function() {
    function DeliveryAndPaymentMethodPriceCalculator(priceBeforeDiscount, totalDiscount, servicePrice) {
      this.priceBeforeDiscount = priceBeforeDiscount;
      this.totalDiscount = totalDiscount;
      this.servicePrice = servicePrice;
    }

    DeliveryAndPaymentMethodPriceCalculator.prototype.calculate_total_price = function(deliveryMethodPrice, paymentMethodPrice) {
      var price_round_system, rounded_price, rounding_offset, that, totalPrice;
      that = this;
      totalPrice = {};
      ['WithVat', 'WithoutVat', 'Vat'].forEach(function(type) {
        return totalPrice["totalPrice" + type] = parseFloat(that.priceBeforeDiscount["priceBeforeDiscount" + type]) - (parseFloat(that.totalDiscount["totalDiscount" + type]) || 0) + (parseFloat(that.servicePrice["servicePrice" + type]) || 0) + (parseFloat(deliveryMethodPrice["deliveryMethodPrice" + type]) || 0) + (parseFloat(paymentMethodPrice["paymentMethodPrice" + type]) || 0);
      });
      price_round_system = $('body').data('price-round-system');
      if (price_round_system !== 0) {
        rounding_offset = 2;
        rounded_price = PublicUtility.CurrencyFormatManager.round(totalPrice['totalPriceWithVat'], rounding_offset - price_round_system);
        totalPrice['totalPriceRoundDifference'] = rounded_price - totalPrice['totalPriceWithVat'];
        totalPrice['totalPriceWithVat'] = rounded_price;
      }
      return totalPrice;
    };

    return DeliveryAndPaymentMethodPriceCalculator;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.Disputes = (function() {
    var checkAndLoadOrderItems, vatPayerFields;

    function Disputes() {
      return this;
    }

    Disputes.initFieldsByRefundMethod = function() {
      var $copyCheckbox, $copyCheckboxForm, $copyDeliveryCheckbox, $copyDeliveryCheckboxForm, $pickupAddress, $refundMethodDescription, copyCheckboxStatus, copyDeliveryCheckboxStatus;
      $refundMethodDescription = $('[data-refund-method-description]');
      $pickupAddress = $('[data-pickup-address]');
      $copyCheckboxForm = $('.copy-addresses-wrapper');
      $copyDeliveryCheckboxForm = $('.copy-delivery-addresses-wrapper');
      $copyCheckbox = $('#copy-addresses');
      $copyDeliveryCheckbox = $('#copy-delivery-addresses');
      copyCheckboxStatus = $copyCheckbox.is(':checked');
      copyDeliveryCheckboxStatus = $copyCheckbox.is(':checked');
      $copyCheckbox.on('change', function() {
        return copyCheckboxStatus = $(this).is(':checked');
      });
      $copyDeliveryCheckbox.on('change', function() {
        return copyDeliveryCheckboxStatus = $(this).is(':checked');
      });
      if ($('[data-refund-method]:checked').val() === 'discount') {
        $refundMethodDescription.show();
        $pickupAddress.hide();
        $copyDeliveryCheckboxForm.hide();
      } else if ($('[data-refund-method]:checked').val() === 'price') {
        $refundMethodDescription.hide();
        $pickupAddress.show();
        $copyCheckbox.prop('checked', false);
        $copyCheckboxForm.hide();
        $copyDeliveryCheckboxForm.hide();
      } else {
        $refundMethodDescription.hide();
        $pickupAddress.show();
        $copyCheckbox.prop('checked', copyCheckboxStatus);
        $copyCheckboxForm.show();
        $copyDeliveryCheckboxForm.hide();
      }
      return $('input[data-refund-method]').change(function() {
        if (this.value === 'discount') {
          $refundMethodDescription.slideDown(300);
          return $pickupAddress.slideUp();
        } else if (this.value === 'price') {
          $refundMethodDescription.slideUp(300);
          $pickupAddress.slideDown(300);
          $copyCheckbox.prop('checked', false);
          return $copyCheckboxForm.hide();
        } else {
          $refundMethodDescription.slideUp(300);
          $pickupAddress.slideDown(300);
          $copyCheckbox.prop('checked', copyCheckboxStatus);
          return $copyCheckboxForm.show();
        }
      });
    };

    Disputes.loadDisputeOrderItems = function() {
      var $invoiceField, $orderField, $receiptField, $receiptUidEndingField;
      $invoiceField = $('[data-invoice=true]');
      $orderField = $('[data-order=true]');
      $receiptField = $('[data-receipt=true]');
      $receiptUidEndingField = $('[data-receipt-uid-ending=true]');
      $invoiceField.on('change', function() {
        return checkAndLoadOrderItems($invoiceField, $orderField, $receiptField, $receiptUidEndingField);
      });
      $orderField.on('change', function() {
        return checkAndLoadOrderItems($invoiceField, $orderField, $receiptField, $receiptUidEndingField);
      });
      $receiptField.on('change', function() {
        return checkAndLoadOrderItems($invoiceField, $orderField, $receiptField, $receiptUidEndingField);
      });
      return $receiptUidEndingField.on('change', function() {
        return checkAndLoadOrderItems($invoiceField, $orderField, $receiptField, $receiptUidEndingField);
      });
    };

    checkAndLoadOrderItems = function($invoiceField, $orderField, $receiptField, $receiptUidEndingField) {
      var documentType, invoiceNumber, loadOrderItemsPath, orderNumber, receiptNumber, receiptUidEndingNumber;
      documentType = $('[data-document-type]:checked').val();
      if (documentType === 'receipt') {
        invoiceNumber = null;
        orderNumber = null;
        receiptNumber = $receiptField.val();
        receiptUidEndingNumber = $receiptUidEndingField.val();
      } else {
        invoiceNumber = $invoiceField.val();
        orderNumber = $orderField.val();
        receiptNumber = null;
        receiptUidEndingNumber = null;
      }
      loadOrderItemsPath = $orderField.data('items-path');
      if ((documentType === 'receipt') && receiptNumber.length && receiptUidEndingNumber.length) {
        $.ajax({
          data: {
            receipt_number: receiptNumber,
            receipt_uid_ending_number: receiptUidEndingNumber,
            document_type: documentType
          },
          type: 'GET',
          dataType: 'script',
          url: loadOrderItemsPath
        });
      } else if ((documentType !== 'receipt') && invoiceNumber.length && orderNumber.length) {
        $.ajax({
          data: {
            invoice_number: invoiceNumber,
            order_number: orderNumber,
            document_type: 'invoice'
          },
          type: 'GET',
          dataType: 'script',
          url: loadOrderItemsPath
        });
      }
      PublicUtility.Layout.fileBrowse();
      return Utility.Disputes.showCustomerRegistrationBanner();
    };

    Disputes.checkboxAsRadio = function() {
      if ($('#accordionDispute .custom-checkbox input:not([type="hidden"])').is(':checked')) {
        $('[data-refund-method]').show();
      }
      return $('#accordionDispute .custom-checkbox input').click(function() {
        $('[data-refund-method]').slideDown();
        $('#accordionDispute input[type=checkbox]').each(function() {
          return $(this).prop('checked', false);
        });
        $(this).prop('checked', true);
        return $($(this).parents('.order-item').data('target')).collapse('show');
      });
    };

    Disputes.disputeItemsChangeListener = function() {
      if ($('.js-dispute-items .custom-checkbox input[type=checkbox]:checked').length) {
        $('[data-refund-method]').show();
      }
      return $(document).on('click', '.js-dispute-items .custom-checkbox input', function() {
        if ($('.js-dispute-items .custom-checkbox input[type=checkbox]:checked').length) {
          return $('[data-refund-method]').slideDown();
        } else {
          return $('[data-refund-method]').slideUp();
        }
      });
    };

    Disputes.collapseMultipleCheckboxes = function() {
      return $(".js-dispute-items").each(function() {
        $("#" + $(this).find("input[type=checkbox]:checked").parents(".collapse").attr('id')).addClass('show');
        return $(this).find("input[type=checkbox]:checked").each(function() {
          var $collapseParent;
          $collapseParent = $($(this).parents('.collapsed').data('target'));
          $collapseParent.addClass('show');
          $collapseParent.find('input, textarea').prop('disabled', false);
          $collapseParent.prev().find('input.input-quantity').prop('disabled', false);
          $collapseParent.closest('.js-collapse-order-items').find('.js-dispute-items > input, .custom-control.custom-checkbox > input').prop('disabled', false);
          return $(this).closest('.disputes-invoice-item-inner').addClass('active');
        });
      });
    };

    Disputes.collapseOnCheckboxChange = function() {
      return $('.js-dispute-items .custom-checkbox input').change(function() {
        if ($(this).is(':checked')) {
          return $($(this).parents('.order-item').data('target')).collapse('show');
        } else {
          return $($(this).parents('.order-item').data('target')).collapse('hide');
        }
      });
    };

    Disputes.disableCollapsedInputs = function() {
      $('.js-dispute-items .collapse').on('show.bs.collapse', function(e) {
        e.stopPropagation();
        $(this).find('input, textarea').prop('disabled', false);
        return $(this).prev().find('input.input-quantity').prop('disabled', false);
      });
      $('.js-dispute-items .collapse').on('hidden.bs.collapse', function() {
        return $(this).find('input, textarea').prop('disabled', true);
      });
      $('.js-dispute-items .collapse').on('hide.bs.collapse', function(e) {
        e.stopPropagation();
        return $(this).prev().find('input.input-quantity').prop('disabled', true);
      });
      $('.js-collapse-order-items').on('show.bs.collapse', function() {
        $(this).find('.js-dispute-items > input, .custom-control.custom-checkbox > input').prop('disabled', false);
        return $(this).parent('.disputes-invoice-item-inner').addClass('active');
      });
      return $('.js-collapse-order-items').on('hide.bs.collapse', function() {
        $(this).find('.js-dispute-items > input, .custom-control.custom-checkbox > input').prop('disabled', true);
        return $(this).parent('.disputes-invoice-item-inner').removeClass('active');
      });
    };

    Disputes.initIbanFields = function(show_iban_fields) {
      var ibanFields;
      ibanFields = $('#iban-fields');
      if (show_iban_fields === 'true') {
        return ibanFields.slideDown(300);
      } else {
        return ibanFields.slideUp(300);
      }
    };

    Disputes.initIbanCalculator = function() {
      var bankAccount;
      bankAccount = $('#bank_account');
      return $('#bank_account').on('blur', function() {
        if (IBAN.isValid($(this).val())) {
          bankAccount.addClass('is-valid');
          return bankAccount.removeClass('is-invalid');
        } else {
          bankAccount.addClass('is-invalid');
          return bankAccount.removeClass('is-valid');
        }
      });
    };

    Disputes.initWrappingDamageFields = function() {
      var note;
      note = $('[data-wrapping-damage-description]');
      if ($('[data-wrapping-damage]:checked').val() === 'yes') {
        note.removeClass('d-none');
        note.show();
      } else {
        note.removeClass('d-none');
        note.hide();
      }
      return $('[data-wrapping-damage]').change(function() {
        if (this.value === 'yes') {
          return note.slideDown(300);
        } else {
          return note.slideUp();
        }
      });
    };

    Disputes.handleUploadFileBlobs = function() {
      Utility.Disputes.setFileSidsInputAttributes();
      setTimeout(function() {
        var fileInput;
        fileInput = $('.custom-file input:file');
        return fileInput.on('change', function(event) {
          var file, files, formData, i, j, len, that;
          that = $(this);
          if (that.attr('data-file-validator')) {
            if (!Utility.Disputes.fileInputValidate(that)) {
              return;
            }
          }
          files = event.target.files;
          formData = new FormData();
          formData.append('identifier', that.attr('data-target'));
          formData.append('model_class_name', that.attr('data-model-class-name'));
          for (i = j = 0, len = files.length; j < len; i = ++j) {
            file = files[i];
            formData.append('files[]', file);
          }
          return $.ajax({
            type: 'POST',
            dataType: 'script',
            data: formData,
            processData: false,
            contentType: false,
            url: that.data('file-blobs-path')
          });
        });
      }, 1);
      return this.handleFileBlobRemove();
    };

    Disputes.setFileSidsInputAttributes = function() {
      $('.file-blobs-form-fields input.file-blob').each(function(index, elem) {
        var $fileInput, $wrapper, id, name;
        $wrapper = $(elem).closest('.files-wrapper');
        $fileInput = $wrapper.find('input:file[data-file-blobs-path]');
        id = $fileInput.attr('id').replace(/_files$/, '_file_sids');
        name = $fileInput.attr('name').replace(/\[files\]\[\]$/, '[file_sids][]');
        $(elem).attr('id', id);
        return $(elem).attr('name', name);
      });
      return this.handleFileBlobRemove();
    };

    Disputes.handleFileBlobRemove = function() {
      return $('.file-blob-item__remove').on('click', function() {
        $(this).parents('.file-blob-item').addClass('removing');
        return setTimeout((function(_this) {
          return function() {
            return $(_this).parents('.file-blob-item').remove();
          };
        })(this), 150);
      });
    };

    Disputes.fileInputValidate = function(elem) {
      var allowedExtensions, fExt, fSize, file, files, invalidExt, invalidSize, j, len, parent, sizeLimit;
      sizeLimit = elem.data('file-validator').size;
      allowedExtensions = elem.data('file-validator').ext;
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        parent = elem.parents('.files-wrapper');
        parent.find('.invalid-feedback-file').remove();
        files = elem[0].files;
        invalidSize = false;
        invalidExt = false;
        for (j = 0, len = files.length; j < len; j++) {
          file = files[j];
          fSize = file.size;
          fExt = file.name.split('.').pop().toLowerCase();
          if (fSize > parseInt(sizeLimit)) {
            if (!invalidSize) {
              parent.append("<div class='invalid-feedback invalid-feedback-file'>" + (I18n.t('js.errors.files_size', {
                size: sizeLimit / (1024 * 1024)
              })) + "</div>");
              parent.find('.invalid-feedback-file').show();
              invalidSize = true;
              setTimeout(function() {
                return parent.find('.invalid-feedback-file').fadeOut(300, function() {
                  $(this).remove();
                  return invalidSize = false;
                });
              }, 5000);
            }
          }
          if (allowedExtensions.indexOf(fExt) === -1) {
            if (!invalidExt) {
              parent.append("<div class='invalid-feedback invalid-feedback-file'>" + (I18n.t('js.errors.files_ext')) + "</div>");
              parent.find('.invalid-feedback-file').show();
              invalidExt = true;
              setTimeout(function() {
                return parent.find('.invalid-feedback-file').fadeOut(300, function() {
                  $(this).remove();
                  return invalidSize = false;
                });
              }, 5000);
            }
          }
        }
        if ($('.invalid-feedback-file').length === 0) {
          return true;
        } else {
          elem.val('');
          return false;
        }
      }
    };

    Disputes.checkboxSelected = function() {
      return $('[data-return-item]').each(function() {
        var checkCheckobx, checkbox, item, quantityInput;
        item = $(this);
        checkbox = item.find('[data-return-item-checkbox]');
        quantityInput = item.find('[data-return-item-quantity]');
        checkCheckobx = function() {
          if (checkbox.is(':checked')) {
            return quantityInput.prop('disabled', false);
          } else {
            return quantityInput.prop('disabled', true);
          }
        };
        checkCheckobx();
        return checkbox.click(function() {
          return checkCheckobx();
        });
      });
    };

    Disputes.calculateImportPriceOnItemEdit = function() {
      var pickupAddress;
      pickupAddress = $('#pickup-address');
      return $('[data-return-item-quantity], [data-return-item-checkbox]').change(function() {
        var calculateImportPirceDelay;
        clearTimeout(calculateImportPirceDelay);
        return calculateImportPirceDelay = setTimeout((function() {
          var checkedItems;
          checkedItems = $('#order-items [data-return-item-checkbox]:checked').map(function() {
            return {
              shop_invoice_item_id: $(this).closest('.js-dispute-items').prev().val(),
              quantity: $(this).closest('.js-dispute-items').find('input.input-quantity').val(),
              selected: true
            };
          });
          return $.ajax({
            data: {
              public_dispute_return_form: {
                order_number: $('[data-order=true]').val(),
                invoice_number: $('[data-invoice=true]').val(),
                return_items_attributes: checkedItems.get()
              }
            },
            type: 'GET',
            dataType: 'script',
            url: pickupAddress.data('calculateImportDeliveryLimitPath')
          });
        }), 1000);
      });
    };

    Disputes.initPackagePiskupDatepicker = function() {
      return $('[data-datepicker="packages_pickup_date"]').each(function() {
        var $dateHiddenField, $datePicker, date, disabled_days, end_date, format_date, start_date;
        $datePicker = $(this);
        $dateHiddenField = $datePicker.next('input');
        format_date = moment.localeData().longDateFormat('l');
        start_date = $datePicker.data('start-date');
        end_date = $datePicker.data('end-date');
        if ($datePicker.val().length > 0) {
          date = $datePicker.val();
        } else {
          date = start_date;
          $dateHiddenField.val(date);
        }
        disabled_days = $.map($datePicker.data('disabled-days'), function(date, i) {
          return moment(date);
        });
        $datePicker.datetimepicker({
          locale: I18n.locale,
          format: format_date,
          extraFormats: ['YYYY-MM-DD'],
          date: date,
          minDate: start_date,
          maxDate: end_date,
          disabledDates: disabled_days
        });
        $datePicker.focus(function() {
          return $datePicker.datetimepicker('show');
        });
        $datePicker.blur(function() {
          return $datePicker.datetimepicker('hide');
        });
        $datePicker.on('keydown', function() {
          return false;
        });
        return $datePicker.on('hide.datetimepicker', function(e) {
          return $dateHiddenField.val(moment(e.date._d).format('YYYY-MM-DD'));
        });
      });
    };

    Disputes.initFieldsByDocumentType = function() {
      var $invoiceFields, $receiptFields, disputes_alert;
      $invoiceFields = $('[data-document-type-fields="invoice"]');
      $receiptFields = $('[data-document-type-fields="receipt"]');
      disputes_alert = $('.js-disputes-alert');
      if ($('[data-document-type]:checked').val() === 'receipt') {
        $receiptFields.show();
        $invoiceFields.hide();
        disputes_alert.hide();
      } else if ($('[data-document-type]:checked').val() === 'invoice') {
        $receiptFields.hide();
        $invoiceFields.show();
        disputes_alert.show();
      } else {
        $receiptFields.hide();
        $invoiceFields.hide();
        disputes_alert.show();
      }
      return $('[data-document-type]').change(function() {
        if (this.value === 'receipt') {
          $receiptFields.slideDown(300);
          $invoiceFields.slideUp();
          return disputes_alert.slideUp(300);
        } else {
          $receiptFields.slideUp(300);
          $invoiceFields.slideDown(300);
          return disputes_alert.slideDown(300);
        }
      });
    };

    Disputes.copyOfDeliveryAddressFields = function() {
      return $(document).on('keyup', function() {
        var checkbox, city, firstname, phone_number, street, street_note, surname, zip_code;
        checkbox = $('#copy-delivery-addresses');
        firstname = $('#contact_firstname').val();
        surname = $('#contact_surname').val();
        phone_number = $('#contact_phone_number').val();
        street = $('#contact_street').val();
        street_note = $('#contact_street_note').val();
        city = $('#contact_city').val();
        zip_code = $('#contact_zip_code').val();
        if (checkbox.is(':checked')) {
          $('#firstname').val(firstname);
          $('#surname').val(surname);
          $('#phone_number').val(phone_number);
          $('#street').val(street);
          $('#street_note').val(street_note);
          $('#city').val(city);
          return $('#zip_code').val(zip_code);
        } else {
          $('#firstname').val();
          $('#surname').val();
          $('#phone_number').val();
          $('#street').val();
          $('#street_note').val();
          $('#city').val();
          $('#zip_code').val();
          return checkbox.on('click', function() {
            $('#firstname').val(firstname);
            $('#surname').val(surname);
            $('#phone_number').val(phone_number);
            $('#street').val(street);
            $('#street_note').val(street_note);
            $('#city').val(city);
            return $('#zip_code').val(zip_code);
          });
        }
      });
    };

    Disputes.copyOfAddressFields = function() {
      return $(document).on('keyup', function() {
        var checkbox, city, firstname, phone_number, street, street_note, surname, zip_code;
        if ($('#copy-addresses').length) {
          checkbox = $('#copy-addresses');
          firstname = $('#firstname').val();
          surname = $('#surname').val();
          phone_number = $('#phone_number').val();
          street = $('#street').val();
          street_note = $('#street_note').val();
          city = $('#city').val();
          zip_code = $('#zip_code').val();
          if (checkbox.is(':checked')) {
            $('#pickup_firstname').val(firstname);
            $('#pickup_surname').val(surname);
            $('#pickup_phone_number').val(phone_number);
            $('#pickup_street').val(street);
            $('#pickup_street_note').val(street_note);
            $('#pickup_city').val(city);
            return $('#pickup_zip_code').val(zip_code);
          } else {
            $('#pickup_firstname').val();
            $('#pickup_surname').val();
            $('#pickup_phone_number').val();
            $('#pickup_street').val();
            $('#pickup_street_note').val();
            $('#pickup_city').val();
            $('#pickup_zip_code').val();
            return checkbox.on('click', function() {
              $('#pickup_firstname').val(firstname);
              $('#pickup_surname').val(surname);
              $('#pickup_phone_number').val(phone_number);
              $('#pickup_street').val(street);
              $('#pickup_street_note').val(street_note);
              $('#pickup_city').val(city);
              return $('#pickup_zip_code').val(zip_code);
            });
          }
        }
      });
    };

    Disputes.initReceiptFields = function() {
      var $copyDeliveryCheckbox, $ibanFields, $receiptFields, checkbox_delivery_address;
      $receiptFields = $('[data-contact-address]');
      $ibanFields = $('#iban-fields');
      $copyDeliveryCheckbox = $('#copy-delivery-addresses');
      checkbox_delivery_address = $('.copy-delivery-addresses-wrapper');
      if ($('[data-document-type]:checked').val() === 'receipt') {
        $ibanFields.hide();
        $receiptFields.show();
        checkbox_delivery_address.show();
      } else {
        $ibanFields.show();
        $receiptFields.hide();
        checkbox_delivery_address.hide();
        $copyDeliveryCheckbox.prop('checked', false);
      }
      return $('[data-document-type]').change(function() {
        if (this.value === 'receipt') {
          $ibanFields.hide();
          $receiptFields.show();
          checkbox_delivery_address.show();
          $copyDeliveryCheckbox.prop('checked', true);
          return $("#changeable-title").text(I18n.t('js.public.disputes.shared.form.address.short_info'));
        } else {
          $ibanFields.show();
          $receiptFields.hide();
          $copyDeliveryCheckbox.prop('checked', false);
          return $("#changeable-title").text(I18n.t('js.public.disputes.shared.form.address.info'));
        }
      });
    };

    Disputes.pickupAddress = function() {
      var that;
      that = this;
      return $('[data-show-pickup-delivery] [type="radio"]').change(function() {
        var $this, checkboxTarget;
        $this = $(this);
        checkboxTarget = $this.data('fieldsTarget');
        that.pickupAddressFields($this, checkboxTarget);
        if (checkboxTarget !== 'pickup-delivery-personal-delivery') {
          $('.js-pickup-bill-address-fields').slideDown({
            duration: 300
          });
        } else {
          $('.js-pickup-bill-address-fields').slideUp({
            duration: 300
          });
        }
        if (checkboxTarget === 'pickup-delivery-personal-take') {
          $('#copy-addresses').prop('checked', false).trigger('change');
          $('.copy-addresses-wrapper').addClass('d-none');
          $('.js-packages-count-personal-take').show();
          return $('.js-packages-count-personal-take').prop('disabled', false);
        } else {
          $('.copy-addresses-wrapper').removeClass('d-none');
          $('.js-packages-count-personal-take').hide();
          $('.js-packages-count-courier').prop('disabled', checkboxTarget !== 'pickup-delivery-courier');
          $('.js-packages-count-personal-take').prop('disabled', checkboxTarget !== 'pickup-delivery-personal-take');
          return $('.js-packages-count-personal-take').prop('disabled', true);
        }
      });
    };

    Disputes.pickupAddressFields = function(e, fieldsTarget) {
      if (e.is(':checked')) {
        $('.js-pickup-delivery-fields[data-' + fieldsTarget + ']').slideDown({
          duration: 300
        });
        return $('.js-pickup-delivery-fields:not([data-' + fieldsTarget + '])').slideUp({
          duration: 300
        });
      } else {
        return $('.js-pickup-delivery-fields[data-' + fieldsTarget + ']').slideUp({
          duration: 300
        });
      }
    };

    Disputes.copyAddressFields = function() {
      var checkbox, sourceFieldsPrefix, targetFieldsPrefix;
      checkbox = $('#copy-addresses');
      sourceFieldsPrefix = checkbox.data('source-fields-prefix');
      targetFieldsPrefix = checkbox.data('target-fields-prefix');
      checkbox.change(function() {
        var city, firstname, phone_number, street, street_note, surname, zip_code;
        if (checkbox.is(':checked')) {
          firstname = $('#' + sourceFieldsPrefix + 'firstname').val();
          surname = $('#' + sourceFieldsPrefix + 'surname').val();
          phone_number = $('#' + sourceFieldsPrefix + 'phone_number').val();
          street = $('#' + sourceFieldsPrefix + 'street').val();
          street_note = $('#' + sourceFieldsPrefix + 'street_note').val();
          city = $('#' + sourceFieldsPrefix + 'city').val();
          zip_code = $('#' + sourceFieldsPrefix + 'zip_code').val();
          $('#' + targetFieldsPrefix + 'firstname').val(firstname);
          $('#' + targetFieldsPrefix + 'surname').val(surname);
          $('#' + targetFieldsPrefix + 'phone_number').val(phone_number);
          $('#' + targetFieldsPrefix + 'street').val(street);
          $('#' + targetFieldsPrefix + 'street_note').val(street_note);
          $('#' + targetFieldsPrefix + 'city').val(city);
          $('#' + targetFieldsPrefix + 'zip_code').val(zip_code);
          return $('.js-pickup-bill-address').slideUp({
            duration: 300
          });
        } else {
          return $('.js-pickup-bill-address').slideDown({
            duration: 300
          });
        }
      });
      return $(document).on('keyup', function() {
        var city, firstname, phone_number, street, street_note, surname, zip_code;
        checkbox = $('#copy-addresses');
        if (checkbox.is(':checked')) {
          firstname = $('#' + sourceFieldsPrefix + 'firstname').val();
          surname = $('#' + sourceFieldsPrefix + 'surname').val();
          phone_number = $('#' + sourceFieldsPrefix + 'phone_number').val();
          street = $('#' + sourceFieldsPrefix + 'street').val();
          street_note = $('#' + sourceFieldsPrefix + 'street_note').val();
          city = $('#' + sourceFieldsPrefix + 'city').val();
          zip_code = $('#' + sourceFieldsPrefix + 'zip_code').val();
          $('#' + targetFieldsPrefix + 'firstname').val(firstname);
          $('#' + targetFieldsPrefix + 'surname').val(surname);
          $('#' + targetFieldsPrefix + 'phone_number').val(phone_number);
          $('#' + targetFieldsPrefix + 'street').val(street);
          $('#' + targetFieldsPrefix + 'street_note').val(street_note);
          $('#' + targetFieldsPrefix + 'city').val(city);
          return $('#' + targetFieldsPrefix + 'zip_code').val(zip_code);
        }
      });
    };

    Disputes.customerTypeOptions = function() {
      var customerTypes, vatPayer;
      customerTypes = $('[data-customer-types]');
      vatPayer = $('[data-vat-payer]');
      if (vatPayer.length) {
        vatPayerFields(vatPayer);
        vatPayer.change(function() {
          return vatPayerFields($(this));
        });
      }
      if ($('[data-customer-type]:checked').val() === 'private_person') {
        $('[data-company-fields]').hide();
      } else {
        $('[data-company-fields]').show();
      }
      return $('[data-customer-type]').change(function() {
        if (this.value === 'private_person') {
          return $('[data-company-fields]').slideUp(300);
        } else {
          return $('[data-company-fields]').slideDown(300);
        }
      });
    };

    vatPayerFields = function(vatPayer) {
      var that;
      that = this;
      if (vatPayer.is(':checked')) {
        $('[data-vat-code]').slideDown(300);
        return $("[data-vat-code] :input").prop("disabled", false);
      } else {
        $('[data-vat-code]').slideUp(300);
        return $("[data-vat-code] :input").prop("disabled", true);
      }
    };

    Disputes.checkSelectedOrderItem = function() {
      var $targetCollapse, $targetItem, itemId, params, url;
      url = window.location.href;
      params = new URLSearchParams(url.split('?')[1]);
      itemId = params.get('item');
      if (!itemId) {
        return;
      }
      $targetItem = $('[data-target="#order-item' + itemId + '"]');
      $targetCollapse = $('#order-item' + itemId);
      if ($targetItem.length) {
        $targetItem.parents('.collapse').collapse('show');
        $targetItem.find('input[type="checkbox"]').prop('checked', true);
        $('html, body').animate({
          scrollTop: $targetItem.offset().top - 200
        });
        if ($targetCollapse.length) {
          return $targetCollapse.collapse('show');
        }
      }
    };

    Disputes.validateDocumentTypes = function(validDocumentType, errors) {
      var errorHtml;
      if (validDocumentType === 'true') {
        return $('#invalid_document_type_errors .mzkr-alert').addClass('d-none');
      } else {
        errorHtml = errors.map(function(error) {
          return "<li>" + error + "</li>";
        }).join('');
        $('#invalid_document_type_errors .mzkr-alert').html(errorHtml);
        return $('#invalid_document_type_errors .mzkr-alert').removeClass('d-none');
      }
    };

    Disputes.fillCustomerAttributes = function(formName, customerAttributes) {
      var basicAttributes, copyDeliveryAdressCheckbox, copyPickUpAdressCheckbox, deliveryAttributes, key, pickupAttributes, results, value;
      copyPickUpAdressCheckbox = $('#copy-addresses');
      copyDeliveryAdressCheckbox = $('#copy-delivery-addresses');
      basicAttributes = customerAttributes.basic_attributes;
      deliveryAttributes = customerAttributes.delivery_attributes;
      pickupAttributes = customerAttributes.pickup_attributes;
      for (key in basicAttributes) {
        value = basicAttributes[key];
        $('input[name="' + formName + '[' + key + ']"]').val(value);
      }
      if (copyDeliveryAdressCheckbox.is(':checked')) {
        for (key in deliveryAttributes) {
          value = deliveryAttributes[key];
          $('input[name="' + formName + '[' + key + ']"]').val(value);
        }
      }
      if (copyPickUpAdressCheckbox.is(':checked')) {
        results = [];
        for (key in pickupAttributes) {
          value = pickupAttributes[key];
          results.push($('input[name="' + formName + '[' + key + ']"]').val(value));
        }
        return results;
      }
    };

    Disputes.showCustomerRegistrationBanner = function() {
      if ($('#customer_registration_required').val() === 'true') {
        return $('#registration-form-banner').removeClass('d-none');
      } else {
        return $('#registrationform-banner').addClass('d-none');
      }
    };

    Disputes.validateMandatoryRegistration = function(valid, customer_email) {
      if (valid === 'true') {
        $('#registration-form-banner').removeClass('d-none');
        return $('#customer_registration_email').val(customer_email);
      } else {
        return $('#registrationform-banner').addClass('d-none');
      }
    };

    return Disputes;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.DynamicContentLoader = (function() {
    function DynamicContentLoader() {
      PublicUtility.Widgets.initWidgetTabs();
      App.PublicProducts.productCollapsibleContent('.card-inner.collapsible');
    }

    DynamicContentLoader.initMiniBasket = function() {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        $('.js-basket-overview-trigger').on('mouseover', function() {
          var that;
          that = this;
          $('body').addClass('basket-overview-open');
          if (this.dataset.basketLoaded !== 'true' && this.dataset.basketEmpty !== 'true') {
            return $.ajax({
              type: 'GET',
              url: Routes.basket_overview_layout_path(),
              xhrFields: {
                withCredentials: true
              },
              dataType: 'json',
              success: function(data) {
                $('.basket-overview').html(data.html);
                that.dataset.basketLoaded = true;
                PublicUtility.Layout.toolTip();
                return PublicUtility.Layout.tooltipInLink($('.basket-overview'));
              }
            });
          }
        });
        $('.basket-overview').on('mouseleave', function() {
          return $('body').removeClass('basket-overview-open');
        });
        return $('.basket-overview-overlay').on('mouseover', function() {
          return $('body').removeClass('basket-overview-open');
        });
      }
    };

    DynamicContentLoader.loadContentInScope = function(scope, opts) {
      if (scope == null) {
        scope = document;
      }
      if (opts == null) {
        opts = {};
      }
      $('[data-dynamic-load-content]').each(function() {
        var method;
        method = $(this).data('dynamic-load-method');
        return PublicUtility.DynamicContentLoader[method]($(this).data('dynamic-load-path'), $(this), opts[method] || {});
      });
      return $('[data-scroll-load-content]').each(function() {
        var $this, $widgetTabs, elementIsInView, loadContent;
        $this = this;
        $widgetTabs = $(this).closest('.widget-tabs');
        elementIsInView = function(elem) {
          var docViewBottom, docViewTop, elemTop, elemTopWithOffset;
          docViewTop = $(window).scrollTop();
          docViewBottom = docViewTop + $(window).height();
          elemTopWithOffset = $(elem).offset().top - parseInt($(elem).data('scroll-load-offset') || 0);
          elemTop = $(elem).offset().top;
          return (elemTopWithOffset <= docViewBottom && elemTopWithOffset >= docViewTop) || (elemTop <= docViewBottom && elemTop >= docViewTop);
        };
        loadContent = function() {
          var method, targetElem;
          targetElem = $widgetTabs.length > 0 ? $widgetTabs[0] : $this;
          if (elementIsInView(targetElem) && !$($this).data('scroll-load-loaded')) {
            $($this).data('scroll-load-loaded', true);
            method = $($this).data('scroll-load-method');
            return PublicUtility.DynamicContentLoader[method]($($this).data('scroll-load-path'), $($this), opts[method] || {});
          }
        };
        $(window).scroll(loadContent);
        return loadContent();
      });
    };

    DynamicContentLoader.benefits = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          $('#benefits').html(data.html);
          PublicUtility.ProductList.initBoughtAt();
          App.PublicProducts.productCollapsibleContent('.card-inner.collapsible');
          new PublicUtility.Analytics('#benefits');
          return $(document.body).trigger('sticky_kit:recalc');
        }
      });
    };

    DynamicContentLoader.testimonials = function(path, elem, opts) {
      if (opts.disable) {
        return;
      }
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          if (data.status === 200) {
            elem.html(data.html);
            PublicUtility.Carousel.initTestimonialCarousel(elem);
            return PublicUtility.Layout.toolTip();
          }
        }
      });
    };

    DynamicContentLoader.productQuestions = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'script',
        cache: true,
        ajaxSend: function() {
          return $("#product-questions .product-questions-spinner").show();
        }
      });
    };

    DynamicContentLoader.productTabs = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'script',
        cache: true
      });
    };

    DynamicContentLoader.productDocuments = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'script',
        cache: true
      });
    };

    DynamicContentLoader.filterRecommendations = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          $('#filter_recommendations').html(data.html);
          new PublicUtility.Carousel('#filter_recommendations');
          new PublicUtility.Analytics('#filter_recommendations');
          return PublicUtility.ProductList.initBoughtAt();
        }
      });
    };

    DynamicContentLoader.dynamicNodesAndProducts = function(path) {
      return App.PublicCmsSitemapNodesDynamicNodesAndProducts.loadData(path);
    };

    DynamicContentLoader.productDetailRecommendations = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          $('#product_detail_recommendations').html(data.html);
          new PublicUtility.Carousel('#product_detail_recommendations');
          new PublicUtility.Analytics('#product_detail_recommendations');
          PublicUtility.SimilarProducts.initCompareSimilarProducts();
          PublicUtility.WishList.initInWishList();
          PublicUtility.ProductList.initBoughtAt();
          PublicUtility.Layout.deferLuigisScan('#product_recommended_annotation', '#product_recommended_results');
          App.PublicProducts.positionAlternativesProducts();
          return PublicUtility.Layout.toolTip();
        }
      });
    };

    DynamicContentLoader.productDetailRecommendationsComplements = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          $('#product_detail_recommendations').html(data.html);
          new PublicUtility.Carousel('#product_detail_recommendations');
          new PublicUtility.Analytics('#product_detail_recommendations');
          PublicUtility.SimilarProducts.initCompareSimilarProducts();
          PublicUtility.WishList.initInWishList();
          PublicUtility.ProductList.initBoughtAt();
          PublicUtility.Layout.deferLuigisScan('#product_recommended_annotation', '#product_recommended_results');
          App.PublicProducts.positionComplementsProducts();
          return PublicUtility.Layout.toolTip();
        }
      });
    };

    DynamicContentLoader.basketExtraGiftRecommendations = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          return $('#basket_extra_gift_recommendations').html(data.html);
        }
      });
    };

    DynamicContentLoader.groupSelector = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          var groupSelectorSection;
          if (data) {
            $('#group_selector').html(data.html);
            groupSelectorSection = $('#group_selector_section');
            if (groupSelectorSection.length) {
              return new PublicUtility.ProductGroupSelector(groupSelectorSection);
            }
          }
        }
      });
    };

    DynamicContentLoader.homeRecommendations = function(path) {
      if (!Cookies.get('visited_products')) {
        return;
      }
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          $('#home_recommendations').html(data.html);
          return new PublicUtility.Carousel('#home_recommendations');
        }
      });
    };

    DynamicContentLoader.widgetProducts = function(path, elem) {
      return PublicUtility.Widgets.loadWidgetProducts(path, elem);
    };

    DynamicContentLoader.widgetRecommendationsProducts = function(path) {
      return PublicUtility.Widgets.loadWidgetRecommendationsProducts(path);
    };

    DynamicContentLoader.widgetRecommendationsSitemapNodes = function(path) {
      return PublicUtility.Widgets.loadWidgetRecommendationsSitemapNodes(path);
    };

    DynamicContentLoader.countrySelector = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'script',
        success: function(data) {
          return data;
        }
      });
    };

    return DynamicContentLoader;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.ExternalSearch = (function() {
    function ExternalSearch() {}

    ExternalSearch.loadComponents = function() {
      PublicUtility.ProductList.initFilterSearch();
      PublicUtility.ExternalSearch.initLugisProductsCount();
      PublicUtility.ExternalSearch.convertAnalyticsTrack();
      PublicUtility.ExternalSearch.checkQueryPhrase();
      PublicUtility.ExternalSearch.noResultForm();
      PublicUtility.ExternalSearch.nextPageClick();
      PublicUtility.ExternalSearch.initSearchSorting();
      PublicUtility.Layout.addToBasketListener();
      PublicUtility.ProductList.initStickyFilters();
      return setTimeout(function() {
        return PublicUtility.Carousel.initRecomendedCarousel();
      }, 100);
    };

    ExternalSearch.convertAnalyticsTrack = function() {
      return new PublicUtility.Analytics('.product-list');
    };

    ExternalSearch.initLugisProductsCount = function() {
      var paginate_count;
      paginate_count = I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.paginate_count', {
        from: 1,
        to: $('.js-products-wrap .product-tile').length,
        total_count: $('.paginate-count').attr('data-hits-count')
      });
      return $('.paginate-count').text(paginate_count);
    };

    ExternalSearch.checkQueryPhrase = function() {
      if (window.queryPhrase !== window.oldQueryPhrase) {
        window.lb_counter = 1;
        window.oldQueryPhrase = window.queryPhrase;
        return new PublicUtility.Analytics('[data-search-event-analytics]');
      }
    };

    ExternalSearch.noResultForm = function() {
      var $form;
      $form = $('#noResultForm');
      return $form.on('submit', function(e) {
        var handle200, handle400, validEmail, validTextarea;
        e.preventDefault();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($('input[name="mail"]', $form).val())) {
          $('input[name="mail"]', $form).removeClass('is-invalid');
          validEmail = true;
        } else {
          $('input[name="mail"]', $form).addClass('is-invalid');
          validEmail = false;
        }
        if ($('textarea', $form).val().length) {
          $('textarea', $form).removeClass('is-invalid');
          validTextarea = true;
        } else {
          $('textarea', $form).addClass('is-invalid');
          validTextarea = false;
        }
        if (validEmail && validTextarea) {
          handle200 = function(data, textStatus, jqXHR) {
            $('.lb-container').prepend('<div class="alert alert-success">' + I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.message_sent') + '</div>');
            $('.btn-primary', $form).removeClass('btn-primary').addClass('btn-success').html('<i class="fas fa-check"></i> <span> ' + I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.sent') + ' </span>').attr('disabled', 'true');
            $('textarea, input', $form).each(function() {
              $(this).val('');
              return $(this).removeClass('is-invalid');
            });
            $('html, body').animate({
              scrollTop: 0
            }, 0);
            return setTimeout(function() {
              $('.alert', '.lb-container').remove();
              $('.btn-success', $form).html(I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.send'));
              return $('.btn-success', $form).addClass('btn-primary').removeClass('btn-success').removeAttr('disabled');
            }, 4000);
          };
          handle400 = function(jqXHR, textStatus, errorThrown) {
            return $('.btn-primary', $form).after('<div class="text-danger my=3">' + I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.something_wrong') + '</div>');
          };
          return $.ajax({
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            url: $form.data('external-search-form-url'),
            data: JSON.parse(JSON.stringify($form.data('external-search-form-params')).replaceAll('{EMAIL}', $(this).find('input[type=email]').val()).replaceAll('{COMMENT}', $(this).find('textarea').val())),
            statusCode: {
              200: handle200,
              201: handle200,
              400: handle400,
              404: handle400
            }
          });
        }
      });
    };

    ExternalSearch.nextPageClick = function() {
      if (window.lbScroll) {
        $('html, body').animate({
          scrollTop: window.lbScroll
        }, 0);
      }
      $(document).off('click.lb-next', '.lb-pagination__next');
      return $(document).on({
        'click.lb-next': function() {
          return window.lbScroll = $(window).scrollTop();
        }
      }, '.lb-pagination__next');
    };

    ExternalSearch.initSearchSorting = function() {
      var selectedItemText;
      selectedItemText = $('.sortby-dropdown .sortby-dropdown__item--active').text();
      $('.sortby-dropdown__placeholder').text(selectedItemText);
      $(document).off('click', '.sortby-dropdown__item');
      $(document).on('click', '.sortby-dropdown__item', function() {
        $('.sortby-dropdown__placeholder').text($(this).text());
        return $('.sortby-dropdown__menu').removeClass('sortby-dropdown__menu--open');
      });
      $(document).off('click', '.sortby-dropdown__placeholder');
      $(document).on('click', '.sortby-dropdown__placeholder', function() {
        if ($('.sortby-dropdown__menu').hasClass('sortby-dropdown__menu--open')) {
          return $('.sortby-dropdown__menu').removeClass('sortby-dropdown__menu--open');
        } else {
          return $('.sortby-dropdown__menu').addClass('sortby-dropdown__menu--open');
        }
      });
      return $(document).on('click', function(e) {
        if (!$(e.target).hasClass('sortby-dropdown__placeholder')) {
          return $('.sortby-dropdown__menu').removeClass('sortby-dropdown__menu--open');
        }
      });
    };

    return ExternalSearch;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.FilterBanner = (function() {
    function FilterBanner() {}

    FilterBanner.initFilterBanner = function(filter_banner, moreProducts) {
      var $filterBanner, $listingTiles, bannerPositions, invisibleTiles, maxPositions, newFilterBanner, position;
      $('.filter-banner-wrapper').html(filter_banner);
      $filterBanner = $('.filter-banner-wrapper .filter-banner');
      if ($filterBanner.length) {
        $listingTiles = moreProducts ? moreProducts : $('.js-products-wrap > div');
        if ($listingTiles.length > 13) {
          maxPositions = 20;
          if ($listingTiles.length + 1 < maxPositions) {
            maxPositions = $listingTiles.length - 1;
          }
          bannerPositions = Array.from(Array(maxPositions - 11).keys()).filter(function(f) {
            return ((f % 3 === 0) || (f % 3 === 1)) && (f % 2 === 0);
          });
          position = bannerPositions[Math.floor(Math.random() * bannerPositions.length)] + 12;
          $($listingTiles[position - 1]).after($filterBanner.clone());
          newFilterBanner = $('.js-products-wrap .filter-banner').last();
          invisibleTiles = $('<div class="' + newFilterBanner.next().attr('class') + '"></div>');
          invisibleTiles.removeClass('mzkr-d-flex').addClass('mzkr-d-none');
          newFilterBanner.after(invisibleTiles);
          newFilterBanner.removeClass('mzkr-d-none').addClass('mzkr-d-flex');
          newFilterBanner.children().first().attr('data-analytics-track', '');
        }
        return new PublicUtility.Analytics('.js-products-wrap .filter-banner');
      }
    };

    return FilterBanner;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.FilterPagination = (function() {
    var getFilterData, getFilterParams, reRender, scrollToElement;

    function FilterPagination() {}

    FilterPagination.handlePaginate = function() {
      var $loadMore, $paginationWrapper, $titleWrapper, baseUrl;
      $titleWrapper = $('.js-title');
      $paginationWrapper = $('.js-pagination');
      $loadMore = $paginationWrapper.find('.load-next-page');
      baseUrl = $('.js-filter-pagination-wrapper').data('base-url');
      $paginationWrapper.find('.paginate-previous-page, .paginate-next-page').on('click', function(e) {
        var currentPage, direction, newPage;
        e.preventDefault();
        direction = $(this).data('direction');
        currentPage = $paginationWrapper.find('.paginate-pages').data('current-page');
        if (direction === 'prev') {
          newPage = currentPage - 1;
        } else {
          newPage = currentPage + 1;
        }
        reRender(baseUrl, Object.assign({}, {
          page: newPage
        }, getFilterParams()));
        return scrollToElement($titleWrapper);
      });
      $paginationWrapper.find('.js-go-to-page, .js-current-page').on('click', function(e) {
        var newPage;
        e.preventDefault();
        newPage = $(this).data('page-number');
        reRender(baseUrl, Object.assign({}, {
          page: newPage
        }, getFilterParams()));
        return scrollToElement($titleWrapper);
      });
      $loadMore.on('click', function(e) {
        var currentPage, newPage;
        e.preventDefault();
        currentPage = $paginationWrapper.find('.paginate-pages').data('current-page');
        newPage = currentPage + 1;
        return reRender(baseUrl, Object.assign({}, {
          page: newPage,
          load_more: true
        }, getFilterParams()));
      });
      return $paginationWrapper.find('.paginate-previous-page, .paginate-next-page, .load-next-page, .js-go-to-page').each(function() {
        var link, urlObject;
        link = $(this).attr('href');
        if (link === '#') {
          return;
        }
        urlObject = new URL(link);
        urlObject.searchParams["delete"]('_');
        urlObject.searchParams["delete"]('load_more');
        return $(this).attr('href', urlObject.toString());
      });
    };

    reRender = function(url, data, stateUrl) {
      var filterData, key, urlObject, value;
      $.ajax({
        data: data,
        type: 'GET',
        dataType: 'script',
        url: url
      });
      urlObject = new URL(stateUrl || window.location.href);
      if (data.page) {
        urlObject.searchParams.set('page', data.page);
      }
      filterData = getFilterData(data);
      if (filterData) {
        for (key in filterData) {
          value = filterData[key];
          urlObject.searchParams.set(key, value);
          if (!value) {
            urlObject.searchParams["delete"](key);
          }
        }
      }
      return window.history.pushState({}, '', urlObject.toString());
    };

    scrollToElement = function(element) {
      var elementHeight, navHeight, offset, windowHeight;
      navHeight = $('#main-nav').height();
      elementHeight = element.height();
      windowHeight = $(window).height();
      if ($(window).width() < 769) {
        offset = Math.min(elementHeight, windowHeight) - navHeight + element.offset().top - 80;
      } else {
        offset = Math.min(elementHeight, windowHeight) - navHeight + element.offset().top - 130;
      }
      return $('html, body').animate({
        scrollTop: offset
      }, 500);
    };

    FilterPagination.handleCategories = function() {
      var $categories, $categoriesWrapper, $titleWrapper;
      $titleWrapper = $('.js-title');
      $categoriesWrapper = $('.categories-wrapper');
      $categories = $categoriesWrapper.find('.category-pill');
      return $categories.on('click', function(e) {
        var queryParameters, stateUrl, url;
        e.preventDefault();
        $categories.removeClass('mzkr-label--active');
        $(this).addClass('mzkr-label--active');
        url = $(this).attr('href');
        stateUrl = new URL(url, window.location.origin);
        queryParameters = {};
        if ($categoriesWrapper.data('refresh-filters')) {
          queryParameters['refresh_filters'] = true;
        }
        reRender(url, queryParameters, stateUrl.toString());
        return scrollToElement($titleWrapper);
      });
    };

    FilterPagination.handleFilters = function() {
      $('.js-clear-filters').on('click', function() {
        var baseUrl, url;
        baseUrl = $('.js-filter-pagination-wrapper').data('base-url');
        url = new URL(baseUrl, window.location.origin);
        return reRender(url, {
          refresh_filters: true
        }, url);
      });
      return $('.js-filters select').each(function() {
        return $(this).on('change', function() {
          var $paginationWrapper, additionalParameters, baseUrl, currentPage, filterName, urlObject;
          $paginationWrapper = $('.js-pagination');
          baseUrl = $('.js-filter-pagination-wrapper').data('base-url');
          currentPage = $paginationWrapper.find('.paginate-pages').data('current-page');
          filterName = $(this).data('filter-type');
          additionalParameters = {};
          additionalParameters[filterName] = $(this).val();
          urlObject = new URL(window.location.href);
          urlObject.searchParams["delete"]('page');
          return reRender(baseUrl, getFilterParams(additionalParameters), urlObject.toString());
        });
      });
    };

    getFilterParams = function(additionalParameters) {
      var entries, url;
      if (additionalParameters == null) {
        additionalParameters = {};
      }
      url = new URL(window.location.href);
      entries = Array.from(url.searchParams.entries()).reduce(function(obj, arg) {
        var key, value;
        key = arg[0], value = arg[1];
        obj[key] = value;
        return obj;
      }, {});
      return Object.assign({}, getFilterData(entries), additionalParameters);
    };

    getFilterData = function(data) {
      var filterTypes;
      filterTypes = $(".js-filters [data-filter-type]").map(function() {
        return $(this).data("filter-type");
      }).get();
      return Object.fromEntries(Object.entries(data).filter(function(arg) {
        var _, key;
        key = arg[0], _ = arg[1];
        return filterTypes.includes(key);
      }));
    };

    return FilterPagination;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.GoogleMaps = (function() {
    function GoogleMaps($mapWrapper) {
      var that;
      that = this;
      this.markers = [];
      this.myPositionMarker = null;
      this.markerCluster = null;
      this.deliveryPoints = [];
      this.activeMarker = null;
      this.myPosition = null;
      this.map = null;
      this.fitBoundsZoom = false;
      this.maxZoomForLargeClusters = 5000;
      if (window.apiLoaded) {
        this.map = new google.maps.Map($mapWrapper[0], {
          mapTypeControl: false,
          gestureHandling: 'greedy',
          fullscreenControl: false,
          streetViewControl: false,
          styles: [
            {
              featureType: 'poi',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            }
          ]
        });
        this.bounds = new google.maps.LatLngBounds;
      } else {
        that.mapNotLoaded($mapWrapper);
      }
    }

    GoogleMaps.prototype.addMarker = function(deliveryPoint, image) {
      var icon, marker, that;
      that = this;
      icon = {
        url: image,
        scaledSize: new google.maps.Size(27, 38)
      };
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(deliveryPoint.latitude, deliveryPoint.longitude),
        map: this.map,
        icon: icon,
        deliveryPointCode: deliveryPoint.code
      });
      this.markers.push(marker);
      this.bounds.extend(marker.position);
      return marker;
    };

    GoogleMaps.prototype.initClusterer = function() {
      var algorithm, clusterClick, clusterIcon, clusterImageUrl, clusterRenderer, that;
      that = this;
      clusterImageUrl = $('[data-cluster-image]').data('cluster-image');
      clusterIcon = {
        url: clusterImageUrl,
        scaledSize: new google.maps.Size(50, 50)
      };
      clusterRenderer = {
        render: function(cluster, stats) {
          return new google.maps.Marker({
            label: {
              text: String(cluster.count),
              color: 'black',
              fontSize: '10px',
              fontWeight: 'bold'
            },
            position: cluster.position,
            height: 50,
            width: 50,
            icon: clusterIcon
          });
        }
      };
      clusterClick = function(e, cluster, map) {
        map.setCenter(cluster.position);
        return map.setZoom(map.getZoom() + 2);
      };
      algorithm = new markerClusterer.GridAlgorithm({
        gridSize: 60
      });
      return this.markerCluster = new markerClusterer.MarkerClusterer({
        markers: this.markers,
        map: this.map,
        renderer: clusterRenderer,
        onClusterClick: clusterClick,
        algorithm: algorithm
      });
    };

    GoogleMaps.prototype.addMarkersToClusterer = function(markers) {
      if (this.markerCluster) {
        return this.markerCluster.addMarkers(markers);
      }
    };

    GoogleMaps.prototype.mapNotLoaded = function($mapWrapper) {
      return $mapWrapper.siblings('.map-message').removeClass('d-none');
    };

    GoogleMaps.prototype.centerByBounds = function() {
      var that;
      that = this;
      if (that.deliveryPoints.length) {
        return setTimeout((function() {
          var setZoom;
          that.map.fitBounds(that.bounds);
          if (that.fitBoundsZoom && (that.map.getZoom() < 12)) {
            that.map.setZoom(that.map.getZoom() + 2);
            return that.fitBoundsZoom = false;
          } else if (that.deliveryPoints.length > that.maxZoomForLargeClusters) {
            setZoom = that.map.getZoom() < 8 ? 8 : that.map.getZoom();
            return that.map.setZoom(setZoom);
          }
        }), 1);
      }
    };

    GoogleMaps.setPositionCookie = function(deliveryMethodId, deliveryPointPosition, lastPosition) {
      var parsedPositionCookie, positionCookie;
      if (deliveryPointPosition == null) {
        deliveryPointPosition = null;
      }
      if (lastPosition == null) {
        lastPosition = null;
      }
      positionCookie = Cookies.get("deliveryMethodPosition" + deliveryMethodId);
      if (positionCookie) {
        parsedPositionCookie = JSON.parse(positionCookie);
        if (deliveryPointPosition) {
          parsedPositionCookie.deliveryPointPosition = deliveryPointPosition;
        }
        if (lastPosition) {
          parsedPositionCookie.lastPosition = lastPosition;
        }
        positionCookie = parsedPositionCookie;
      } else {
        positionCookie = {
          deliveryPointPosition: deliveryPointPosition,
          lastPosition: lastPosition
        };
      }
      return Cookies.set("deliveryMethodPosition" + deliveryMethodId, JSON.stringify(positionCookie), {
        secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
      });
    };

    GoogleMaps.getPositionFromCookie = function(deliveryMethod) {
      var knownPosition, parsedPositionCookie, positionCookie, that;
      that = this;
      positionCookie = Cookies.get("deliveryMethodPosition" + deliveryMethod.deliveryMethodId);
      if (positionCookie) {
        parsedPositionCookie = JSON.parse(positionCookie);
        knownPosition = null;
        if (parsedPositionCookie.deliveryPointPosition) {
          knownPosition = parsedPositionCookie.deliveryPointPosition;
          return that.myPosition = new google.maps.LatLng(knownPosition.lat, knownPosition.lng);
        } else if (parsedPositionCookie.lastPosition) {
          knownPosition = parsedPositionCookie.lastPosition;
          return that.myPosition = new google.maps.LatLng(knownPosition.lat, knownPosition.lng);
        } else {
          return null;
        }
      }
    };

    GoogleMaps.prototype.setKnownPosition = function(deliveryMethod) {
      var knownPosition, parsedPositionCookie, positionCookie, that;
      that = this;
      positionCookie = Cookies.get("deliveryMethodPosition" + deliveryMethod.deliveryMethodId);
      if (positionCookie) {
        parsedPositionCookie = JSON.parse(positionCookie);
        knownPosition = null;
        if (parsedPositionCookie.deliveryPointPosition) {
          knownPosition = parsedPositionCookie.deliveryPointPosition;
        } else if (parsedPositionCookie.lastPosition) {
          knownPosition = parsedPositionCookie.lastPosition;
        } else {
          deliveryMethod.googleMap.setMyPosition(deliveryMethod);
          return;
        }
        that.myPosition = new google.maps.LatLng(knownPosition.lat, knownPosition.lng);
        deliveryMethod.sortDeliveryPointsByLocation();
        $('.js-loading-position-info').addClass('d-none');
        return setTimeout((function() {
          that.map.setZoom(14);
          return that.map.panTo(that.myPosition);
        }), 100);
      } else {
        return deliveryMethod.googleMap.setMyPosition(deliveryMethod);
      }
    };

    GoogleMaps.getKnownPosition = function(deliveryMethod) {
      var that;
      that = this;
      that.myPosition = that.myPosition ? that.myPosition : null;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((function(position) {
          var pos;
          pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          Utility.GoogleMaps.setPositionCookie(deliveryMethod.deliveryMethodId, null, pos);
          return that.myPosition = new google.maps.LatLng(pos.lat, pos.lng);
        }), function() {
          Utility.GoogleMaps.getPositionFromCookie(deliveryMethod);
          return Utility.GoogleMaps.handleLocationError(true);
        });
      } else {
        Utility.GoogleMaps.getPositionFromCookie(deliveryMethod);
        Utility.GoogleMaps.handleLocationError(false);
      }
      return that.myPosition;
    };

    GoogleMaps.saveUserGeoLocation = function(position) {
      var that;
      that = this;
      return that.myPosition = new google.maps.LatLng(position.lat, position.lng);
    };

    GoogleMaps.prototype.setMyPosition = function(deliveryMethod) {
      var that;
      that = this;
      $('.geolocation-info').each(function() {
        return $(this).html('');
      });
      if (navigator.geolocation) {
        return navigator.geolocation.getCurrentPosition((function(position) {
          var pos;
          pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          Utility.GoogleMaps.setPositionCookie(deliveryMethod.deliveryMethodId, null, pos);
          that.myPosition = new google.maps.LatLng(pos.lat, pos.lng);
          deliveryMethod.sortDeliveryPointsByLocation();
          $('.js-loading-position-info').addClass('d-none');
          setTimeout((function() {
            that.myPositionMarker = new google.maps.Marker({
              position: that.myPosition,
              map: that.map
            });
            that.map.setZoom(14);
            return that.map.panTo(that.myPositionMarker.getPosition());
          }), 100);
          return $('.js-set-location i').removeClass('fal fa-circle-notch fa-spin').addClass('fas fa-location');
        }), function() {
          return Utility.GoogleMaps.handleLocationError(true);
        });
      } else {
        return Utility.GoogleMaps.handleLocationError(false);
      }
    };

    GoogleMaps.handleLocationError = function(browserHasGeolocation) {
      $('.js-set-location i').removeClass('fal fa-circle-notch fa-spin').addClass('fas fa-location');
      $('.js-loading-position-info').addClass('d-none');
      if (browserHasGeolocation) {
        return $('.geolocation-info').each(function() {
          return $(this).html("<div> (" + (I18n.t("js.public.shop.delivery_and_payment_methods.show.location_disabled")) + ") </div>");
        });
      } else {
        $('.js-set-location').attr('disabled', true).addClass('disabled');
        return $('.geolocation-info').each(function() {
          return $(this).html("<div> (" + (I18n.t("js.public.shop.delivery_and_payment_methods.show.unsupported_browser")) + ") </div>");
        });
      }
    };

    GoogleMaps.prototype.showActiveMarkerOnMap = function(marker, deliveryMethod, setZoom) {
      var icon, that;
      that = this;
      if (setZoom) {
        this.map.setZoom(18);
      }
      this.map.panTo(marker.getPosition());
      if (this.activeMarker) {
        icon = {
          url: deliveryMethod.markerImage,
          scaledSize: new google.maps.Size(27, 38)
        };
        this.activeMarker.setIcon(icon);
        this.activeMarker.setMap(this.map);
      }
      icon = {
        url: deliveryMethod.selectedMarkerImage,
        scaledSize: new google.maps.Size(38, 50)
      };
      marker.setIcon(icon);
      return this.activeMarker = marker;
    };

    GoogleMaps.prototype.resetMarkers = function() {
      var i, len, marker, ref;
      ref = this.markers;
      for (i = 0, len = ref.length; i < len; i++) {
        marker = ref[i];
        marker.setMap(null);
      }
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }
      this.markers = [];
      return this.bounds = new google.maps.LatLngBounds();
    };

    return GoogleMaps;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Layout = (function() {
    function Layout() {
      this.init();
      return this;
    }

    Layout.prototype.init = function() {
      PublicUtility.LoadSentry.initSentry();
      this.initPasiveScrollListener();
      new PublicUtility.DynamicContentLoader();
      new PublicUtility.Analytics();
      new PublicUtility.Carousel();
      new PublicUtility.Search();
      new PublicUtility.WebpushNotification();
      new PublicUtility.CookiesConsent();
      new Mzkr.Accordion();
      new Mzkr.Tabs();
      new Mzkr.Modal();
      Mzkr.Breadcrumb.init();
      PublicUtility.Layout.initInScope();
      this.polyfillFunctions();
      this.initMomentFormat();
      this.initTargetButtons();
      this.dynamicFields();
      this.initDestroyButton();
      PublicUtility.Layout.stickyInit();
      this.submitBtnInit();
      this.initBanners();
      this.discountTimer();
      this.bannersShow();
      this.popupModal();
      this.clearEmptyElements();
      this.initDataConfirmModal();
      PublicUtility.SimilarProducts.initCompareSimilarProducts();
      this.initFormSubmitOnSelectSet();
      this.cacheboxToggler();
      this.initCopyToClipboard();
      this.shareComponent();
      PublicUtility.Layout.addToBasketListener();
      PublicUtility.Layout.restrictInputCharacters();
      this.collapseCountries();
      this.deferLbAutocomplete();
      this.passwordVisibilityControl();
      this.initTurboFrameMissingBehaviour();
      PublicUtility.Layout.setModalBannerPosition();
      this.showCategoryDescription();
      this.internationalBar();
      this.internationalModal();
      this.tilesMoreBtn();
      PublicUtility.Layout.initApplyCampaignCouponLink();
      PublicUtility.ProductQuestions.reactionsInit();
      this.hideSkeletonLoading();
      return PublicUtility.Layout.initBasketItemsSidebar();
    };

    Layout.initInScope = function(scope) {
      if (scope == null) {
        scope = document;
      }
      PublicUtility.Layout.initSelect(scope);
      PublicUtility.Layout.initDatepicker(scope);
      PublicUtility.Layout.initDatetimepicker(scope);
      PublicUtility.PhoneNormalize.initPhoneLib(scope);
      PublicUtility.Layout.initStarRating(scope);
      PublicUtility.Layout.fileBrowse(scope);
      PublicUtility.Layout.toolTip();
      return PublicUtility.Layout.tooltipInLink(scope);
    };

    Layout.initGallerySlider = function() {
      return $('#gallery-slider').lightSlider({
        item: 6,
        loop: true,
        pager: false,
        slideMargin: 0,
        enableDrag: true,
        currentPagerPosition: 'left',
        controls: true,
        addClass: 'slider-shop',
        responsive: [
          {
            breakpoint: 576,
            settings: {
              item: 3
            }
          }
        ],
        onSliderLoad: function(el) {
          return lightGallery(el[0], {
            selector: '#gallery-slider .lslide',
            plugins: [lgThumbnail, lgZoom],
            download: false,
            toggleThumb: true,
            mobileSettings: {
              controls: true,
              showCloseIcon: true
            }
          });
        }
      });
    };

    Layout.checkScrollText = function(scope) {
      var $scrollInner, animation, scrollInner, scrollText, time, timeDelay, timeScroll, timeSecond;
      if (scope == null) {
        scope = document;
      }
      scrollInner = $('.scroll-inner').width();
      scrollText = $('.scroll-text');
      if (!scrollText.length) {
        return;
      }
      if (scrollText.width() > scrollInner) {
        scrollText.removeClass('active');
        scrollText.removeClass('scrolling');
        $('.scroll-inner').css('animation', 'none');
      } else if (scrollText[0].scrollWidth > scrollText.innerWidth()) {
        scrollText.addClass('active');
        if (!scrollText.hasClass('scrolling')) {
          scrollInner = $('.scroll-inner').width();
          scrollText = $('.scroll-text');
          time = scrollInner / 65;
          timeScroll = $('.scroll-text').width() / 65;
          timeSecond = time + timeScroll;
          timeDelay = time + 3;
          animation = 'firstmarquee ' + time + 's linear 3s, marquee ' + timeSecond + 's linear ' + timeDelay + 's infinite';
          $scrollInner = $('.scroll-inner').css('animation', 'none');
          setTimeout(function() {
            return $scrollInner.css('animation', animation);
          });
        }
        scrollText.addClass('scrolling');
      }
      return scrollText.removeClass('invisible');
    };

    Layout.prototype.initBanners = function() {
      if ($('.nav-top-banner').length) {
        PublicUtility.Layout.checkScrollText();
        return $(window).resize(function() {
          return PublicUtility.Layout.checkScrollText();
        });
      }
    };

    Layout.initStarRating = function(scope) {
      if (scope == null) {
        scope = document;
      }
      $('.rating-widget').each(function() {
        var i, results, starInput, starsInput;
        starInput = $(this).parent().find('input').attr('value') / 20;
        starsInput = $(this).find('.star');
        if (starInput >= 1) {
          i = 0;
          results = [];
          while (i < starInput) {
            $(starsInput[i]).addClass('selected');
            results.push(i++);
          }
          return results;
        }
      });
      $(document).on('mouseover', '.stars:not(.disabled) .star', function() {
        var onStar;
        onStar = parseInt($(this).data('value'), 10);
        return $(this).closest('.stars').find('.star').each(function(e) {
          if (e < onStar) {
            return $(this).addClass('hover');
          } else {
            return $(this).removeClass('hover');
          }
        });
      });
      $(document).on('mouseout', '.stars:not(.disabled) .star', function() {
        return $(this).closest('.stars').find('.star').each(function(e) {
          return $(this).removeClass('hover');
        });
      });
      return $(document).on('click', '.stars:not(.disabled) .star', function() {
        var i, onStar, ratingValue, stars;
        onStar = parseInt($(this).data('value'), 10);
        stars = $(this).parent().children('.star');
        i = 0;
        while (i < stars.length) {
          $(stars[i]).removeClass('selected');
          i++;
        }
        i = 0;
        while (i < onStar) {
          $(stars[i]).addClass('selected');
          i++;
        }
        ratingValue = parseInt($(this).data('value'), 10);
        if (ratingValue >= 1) {
          return $(this).closest('.rating-widget').parent().find('input').attr('value', ratingValue * 20);
        }
      });
    };

    Layout.initSelect = function(scope) {
      var defaultSelect2Options, sortSelect2Options;
      if (scope == null) {
        scope = document;
      }
      defaultSelect2Options = {
        allowClear: true,
        placeholder: I18n.t('js.select2.placeholder'),
        width: '100%'
      };
      sortSelect2Options = {
        allowClear: false,
        minimumResultsForSearch: -1
      };
      $(scope).find('.dataTables_wrapper select').addClass('no-select2');
      $(scope).find('select:not(.no-select2):not(.select2-hidden-accessible):not([data-ajax-select])').each(function() {
        var modalSelect2Options;
        if ($(this).closest('#modal-container').length) {
          modalSelect2Options = {
            placeholder: I18n.t('js.select2.placeholder'),
            width: 'element',
            dropdownParent: $(this).closest('.mzkr-modal')
          };
          return $(this).select2(modalSelect2Options);
        } else {
          return $(this).select2(defaultSelect2Options);
        }
      });
      $(scope).find('select.select-sort').select2(sortSelect2Options);
      PublicUtility.Select.fixEnter($(scope).find('.select2-hidden-accessible'));
      $(scope).find('[data-ajax-select]').each(function() {
        var $this, options, url;
        $this = $(this);
        options = {};
        if ($this.attr('multiple') === 'multiple') {
          options.multiple = true;
        }
        url = function() {
          return $this.data('ajax-select');
        };
        return PublicUtility.Select.ajaxSelect($this, url, options);
      });
      if (!/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        return $(document).on('select2:open', function(e) {
          var searchField;
          searchField = document.querySelector("[aria-controls='select2-" + e.target.id + "-results']");
          if (searchField != null) {
            return searchField.focus();
          }
        });
      }
    };

    Layout.initDatepicker = function(scope) {
      var format_date;
      if (scope == null) {
        scope = document;
      }
      format_date = moment.localeData().longDateFormat('l');
      return $(scope).find('[data-provide=datepicker]').each(function() {
        var date, dayOfWeek, obj;
        obj = $(this);
        if (obj.data('disable-weekend')) {
          date = moment().add(2, 'days');
          dayOfWeek = date.day();
          if (dayOfWeek === 6) {
            date = date.add(2, 'days');
          } else if (dayOfWeek === 0) {
            date = date.add(1, 'days');
          }
          return obj.datetimepicker({
            daysOfWeekDisabled: [0, 6],
            locale: I18n.locale,
            format: format_date,
            minDate: date,
            defaultDate: date
          });
        } else {
          date = moment(obj.val(), format_date).toDate();
          return obj.datetimepicker({
            locale: I18n.locale,
            format: format_date,
            date: date
          });
        }
      });
    };

    Layout.initDatetimepicker = function(scope) {
      var format_datetime;
      if (scope == null) {
        scope = document;
      }
      format_datetime = moment.localeData().longDateFormat('l') + ' ' + moment.localeData().longDateFormat('LT');
      return $(scope).find('[data-provide=datetimepicker]').each(function() {
        var datetime, obj;
        obj = $(this);
        datetime = moment(obj.val(), format_datetime);
        return obj.datetimepicker({
          locale: I18n.locale,
          format: format_datetime,
          date: datetime
        });
      });
    };

    Layout.prototype.polyfillFunctions = function() {

      /**
       * Element.closest() polyfill
       * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
       */
      if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
        Element.prototype.closest = function(s) {
          var ancestor, el;
          el = this;
          ancestor = this;
          if (!document.documentElement.contains(el)) {
            return null;
          }
          while (true) {
            if (ancestor.matches(s)) {
              return ancestor;
            }
            ancestor = ancestor.parentElement;
            if (ancestor === null) {
              break;
            }
          }
          return null;
        };
      }

      /**
       * Element.matches() polyfill (simple version)
       * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
       */
      if (!Element.prototype.matches) {
        return Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }
    };

    Layout.prototype.initMomentFormat = function() {
      if (I18n.t('js.date.formats.l').length) {
        return moment.updateLocale(I18n.locale, {
          longDateFormat: {
            l: I18n.t('js.date.formats.l')
          }
        });
      }
    };

    Layout.prototype.initTargetButtons = function() {
      return $(document).on('click', '.targets', function() {
        var element, hide_elements, j, k, len, len1, results, show_elements;
        show_elements = $(this).data('show-targets');
        if (show_elements) {
          for (j = 0, len = show_elements.length; j < len; j++) {
            element = show_elements[j];
            $(element).show();
          }
        }
        hide_elements = $(this).data('hide-targets');
        if (hide_elements) {
          results = [];
          for (k = 0, len1 = hide_elements.length; k < len1; k++) {
            element = hide_elements[k];
            results.push($(element).hide());
          }
          return results;
        }
      });
    };

    Layout.prototype.dynamicFields = function() {
      $(document).on('click', '[data-dynamic-form-fields-remove]', function(evt) {
        evt.preventDefault();
        return $(this).closest('[data-nested-fields]').remove();
      });
      return $(document).on('click', '[data-dynamic-form-fields-add]', function(evt) {
        var association, content, new_id, regexp;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        association = $(this).data("association");
        content = $(this).data("content");
        new_id = new Date().getTime();
        regexp = new RegExp("new_" + $(this).data("association"), "g");
        $(this).parent().before(content.replace(regexp, new_id));
        return $('[data-nested-fields]').find('[data-dynamic-form-fields-remove]').last().on('click', function(evt) {
          evt.preventDefault();
          return $(this).closest('[data-nested-fields]').remove();
        });
      });
    };

    Layout.prototype.initDestroyButton = function() {
      return $(document).on('click', '.destroy-button', function(evt) {
        return $(this).closest('.destroyable').html('');
      });
    };

    Layout.stickyInit = function() {
      if ($('.sticky-column').innerHeight() !== $('.sticky-column').parent().innerHeight()) {
        return $('.sticky-column').stick_in_parent({
          offset_top: 152
        });
      }
    };

    Layout.prototype.submitBtnInit = function() {
      var submitButton;
      submitButton = $('.cartSubmitFormBtn:not([data-form--validation-target="submitBtn"])');
      if (submitButton.length) {
        return submitButton.click(function() {
          var $form, $submitBtn;
          $submitBtn = $('.cartSubmitFormBtn');
          $submitBtn.addClass('disabled');
          $submitBtn.val('disabled');
          $form = $('[data-submit-form]');
          return $form.submit();
        });
      }
    };

    Layout.prototype.initPasiveScrollListener = function() {
      return jQuery.event.special.touchstart = {
        setup: function(_, ns, handle) {
          return this.addEventListener('touchstart', handle, {
            passive: true
          });
        }
      };
    };

    Layout.prototype.discountTimer = function() {
      var countDown, date, dateCompatible, day, end_time, format_date, hour, minute, second, t, time_counter, x;
      format_date = moment.localeData().longDateFormat('l');
      time_counter = $('.banner-time-counter');
      if (time_counter.length) {
        second = 1000;
        minute = second * 60;
        hour = minute * 60;
        day = hour * 24;
        end_time = time_counter.data('end-time');
        t = end_time.split(/[- :]/);
        date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
        dateCompatible = new Date(date);
        countDown = new Date(dateCompatible);
        return x = setInterval((function() {
          var dayT, days, distance, hourT, hours, minuteT, minutes, now, secondT, seconds;
          now = (new Date).getTime();
          distance = countDown - now;
          days = Math.floor(distance / day);
          hours = Math.floor(distance % day / hour);
          minutes = Math.floor(distance % hour / minute);
          seconds = Math.floor(distance % minute / second);
          time_counter.find('.days').text(days);
          time_counter.find('.hours').text(hours);
          time_counter.find('.minutes').text(minutes);
          time_counter.find('.seconds').text(seconds);
          if (days) {
            dayT = I18n.t('js.public.banners.counter.day', {
              count: days
            });
            $('.daysT', time_counter).text(' ' + dayT + ' ');
          }
          if (hours || days) {
            hourT = I18n.t('js.public.banners.counter.hour', {
              count: hours
            });
            $('.hoursT', time_counter).text(' ' + hourT + ' ');
          }
          if (minutes || hours) {
            minuteT = I18n.t('js.public.banners.counter.minute', {
              count: minutes
            });
            $('.minutesT', time_counter).text(' ' + minuteT + ' ');
          }
          if (seconds || minutes) {
            secondT = I18n.t('js.public.banners.counter.second', {
              count: seconds
            });
            $('.secondsT', time_counter).text(' ' + secondT + ' ');
          }
          if (days === 0) {
            time_counter.find('.days-desc, .days').hide();
          }
          if (days === 0 && hours === 0) {
            time_counter.find('.hours-desc, .hours').hide();
          }
          if (days === 0 && hours === 0 && minutes === 0) {
            return time_counter.addClass('invisible');
          } else {
            return time_counter.removeClass('invisible');
          }
        }), second);
      }
    };

    Layout.prototype.popupModal = function() {
      var countDownFlip, flipdown;
      if ($('.popupModal').length) {
        countDownFlip = $('.popupModal .banner-container').data('countdown-to');
        if (typeof countDownFlip !== 'undefined') {
          countDownFlip = new Date(countDownFlip);
          flipdown = new FlipDown(countDownFlip.getTime() / 1000);
          return flipdown.start();
        }
      }
    };

    Layout.prototype.bannersShow = function() {
      var bannerPageViewsCount, banners;
      banners = $('.bannerContainer');
      bannerPageViewsCount = Cookies.get('banner_page_views_count');
      if (bannerPageViewsCount != null) {
        bannerPageViewsCount = parseInt(bannerPageViewsCount) + 1;
        Cookies.set('banner_page_views_count', bannerPageViewsCount, {
          expires: 1,
          secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
        });
      } else {
        bannerPageViewsCount = 0;
        Cookies.set('banner_page_views_count', bannerPageViewsCount, {
          expires: 1,
          secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
        });
      }
      return banners.each(function() {
        var bannerContainer, maxBannerViewsCount, showBannerByMaxBannerViewsCount, showBannerByviewsPeriod, viewsPeriod;
        bannerContainer = $(this);
        if (bannerContainer.length) {
          maxBannerViewsCount = bannerContainer.data('max-banner-views-count');
          viewsPeriod = bannerContainer.data('views-period');
          showBannerByMaxBannerViewsCount = true;
          showBannerByviewsPeriod = true;
          if (maxBannerViewsCount != null) {
            if ((bannerPageViewsCount % maxBannerViewsCount) !== 0) {
              showBannerByMaxBannerViewsCount = false;
            }
            if (viewsPeriod != null) {
              if ((bannerPageViewsCount / maxBannerViewsCount) >= viewsPeriod) {
                showBannerByviewsPeriod = false;
              }
            }
          }
          if (showBannerByMaxBannerViewsCount && showBannerByviewsPeriod) {
            return Mzkr.Modal.show('.bannerContainer');
          }
        }
      });
    };

    Layout.toolTip = function() {
      $('.custom-checkbox [data-toggle="popover"]').on('click', function(e) {
        e.preventDefault();
        return e.stopPropagation();
      });
      $('.product-tile [data-toggle="tooltip"], .mzkr-checkbox [data-toggle="tooltip"]').on('click', function(e) {
        e.preventDefault();
        return e.stopPropagation();
      });
      $('[data-toggle="popover"]').each(function() {
        var $this;
        $this = $(this);
        if ($this.parents('.mzkr-modal').length) {
          return $this.popover({
            html: true,
            container: '.mzkr-modal__content'
          });
        } else {
          return $this.popover({
            html: true,
            container: 'body'
          });
        }
      });
      $('[data-toggle="tooltip"]').each(function() {
        var $this, container;
        $this = $(this);
        if ($this.parents('.internal-features-wrap').length) {
          return $this.tooltip({
            container: '.internal-features-wrap'
          });
        } else if ($this.parents('.mzkr-modal').length) {
          return $this.tooltip({
            container: '.mzkr-modal__content'
          });
        } else {
          container = $this.attr('data-container') || 'body';
          return $this.tooltip({
            container: container
          });
        }
      });
      if ($('[data-toggle="popover"]').length) {
        return $('html').on('mouseup', function(e) {
          var $clicked;
          $clicked = $(e.target);
          if (!$clicked.closest('.popover').length) {
            return $('.popover').each(function() {
              return $(this).popover('hide');
            });
          }
        });
      }
    };

    Layout.prototype.clearEmptyElements = function() {
      var i, results;
      i = 0;
      results = [];
      while (i < 5) {
        if ($('.styled-text').length) {
          $('.styled-text div:not(.ico), .styled-text p, .styled-text ul, .styled-text li, .styled-text :header, .styled-text strong').each(function() {
            var $this;
            $this = $(this);
            if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
              return $this.remove();
            }
          });
        }
        if ($('.styled-text .accordion').length) {
          $('.styled-text .accordion :header, .styled-text .accordion :header strong, .styled-text .accordion :header .ico:only-child').each(function() {
            var $this;
            $this = $(this);
            if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
              return $this.remove();
            }
          });
        }
        results.push(i++);
      }
      return results;
    };

    Layout.fileBrowse = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return $('.custom-file input:file').change(function(e) {
        var files, i;
        files = [];
        i = 0;
        while (i < $(this)[0].files.length) {
          files.push($(this)[0].files[i].name);
          i++;
        }
        return $(this).next('.custom-file-label').html(files.join(', '));
      });
    };

    Layout.prototype.initFormSubmitOnSelectSet = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return $('[data-submit-on-select-set="true"]').each(function() {
        var $this;
        $this = $(this);
        return $(this).find('select').change(function() {
          return $this.submit();
        });
      });
    };

    Layout.prototype.initDataConfirmModal = function() {
      dataConfirmModal.setDefaults({
        title: I18n.t('js.public.modals.confirm.title'),
        commit: I18n.t('js.public.modals.confirm.commit'),
        cancel: I18n.t('js.public.modals.confirm.cancel'),
        cancelClass: 'mzkr-btn-primary--outline',
        modalClass: 'modal-centered confirm-modal',
        zIndex: 100005
      });
      return Turbo.setConfirmMethod(function(message, element) {
        var body, modal;
        modal = $(element).confirmModal();
        body = modal.find('.modal-body p').html(message);
        return new Promise(function(resolve) {
          var modalConfirmed;
          modalConfirmed = false;
          modal.on('click', function(e) {
            if ($(e.target).hasClass('commit')) {
              return modalConfirmed = true;
            }
          });
          return modal.on('hidden.bs.modal', function(e) {
            return resolve(modalConfirmed);
          });
        });
      });
    };

    Layout.prototype.cacheboxToggler = function() {
      return $('.cache-box-toggler').click(function() {
        var cacheBoxOpened;
        cacheBoxOpened = Cookies.get('cacheBoxOpened') === 'true' ? true : false;
        $('.cache-box').toggleClass('cache-box-open');
        return Cookies.set('cacheBoxOpened', !cacheBoxOpened, {
          secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
        });
      });
    };

    Layout.tooltipInLink = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return $('[data-one-click-btn] [data-toggle="tooltip"]', scope).on('click', function(e) {
        e.preventDefault();
        return e.stopImmediatePropagation();
      });
    };

    Layout.prototype.initCopyToClipboard = function() {
      return $('[data-clipboard]').each(function() {
        var $input, $this, thisData;
        $this = $(this);
        $this.before('<input type="text" class="clipboard-input">');
        $input = $this.prev('input');
        thisData = $this.data('clipboard');
        if (typeof thisData === 'object' && thisData !== null) {
          $input.val(JSON.stringify(thisData));
        } else {
          $input.val(thisData);
        }
        return $this.click(function() {
          $input[0].select();
          $input[0].setSelectionRange(0, 99999);
          document.execCommand("copy");
          $input.blur();
          if ($this.attr('data-title-confirm')) {
            return $this.attr('data-original-title', $this.attr('data-title-confirm')).tooltip('show');
          }
        });
      });
    };

    Layout.prototype.shareComponent = function() {
      var modalBannerFocusTrap, renderContent;
      renderContent = function(elem) {
        var btnText, content, fbLink, title, waLink;
        btnText = I18n.t('js.public.components.share.copy');
        title = elem.attr('data-shr-cmp-title');
        content = elem.attr('data-shr-cmp-content');
        fbLink = "https://www.facebook.com/sharer/sharer.php?u=" + content;
        waLink = "https://wa.me/?text=" + content;
        return $('.shr-banner').html("<button class='close close-banner'><span aria-hidden='true'><i class='far fa-times'></i></span></button>" + "<div class='mzkr-mb-3 font-weight-bold'>" + title + "</div>" + "<div class='mzkr-form'>" + "<input value='" + content + "' readonly style='width: 100%;' class='mzkr-mb-5 bg-white mzkr-text-dark form-control' id='shr-cmp-content'></input>" + "</div>" + "<div class='mzkr-d-flex mzkr-align-items-center'>" + "<button class='mzkr-btn-primary--outline mzkr-btn--sm mzkr-mr-3' id='shr-cmp-copy'><i class='fal fa-copy mzkr-btn__icon-left'></i>" + btnText + "</button>" + "<a class='mzkr-btn-primary--outline mzkr-btn--sm mzkr-btn__icon mzkr-mr-3' href='" + fbLink + "'><i class='fab fa-facebook-f'></i></a>" + "<a class='mzkr-btn-primary--outline mzkr-btn--sm mzkr-btn__icon' href='" + waLink + "'><i class='fab fa-whatsapp fa-lg'></i></a>" + "</div>");
      };
      modalBannerFocusTrap = PublicUtility.Layout.focusTrap($('.modal-banner')[0]);
      $('.shr-cmp-activator').each(function() {
        return $(this).on('click', function() {
          var _that;
          event.stopPropagation();
          _that = $(this);
          clearTimeout(window.bannerShareComponentDelay);
          if ($('.modal-banner').hasClass('shown')) {
            $('.modal-banner').removeClass('shown');
            setTimeout((function() {
              renderContent(_that);
              return $('.modal-banner').addClass('shown');
            }), 300);
          } else {
            renderContent(_that);
            $('.modal-banner').addClass('shown');
            if (modalBannerFocusTrap != null) {
              modalBannerFocusTrap.activate();
            }
          }
          window.bannerShareComponentDelay = setTimeout((function() {
            $('.modal-banner').removeClass('shown');
            return modalBannerFocusTrap != null ? modalBannerFocusTrap.deactivate() : void 0;
          }), 5000);
          $('.modal-banner').unbind('mouseenter mouseleave');
          $('.modal-banner').mouseenter(function() {
            return clearTimeout(window.bannerShareComponentDelay);
          }).mouseleave(function() {
            return window.bannerShareComponentDelay = setTimeout((function() {
              $('.modal-banner').removeClass('shown');
              return modalBannerFocusTrap != null ? modalBannerFocusTrap.deactivate() : void 0;
            }), 3000);
          });
          PublicUtility.Layout.setModalBannerPosition();
          return $('#shr-cmp-copy').on('click', function() {
            var content;
            content = $('#shr-cmp-content');
            content.select();
            return document.execCommand('copy');
          });
        });
      });
      return $('.modal-banner').on('click', '.close-banner', function() {
        $('.modal-banner').removeClass('shown');
        if (modalBannerFocusTrap != null) {
          modalBannerFocusTrap.deactivate();
        }
        return clearTimeout(window.bannerShareComponentDelay);
      });
    };

    Layout.addToBasketListener = function() {
      return $(document).on('click', '.js-add-to-cart', function() {
        var $this;
        $this = $(this);
        return setTimeout((function() {
          return $this.addClass('disabled').attr('disabled', true);
        }), 1);
      });
    };

    Layout.enableAddToBasketBtn = function() {
      return $('.js-add-to-cart').removeClass('disabled').attr('disabled', false);
    };

    Layout.restrictInputCharacters = function() {
      return $('[data-restrict-input-characters]').each(function() {
        var _this, restrictedChars;
        _this = $(this);
        restrictedChars = _this.data('restrict-input-characters');
        return _this.on('input', function(event) {
          var regex;
          regex = new RegExp('[' + restrictedChars + ']', 'gi');
          return _this.val(_this.val().replace(regex, ''));
        });
      });
    };

    Layout.extraGiftSelect = function() {
      var selectedProduct;
      selectedProduct = $('.js-extra-gift-tile.selected').first();
      if (selectedProduct.length) {
        $('.mzkr-modal input[type="submit"]').removeClass('disabled').attr('disabled', false);
        $('#public_shop_basket_item_form_product_hash').attr('value', selectedProduct.data('product-id'));
      }
      return $('.js-extra-gift-tile').click(function() {
        var $this, productIdHash;
        $this = $(this);
        productIdHash = $this.data('product-id');
        $('.js-extra-gift-tile').removeClass('selected');
        $this.addClass('selected');
        $('.mzkr-modal input[type="submit"]').removeClass('disabled').attr('disabled', false);
        return $('#public_shop_basket_item_form_product_hash').attr('value', productIdHash);
      });
    };

    Layout.deferLuigisScan = function(selector1, selector2) {
      var defer, deferCounter, deferCounterMax;
      deferCounter = 0;
      deferCounterMax = 2000;
      defer = function() {
        if ((typeof Luigis !== "undefined" && Luigis !== null ? Luigis.Scan : void 0) && (deferCounter < deferCounterMax)) {
          return Luigis.Scan(selector1, selector2);
        } else {
          return setTimeout((function() {
            deferCounter += 1;
            return defer();
          }), 50);
        }
      };
      return defer();
    };

    Layout.prototype.deferLbAutocomplete = function() {
      var defer, deferCounter, deferCounterMax;
      deferCounter = 0;
      deferCounterMax = 2000;
      defer = function() {
        if (window.Luigis && window.Luigis.collector) {
          return;
        }
        if (window.autocompleteInitLoaded && (deferCounter < deferCounterMax)) {
          window.setupAutocomplete();
          window._itemsCounter = 0;
          return window._categoriesCounter = 0;
        } else {
          return setTimeout((function() {
            deferCounter += 1;
            return defer();
          }), 50);
        }
      };
      return defer();
    };

    Layout.prototype.collapseCountries = function() {
      return $('.js-countries-collapse').click(function() {
        $(this).remove();
        return $('.countries-wrap').toggleClass('collapsed');
      });
    };

    Layout.prototype.passwordVisibilityControl = function() {
      return $('.password-visibility-control .visibility-control').click(function() {
        var $input, $this;
        $this = $(this);
        $input = $this.parents('.password-visibility-control').find('input');
        if ($input.attr('type') === 'password') {
          $input.attr('type', 'text');
          return $this.addClass('hide');
        } else {
          $input.attr('type', 'password');
          return $this.removeClass('hide');
        }
      });
    };

    Layout.prototype.initTurboFrameMissingBehaviour = function() {
      var errorAppended;
      errorAppended = false;
      return document.addEventListener("turbo:frame-missing", function(event) {
        event.preventDefault();
        if (errorAppended) {
          return;
        }
        errorAppended = true;
        Sentry.captureException(event);
        return $('#alerts-container').append("<div class='container mt-3'><div class='alert alert-danger'>" + (I18n.t('js.shared.errors.unexpected_error')) + "</div></div>");
      });
    };

    Layout.setModalBannerPosition = function() {
      var $modalBaner, $window, setPosition;
      $window = $(window);
      $modalBaner = $('.modal-banner');
      setPosition = function() {
        if ($window.width() > 767) {
          return $modalBaner.css('top', $('.mzkr-nav-wrap').height() + 16);
        } else {
          return $modalBaner.css('top', 'auto');
        }
      };
      if ($modalBaner.length) {
        setPosition();
        $window.scroll(function() {
          return setPosition();
        });
        return $window.resize(function() {
          return setPosition();
        });
      }
    };

    Layout.prototype.showCategoryDescription = function() {
      var $description, $readMoreBtn;
      $description = $('.listing-sub-text-inner');
      $readMoreBtn = $('.listing-sub-text .read-more');
      if ($description.prop('scrollHeight') > 52) {
        $readMoreBtn.show().text(I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.description_read_more'));
      }
      return $readMoreBtn.click(function() {
        var $this;
        $this = $(this);
        if ($this.hasClass('hide-description')) {
          $this.removeClass('hide-description');
          $this.text(I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.description_read_more'));
          $description.css('max-height', 52);
        } else {
          $this.addClass('hide-description');
          $this.text(I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.description_read_less'));
          $description.css('max-height', $description.prop('scrollHeight'));
        }
        return setTimeout((function() {
          return PublicUtility.ProductList.initStickyFilters(true);
        }), 300);
      });
    };

    Layout.prototype.internationalBar = function() {
      var $detectedCountryItem, currentCountry, currentCountryCode, detectedCountry;
      if ($('.international-bar').length) {
        currentCountryCode = Cookies.get('current_country_code');
        detectedCountry = Cookies.get('detected_country_code');
        currentCountry = $('body').attr('data-legal').toLowerCase();
        if (!currentCountryCode && ((detectedCountry != null) && detectedCountry !== currentCountry)) {
          $('body').addClass('body-is-international');
          $('body').removeClass('body-banner-top');
          $('.international-bar').removeClass('mzkr-d-none');
          $('.nav-top-banner').addClass('mzkr-d-none');
        }
        if (detectedCountry != null) {
          $detectedCountryItem = $('.dropdown-menu a[data-country-code="' + detectedCountry + '"]').parent('.dropdown-item');
          $detectedCountryItem.addClass('detected-country');
          $('.international-bar .dropdown-menu').prepend($detectedCountryItem);
        }
        $('.international-bar-dropdown').on('click', '.dropdown-menu a', function(e) {
          var $dropdownToggle, $img, $selectedItem, countryCode, text, url;
          e.preventDefault();
          $selectedItem = $(e.currentTarget);
          $img = $selectedItem.find('img').clone();
          text = $selectedItem.text().trim();
          url = $selectedItem.attr('href');
          countryCode = $selectedItem.attr('data-country-code');
          $dropdownToggle = $('.international-bar-dropdown .dropdown-toggle');
          return $dropdownToggle.empty().append($img).append(text).attr('data-url', url).attr('data-country-code', countryCode);
        });
        return $('.submit-country').on('click', function(e) {
          var $dropdownButton, countryCode, newUrl, url;
          $dropdownButton = $('.international-bar-dropdown .dropdown-toggle');
          url = $dropdownButton.attr('data-url');
          countryCode = $dropdownButton.attr('data-country-code');
          if (url) {
            newUrl = new URL(url, window.location.origin);
            newUrl.searchParams.set('current_country_code', countryCode);
            newUrl.searchParams.set('utm_medium', 'country_bar');
            newUrl.searchParams.set('utm_source', window.location.hostname);
            return window.location.href = newUrl.toString();
          }
        });
      }
    };

    Layout.prototype.internationalModal = function() {
      if ($('#international-modal').length) {
        Mzkr.Modal.show('#international-modal');
        $('.js-more-sites').on('click', function() {
          var $countryList;
          $countryList = $('.country-list');
          $countryList.css({
            'height': $countryList.prop('scrollHeight')
          });
          setTimeout((function() {
            return $countryList.css({
              'height': 'auto'
            });
          }), 150);
          return $(this).hide();
        });
        $('#international-modal').on('onMzkrModalHide', function() {
          return Cookies.set('int_modal_closed', 'true', {
            expires: 30
          });
        });
        return $('#international-modal .country-list a').on('click', function() {
          return Cookies.set('int_modal_closed', 'true', {
            expires: 30
          });
        });
      }
    };

    Layout.initApplyCampaignCouponLink = function() {
      $('.js-add-to-cart').on('click', function(event) {
        var $productTile, $productTileCouponLinks;
        $productTile = $(this).closest('.product-tile');
        $productTileCouponLinks = $productTile.find('[data-apply-coupon-from-link-path]');
        return $productTileCouponLinks.attr('data-disabled', true);
      });
      return $("[data-apply-coupon-from-link-path]").on('click', function(event) {
        var $productTile, $productTileCouponLinks, that, url;
        event.preventDefault();
        event.stopPropagation();
        that = $(this);
        $productTile = that.closest('.product-tile');
        $productTileCouponLinks = $productTile.find('[data-apply-coupon-from-link-path]');
        if (that.attr('data-disabled')) {
          return;
        }
        if (that.attr('data-result-type') === 'virtual_product') {
          url = $productTile.find('.add-to-cart-btn').attr('href');
          return $.ajax({
            type: 'GET',
            dataType: 'script',
            url: url,
            success: function() {
              return that.removeAttr('data-disabled', true);
            }
          });
        } else {
          $productTileCouponLinks.attr('data-disabled', true);
          $productTile.find('.js-add-to-cart').attr('disabled', true);
          return $.ajax({
            type: 'POST',
            dataType: 'script',
            url: that.attr('data-apply-coupon-from-link-path'),
            success: function() {
              $productTileCouponLinks.removeAttr('data-disabled', true);
              return $productTile.find('.js-add-to-cart').removeAttr('disabled');
            }
          });
        }
      });
    };

    Layout.prototype.tilesMoreBtn = function() {
      return $('.widget-main-wrapper').on('click', '.tiles-more-btn', function() {
        var $this, $tilesWrapper;
        $this = $(this);
        $tilesWrapper = $this.parent('.tiles-wrapper');
        $tilesWrapper.css('height', $tilesWrapper.outerHeight());
        $this.siblings('.tile:hidden').css({
          display: 'inline-flex',
          visibility: 'visible'
        });
        $this.hide();
        return $tilesWrapper.animate({
          height: $tilesWrapper.prop('scrollHeight')
        }, 150, 'swing', function() {
          return $tilesWrapper.css('height', 'auto');
        });
      });
    };

    Layout.setCouponsPageCookies = function() {
      if (Cookies.get('coupons_page_visited') === 'true') {
        return;
      }
      Cookies.set('coupons_page_visited', 'true', {
        expires: 30
      });
      return $('.user-menu-sidebar .coupons-item').removeClass('highlighted-item');
    };

    Layout.prototype.hideSkeletonLoading = function() {
      return $(document).ready(function() {
        return $('[data-skeleton-loading="true"]').attr('data-skeleton-loading', 'false');
      });
    };

    Layout.disableOnClick = function(element, timeout) {
      var $element;
      if (timeout == null) {
        timeout = 5000;
      }
      $element = $(element);
      return $element.on('click', function() {
        $element.addClass('disabled');
        if (timeout) {
          return setTimeout((function() {
            return $element.removeClass('disabled');
          }), timeout);
        }
      });
    };

    Layout.focusTrap = function(container) {
      var activate, deactivate, getFocusableElements, handleKeydown, previousActiveElement;
      previousActiveElement = null;
      getFocusableElements = function() {
        return $(container).find('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]),iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]').filter(function(i, el) {
          return $(el).is(':visible');
        });
      };
      handleKeydown = function(e) {
        var firstEl, focusableEls, lastEl;
        if (e.key !== 'Tab') {
          return;
        }
        focusableEls = getFocusableElements();
        if (!focusableEls.length) {
          return;
        }
        firstEl = focusableEls[0];
        lastEl = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === firstEl || !$.contains(container, document.activeElement)) {
            e.preventDefault();
            return lastEl.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            return firstEl.focus();
          }
        }
      };
      activate = function() {
        var focusableEls, ref;
        previousActiveElement = document.activeElement;
        container.addEventListener('keydown', handleKeydown);
        focusableEls = getFocusableElements();
        return (ref = focusableEls[0]) != null ? ref.focus() : void 0;
      };
      deactivate = function() {
        container.removeEventListener('keydown', handleKeydown);
        return previousActiveElement != null ? typeof previousActiveElement.focus === "function" ? previousActiveElement.focus() : void 0 : void 0;
      };
      return {
        activate: activate,
        deactivate: deactivate
      };
    };

    Layout.initBasketItemsSidebar = function() {
      var basketItemsFocusTrap;
      basketItemsFocusTrap = PublicUtility.Layout.focusTrap($('.basket-items-sidebar')[0]);
      PublicUtility.Layout.basketItemsSidebar = {
        show: function() {
          $('body').addClass('basket-items-sidebar-open');
          return basketItemsFocusTrap != null ? basketItemsFocusTrap.activate() : void 0;
        },
        hide: function() {
          $('body').removeClass('basket-items-sidebar-open');
          return basketItemsFocusTrap != null ? basketItemsFocusTrap.deactivate() : void 0;
        }
      };
      return $(document).on('click', '.basket-items-sidebar-overlay, .basket-items-sidebar-close', function() {
        return PublicUtility.Layout.basketItemsSidebar.hide();
      });
    };

    return Layout;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.LunrSearch = (function() {
    function LunrSearch() {
      this.lunr = null;
    }

    LunrSearch.prototype.initLunrProducts = function(products) {
      return this.lunr = lunr(function() {
        this.pipeline.remove(lunr.stemmer);
        this.ref('name');
        this.field('name');
        return products.forEach((function(product) {
          var indexProduct;
          indexProduct = {
            'name': product
          };
          return this.add(indexProduct);
        }), this);
      });
    };

    return LunrSearch;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Navigation = (function() {
    function Navigation() {
      this.initListeners();
      this.couponsPageVisited();
      Mzkr.HorizontalScroll.init('.mzkr-nav-categories-wrap .mzkr-horizontal-scroll', false);
    }

    Navigation.prototype.initListeners = function() {
      var $html, $navSidebar, $navWrap, $navbarOpenToggle, navDown, navUp, sidebarFocusTrap, that, userMenuFocusTrap, zeynepSideBar;
      if (!$('.mzkr-nav').length) {
        return;
      }
      that = this;
      $navbarOpenToggle = $('.js-nav-sidebar-open');
      $navSidebar = $('.js-nav-sidebar');
      zeynepSideBar = $navSidebar.zeynep();
      $html = $('html');
      $navWrap = $('.mzkr-nav-wrap');
      sidebarFocusTrap = PublicUtility.Layout.focusTrap($('.js-nav-sidebar')[0]);
      userMenuFocusTrap = PublicUtility.Layout.focusTrap($('#user-menu-sidebar')[0]);
      $navbarOpenToggle.click(function() {
        if (!$navSidebar.hasClass('opened') && $(window).width() > 767) {
          setTimeout(function() {
            return $('.nav-sidebar-menu.mainmenu .activities-menu-item > a').click();
          }, 0);
        }
        $navSidebar.addClass('opened');
        $html.addClass('zeynep-opened');
        $navbarOpenToggle.attr('aria-expanded', 'true');
        setTimeout(function() {
          return $navSidebar.find('.menu-item a').first().focus();
        }, 100);
        return sidebarFocusTrap != null ? sidebarFocusTrap.activate() : void 0;
      });
      $('.zeynep-overlay, .js-nav-sidebar-close, .js-nav-sidebar .countries-selector').on('click', function() {
        var $submenuOpened;
        $navSidebar.removeClass('opened');
        $html.removeClass('zeynep-opened');
        $submenuOpened = $('.submenu.opened');
        $('[data-submenu-close]', $submenuOpened).first().click();
        $submenuOpened.removeClass('opened current');
        $navSidebar.removeClass('submenu-opened');
        $navbarOpenToggle.attr('aria-expanded', 'false');
        return sidebarFocusTrap != null ? sidebarFocusTrap.deactivate() : void 0;
      });
      zeynepSideBar.on('opening', function() {
        if (window.innerWidth > 768) {
          $('.show.showing').last().removeClass('show');
          return setTimeout(function() {
            return $('.showing').last().removeClass('showing');
          }, 300);
        }
      });
      zeynepSideBar.on('opened', function() {
        if ($navSidebar.hasClass('submenu-opened')) {
          $('.submenu').each(function() {
            var $this;
            $this = $(this);
            if ($('.submenu-child.current', $(this)).length) {
              $this.addClass('submenu-child-open');
            } else {
              $this.removeClass('submenu-child-open');
            }
            return $this.not('.current, .submenu-child-open').removeClass('opened');
          });
          $('.menu-item').each(function() {
            var $this;
            $this = $(this);
            if ($('.submenu.current', $(this)).length) {
              $this.addClass('active');
              if ($this.hasClass('has-submenu')) {
                return $this.children('.menu-item__link').attr('aria-expanded', 'true');
              }
            } else {
              $this.removeClass('active');
              if ($this.hasClass('has-submenu')) {
                return $this.children('.menu-item__link').attr('aria-expanded', 'false');
              }
            }
          });
        }
        return $('.opened.current').addClass('show showing');
      });
      zeynepSideBar.on('closing', function() {
        $('.show.showing').last().removeClass('show');
        return setTimeout(function() {
          return $('.showing').last().removeClass('showing');
        }, 300);
      });
      zeynepSideBar.on('closed', function() {
        if ($navSidebar.hasClass('submenu-opened')) {
          $('.submenu').each(function() {
            var $this;
            $this = $(this);
            if ($('.submenu-child.current', $(this)).length) {
              return $this.addClass('submenu-child-open');
            } else {
              return $this.removeClass('submenu-child-open');
            }
          });
        }
        return $('.menu-item').each(function() {
          var $this;
          $this = $(this);
          if ($('.submenu.current', $(this)).length) {
            return $this.addClass('active');
          } else {
            return $this.removeClass('active');
          }
        });
      });
      that.adjustCollapseView();
      $(window).on('resize', function() {
        return that.adjustCollapseView();
      });
      navUp = function() {
        $navWrap.addClass('nav-up');
        $('.nav-top-banner').addClass('nav-top-banner-hidden');
        $('.mzkr-nav__search-input:focus').blur();
        $('.dropdown.show, .dropdown-menu.show').removeClass('show');
        $navWrap.addClass('nav-collapsed');
        return $('body').addClass('body-is-nav-collapsed');
      };
      navDown = function() {
        $navWrap.removeClass('nav-collapsed');
        $navWrap.removeClass('nav-up');
        $('.nav-top-banner').removeClass('nav-top-banner-hidden').removeClass('banner-z');
        $('#global-search-results-wrapper').hide();
        $('.mzkr-nav__search-input:focus').blur();
        return $('body').removeClass('body-is-nav-collapsed');
      };
      if ($('.mzkr-nav-wrap').length) {
        $(window).scroll(function() {
          if ($(window).scrollTop() > $('.mzkr-nav-wrap').height()) {
            if (!$('.mzkr-nav-wrap').hasClass('nav-up')) {
              navUp();
            }
          }
          if ($(window).scrollTop() < $('.mzkr-nav-wrap').height()) {
            if ($('.mzkr-nav-wrap').hasClass('nav-up')) {
              return navDown();
            }
          }
        });
      }
      $('.js-user-menu-trigger').on('click', function() {
        $('body').addClass('user-menu-sidebar-open');
        $(this).attr('aria-expanded', 'true');
        setTimeout(function() {
          return $('#user-menu-sidebar .user-menu a').first().focus();
        }, 100);
        return userMenuFocusTrap != null ? userMenuFocusTrap.activate() : void 0;
      });
      return $('.user-menu-sidebar-overlay, .js-user-menu-sidebar-close').on('click', function() {
        $('body').removeClass('user-menu-sidebar-open');
        $('.js-user-menu-trigger').attr('aria-expanded', 'false');
        return userMenuFocusTrap != null ? userMenuFocusTrap.deactivate() : void 0;
      });
    };

    Navigation.prototype.adjustCollapseView = function() {
      var desktopView;
      desktopView = window.innerWidth;
      if (desktopView > 991) {
        return $('.collapse-mobile[data-toggle]').attr('data-toggle', '');
      } else {
        return $('.collapse-mobile[data-toggle]').attr('data-toggle', 'collapse');
      }
    };

    Navigation.prototype.couponsPageVisited = function() {
      if (Cookies.get('coupons_page_visited') === 'true') {
        return;
      }
      return $('.user-menu-sidebar .coupons-item').addClass('highlighted-item');
    };

    return Navigation;

  })();

}).call(this);
(function() {
  var base;

  window.Utility || (window.Utility = {});

  (base = window.Utility).Payments || (base.Payments = {});

  Utility.Payments.AdyenV2ExpressCheckoutService = (function() {
    AdyenV2ExpressCheckoutService.successfullStates = ['Authorised'];

    AdyenV2ExpressCheckoutService.waitingStates = ['Received', 'Pending', 'PresentToShopper'];

    AdyenV2ExpressCheckoutService.cancelledStates = ['Cancelled'];

    AdyenV2ExpressCheckoutService.errorStates = ['Error'];

    AdyenV2ExpressCheckoutService.refusedStates = ['Refused'];

    AdyenV2ExpressCheckoutService.initData = {};

    AdyenV2ExpressCheckoutService.environment = {};

    AdyenV2ExpressCheckoutService.routes = {};

    AdyenV2ExpressCheckoutService.currentTransactionReference = null;

    AdyenV2ExpressCheckoutService.orderDataResponse = {};

    AdyenV2ExpressCheckoutService.paymentMethodsResponse = {};

    AdyenV2ExpressCheckoutService.onAuthorizedData = {};

    AdyenV2ExpressCheckoutService.paymentMethod = {};

    AdyenV2ExpressCheckoutService.googlePayComponent = null;

    AdyenV2ExpressCheckoutService.delayedTime = 4000;

    AdyenV2ExpressCheckoutService.googlePayBtnMountContainer = '#ecs-google-pay-container';

    AdyenV2ExpressCheckoutService.applePayBtnMountContainer = '#ecs-apple-pay-container';

    AdyenV2ExpressCheckoutService.threeDSecure2MountContainer = '#components-container';

    AdyenV2ExpressCheckoutService.googlePayAdyenVariantName = 'googlepay';

    AdyenV2ExpressCheckoutService.applePayAdyenVariantName = 'applepay';

    AdyenV2ExpressCheckoutService.successImageUrl = 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/components/success.gif';

    AdyenV2ExpressCheckoutService.errorImageUrl = 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/components/error.gif';

    AdyenV2ExpressCheckoutService.applePaymentMethod = {};

    AdyenV2ExpressCheckoutService.totalPriceLabel = 'MUZIKER';

    AdyenV2ExpressCheckoutService.lastFinalizeTransactionResponse = {};

    function AdyenV2ExpressCheckoutService() {
      return this;
    }

    AdyenV2ExpressCheckoutService.init = function(data) {
      this.initData = data;
      this.environment = data["environment"];
      return this.drawInitialComponent();
    };

    AdyenV2ExpressCheckoutService.drawInitialComponent = function() {
      var applePayConfiguration, googlePayInitialConfiguration, klass, that;
      klass = Utility.Payments.AdyenV2ExpressCheckoutService;
      that = this;
      googlePayInitialConfiguration = {
        environment: this.initData['environment'],
        analytics: {
          enabled: false
        },
        paymentMethodsConfiguration: {
          googlepay: {
            buttonType: 'order',
            buttonColor: 'white',
            buttonSizeMode: 'fill',
            buttonLocale: this.initData['current_locale'],
            onClick: function(resolve, reject) {
              $('.gpay-button').attr('disabled', true);
              return klass.googlePayOnClickOnPayButton(resolve, reject);
            }
          }
        }
      };
      applePayConfiguration = {
        environment: this.initData['environment'],
        clientKey: this.initData['client_key'],
        analytics: {
          enabled: false
        },
        paymentMethodsResponse: {
          paymentMethods: [
            {
              "configuration": {
                "merchantId": this.initData['merchant_id_for_apple_pay'],
                "merchantName": "Muziker a.s."
              },
              "name": "Apple Pay",
              "type": "applepay"
            }
          ]
        },
        paymentMethodsConfiguration: {
          applepay: {
            amount: {
              currency: this.initData["currency_code"],
              value: 0
            },
            countryCode: this.initData["country_code"],
            buttonType: 'plain',
            buttonColor: 'white',
            version: 1,
            totalPriceLabel: this.totalPriceLabel,
            totalPriceStatus: 'pending',
            merchantCapabilities: ['supports3DS'],
            requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
            requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
            onSubmit: function(state, component) {
              return klass.applePayOnSubmit(state, component);
            },
            onAuthorized: function(resolve, reject, event) {
              klass.applePayOnAuthorized(JSON.stringify(event.payment));
              return resolve;
            },
            onPaymentMethodSelected: function(resolve, reject, event) {
              var update;
              update = {
                newTotal: klass.newTotalHash(),
                newLineItems: klass.orderDataResponse['line_items']
              };
              return resolve(update);
            },
            onShippingContactSelected: function(resolve, reject, event) {
              var customerCountryCode, update;
              customerCountryCode = event.shippingContact.countryCode;
              if (customerCountryCode !== klass.initData["country_code"]) {
                update = {
                  newTotal: klass.newTotalHash(),
                  errors: [
                    new ApplePayError('shippingContactInvalid', 'countryCode', I18n.t('js.public.payments.providers.adyen_v2.apple_pay_express_checkout.provide_correct_shipping_address', {
                      country_code: klass.initData["country_code"]
                    }))
                  ]
                };
                return resolve(update);
              }
              update = {
                newTotal: klass.newTotalHash(),
                newLineItems: klass.orderDataResponse['line_items'],
                newShippingMethods: klass.getShippingMethods(customerCountryCode)
              };
              return resolve(update);
            },
            onShippingMethodSelected: function(resolve, reject, event) {
              var update;
              update = {
                newTotal: klass.newTotalHash(),
                newLineItems: klass.orderDataResponse['line_items'],
                newShippingMethods: klass.getShippingMethods(klass.initData["country_code"])
              };
              return resolve(update);
            },
            onClick: function(resolve, reject) {
              return klass.applePayOnClickOnPayButton(resolve, reject);
            }
          }
        }
      };
      if ($(this.googlePayBtnMountContainer).length > 0) {
        this.mountGooglePayECSComponent(this.googlePayAdyenVariantName, googlePayInitialConfiguration, this.googlePayBtnMountContainer, {});
      }
      if ($(this.applePayBtnMountContainer).length > 0 && /apple/i.test(navigator.vendor)) {
        if (!this.initData['merchant_id_for_apple_pay'].length) {
          return console.error('Missing ENV merchant_id_for_apple_pay');
        }
        return this.mountECSComponent(this.applePayAdyenVariantName, applePayConfiguration, this.applePayBtnMountContainer, {});
      }
    };

    AdyenV2ExpressCheckoutService.googlePayRefreshEcsComponent = function() {
      var configuration, error, klass, that;
      klass = Utility.Payments.AdyenV2ExpressCheckoutService;
      that = this;
      console.log('Google Pay is loading in environment: ' + this.orderDataResponse['payment_data']['environment']);
      console.log('Google Pay merchant identifier is: ' + this.orderDataResponse['payment_data']["google_pay_merchant_identifier"]);
      console.log('Google Pay merchant name is: ' + this.orderDataResponse['payment_data']["google_pay_merchant_name"]);
      configuration = {
        environment: this.orderDataResponse['payment_data']['environment'],
        clientKey: this.orderDataResponse['payment_data']['client_key'],
        analytics: {
          enabled: false
        },
        paymentMethodsResponse: this.paymentMethodsResponse,
        paymentMethodsConfiguration: {
          googlepay: {
            amount: {
              currency: this.initData["currency_code"],
              value: this.orderDataResponse['payment_data']['amount']['value']
            },
            environment: this.googlePayEnv(this.orderDataResponse['payment_data']['environment']),
            configuration: {
              gatewayMerchantId: this.orderDataResponse['payment_data']["merchant_account"],
              merchantId: this.orderDataResponse['payment_data']["google_pay_merchant_identifier"],
              merchantName: this.orderDataResponse['payment_data']["google_pay_merchant_name"]
            },
            buttonType: 'plain',
            buttonColor: 'white',
            buttonSizeMode: 'static',
            emailRequired: true,
            billingAddressRequired: true,
            shippingAddressRequired: true,
            shippingAddressParameters: {
              allowedCountryCodes: this.allowedShippingCountries(this.orderDataResponse['payment_data']['countryCode']),
              phoneNumberRequired: true
            },
            shippingOptionRequired: true,
            shippingOptionParameters: {
              defaultSelectedOptionId: "shipping-001",
              shippingOptions: [
                {
                  id: "shipping-001",
                  label: this.orderDataResponse['shipping_costs']['price'] + " " + this.initData["currency_code"] + ": " + this.orderDataResponse['shipping_costs']['label']
                }
              ]
            },
            transactionInfo: {
              currencyCode: this.initData["currency_code"],
              countryCode: this.initData["country_code"],
              totalPriceStatus: 'FINAL',
              totalPrice: this.orderDataResponse['order_total'],
              totalPriceLabel: I18n.t('js.public.payments.providers.adyen_v2.google_pay_express_checkout.total'),
              displayItems: klass.orderDataResponse['line_items']
            },
            onSubmit: function(state, component) {
              return klass.googlePayOnSubmit(state, component);
            },
            onAuthorized: function(paymentData) {
              return klass.googlePayOnAuthorized(paymentData);
            },
            onError: function(error, component) {
              $('.gpay-button').attr('disabled', false);
              return klass.googlePayOnError(error, component);
            },
            onAdditionalDetails: function(state, component) {
              return klass.googlePayOnAdditionalDetails(state, component);
            }
          }
        }
      };
      try {
        return AdyenCheckout(configuration).then(function(checkout) {
          var mount_error;
          try {
            that.googlePayComponent = checkout.create(that.googlePayAdyenVariantName, {});
            that.googlePayComponent.isAvailable().then((function(_this) {
              return function() {
                that.googlePayComponent.mount(that.googlePayBtnMountContainer);
                return setTimeout(function() {
                  return that.googlePayComponent.submit();
                }, 300);
              };
            })(this));
          } catch (error1) {
            mount_error = error1;
          }
        });
      } catch (error1) {
        error = error1;
      }
    };

    AdyenV2ExpressCheckoutService.mountECSComponent = function(variantName, configuration, mountPoint, localConfiguration) {
      var error;
      try {
        return AdyenCheckout(configuration).then(function(checkout) {
          var mount_error;
          try {
            checkout.create(variantName, localConfiguration).mount(mountPoint);
          } catch (error1) {
            mount_error = error1;
          }
        });
      } catch (error1) {
        error = error1;
      }
    };

    AdyenV2ExpressCheckoutService.mountGooglePayECSComponent = function(variantName, configuration, mountPoint, localConfiguration) {
      var error, klass;
      klass = Utility.Payments.AdyenV2ExpressCheckoutService;
      try {
        return AdyenCheckout(configuration).then(function(checkout) {
          var googlePayIsLoadedPromise, mount_error;
          try {
            googlePayIsLoadedPromise = App.PublicProducts.loadJavascriptFile('https://pay.google.com/gp/p/js/pay.js', function() {});
            googlePayIsLoadedPromise.then(function() {
              klass.googlePayComponent = checkout.create(variantName, localConfiguration);
              return klass.googlePayComponent.isAvailable().then(function(isLoaded) {
                if (isLoaded === true) {
                  return klass.googlePayComponent.mount(mountPoint);
                }
              });
            });
          } catch (error1) {
            mount_error = error1;
          }
        });
      } catch (error1) {
        error = error1;
      }
    };

    AdyenV2ExpressCheckoutService.googlePayOnClickOnPayButton = function(resolve, reject) {
      var that;
      that = this;
      this.paymentMethod = 'google_pay_express_checkout';
      return that.getOrderData().then(function(response) {
        if (response['error'] && response['error'].length > 0) {
          return that.redirectAndShowErrorFlashMessage(response);
        }
        return that.getPaymentMethods().then(function() {
          return that.getCurrentReference().then(function() {
            return that.googlePayRefreshEcsComponent();
          });
        });
      });
    };

    AdyenV2ExpressCheckoutService.applePayOnClickOnPayButton = function(resolve, reject) {
      var klass;
      klass = Utility.Payments.AdyenV2ExpressCheckoutService;
      klass.paymentMethod = 'apple_pay_express_checkout';
      return klass.getOrderData().then(function(response) {
        if (response['error'] && response['error'].length > 0) {
          return klass.redirectAndShowErrorFlashMessage(response);
        }
        return klass.getPaymentMethods().then(function() {
          return klass.getCurrentReference().then(function() {
            return resolve();
          });
        });
      });
    };

    AdyenV2ExpressCheckoutService.googlePayOnSubmit = function(state, component) {
      var that;
      that = this;
      this.setModalTitle();
      this.googlePayComponent.mount(this.threeDSecure2MountContainer);
      this.hideGooglePayBtnForThreeDsecureContainer();
      this.showAdyenECSModal();
      return this.makePayment(state.data).then(function(paymentResponse) {
        that.finalizeTransaction().then(function(finalizeResponse) {
          if (finalizeResponse['error'] && finalizeResponse['error'].length > 0) {
            return that.redirectAndShowErrorFlashMessage(finalizeResponse);
          }
          that.changeRoutesWithNewToken(finalizeResponse['new_order_public_token']);
          if (paymentResponse.action) {
            that.hideAdyenECSModalLoading();
            return component.handleAction(paymentResponse.action);
          } else if (paymentResponse.status) {
            that.hideAdyenECSModalLoading();
            that.hideAdyenECSModalLogos();
            that.displayResultMessage(false, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error'), 'components-container');
            return that.delayedRedirect(that.delayedTime, that.routes['failClientOrderUrl']);
          } else {
            that.hideAdyenECSModalLogos();
            that.showAdyenECSModalLoading;
            return that.showFinalStatus(paymentResponse, component, finalizeResponse['checkout_error']);
          }
        });
      })["catch"](function(error) {
        throw Error(error);
      });
    };

    AdyenV2ExpressCheckoutService.applePayOnSubmit = function(state, component) {
      var that;
      that = this;
      return this.makePayment(state.data).then(function(paymentResponse) {
        that.finalizeTransaction().then(function(finalizeResponse) {
          if (finalizeResponse['error'] && finalizeResponse['error'].length > 0) {
            return that.redirectAndShowErrorFlashMessage(finalizeResponse);
          }
          that.changeRoutesWithNewToken(finalizeResponse['new_order_public_token']);
          if (paymentResponse.action) {
            return component.handleAction(paymentResponse.action);
          } else if (paymentResponse.status) {
            return that.delayedRedirect(that.delayedTime, that.routes['failClientOrderUrl']);
          } else {
            return that.showFinalStatus(paymentResponse, component, finalizeResponse['checkout_error']);
          }
        });
      })["catch"](function(error) {
        throw Error(error);
      });
    };

    AdyenV2ExpressCheckoutService.googlePayOnAuthorized = function(paymentData) {
      return this.onAuthorizedData = paymentData;
    };

    AdyenV2ExpressCheckoutService.applePayOnAuthorized = function(paymentData) {
      return this.onAuthorizedData = paymentData;
    };

    AdyenV2ExpressCheckoutService.googlePayOnError = function(error, component) {
      return console.error(error.name, error.message, error.stack, component);
    };

    AdyenV2ExpressCheckoutService.googlePayOnAdditionalDetails = function(state, component) {
      var data, that;
      that = this;
      data = state.data;
      this.makeDetailsCall(data).then(function(response) {
        if (response.action) {
          component.handleAction(response.action);
        } else if (response.status) {
          that.hideAdyenECSModalLoading();
          that.hideAdyenECSModalLogos();
          that.displayResultMessage(false, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error'), 'components-container');
          return that.delayedRedirect(that.delayedTime, that.routes['failClientOrderUrl']);
        } else {
          that.hideAdyenECSModalLogos();
          that.showAdyenECSModalLoading();
          that.showFinalStatus(response, component, that.lastFinalizeTransactionResponse['checkout_error']);
        }
      })["catch"](function(error) {
        throw Error(error);
      });
    };

    AdyenV2ExpressCheckoutService.redirectAndShowErrorFlashMessage = function(response) {
      var flashUrl, params;
      flashUrl = this.routes['redirectWithFlashUrl'];
      params = {
        redirect_to: window.location.href,
        flash_key: response['error'],
        type: 'alert',
        error_description: response['error_description']
      };
      return window.location.href = flashUrl + "?" + (this.encodeGetParams(params));
    };

    AdyenV2ExpressCheckoutService.thankYouPageUrl = function(paymentStatus, flashType, checkoutError) {
      var flashKey, flashUrl, params, redirectTo;
      flashUrl = this.routes['redirectWithFlashUrl'];
      redirectTo = this.routes['clientOrderUrl'];
      flashKey = paymentStatus;
      if (checkoutError && checkoutError.length > 0) {
        flashType = 'alert';
        flashKey = checkoutError;
      }
      params = {
        redirect_to: redirectTo,
        flash_key: flashKey,
        type: flashType
      };
      return flashUrl + "?" + (this.encodeGetParams(params));
    };

    AdyenV2ExpressCheckoutService.encodeGetParams = function(p) {
      return Object.entries(p).map(function(kv) {
        return kv.map(encodeURIComponent).join("=");
      }).join("&");
    };

    AdyenV2ExpressCheckoutService.getOrderData = function() {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.initData['create_order_path'],
          method: 'POST',
          data: {
            payment_method: that.paymentMethod
          }
        }).done(function(data) {
          data['routesHash'] = {
            paymentMethodsUrl: data['routes']["payment_methods_url"],
            makePaymentUrl: data['routes']["make_payment_url"],
            finalizeTransactionUrl: data['routes']["finalize_transaction_url"],
            processNotRedirectTypeUrl: data['routes']["process_not_redirect_type_url"],
            clientOrderUrl: data['routes']['client_order_url'],
            currentReferenceUrl: data['routes']['current_reference_url'],
            redirectWithFlashUrl: data['routes']['redirect_with_flash_url']
          };
          that.orderDataResponse = data;
          that.routes = data['routesHash'];
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.getPaymentMethods = function() {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.routes['paymentMethodsUrl'],
          method: 'GET'
        }).done(function(data) {
          that.paymentMethodsResponse = data;
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.getCurrentReference = function() {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.routes['currentReferenceUrl'],
          method: 'GET'
        }).done(function(data) {
          that.currentTransactionReference = data.id_hash;
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.makePayment = function(state_data) {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.routes['makePaymentUrl'],
          method: 'POST',
          data: state_data
        }).done(function(data) {
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.makeDetailsCall = function(state_data) {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.routes['processNotRedirectTypeUrl'],
          method: 'POST',
          data: state_data
        }).done(function(data) {
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.finalizeTransaction = function() {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.routes['finalizeTransactionUrl'],
          method: 'POST',
          data: {
            transaction_id_hash: that.currentTransactionReference,
            auth_data: that.onAuthorizedData,
            payment_method: that.paymentMethod
          }
        }).done(function(data) {
          that.lastFinalizeTransactionResponse = data;
          return resolve(data);
        }).fail(function(xhr) {
          that.lastFinalizeTransactionResponse = data;
          return reject(null);
        });
      });
    };

    AdyenV2ExpressCheckoutService.googlePayEnv = function(environment) {
      if (environment === 'live') {
        return 'PRODUCTION';
      } else {
        return 'TEST';
      }
    };

    AdyenV2ExpressCheckoutService.showFinalStatus = function(response, component, checkoutError) {
      this.hideAdyenECSModalLoading();
      this.hideAdyenECSModalLogos();
      if (this.successfullStates.includes(response.resultCode)) {
        this.displayResultMessage(true, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.success'), 'components-container');
        if (response.additionalData && response.additionalData['fraudResultType'] === 'AMBER') {
          return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('verify', 'notice', checkoutError));
        } else {
          return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('success', 'notice', checkoutError));
        }
      } else if (this.waitingStates.includes(response.resultCode)) {
        this.displayResultMessage(true, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.waiting'), 'components-container');
        return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('waiting', 'notice', checkoutError));
      } else if (this.cancelledStates.includes(response.resultCode)) {
        this.displayResultMessage(false, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.cancelled'), 'components-container');
        return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('fail', 'alert', checkoutError));
      } else if (this.refusedStates.includes(response.resultCode)) {
        this.displayResultMessage(false, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.refused'), 'components-container');
        return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('fail', 'alert', checkoutError));
      } else {
        this.displayResultMessage(false, I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error'), 'components-container');
        return this.delayedRedirect(this.delayedTime, this.thankYouPageUrl('fail', 'alert', checkoutError));
      }
    };

    AdyenV2ExpressCheckoutService.displayResultMessage = function(isAuthorized, resultCode, wrapperName) {
      var container, image, img_src, resultText;
      image = document.createElement('img');
      img_src = isAuthorized ? this.successImageUrl : this.errorImageUrl;
      image.setAttribute('src', img_src);
      image.setAttribute('height', '100');
      image.style.display = 'flex';
      image.style.margin = 'auto auto 30px';
      resultText = document.createElement('div');
      resultText.setAttribute('data-testid', 'result-message');
      resultText.style.textAlign = 'center';
      resultText.textContent = resultCode;
      container = document.getElementById(wrapperName);
      container.appendChild(image);
      container.appendChild(resultText);
    };

    AdyenV2ExpressCheckoutService.delayInSec = function(time, val) {
      return new Promise(function(resolve) {
        return setTimeout(resolve, time, val);
      });
    };

    AdyenV2ExpressCheckoutService.delayedRedirect = function(time, url) {
      return this.delayInSec(time).then(function(resolve) {
        return window.location.href = url;
      });
    };

    AdyenV2ExpressCheckoutService.setModalTitle = function() {
      var headerTitle;
      headerTitle = this.paymentMethod === 'google_pay_express_checkout' ? 'Google Pay Express Checkout' : this.paymentMethod === 'apple_pay_express_checkout' ? 'Apple Pay Express Checkout' : void 0;
      return $('#adyen-ecs-modal .mzkr-modal__title').html(headerTitle);
    };

    AdyenV2ExpressCheckoutService.allowedShippingCountries = function(countryCode) {
      if (this.environment === 'live') {
        return [countryCode];
      } else {
        return [countryCode, 'PL'];
      }
    };

    AdyenV2ExpressCheckoutService.hideGooglePayBtnForThreeDsecureContainer = function() {
      return $('#components-container .adyen-checkout__paywithgoogle').hide();
    };

    AdyenV2ExpressCheckoutService.showAdyenECSModal = function() {
      return Mzkr.Modal.show('#adyen-ecs-modal');
    };

    AdyenV2ExpressCheckoutService.hideAdyenECSModalLoading = function() {
      return $('#modal-loading-img').hide();
    };

    AdyenV2ExpressCheckoutService.showAdyenECSModalLoading = function() {
      return $('#modal-loading-img').show();
    };

    AdyenV2ExpressCheckoutService.hideAdyenECSModalLogos = function() {
      return $('#adyen-ecs-modal .adyen-logos').hide();
    };

    AdyenV2ExpressCheckoutService.changeRoutesWithNewToken = function(newPublicToken) {
      return this.routes['clientOrderUrl'] = this.replaceTokenInUrl(this.routes['clientOrderUrl'], newPublicToken);
    };

    AdyenV2ExpressCheckoutService.replaceTokenInUrl = function(url, newToken) {
      return url.replace(/token=[\w]+/gi, "token=" + newToken);
    };

    AdyenV2ExpressCheckoutService.newTotalHash = function() {
      return {
        label: this.totalPriceLabel,
        amount: this.orderDataResponse['order_total'],
        type: "final"
      };
    };

    AdyenV2ExpressCheckoutService.getShippingMethods = function(countryCode) {
      switch (countryCode) {
        case this.initData["country_code"]:
          return [
            {
              label: this.orderDataResponse['shipping_costs']['label'],
              detail: this.orderDataResponse['shipping_costs']['label'],
              amount: this.orderDataResponse['shipping_costs']['price'],
              identifier: 'shipping'
            }
          ];
        default:
          return [];
      }
    };

    return AdyenV2ExpressCheckoutService;

  })();

}).call(this);
(function() {
  var base1;

  window.Utility || (window.Utility = {});

  (base1 = window.Utility).Payments || (base1.Payments = {});

  Utility.Payments.AdyenV2Service = (function() {
    AdyenV2Service.translation_keys_item_array = [];

    AdyenV2Service.translation_values_item_array = [];

    AdyenV2Service.locale_key_mapping = {};

    AdyenV2Service.successfull_states = ['Authorised'];

    AdyenV2Service.waiting_states = ['Received', 'Pending', 'PresentToShopper'];

    AdyenV2Service.cancelled_states = ['Cancelled'];

    AdyenV2Service.error_states = ['Error'];

    AdyenV2Service.refused_states = ['Refused'];

    AdyenV2Service.currentTransactionReference = null;

    AdyenV2Service.delayedTime = 4000;

    AdyenV2Service.dropinInstance || (AdyenV2Service.dropinInstance = null);

    function AdyenV2Service() {
      return this;
    }

    AdyenV2Service.init = function(data) {
      var that;
      this.init_data = data;
      this.translation_data = I18n.t('js.public.payments.providers.adyen_v2.dropin_form');
      this.payment_methods_url = data["payment_methods_url"];
      this.make_payment_url = data["make_payment_url"];
      this.current_reference_url = data["current_reference_url"];
      this.disable_stored_payment_detail_url = data['disable_stored_payment_detail_url'];
      this.process_not_redirect_type_url = data["process_not_redirect_type_url"];
      this.client_order_url = data['client_order_url'];
      this.success_client_order_url = data['success_client_order_url'];
      this.waiting_client_order_url = data['waiting_client_order_url'];
      this.fail_client_order_url = data['fail_client_order_url'];
      this.verify_client_order_url = data['verify_client_order_url'];
      this.environment = data["environment"];
      this.locale_mapping = data["locale_mapping"];
      this.clientKey = data["client_key"];
      this.locale_key_mapping = this.prepare_locale_key_mapping();
      this.construct_translation_array(this.translation_data, '');
      this.prepare_translations_for_config();
      console.log('Google Pay is loading in environment: ' + this.environment);
      console.log('Google Pay merchant identifier is: ' + this.init_data["google_pay_merchant_identifier"]);
      console.log('Google Pay merchant name is: ' + this.init_data["google_pay_merchant_name"]);
      that = this;
      that.getCurrentReference().then(function(response) {
        return that.currentTransactionReference = response.id_hash;
      });
      return $.get(this.payment_methods_url, function(data) {
        var configuration, error;
        configuration = that.config();
        configuration['paymentMethodsResponse'] = data;
        configuration['translations'] = {};
        configuration['translations'][that.locale_mapping] = that.translated_rows;
        configuration['paymentMethodsConfiguration'] = {
          applepay: {
            amount: {
              value: that.multiplied_total_price(),
              currency: that.init_data["currency_code"]
            },
            countryCode: that.init_data["country_code"]
          },
          directEbanking: {
            name: that.payment_method_name('directebanking', 'Online bank transfer')
          },
          klarna_account: {
            name: that.payment_method_name('klarna_account', 'Pay over time with Klarna')
          },
          klarna: {
            name: that.payment_method_name('klarna', 'Pay later with Klarna')
          },
          dotpay: {
            name: that.payment_method_name('dotpay', 'Local Polish payment Methods')
          },
          bcmc: {
            name: that.payment_method_name('bcmc', 'Bancontact card'),
            enableStoreDetails: true
          },
          bcmc_mobile_QR: {
            name: that.payment_method_name('bcmc_mobile', 'Payconiq by Bancontact')
          },
          bcmc_mobile_app: {
            name: that.payment_method_name('bcmc_mobile', 'Payconiq by Bancontact'),
            enableStoreDetails: false
          },
          card: {
            name: that.payment_method_name('card', 'Credit Card'),
            enableStoreDetails: true,
            clickToPayConfiguration: {
              merchantDisplayName: 'MUZIKER',
              shopperEmail: that.init_data['customer_email']
            }
          }
        };
        $('#modal-loading-img').hide();
        try {
          return AdyenCheckout(configuration).then(function(checkout) {
            var error;
            try {
              if (that.dropinInstance) {
                that.dropinInstance.unmount();
              }
            } catch (error1) {
              error = error1;
              console.error(error);
            }
            that.dropinInstance = checkout.create('dropin', {
              paymentMethodsConfiguration: {
                paywithgoogle: {
                  environment: that.google_pay_env(),
                  amount: {
                    currency: that.init_data["currency_code"],
                    value: that.multiplied_total_price()
                  },
                  configuration: {
                    gatewayMerchantId: that.init_data["merchant_account"],
                    merchantIdentifier: that.init_data["google_pay_merchant_identifier"],
                    merchantName: that.init_data["google_pay_merchant_name"]
                  }
                }
              },
              showRemovePaymentMethodButton: true,
              onDisableStoredPaymentMethod: function(storedPaymentMethodId, resolve, reject) {
                return that.disableStoredPaymentMethod(storedPaymentMethodId, that.disable_stored_payment_detail_url, resolve, reject);
              }
            }).mount('#dropin-container');
          });
        } catch (error1) {
          error = error1;
          return console.error(error);
        }
      });
    };

    AdyenV2Service.config = function() {
      var configuration, that;
      that = this;
      return configuration = {
        paymentMethodsResponse: '',
        clientKey: this.clientKey,
        locale: this.locale_mapping,
        environment: this.environment,
        analytics: {
          enabled: false
        },
        onSubmit: function(state, dropin) {
          var dataForPayment;
          dropin.setStatus('loading');
          dataForPayment = state.data;
          dataForPayment.current_id_hash = that.currentTransactionReference;
          that.makePayment(dataForPayment).then(function(response) {
            dropin.setStatus('ready');
            if (response.action) {
              dropin.handleAction(response.action);
            } else if (response.status) {
              dropin.setStatus('error', {
                message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error')
              });
            } else {
              that.showFinalStatus(response, dropin);
            }
          })["catch"](function(error) {
            throw Error(error);
          });
        },
        onAdditionalDetails: function(state, dropin) {
          var data;
          data = state.data;
          data.current_id_hash = that.currentTransactionReference;
          that.makeDetailsCall(data).then(function(response) {
            if (response.action) {
              dropin.handleAction(response.action);
            } else if (response.status) {
              dropin.setStatus('error', {
                message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error')
              });
            } else {
              that.showFinalStatus(response, dropin);
            }
          })["catch"](function(error) {
            throw Error(error);
          });
        }
      };
    };

    AdyenV2Service.showFinalStatus = function(response, dropin) {
      if (this.successfull_states.includes(response.resultCode)) {
        dropin.setStatus('success', {
          message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.success')
        });
        if (response.additionalData && response.additionalData['fraudResultType'] === 'AMBER') {
          return this.delayedRedirect(this.delayedTime, this.verify_client_order_url);
        } else {
          return this.delayedRedirect(this.delayedTime, this.success_client_order_url);
        }
      } else if (this.waiting_states.includes(response.resultCode)) {
        dropin.setStatus('success', {
          message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.waiting')
        });
        return this.delayedRedirect(this.delayedTime, this.waiting_client_order_url);
      } else if (this.cancelled_states.includes(response.resultCode)) {
        dropin.setStatus('error', {
          message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.cancelled')
        });
        return this.delayedRedirect(this.delayedTime, this.fail_client_order_url);
      } else if (this.refused_states.includes(response.resultCode)) {
        dropin.setStatus('error', {
          message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.refused')
        });
        return this.delayedRedirect(this.delayedTime, this.fail_client_order_url);
      } else {
        dropin.setStatus('error', {
          message: I18n.t('js.public.payments.providers.adyen_v2.dropin_form.status_messages.error')
        });
        return this.delayedRedirect(this.delayedTime, this.fail_client_order_url);
      }
    };

    AdyenV2Service.makeDetailsCall = function(state_data) {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.process_not_redirect_type_url,
          method: 'POST',
          data: state_data
        }).done(function(data) {
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2Service.makePayment = function(state_data) {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.make_payment_url,
          method: 'POST',
          data: state_data
        }).done(function(data) {
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2Service.getCurrentReference = function() {
      var that;
      that = this;
      return new Promise(function(resolve, reject) {
        return $.ajax({
          url: that.current_reference_url,
          method: 'GET'
        }).done(function(data) {
          return resolve(data);
        }).fail(function(xhr) {
          return reject(null);
        });
      });
    };

    AdyenV2Service.disableStoredPaymentMethod = function(storedPaymentMethodId, disableStoredPaymentDetailUrl, resolve, reject) {
      var that;
      that = this;
      return $.ajax({
        url: disableStoredPaymentDetailUrl,
        method: 'POST',
        data: {
          stored_payment_method_id: storedPaymentMethodId
        }
      }).done(function(data) {
        return resolve();
      }).fail(function(xhr) {
        return reject();
      });
    };

    AdyenV2Service.underscore_to_camel_case_key = function(underscore_key) {
      var arr, i, newStr;
      arr = underscore_key.split(/[_]/);
      newStr = '';
      i = 1;
      while (i < arr.length) {
        newStr += arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        i++;
      }
      return arr[0] + newStr;
    };

    AdyenV2Service.construct_translation_array = function(obj, arg_path) {
      var j, k, l, path, path_arr, ref, value_path;
      for (k in obj) {
        path = arg_path + '.' + k;
        path_arr = path.split('.');
        value_path = '';
        for (j = l = 1, ref = path_arr.length; 1 <= ref ? l < ref : l > ref; j = 1 <= ref ? ++l : --l) {
          value_path += '["' + path_arr[j] + '"]';
        }
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          this.construct_translation_array(obj[k], path);
        } else {
          this.translation_keys_item_array.push(path);
          this.translation_values_item_array.push(eval('AdyenV2Service.translation_data' + value_path));
        }
      }
    };

    AdyenV2Service.prepare_translations_for_config = function() {
      var camel_case_locale_key, item_index, key_hash, locale_key, locale_key_mapped, results;
      this.translated_rows = {};
      if (this.init_data["merchant_account"] === 'MuzikerPL') {
        return this.translated_rows;
      }
      results = [];
      for (item_index in this.translation_keys_item_array) {
        locale_key = this.translation_keys_item_array[item_index].substring(1);
        locale_key_mapped = this.locale_key_mapping[locale_key] || locale_key;
        camel_case_locale_key = this.underscore_to_camel_case_key(locale_key_mapped);
        key_hash = {};
        key_hash[camel_case_locale_key] = this.translation_values_item_array[item_index];
        results.push(this.translated_rows = Object.assign(this.translated_rows, key_hash));
      }
      return results;
    };

    AdyenV2Service.prepare_locale_key_mapping = function() {
      return {
        'voucher.introduction.title': 'voucher.introduction',
        'pay_button.title': 'pay_button',
        "credit_card.cvc_field.title.title": 'credit_card.cvc_field.title',
        'credit_card.expiry_date_field.month.title': 'credit_card.expiry_date_field.month',
        'credit_card.expiry_date_field.year.title': 'credit_card.expiry_date_field.year',
        'date_of_birth.title': 'date_of_birth',
        'error.va.gen.1': 'error.va.gen.01',
        'error.va.gen.2': 'error.va.gen.02',
        'error.va.sf-cc-num.1': 'error.va.sf-cc-num.01',
        'error.va.sf-cc-num.2': 'error.va.sf-cc-num.02',
        'error.va.sf-cc-num.3': 'error.va.sf-cc-num.03',
        'error.va.sf-cc-dat.1': 'error.va.sf-cc-dat.01',
        'error.va.sf-cc-dat.2': 'error.va.sf-cc-dat.02'
      };
    };

    AdyenV2Service.payment_method_name = function(method, default_name) {
      var translated_payment_name;
      translated_payment_name = I18n.t('js.public.payments.providers.adyen_v2.dropin_form.payment_method_names.' + method);
      if (translated_payment_name.startsWith('[missing')) {
        console.log(translated_payment_name);
        translated_payment_name = default_name;
      }
      return translated_payment_name;
    };

    AdyenV2Service.google_pay_env = function() {
      if (this.environment === 'live') {
        return 'PRODUCTION';
      } else {
        return 'TEST';
      }
    };

    AdyenV2Service.delayInSec = function(time, val) {
      return new Promise(function(resolve) {
        return setTimeout(resolve, time, val);
      });
    };

    AdyenV2Service.delayedRedirect = function(time, url) {
      return this.delayInSec(time).then(function(resolve) {
        return window.location.href = url;
      });
    };

    AdyenV2Service.round_with_precision = function(num, precision) {
      var base;
      base = Math.pow(10, precision);
      return Math.round(num * base) / base;
    };

    AdyenV2Service.multiplied_total_price = function() {
      var amount, multiplier;
      amount = parseFloat(this.init_data["amount"]);
      multiplier = parseInt(this.init_data["multiplier"]);
      return this.round_with_precision(amount * multiplier, 0);
    };

    return AdyenV2Service;

  })();

}).call(this);
(function() {
  var base;

  window.Utility || (window.Utility = {});

  (base = window.Utility).Payments || (base.Payments = {});

  Utility.Payments.KevinService = (function() {
    function KevinService() {
      return this;
    }

    KevinService.init = function(data) {
      var that;
      this.init_data = data;
      this.bank_selection_url = data["bank_selection_url"];
      that = this;
      return that.get_bank_selection(data);
    };

    KevinService.get_bank_selection = function(data) {
      var that;
      that = this;
      return $.get(this.bank_selection_url, function(data) {
        return that.on_bank_selection(data);
      });
    };

    KevinService.on_bank_selection = function(data) {
      var that;
      that = this;
      $('#modal-loading-img').hide();
      $('#bank_selection_content').html(data);
      $('form .row.bank_details').on('click', 'label img', function() {
        var $form, $this;
        $this = $(this);
        $this.closest('label').find('input').prop("checked", true);
        $form = $this.closest('form');
        $form.submit();
        $('#bank_selection_content').html('');
        return $('#modal-loading-img').show();
      });
      return $('form .row.bank_details').on('click', '.delete_link', function(e) {
        $('#bank_selection_content').html('');
        $('#modal-loading-img').show();
        $.ajax({
          type: 'POST',
          url: $(this).attr('href'),
          success: function() {
            return that.get_bank_selection(that.init_data);
          }
        });
        return e.preventDefault();
      });
    };

    return KevinService;

  })();

}).call(this);
(function() {
  var base,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  window.Utility || (window.Utility = {});

  (base = window.Utility).Payments || (base.Payments = {});

  Utility.Payments.PublicShopPaymentQrCodes = (function() {
    function PublicShopPaymentQrCodes() {
      this.counterToSeconds = bind(this.counterToSeconds, this);
      this.extractPaymentQrCode = bind(this.extractPaymentQrCode, this);
    }

    PublicShopPaymentQrCodes.prototype.extractPaymentQrCode = function() {
      var blurImage, counter, defaultImagePath, format, img, incrementalCounter, qrCodeData, qrCodePlacement;
      qrCodePlacement = $('#qr-code-placement');
      if (qrCodePlacement.length === 0) {
        return;
      }
      blurImage = document.getElementById('qr-code-placement');
      counter = this.counterToSeconds(1);
      incrementalCounter = this.counterToSeconds(-1);
      format = qrCodePlacement.data('format');
      qrCodeData = qrCodePlacement.data('qr-code-data');
      defaultImagePath = qrCodePlacement.data('default-image-path');
      if (qrCodeData && qrCodeData.length > 0) {
        img = $('<img id="qr-code">');
        img.attr('src', 'data:image/' + format + ';base64,' + qrCodeData);
        img.attr('width', '150');
        img.appendTo('#qr-code-placement');
        return;
      } else {
        qrCodePlacement.html('');
        img = $('<img id="qr-code">');
        img.attr('src', defaultImagePath);
        blurImage.style.filter = 'blur(4px)';
        img.attr('width', '150');
        img.appendTo('#qr-code-placement');
      }
      return window.countDownInterval = setInterval((function() {
        counter--;
        if (counter === 0) {
          return $.ajax({
            type: 'GET',
            url: qrCodePlacement.data('path'),
            success: function(data) {
              if (data.base_qr_code === null) {
                incrementalCounter++;
                return counter = parseInt(Math.exp(incrementalCounter));
              } else {
                qrCodePlacement.html('');
                img = $('<img id="qr-code">');
                img.attr('src', 'data:image/' + format + ';base64,' + data.base_qr_code);
                img.attr('width', '150');
                blurImage.style.filter = 'blur()';
                img.appendTo('#qr-code-placement');
                return clearInterval(window.countDownInterval);
              }
            }
          });
        }
      }), 1000);
    };

    PublicShopPaymentQrCodes.prototype.counterToSeconds = function(counter) {
      return parseInt(Math.exp(counter));
    };

    return PublicShopPaymentQrCodes;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.PhoneNormalize = (function() {
    function PhoneNormalize() {}

    PhoneNormalize.initPhoneLib = function(scope) {
      var initPhones;
      if (scope == null) {
        scope = document;
      }
      initPhones = $(scope).find('.phone-number');
      return initPhones.each(function() {
        var currentCountry, defaultCountries, finalOnlyCountries, form, internationalCountries, iti, onlyCountries, phoneElement, validate;
        phoneElement = $(this);
        if (phoneElement.length && !phoneElement.hasClass('iti-initialized')) {
          phoneElement.addClass('iti-initialized');
          form = phoneElement.closest('form');
          internationalCountries = phoneElement.data('international-countries');
          currentCountry = phoneElement.data('init-country');
          defaultCountries = ['cz', 'lt', 'pt', 'it', 'hu', 'ro', 'nl', 'sk', 'lu', 'be', 'fi', 'es', 'lv', 'se', 'gb', 'ee', 'ie', 'si', 'fr', 'gr', 'at', 'de', 'pl', 'dk', 'bg', 'hr', 'ch'];
          onlyCountries = phoneElement.data('only-countries');
          finalOnlyCountries = onlyCountries.length ? onlyCountries : defaultCountries.concat(internationalCountries);
          iti = intlTelInput(phoneElement[0], {
            containerClass: 'intl-tel-input',
            initialCountry: currentCountry,
            hiddenInput: function(telInputName) {
              return {
                phone: telInputName.replace(/\[(\w+)\]$/, '[normalized_$1]')
              };
            },
            allowDropdown: finalOnlyCountries.length !== 1,
            onlyCountries: finalOnlyCountries,
            separateDialCode: true,
            i18n: {
              searchPlaceholder: ''
            }
          });
          iti.hiddenInput.value = iti.getNumber();
          phoneElement[0].addEventListener('countrychange', phoneElement.trigger('blur'), false);
          validate = function() {
            var formSubmitBtn, skipSubmitValidation;
            phoneElement[0].classList.remove('is-invalid');
            formSubmitBtn = $('.cartSubmitFormBtn');
            skipSubmitValidation = phoneElement[0].classList.contains('no-submit-validation');
            if (!formSubmitBtn.length) {
              formSubmitBtn = form.find('input[type=submit]');
            }
            iti.hiddenInput.value = iti.getNumber();
            if (phoneElement[0].value.trim()) {
              if (!iti.isValidNumber() && !phoneElement.hasClass('intl-no-validate')) {
                phoneElement[0].classList.add('is-invalid');
                if (!skipSubmitValidation) {
                  formSubmitBtn.addClass('disabled');
                }
                if (!skipSubmitValidation) {
                  formSubmitBtn.attr('disabled', '');
                }
                return;
              }
            }
            formSubmitBtn.removeClass('disabled');
            formSubmitBtn.removeAttr('disabled');
          };
          phoneElement[0].addEventListener('countrychange', validate, false);
          phoneElement[0].addEventListener('keyup', validate, false);
          return phoneElement[0].addEventListener('change', validate, false);
        }
      });
    };

    PhoneNormalize.formatAfterLoadData = function(phoneInput) {
      var intlInstance, number;
      if (!phoneInput) {
        return;
      }
      intlInstance = window.intlTelInput.getInstance(phoneInput);
      if (intlInstance) {
        number = intlInstance.getNumber();
        if (number) {
          return intlInstance.setNumber(number);
        }
      }
    };

    return PhoneNormalize;

  })();

}).call(this);
(function() {
  var localStorageProductComparisonsKey,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  window.PublicUtility || (window.PublicUtility = {});

  localStorageProductComparisonsKey = 'product_comparisons';

  PublicUtility.ProductComparison = (function() {
    var fetchDataToLocalStorage;

    function ProductComparison() {}

    ProductComparison.initInProductComparison = function(scope) {
      var $dataElement, _, currentProductComparisonsData, initialized, pcProductsStorage, pcProductsStorageData, product, productComparisonId, productComparisonsProducts, productInProductComparison, productList, productsCodes, ref, storage, translation;
      if (scope == null) {
        scope = document;
      }
      if (!$('[data-current-product-comparisons]').length) {
        return;
      }
      try {
        storage = window.localStorage;
      } catch (error) {
        _ = error;
        storage = false;
      }
      if (!storage) {
        return;
      }
      $dataElement = $('[data-current-product-comparisons]');
      initialized = parseInt($dataElement.attr('data-initialized') || 0);
      if (!initialized) {
        fetchDataToLocalStorage(storage);
      }
      $dataElement.attr('data-initialized', 1);
      try {
        pcProductsStorage = JSON.parse(storage.getItem(localStorageProductComparisonsKey)) || {};
      } catch (error) {
        _ = error;
        pcProductsStorage = {};
      }
      pcProductsStorageData = pcProductsStorage['data'];
      product = $(scope).find('.container[data-product-code]');
      currentProductComparisonsData = Object.keys(JSON.parse($dataElement.attr('data-current-product-comparisons')) || {});
      if (!product.length) {
        product = $(scope).find('[data-product-comparison-product]');
      }
      productList = $(scope).find('[data-wish-and-buy] .product-tile');
      if (pcProductsStorageData && (product.length || productList.length)) {
        productInProductComparison = [];
        try {
          productComparisonsProducts = pcProductsStorageData;
        } catch (error) {
          _ = error;
          productComparisonsProducts = {};
        }
        for (productComparisonId in productComparisonsProducts) {
          productsCodes = productComparisonsProducts[productComparisonId];
          if (productsCodes.length) {
            if (currentProductComparisonsData) {
              if (currentProductComparisonsData.indexOf(productComparisonId) >= 0) {
                productInProductComparison.push.apply(productInProductComparison, productsCodes);
              }
            }
          }
        }
        if (product.length) {
          translation = 'js.public.products.product_comparison_items.remove_from_product_comparison';
          if (ref = product.data('product-code'), indexOf.call(productInProductComparison, ref) >= 0) {
            translation = 'js.public.products.product_comparison_items.add_to_product_comparison';
            PublicUtility.ProductComparison.addToProductComparison(product);
          }
          PublicUtility.ProductComparison.changeProductComparisonLinkTextAfterClick($('.product-comparison-in-detail.is-valid'), I18n.t(translation));
        }
        if (productList.length) {
          return productList.each(function() {
            var element, productCodes;
            element = $(this);
            productCodes = element.data('product-codes');
            if (productCodes) {
              return productCodes.forEach(function(item) {
                if (indexOf.call(productInProductComparison, item) >= 0) {
                  return PublicUtility.ProductComparison.addToProductComparison(element);
                }
              });
            }
          });
        }
      }
    };

    ProductComparison.addToProductComparison = function(element) {
      var productComparisonIcon, productComparisonLink, removeTranslationText;
      productComparisonLink = element.find('.product-comparison-link');
      productComparisonIcon = element.find('.product-comparison-icon');
      removeTranslationText = I18n.t('js.public.products.product_comparison_items.remove_from_product_comparison');
      productComparisonLink.closest('.wrapper').addClass('product-comparison-active');
      productComparisonIcon.closest('.wrapper').addClass('product-comparison-active');
      productComparisonLink.attr('title', removeTranslationText).attr('data-method', 'delete').attr('href', Routes.product_comparison_items_destroy_by_code_path(element.data('product-code')));
      if (productComparisonLink.hasClass('in-group-selector') || productComparisonLink.hasClass('product-comparison-in-detail')) {
        $('span', productComparisonLink).html(removeTranslationText);
        productComparisonLink.attr('data-disable-with', removeTranslationText);
      }
      if (productComparisonLink.hasClass('product-comparison-in-detail')) {
        productComparisonLink.removeClass('product-comparison-add').addClass('product-comparison-remove');
        return PublicUtility.ProductComparison.changeProductComparisonLinkTextAfterClick(productComparisonLink, I18n.t('js.public.products.product_comparison_items.add_to_product_comparison'));
      }
    };

    ProductComparison.removeFromProductComparison = function(element) {
      var addTranslationText, productComparisonIcon, productComparisonLink;
      productComparisonLink = element.find('.product-comparison-link');
      productComparisonIcon = element.find('.product-comparison-icon');
      addTranslationText = I18n.t('js.public.products.product_comparison_items.add_to_product_comparison');
      productComparisonLink.closest('.wrapper').removeClass('product-comparison-active');
      productComparisonIcon.closest('.wrapper').removeClass('product-comparison-active');
      productComparisonLink.attr('title', addTranslationText).attr('data-method', 'post').attr('href', Routes.product_comparison_items_path({
        product_code: element.data('product-code')
      }));
      if (productComparisonLink.hasClass('in-group-selector') || productComparisonLink.hasClass('product-comparison-in-detail')) {
        $('span', productComparisonLink).html(addTranslationText);
        productComparisonLink.attr('data-disable-with', addTranslationText);
      }
      if (productComparisonLink.hasClass('product-comparison-in-detail')) {
        productComparisonLink.removeClass('product-comparison-remove').addClass('product-comparison-add');
        return PublicUtility.ProductComparison.changeProductComparisonLinkTextAfterClick(productComparisonLink, I18n.t('js.public.products.product_comparison_items.remove_from_product_comparison'));
      }
    };

    ProductComparison.changeProductComparisonLinkTextAfterClick = function(el, text) {
      if (el.length) {
        return el.click(function() {
          return $('span', $(this)).html(text);
        });
      }
    };

    ProductComparison.manageLocalStorage = function(action, productCode, productComparisonId, identifier) {
      var $dataElement, _, pcCurrentProductsStorageData, pcProductsStorage, pcProductsStorageData, productIndexInProductComparison, storage;
      try {
        storage = window.localStorage;
      } catch (error) {
        _ = error;
        storage = false;
      }
      if (!storage) {
        return;
      }
      fetchDataToLocalStorage(storage);
      pcProductsStorage = JSON.parse(storage.getItem(localStorageProductComparisonsKey)) || {};
      pcProductsStorageData = pcProductsStorage['data'] || {};
      pcCurrentProductsStorageData = pcProductsStorageData[productComparisonId] || [];
      productIndexInProductComparison = pcCurrentProductsStorageData.indexOf(productCode);
      $dataElement = $('[data-current-product-comparisons]');
      if (action === 'create') {
        pcCurrentProductsStorageData.push(productCode);
      } else {
        pcCurrentProductsStorageData.splice(productIndexInProductComparison, 1);
      }
      if (pcCurrentProductsStorageData.length) {
        pcProductsStorageData[productComparisonId] = pcCurrentProductsStorageData;
        storage.setItem(localStorageProductComparisonsKey, JSON.stringify({
          data: pcProductsStorageData,
          identifier: identifier
        }));
        return $dataElement.attr('data-identifier', identifier);
      } else {
        delete pcProductsStorageData[productComparisonId];
        if (Object.keys(pcProductsStorageData).length) {
          storage.setItem(localStorageProductComparisonsKey, JSON.stringify({
            data: pcProductsStorageData,
            identifier: identifier
          }));
          return $dataElement.attr('data-identifier', identifier);
        } else {
          return storage.removeItem(localStorageProductComparisonsKey);
        }
      }
    };

    fetchDataToLocalStorage = function(storage) {
      return setTimeout((function() {
        var $dataElement, content, count, currentIdentifier, storageIdentifier;
        content = JSON.parse(storage.getItem(localStorageProductComparisonsKey)) || {};
        $dataElement = $('[data-current-product-comparisons]');
        count = parseInt($dataElement.attr('data-count') || 0);
        currentIdentifier = $dataElement.attr('data-identifier');
        storageIdentifier = (content || {})['identifier'];
        if ((!content || (content && currentIdentifier !== storageIdentifier)) && count > 0) {
          return $.ajax({
            url: Routes.fetch_storage_data_product_comparisons_path(),
            type: 'get',
            success: function(data) {
              return storage.setItem(localStorageProductComparisonsKey, JSON.stringify(data));
            }
          });
        } else if (content && count === 0) {
          return storage.removeItem(localStorageProductComparisonsKey);
        }
      }), 100);
    };

    return ProductComparison;

  })();

}).call(this);
(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.ProductGroupSelector = (function() {
    function ProductGroupSelector(element) {
      var enableBuyOnlyOneProduct;
      this.elementScope = element.closest('.mzkr-modal').length ? element.closest('.mzkr-modal') : element;
      this.allProducts = element.data('group-products');
      this.isReadOnly = typeof element.data('selector-is-read-only') !== 'undefined' ? true : false;
      this.allValues = element.data('technical-param-values');
      this.allParams = [];
      this.valuesForParams = {};
      this.selectedProduct = element.data('selected-product');
      this.selectorPosition = element.data('selector-position');
      this.showStockAvailable = $('[data-product-stock-available]').length > 0;
      this.showStockStatus = $('[data-product-stock-status]').length > 0;
      enableBuyOnlyOneProduct = this.allProducts.length === 1 && this.selectorPosition === 'product_list' ? true : false;
      this.groupImgLargeTreshold = 5;
      this.initializeValuesAndSelectors();
      if (this.selectedProduct) {
        this.setValuesFromProduct();
      }
      if (element.closest('.mzkr-modal').length) {
        new PublicUtility.Analytics(element.closest('.mzkr-modal'));
      }
      this.refreshParamsWithValues(enableBuyOnlyOneProduct);
    }

    ProductGroupSelector.prototype.initializeValuesAndSelectors = function() {
      var that;
      that = this;
      return $(this.elementScope).find('[data-param-id]').each(function() {
        var paramId, paramPosition, paramType;
        paramId = $(this).data('param-id');
        paramPosition = $(this).data('param-position');
        paramType = $(this).data('param-type');
        that.allParams.push({
          paramId: paramId,
          paramPosition: paramPosition,
          paramType: paramType,
          selectedValue: null
        });
        return that["init_selector_for_" + paramType]($(this), paramId, paramPosition);
      });
    };

    ProductGroupSelector.prototype.setValuesFromProduct = function() {
      var findProduct, j, k, len, len1, product, ref, ref1, results, that, value;
      that = this;
      findProduct = null;
      ref = that.allProducts;
      for (j = 0, len = ref.length; j < len; j++) {
        product = ref[j];
        if (product['id_hash'] === that.selectedProduct.toString()) {
          findProduct = product;
          break;
        }
      }
      if (findProduct) {
        if (that.selectorPosition === 'product_list') {
          that.refreshCartButton(findProduct);
          that.changeProductInfo(findProduct);
        }
        ref1 = that.allParams;
        results = [];
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          value = ref1[k];
          results.push(value['selectedValue'] = findProduct['technical_params'][value['paramId']]);
        }
        return results;
      }
    };

    ProductGroupSelector.prototype.redirectToProduct = function(product, selectedValues, afterRefresheAllParams) {
      var cartButton, extraGiftBtn, mayCallRedirect, that;
      that = this;
      if (product !== null && product['path'] !== window.location.pathname) {
        $('[data-loader] .loader-wrap').removeClass('invisible');
        return window.location.href = product['path'];
      } else {
        cartButton = $('[data-add-to-cart-button]');
        extraGiftBtn = $('[data-extra-gift-button-to-basket]');
        mayCallRedirect = false;
        if (cartButton.length) {
          if (product !== null) {
            cartButton.removeAttr('disabled');
            if (extraGiftBtn.length && !extraGiftBtn.hasClass('gift-in-basket')) {
              extraGiftBtn.removeAttr('disabled');
            }
            that.refreshParamsWithValues(mayCallRedirect);
          } else {
            cartButton.attr('disabled', true);
            if (extraGiftBtn.length && !extraGiftBtn.hasClass('gift-in-basket')) {
              extraGiftBtn.attr('disabled', true);
            }
          }
        }
        if (product === null || product['path'] !== window.location.pathname) {
          that.refreshAllParams(selectedValues);
          mayCallRedirect = true;
          if (!afterRefresheAllParams) {
            return that.refreshParamsWithValues(mayCallRedirect);
          }
        }
      }
    };

    ProductGroupSelector.prototype.buyProduct = function(product, selectedValues) {
      var that;
      that = this;
      if (product !== null) {
        that.refreshCartButton(product);
        that.refreshParamsWithValues(false);
        that.changeProductInfo(product);
        if (that.showStockAvailable) {
          return that.productStockAvailability(product);
        }
      } else {
        that.disableAllActionButtons();
        $('[data-basket-product-id-hash]').val('');
        that.refreshAllParams(selectedValues);
        return that.refreshParamsWithValues();
      }
    };

    ProductGroupSelector.prototype.redirectOrBuyProduct = function(allSelectedValues, afterRefresheAllParams, paramId) {
      var bestMatch, bestMatchScore, findParamIndex, findProduct, index, j, k, l, lastSelectedParamIndex, len, len1, len2, newSelectedValuesStart, product, ref, ref1, ref2, score, selectedValue, selectedValuesEnd, selectedValuesString, that;
      if (afterRefresheAllParams == null) {
        afterRefresheAllParams = false;
      }
      if (paramId == null) {
        paramId = null;
      }
      that = this;
      findProduct = null;
      selectedValuesString = allSelectedValues.join('|') + '|';
      ref = that.allProducts;
      for (j = 0, len = ref.length; j < len; j++) {
        product = ref[j];
        if (product['param_values'] === selectedValuesString) {
          findProduct = product;
          break;
        }
      }
      if (!findProduct) {
        findParamIndex = function(paramId, params) {
          var i, index, k, ref1;
          index = null;
          for (i = k = 0, ref1 = params.length; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
            if (params[i].paramId === paramId) {
              index = i;
              break;
            }
          }
          return index;
        };
        lastSelectedParamIndex = findParamIndex(paramId, that.allParams);
        bestMatch = null;
        bestMatchScore = -1;
        ref1 = that.allProducts;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          product = ref1[k];
          newSelectedValuesStart = allSelectedValues.slice(0, lastSelectedParamIndex + 1);
          selectedValuesEnd = allSelectedValues.slice(lastSelectedParamIndex + 1);
          if (product.param_values.startsWith(newSelectedValuesStart.join('|'))) {
            findProduct = product;
            score = 0;
            ref2 = product.param_values.split('|').slice(lastSelectedParamIndex + 1);
            for (index = l = 0, len2 = ref2.length; l < len2; index = ++l) {
              selectedValue = ref2[index];
              if (selectedValue === selectedValuesEnd[index]) {
                score += 2;
              } else if (selectedValuesEnd.includes(selectedValue)) {
                score += 1;
              }
            }
            if (score > bestMatchScore) {
              bestMatch = product;
              bestMatchScore = score;
              findProduct = product;
            }
          }
        }
        if (bestMatch) {
          findProduct = bestMatch;
        }
      }
      if (that.selectorPosition === 'product_list') {
        return that.buyProduct(findProduct, allSelectedValues);
      } else {
        return that.redirectToProduct(findProduct, allSelectedValues, afterRefresheAllParams);
      }
    };

    ProductGroupSelector.prototype.init_selector_for_select_box = function($scopeElement, paramId, paramPosition) {
      var selectbox, that;
      that = this;
      selectbox = $scopeElement.find("[data-selector-for=" + paramId + "]");
      return selectbox.change(function() {
        that.changeSelectedValueForParam(paramId, $(this).val());
        return that.checkNextParam(paramPosition);
      });
    };

    ProductGroupSelector.prototype.init_selector_for_product_image = function($scopeElement, paramId, paramPosition) {
      var that, wrapper;
      that = this;
      wrapper = $scopeElement.find("[data-selector-for=" + paramId + "]");
      wrapper.on('click', '.js-image-product-selector-item:not(.selected)', function() {
        that.changeSelectedValueForParam(paramId, $(this).attr('value'));
        return that.checkNextParam(paramPosition);
      });
      if (!$('.container-product, .list-group-selector').length) {
        return;
      }
      return this.showSelectorImageInGallery(wrapper);
    };

    ProductGroupSelector.prototype.init_selector_for_icon = function($scopeElement, paramId, paramPosition) {
      var that, wrapper;
      that = this;
      wrapper = $scopeElement.find("[data-selector-for=" + paramId + "]");
      return wrapper.on('click', '.js-selector-item-icon:not(.selected)', function() {
        that.changeSelectedValueForParam(paramId, $(this).attr('value'));
        return that.checkNextParam(paramPosition);
      });
    };

    ProductGroupSelector.prototype.checkNextParam = function(paramPosition) {
      var $nextParamElement, $paramOptions, $selectorForParam, nextParamElementParamId, nextParamElementType;
      $nextParamElement = this.elementScope.find("[data-param-position=" + (paramPosition + 1) + "]");
      if (!$nextParamElement.length) {
        return;
      }
      nextParamElementType = $nextParamElement.data('param-type');
      nextParamElementParamId = $nextParamElement.data('param-id');
      $selectorForParam = $nextParamElement.find("[data-selector-for=" + nextParamElementParamId + "]");
      if (nextParamElementType === 'select_box') {
        $paramOptions = $selectorForParam.find('option:selected');
        if ($paramOptions.length) {
          return;
        }
        return $selectorForParam.val($paramOptions.attr('value')).change();
      } else if (nextParamElementType === 'product_image') {
        $paramOptions = $selectorForParam.find('.js-image-product-selector-item.selected');
        if ($paramOptions.length) {
          return;
        }
        return $paramOptions.click();
      } else if (nextParamElementType === 'icon') {
        $paramOptions = $selectorForParam.find('.js-selector-item-icon.selected');
        if ($paramOptions.length) {
          return;
        }
        return $paramOptions.click();
      }
    };

    ProductGroupSelector.prototype.changeSelectedValueForParam = function(paramId, newValue) {
      var containAllSelectedParam, j, len, ref, selectedValues, that, value;
      that = this;
      containAllSelectedParam = true;
      selectedValues = [];
      ref = that.allParams;
      for (j = 0, len = ref.length; j < len; j++) {
        value = ref[j];
        if (value['paramId'] === paramId) {
          value['selectedValue'] = newValue;
        }
        if (value['selectedValue'] !== null) {
          selectedValues.push(value['selectedValue']);
        } else {
          containAllSelectedParam = false;
        }
      }
      if (containAllSelectedParam) {
        return that.redirectOrBuyProduct(selectedValues, false, paramId);
      } else {
        return that.refreshParamsWithValues();
      }
    };

    ProductGroupSelector.prototype.refreshParamsWithValues = function(enableRedirectOrBuy) {
      var afterSiblingValues, allSelectedValues, allValuesForParam, allValuesInProducts, cloneValue, index, j, k, l, lastSelectedValue, len, len1, len2, len3, len4, len5, len6, m, n, o, p, param, paramValueProductImage, product, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, selectedValues, selectedValuesString, stringFromValues, that, value;
      if (enableRedirectOrBuy == null) {
        enableRedirectOrBuy = true;
      }
      that = this;
      lastSelectedValue = null;
      selectedValues = [];
      allSelectedValues = [];
      ref = that.allParams;
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        param = ref[index];
        if (param['selectedValue'] !== null) {
          allSelectedValues.push(param['selectedValue']);
        }
      }
      ref1 = that.allParams;
      for (index = k = 0, len1 = ref1.length; k < len1; index = ++k) {
        param = ref1[index];
        if (index === 0) {
          allValuesForParam = that.allValues["" + param['paramId']];
          allValuesForParam.sort(function(a, b) {
            return a['position'] - b['position'];
          });
          that.valuesForParams["" + param['paramId']] = allValuesForParam;
          for (l = 0, len2 = allValuesForParam.length; l < len2; l++) {
            value = allValuesForParam[l];
            afterSiblingValues = [];
            if (allSelectedValues.length > index + 1) {
              afterSiblingValues = allSelectedValues.slice(index + 1);
            }
            selectedValuesString = selectedValues.concat([value.value]).concat(afterSiblingValues).join('|') + '|';
            value['available'] = null;
            value['disabled'] = null;
            ref2 = that.allProducts;
            for (m = 0, len3 = ref2.length; m < len3; m++) {
              product = ref2[m];
              if (product['param_values'].startsWith(selectedValuesString)) {
                value['available'] = product.eshop_available;
                if (product.eshop_available) {
                  break;
                }
              } else {
                value['disabled'] = true;
              }
            }
          }
          lastSelectedValue = param['selectedValue'];
          if (param['selectedValue'] !== null) {
            selectedValues.push(param['selectedValue']);
          }
          that["refresh_options_" + param['paramType']](param);
          continue;
        }
        if (lastSelectedValue !== null) {
          allValuesInProducts = [];
          paramValueProductImage = {};
          allValuesForParam = [];
          stringFromValues = selectedValues.join('|') + '|';
          ref3 = that.allProducts;
          for (n = 0, len4 = ref3.length; n < len4; n++) {
            product = ref3[n];
            if (product['param_values'].startsWith(stringFromValues)) {
              allValuesInProducts.push(product['technical_params']["" + param['paramId']]);
              if (param['paramType'] === 'product_image') {
                if (!paramValueProductImage[product['technical_params']["" + param['paramId']]] || !product.is_set) {
                  paramValueProductImage[product['technical_params']["" + param['paramId']]] = product.image;
                }
              }
            }
          }
          ref4 = that.allValues["" + param['paramId']];
          for (o = 0, len5 = ref4.length; o < len5; o++) {
            value = ref4[o];
            if (ref5 = value['value'], indexOf.call(allValuesInProducts, ref5) >= 0) {
              cloneValue = JSON.parse(JSON.stringify(value));
              if (param['paramType'] === 'product_image') {
                cloneValue['product_image'] = paramValueProductImage[value['value']];
              }
              afterSiblingValues = [];
              if (allSelectedValues.length > index + 1) {
                afterSiblingValues = allSelectedValues.slice(index + 1);
              }
              selectedValuesString = selectedValues.concat([cloneValue.value]).concat(afterSiblingValues).join('|') + '|';
              cloneValue['available'] = null;
              cloneValue['disabled'] = null;
              ref6 = that.allProducts;
              for (p = 0, len6 = ref6.length; p < len6; p++) {
                product = ref6[p];
                if (product['param_values'].startsWith(selectedValuesString)) {
                  cloneValue['available'] = product.eshop_available;
                  if (product.eshop_available) {
                    break;
                  }
                } else {
                  cloneValue['disabled'] = true;
                }
              }
              allValuesForParam.push(cloneValue);
            }
          }
          allValuesForParam.sort(function(a, b) {
            return a['position'] - b['position'];
          });
          that.valuesForParams["" + param['paramId']] = allValuesForParam;
          if (ref7 = param['selectedValue'], indexOf.call(allValuesInProducts, ref7) < 0) {
            param['selectedValue'] = null;
          }
          lastSelectedValue = param['selectedValue'];
          if (param['selectedValue'] !== null) {
            selectedValues.push(param['selectedValue']);
          }
        } else {
          param['selectedValue'] = null;
          that.valuesForParams["" + param['paramId']] = null;
        }
        that["refresh_options_" + param['paramType']](param);
      }
      if ((selectedValues.length === that.allParams.length) && enableRedirectOrBuy) {
        return that.redirectOrBuyProduct(selectedValues, true);
      }
    };

    ProductGroupSelector.prototype.refresh_options_select_box = function(param) {
      var content, j, len, results, selectBox, that, value, values, valuesLength;
      that = this;
      selectBox = $("#group_selector_section [data-selector-for=" + param['paramId'] + "]");
      that.paramTabLink(selectBox);
      selectBox.removeClass('disabled-one-item');
      selectBox.removeAttr('disabled');
      selectBox.find('option').remove();
      values = that.valuesForParams["" + param['paramId']];
      valuesLength = values === null ? 0 : values.length;
      if (values === null || param['selectedValue'] === null) {
        selectBox.removeClass('selected');
        selectBox.addClass('to-select');
        selectBox.removeAttr('disabled');
        content = "<option disabled hidden=\"\" selected value=\"\">" + (I18n.t('js.public.products.show.group_selector.select_option')) + "</option>";
        $(selectBox).append(content);
      }
      if (values !== null || param['selectedValue'] === null) {
        selectBox.siblings('.js-param-name').removeClass('selected').addClass('to-select');
      }
      if (values === null) {
        return selectBox.attr('disabled', true);
      } else {
        results = [];
        for (j = 0, len = values.length; j < len; j++) {
          value = values[j];
          if (value['value'] === param['selectedValue']) {
            selectBox.siblings('.js-param-name').addClass('selected').removeClass('to-select');
            selectBox.removeClass('to-select');
            if (that.isReadOnly) {
              content = "" + value['translate_value'];
            } else {
              content = "<option selected value=\"" + value['value'] + "\">" + value['translate_value'] + "</option>";
            }
          } else if (that.isReadOnly) {
            content = '';
          } else if (valuesLength === 1) {
            selectBox.removeClass('selected');
            selectBox.addClass('to-select');
            selectBox.removeAttr('disabled');
            content = "<option disabled hidden=\"\" selected value=\"\">" + (I18n.t('js.public.products.show.group_selector.select_option')) + "</option>";
            $(selectBox).append(content);
            content = "<option value=\"" + value['value'] + "\">" + value['translate_value'] + "</option>";
          } else {
            content = "<option value=\"" + value['value'] + "\">" + value['translate_value'] + "</option>";
          }
          if (that.isReadOnly) {
            $(selectBox).after(content);
            results.push($(selectBox).addClass('d-none'));
          } else {
            results.push($(selectBox).append(content));
          }
        }
        return results;
      }
    };

    ProductGroupSelector.prototype.refresh_options_product_image = function(param) {
      var $groupSelectorWrapper, content, imageProductSelectorRender, isExtraGiftSelector, j, len, notAvailableClass, results, that, value, values, valuesLength;
      that = this;
      $groupSelectorWrapper = $("#group_selector_section [data-selector-for=" + param['paramId'] + "]");
      isExtraGiftSelector = $groupSelectorWrapper.hasClass('extra-gift-tile-group-selector');
      that.paramTabLink($groupSelectorWrapper);
      $groupSelectorWrapper.removeClass('disabled-one-item');
      $groupSelectorWrapper.find('.js-image-product-selector-item').remove();
      values = that.valuesForParams["" + param['paramId']];
      valuesLength = values === null ? 0 : values.length;
      imageProductSelectorRender = function(value, extraClass, title, isExtraGiftSelector) {
        var galleryImage, image1x, image2x;
        if (title == null) {
          title = '';
        }
        image1x = isExtraGiftSelector && value['product_image'].image_base ? value['product_image'].image_base : value['product_image'].icon_base;
        image2x = isExtraGiftSelector && value['product_image'].image ? value['product_image'].image : value['product_image'].icon;
        galleryImage = isExtraGiftSelector ? '' : value['product_image'].gallery_image;
        return "<button type=\"button\" class=\"js-image-product-selector-item image-product-selector-item img-contain " + extraClass + "\" data-toggle=\"tooltip\" title=\"" + title + "\" data-gtmevent-click=\"{'id': 'product_selector_image', 'info': '" + value['value'] + "'}\" selected value=\"" + value['value'] + "\" data-gallery-image=\"" + galleryImage + "\">\n  <img src=\"" + image1x + "\" srcset=\"" + image1x + ", " + image2x + " 2x\" alt=\"" + title + "\">\n  <div class='image-product-selector-item-title mzkr-text-dark mzkr-text-md'>" + title + "</div>\n</button>";
      };
      if (values !== null || param['selectedValue'] === null) {
        $groupSelectorWrapper.siblings('.js-param-name').find('.js-param-value').text(I18n.t('js.public.products.show.group_selector.select_option'));
        $groupSelectorWrapper.siblings('.js-param-name').removeClass('selected').addClass('to-select');
      }
      if (values === null) {
        return $groupSelectorWrapper.attr('disabled', true);
      } else {
        if (values.length < this.groupImgLargeTreshold) {
          $groupSelectorWrapper.addClass('group-product-image-lg');
        }
        results = [];
        for (j = 0, len = values.length; j < len; j++) {
          value = values[j];
          if (value['value'] === param['selectedValue']) {
            $groupSelectorWrapper.siblings('.js-param-name').find('.js-param-value').text("(" + value['translate_value'] + ")");
            $groupSelectorWrapper.siblings('.js-param-name').addClass('selected').removeClass('to-select');
            notAvailableClass = value['available'] === false ? 'not-available' : '';
            if (that.isReadOnly) {
              content = imageProductSelectorRender(value, "selected", value['translate_value'], isExtraGiftSelector);
            } else {
              content = imageProductSelectorRender(value, notAvailableClass + " selected ", value['translate_value'], isExtraGiftSelector);
            }
          } else if (that.isReadOnly) {
            content = '';
          } else if (valuesLength === 1) {
            $groupSelectorWrapper.siblings('.js-param-name').find('.js-param-value').text(I18n.t('js.public.products.show.group_selector.select_option'));
            $groupSelectorWrapper.siblings('.js-param-name').removeClass('selected').addClass('to-select');
            content = imageProductSelectorRender(value, '', value['translate_value'], isExtraGiftSelector);
          } else if (value['available'] === true) {
            content = imageProductSelectorRender(value, '', value['translate_value'], isExtraGiftSelector);
          } else if (value['available'] === false) {
            content = imageProductSelectorRender(value, 'not-available', value['translate_value'], isExtraGiftSelector);
          } else if (value['disabled'] === true) {
            content = imageProductSelectorRender(value, 'disabled', value['translate_value'], isExtraGiftSelector);
          } else {
            content = imageProductSelectorRender(value, '', value['translate_value'], isExtraGiftSelector);
          }
          $groupSelectorWrapper.append(content);
          $('.tooltip').remove();
          $('.js-image-product-selector-item', $groupSelectorWrapper).tooltip({
            container: $('.js-image-product-selector-item', $groupSelectorWrapper).closest('.mzkr-modal').length ? '.mzkr-modal' : false
          });
          setTimeout((function() {
            return that.checkForOverflow($groupSelectorWrapper);
          }), 301);
          $(window).off('resize.imageGroupSelector');
          results.push($(window).on('resize.imageGroupSelector', function(e) {
            window.groupSelectorResize;
            clearTimeout(window.groupSelectorResize);
            return window.groupSelectorResize = setTimeout((function() {
              return that.checkForOverflow($groupSelectorWrapper);
            }), 100);
          }));
        }
        return results;
      }
    };

    ProductGroupSelector.prototype.refresh_options_icon = function(param) {
      var $groupSelectorWrapper, content, iconSelectorRender, j, len, notAvailableClass, results, that, value, values, valuesLength;
      that = this;
      $groupSelectorWrapper = $("#group_selector_section [data-selector-for=" + param['paramId'] + "]");
      that.paramTabLink($groupSelectorWrapper);
      $groupSelectorWrapper.removeClass('disabled-one-item');
      $groupSelectorWrapper.find('.js-selector-item-icon').remove();
      $groupSelectorWrapper.removeClass('disabled-one-item');
      values = that.valuesForParams["" + param['paramId']];
      valuesLength = values === null ? 0 : values.length;
      iconSelectorRender = function(value, extraClass, selected) {
        if (extraClass == null) {
          extraClass = '';
        }
        if (selected == null) {
          selected = '';
        }
        return "<button type=\"button\" class=\"js-selector-item-icon selector-item-icon " + extraClass + "\" " + selected + " value=\"" + value['value'] + "\" data-gtmevent-click=\"{'id': 'product_selector_icon', 'info': '" + value['value'] + "'}\">\n  " + value['translate_value'] + "\n</button>";
      };
      if (values !== null || param['selectedValue'] === null) {
        $groupSelectorWrapper.siblings('.js-param-name').removeClass('selected').addClass('to-select');
      }
      if (values === null) {
        return $groupSelectorWrapper.attr('disabled', true);
      } else {
        results = [];
        for (j = 0, len = values.length; j < len; j++) {
          value = values[j];
          if (value['value'] === param['selectedValue']) {
            $groupSelectorWrapper.siblings('.js-param-name').addClass('selected').removeClass('to-select');
            notAvailableClass = value['available'] === false ? 'not-available' : '';
            if (that.isReadOnly) {
              content = iconSelectorRender(value, "selected", 'selected');
            } else {
              content = iconSelectorRender(value, notAvailableClass + " selected", 'selected');
            }
          } else if (that.isReadOnly) {
            content = '';
          } else if (valuesLength === 1) {
            $groupSelectorWrapper.siblings('.js-param-name').find('.js-param-value').text(I18n.t('js.public.products.show.group_selector.select_option'));
            $groupSelectorWrapper.siblings('.js-param-name').removeClass('selected').addClass('to-select');
            content = iconSelectorRender(value);
          } else if (value['available'] === true) {
            content = iconSelectorRender(value);
          } else if (value['available'] === false) {
            content = iconSelectorRender(value, 'not-available');
          } else if (value['disabled'] === true) {
            content = iconSelectorRender(value, 'disabled');
          } else {
            content = iconSelectorRender(value);
          }
          $groupSelectorWrapper.append(content);
          setTimeout((function() {
            return that.checkForOverflow($groupSelectorWrapper);
          }), 301);
          $(window).off('resize.iconGroupSelector');
          results.push($(window).on('resize.iconGroupSelector', function(e) {
            window.groupSelectorResize;
            clearTimeout(window.groupSelectorResize);
            return window.groupSelectorResize = setTimeout((function() {
              return that.checkForOverflow($groupSelectorWrapper);
            }), 100);
          }));
        }
        return results;
      }
    };

    ProductGroupSelector.prototype.refreshAllParams = function(selectedValues) {
      var copySelectedValues, findProduct, index, j, k, len, len1, param, product, ref, ref1, stringFromValues, that;
      that = this;
      copySelectedValues = selectedValues.slice();
      findProduct = null;
      ref = that.allParams.reverse();
      for (index = j = 0, len = ref.length; j < len; index = ++j) {
        param = ref[index];
        if (index === 0) {
          param['selectedValue'] = null;
          copySelectedValues.pop();
          continue;
        }
        stringFromValues = copySelectedValues.join('|') + '|';
        ref1 = that.allProducts;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          product = ref1[k];
          if (product['param_values'].startsWith(stringFromValues)) {
            findProduct = product;
            break;
          }
        }
        if (findProduct !== null) {
          break;
        } else {
          copySelectedValues.pop();
          param['selectedValue'] = null;
        }
      }
      return that.allParams.reverse();
    };

    ProductGroupSelector.prototype.initApplyCampaignCouponLink = function(scope, path) {
      scope.closest('#modal-container').find('[data-add-to-cart-button]').on('click', function(event) {
        var $modal, $modalCouponLinks;
        $modal = $(this).closest('#modal-container');
        $modalCouponLinks = $modal.find('[data-apply-coupon-from-link]');
        return $modalCouponLinks.attr('data-disabled', true);
      });
      return scope.on('click', function(event) {
        var $addToCartButton, that;
        event.preventDefault();
        event.stopPropagation();
        that = $(this);
        $addToCartButton = that.closest('#modal-container').find('[data-add-to-cart-button]');
        if (that.attr('data-disabled')) {
          return;
        }
        scope.attr('data-disabled', true);
        $addToCartButton.attr('disabled', true);
        return $.ajax({
          type: 'POST',
          dataType: 'script',
          url: path,
          success: function() {
            scope.removeAttr('data-disabled', true);
            return $addToCartButton.removeAttr('disabled');
          }
        });
      });
    };

    ProductGroupSelector.prototype.changeProductInfo = function(product) {
      var $applyCampaignCoupon, $extraDiscountPrice, $modalProductBasePrice, $modalProductPercentage, $modalProductPrice, $modalProductSetPriceInfo, $modalProductSetPriceInfoDiscountPrice, $usersetWrapper, basePrice, discountPercentage, discountPrice, extraGift, path, pathAttributes, price, productType, that, usersetLink;
      that = this;
      extraGift = $('[data-basket-extra-gift=true]', this.elementScope);
      if (!extraGift.length) {
        productType = product.is_set ? 'set' : 'standard';
        $('.mzkr-modal [data-basket-product-type]').val(productType);
      }
      $('.mzkr-modal [data-basket-product-id-hash]').val(product.id_hash);
      $('.mzkr-modal [data-image-change]').attr({
        src: product.thumb_image,
        alt: product.name
      });
      $('.mzkr-modal [data-product-name]').html(product.name);
      $('[data-product-path-in-modal]').attr('href', product.path);
      if (that.showStockStatus) {
        that.productStockStatus(product);
      }
      if (!product.add_to_basket) {
        $('[data-add-to-cart-button]', this.elementScope).attr('disabled', true);
      }
      price = $('.mzkr-modal [data-vat-payer]').length ? product.vat_payer_price_without_vat : product.price_with_vat;
      basePrice = $('.mzkr-modal [data-vat-payer]').length ? product.vat_payer_base_price_without_vat : product.base_price_with_vat;
      discountPercentage = product.discount_percentage;
      $modalProductBasePrice = $('.mzkr-modal [data-product-base-price]');
      $modalProductPercentage = $('.mzkr-modal .js-discount-percentage');
      $modalProductPrice = $('.mzkr-modal [data-product-price]');
      $applyCampaignCoupon = $('.mzkr-modal .apply-campaign-coupon');
      $usersetWrapper = $('.mzkr-modal [data-userset-product]');
      if ($usersetWrapper.length) {
        discountPercentage = $usersetWrapper.attr('data-discount-percentage');
        basePrice = price;
        price = basePrice * (1 - (discountPercentage / 100.0));
        discountPrice = basePrice - price;
        $modalProductSetPriceInfo = $('.mzkr-modal .set-price-info');
        $modalProductSetPriceInfo.removeClass('d-none');
        $modalProductSetPriceInfo.find('.final-price .amount').html(PublicUtility.CurrencyFormatManager.number_to_currency(price));
        $modalProductSetPriceInfoDiscountPrice = $modalProductSetPriceInfo.find('.discount-price');
        if (discountPrice > 0) {
          $modalProductSetPriceInfoDiscountPrice.removeClass('d-none');
          $modalProductSetPriceInfoDiscountPrice.find('.amount').html(PublicUtility.CurrencyFormatManager.number_to_currency(discountPrice));
        } else {
          $modalProductSetPriceInfoDiscountPrice.addClass('d-none');
        }
      } else {
        $modalProductBasePrice.addClass('d-none');
        $modalProductPercentage.addClass('d-none');
        $modalProductPrice.removeClass('d-none');
        $modalProductPrice.prev().removeClass('d-none');
        $modalProductPrice.html(PublicUtility.CurrencyFormatManager.number_to_currency(price));
        if (product.coupon_price_with_vat) {
          $applyCampaignCoupon.removeClass('d-none');
          $extraDiscountPrice = $applyCampaignCoupon.find('#extra_discount_price');
          $extraDiscountPrice.attr('data-price', parseFloat(product.coupon_price_with_vat).toFixed(2));
          $extraDiscountPrice.html(PublicUtility.CurrencyFormatManager.number_to_currency(product.coupon_price_with_vat));
          path = Routes.shop_actions_apply_coupon_from_link_path({
            coupon_code: product.coupon_code,
            product_code: product.code
          });
          $applyCampaignCoupon.find('.code-link').attr('href', path).text(product.coupon_code);
          $applyCampaignCoupon.find('.apply-campaign-coupon-link').attr('href', path);
          that.initApplyCampaignCouponLink($applyCampaignCoupon.find('a'), path);
        } else {
          $applyCampaignCoupon.addClass('d-none');
          $extraDiscountPrice = $applyCampaignCoupon.find('#extra_discount_price');
          $extraDiscountPrice.attr('data-price', null);
          $extraDiscountPrice.html('');
          $applyCampaignCoupon.find('.code-link').attr('href', '#').text('');
          $applyCampaignCoupon.find('.apply-campaign-coupon-link').attr('href', '#');
        }
        if (discountPercentage > 0 && $modalProductBasePrice.length) {
          $modalProductBasePrice.removeClass('d-none').html(PublicUtility.CurrencyFormatManager.number_to_currency(basePrice));
          $modalProductPercentage.removeClass('d-none').html("- " + discountPercentage + " %");
        }
      }
      that.actionLinkProduct('wish-list', product, Routes.shop_wish_list_items_path({
        product_code: product.code
      }), I18n.t('js.public.shop.wish_list_items.add_to_wish_list'));
      that.actionLinkProduct('product-comparison', product, Routes.product_comparison_items_path({
        product_code: product.code
      }), I18n.t('js.public.products.product_comparison_items.add_to_product_comparison'));
      if ($usersetWrapper) {
        pathAttributes = {
          public_shop_basket_user_set_item_form: {
            product_code: product.code,
            main_user_set_product_id_hash: $usersetWrapper.attr('data-main-user-set-product-id-hash'),
            user_set_product_id_hash: $usersetWrapper.attr('data-user-set-product-id-hash'),
            action_type: $usersetWrapper.attr('data-action-type')
          }
        };
        that.actionLinkProduct('userset', product, Routes.shop_basket_set_items_path(pathAttributes), I18n.t('js.public.shop.basket_user_set_items.add_to_userset'));
        usersetLink = $('.mzkr-modal [data-userset-product] .userset-link');
        if (product.eshop_available) {
          return usersetLink.parent('[data-userset-product]').popover('disable');
        } else {
          usersetLink.addClass('disabled');
          return usersetLink.parent('[data-userset-product]').popover('enable');
        }
      }
    };

    ProductGroupSelector.prototype.productStockAvailability = function(product, cartButton) {
      var content;
      if (product.eshop_available) {
        content = "<span class=\"green\">" + (I18n.t('js.public.products.group_selectors.list_group_selector.available_in_store')) + "</span>";
      } else {
        $('[data-add-to-cart-button]', this.elementScope).attr('disabled', true);
        content = "<span class=\"red\">" + (I18n.t('js.public.products.group_selectors.list_group_selector.unavailable_in_store')) + "</span>";
      }
      return $('[data-product-stock-available]').html(content);
    };

    ProductGroupSelector.prototype.productStockStatus = function(product) {
      var $stockStatus;
      $stockStatus = this.elementScope.find('.stock-status');
      if (product.tile_stock_status) {
        $stockStatus.attr('class', product.tile_stock_status["class"]);
        return $stockStatus.text(product.tile_stock_status.title);
      } else {
        return $stockStatus.addClass('mzkr-d-none');
      }
    };

    ProductGroupSelector.prototype.refreshCartButton = function(product) {
      var cartButton, that;
      that = this;
      cartButton = $('[data-add-to-cart-button]', that.elementScope);
      if (cartButton.length) {
        cartButton.removeClass('disabled');
        return cartButton.removeAttr('disabled');
      }
    };

    ProductGroupSelector.prototype.disableAllActionButtons = function() {
      $('[data-add-to-cart-button]', this.elementScope).attr('disabled', true);
      $('.wish-list-link', this.elementScope).addClass('disabled');
      return $('.product-comparison-link', this.elementScope).addClass('disabled');
    };

    ProductGroupSelector.prototype.actionLinkProduct = function(type, product, path, text) {
      var actionLink, element;
      element = $(".mzkr-modal [data-" + type + "-product]");
      if (element.length) {
        element.data('product-code', product.code);
        actionLink = element.find("." + type + "-link");
        actionLink.removeClass('disabled').attr('title', text).attr('data-method', 'post').attr('href', path).attr('data-disable-with', text).parent().removeClass('text-danger');
        $('span', actionLink).text(text);
        if (type === 'wish-list') {
          PublicUtility.WishList.initInWishList('.mzkr-modal');
        }
        if (type === 'product-comparison') {
          return PublicUtility.ProductComparison.initInProductComparison('.mzkr-modal');
        }
      }
    };

    ProductGroupSelector.prototype.checkForOverflow = function($selector) {
      var $showMore;
      if ($selector.innerHeight() < $selector[0].scrollHeight) {
        $selector.addClass('overflown');
        $showMore = $selector.siblings('.js-show-more');
        $showMore.removeClass('d-none');
        $showMore.off('click');
        return $showMore.on('click', function() {
          if ($selector.hasClass('overflown-more')) {
            $selector.removeClass('overflown-more');
            return $(this).text(I18n.t('js.public.products.group_selectors.more_variants'));
          } else {
            $selector.addClass('overflown-more');
            return $(this).text(I18n.t('js.public.products.group_selectors.collapse_variants'));
          }
        });
      } else {
        $selector.removeClass('overflown');
        $showMore = $selector.siblings('.js-show-more');
        $showMore.addClass('d-none');
        return $showMore.off('click');
      }
    };

    ProductGroupSelector.prototype.paramTabLink = function($selector) {
      var $paramIdCol, $tabLink, $targetLink, paramId;
      $paramIdCol = $selector.closest('[data-param-id]');
      paramId = $paramIdCol.data('param-id');
      $targetLink = $("[data-link-param-id='" + paramId + "']");
      if ($targetLink.length) {
        $tabLink = $('.js-param-tab-link', $paramIdCol);
        $tabLink.removeClass('d-none');
        $tabLink.text($targetLink.find('.js-tab-tile').text());
        $tabLink.off('click');
        return $tabLink.click(function() {
          return App.PublicProducts.openAndScrollToTab($targetLink.attr('href'));
        });
      }
    };

    ProductGroupSelector.prototype.showSelectorImageInGallery = function(wrapper) {
      wrapper.on('mouseenter', '.js-image-product-selector-item', function(e) {
        var $slectorImg, $targetWrapper, isListGroupSelector, selectorImgSrc;
        selectorImgSrc = $(this).attr('data-gallery-image');
        isListGroupSelector = wrapper.closest('.list-group-selector').length;
        if (!((selectorImgSrc != null) && /^https?:\/\//.test(selectorImgSrc) && $(window).width() > 767)) {
          return;
        }
        if (isListGroupSelector) {
          $targetWrapper = $('.tile-img.tile-group-selector');
          $targetWrapper.find('img[data-image-change]').addClass('hidden');
        } else {
          $targetWrapper = $('.slider-product .lSSlideWrapper');
          $targetWrapper.find('.lightSlider').addClass('hidden');
        }
        $slectorImg = $targetWrapper.find(".gallery-selector-img img[src='" + selectorImgSrc + "']");
        if (!$slectorImg.length) {
          return $('<div class="gallery-selector-img active">').append($('<img>').attr('src', selectorImgSrc)).appendTo($targetWrapper).siblings('.gallery-selector-img').removeClass('active');
        } else {
          return $slectorImg.parent('.gallery-selector-img').addClass('active').siblings('.gallery-selector-img').removeClass('active');
        }
      });
      wrapper.on('mouseleave', wrapper, function(e) {
        var $targetWrapper, isListGroupSelector;
        isListGroupSelector = wrapper.closest('.list-group-selector').length;
        if (isListGroupSelector) {
          $targetWrapper = $('.tile-img.tile-group-selector');
          $targetWrapper.find('img[data-image-change]').removeClass('hidden');
        } else {
          $targetWrapper = $('.slider-product .lSSlideWrapper');
          $targetWrapper.find('.lightSlider').removeClass('hidden');
        }
        return $targetWrapper.find('.gallery-selector-img').removeClass('active');
      });
      return $(window).resize(function() {
        return $('.gallery-selector-img').remove();
      });
    };

    return ProductGroupSelector;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.ProductList = (function() {
    function ProductList(search_url) {
      this.initProductTilesSwiper = bind(this.initProductTilesSwiper, this);
      this.initScrollTo = bind(this.initScrollTo, this);
      this.htmlSafeQuoteMarks = bind(this.htmlSafeQuoteMarks, this);
      this.sortCheckboxes = bind(this.sortCheckboxes, this);
      this.initShowMore = bind(this.initShowMore, this);
      this.changePage = bind(this.changePage, this);
      this.changePageMoveLink = bind(this.changePageMoveLink, this);
      this.initPaginationForNumbers = bind(this.initPaginationForNumbers, this);
      this.initPagination = bind(this.initPagination, this);
      this.initSortBy = bind(this.initSortBy, this);
      this.initResetFilter = bind(this.initResetFilter, this);
      this.buildBadgeText = bind(this.buildBadgeText, this);
      this.checkIndeterminate = bind(this.checkIndeterminate, this);
      this.init$customSlider = bind(this.init$customSlider, this);
      this.initPriceSlider = bind(this.initPriceSlider, this);
      this.onFilterSuccess = bind(this.onFilterSuccess, this);
      this.reloadProducts = bind(this.reloadProducts, this);
      this.multiCheckParamsUrl = bind(this.multiCheckParamsUrl, this);
      this.appliedFilterCount = bind(this.appliedFilterCount, this);
      this.isFilteredCustomSliderColumn = bind(this.isFilteredCustomSliderColumn, this);
      this.isFilteredPrice = bind(this.isFilteredPrice, this);
      this.badgeClick = bind(this.badgeClick, this);
      this.removeFilterBadge = bind(this.removeFilterBadge, this);
      this.init = bind(this.init, this);
      var form, that;
      form = $('#main-filter');
      that = this;
      I18n.filter_currency = I18n.currency;
      this.search_url = search_url;
      this.allowReload = true;
      this.toFirstPage = false;
      form.on('change', function(e) {
        var ref, ref1, ref2;
        that.isAjaxLoadedCheckbox = false;
        if (!((ref = $((ref1 = e.originalEvent) != null ? ref1.target : void 0)) != null ? ref.hasClass('input-search-filter') : void 0)) {
          that.isAjaxLoadedCheckbox = (ref2 = $(e.target)) != null ? ref2.hasClass('js-ajax-filter-checkbox') : void 0;
          return $(this).trigger('submit');
        }
      });
      this.current_ajax_request = null;
      form.on('submit', function(e) {
        e.preventDefault();
        return that.reloadProducts(true);
      });
      this.init();
    }

    ProductList.prototype.init = function() {
      PublicUtility.ProductList.initFilterToggler();
      this.initPriceSlider();
      this.init$customSlider();
      PublicUtility.ProductList.initBoughtAt();
      PublicUtility.ProductList.initFilterSearch();
      this.initSortBy();
      this.initPagination();
      this.initResetFilter();
      PublicUtility.ProductList.showCancelAll();
      this.initShowMore();
      this.sortCheckboxes();
      PublicUtility.ProductList.initStickyFilters();
      this.initScrollTo('.product-questions-link');
      this.scrollToLastVisitedProduct();
      PublicUtility.ProductList.stickyFilterBtn();
      PublicUtility.Layout.toolTip();
      return this.initProductTilesSwiper();
    };

    ProductList.prototype.removeFilterBadge = function(filterValue) {
      var $badge;
      $badge = $("[data-filter-value=\"" + filterValue + "\"]");
      if ($badge.siblings().length === 1) {
        return $badge.parent().remove();
      } else {
        return $badge.remove();
      }
    };

    ProductList.prototype.badgeClick = function() {
      var that;
      that = this;
      return $('.badge-input').on('click', function() {
        var $this, dataFilterGroup, filterCheckboxValue, targetCheck;
        $this = $(this);
        filterCheckboxValue = $this.data("filter-value").toString();
        dataFilterGroup = $this.data('filter-group');
        targetCheck = $("[id='" + dataFilterGroup + "'] input[type=checkbox][data-filter-checkbox='" + (filterCheckboxValue.replace(/"/g, '\\"')) + "']");
        targetCheck.prop('checked', false);
        if ($this.siblings().length === 0) {
          $('[data-target="#' + $this.data('filter-group') + '"]').next().addClass('d-none');
        } else if ($("[data-filter-group=" + $this.data('filter-group') + "]").length === 1) {
          $('[data-target="#' + $this.data('filter-group') + '"]').next().addClass('d-none');
          $("[data-filter-tile-id=\"" + ($this.data('filter-group')) + "\"]").removeClass('active');
        }
        if (targetCheck.parents('.multi-check-wrap').length && !targetCheck.parents('.multi-check').length) {
          targetCheck.parents('.multi-check-wrap').find('.multi-check input[type="checkbox"]').prop('checked', false);
        }
        that.removeFilterBadge(filterCheckboxValue);
        that.appliedFilterCount();
        PublicUtility.ProductList.showCancelAll();
        that.reloadProducts(true);
        return that.checkIndeterminate();
      });
    };

    ProductList.prototype.isFilteredPrice = function(form_data) {
      var form_price_from, form_price_to, priceSlider, prices;
      priceSlider = $('.price-slider');
      if (priceSlider.length) {
        prices = {
          "price_from": priceSlider.data('slider-min').toString(),
          "price_to": priceSlider.data('slider-max').toString()
        };
        form_price_from = form_data.filter(function(x) {
          return x.name === 'price_from';
        });
        form_price_to = form_data.filter(function(x) {
          return x.name === 'price_to';
        });
        return !(form_price_from[0] !== void 0 && form_price_from[0].value === prices['price_from'] && form_price_to[0] !== void 0 && form_price_to[0].value === prices['price_to']);
      }
    };

    ProductList.prototype.isFilteredCustomSliderColumn = function(form_data, column) {
      var form_value_from, form_value_to, name, slider, values;
      name = column.replace('_from.', '.').replace('_to.', '.');
      slider = $('.slider_' + $.escapeSelector(name));
      values = {
        "from": slider.data('slider-min').toString(),
        "to": slider.data('slider-max').toString()
      };
      form_value_from = form_data.filter(function(x) {
        return x.name === slider.data('hidden-field-from-id');
      });
      form_value_to = form_data.filter(function(x) {
        return x.name === slider.data('hidden-field-to-id');
      });
      return !(form_value_from[0] !== void 0 && form_value_from[0].value === values['from'] && form_value_to[0] !== void 0 && form_value_to[0].value === values['to']);
    };

    ProductList.showCancelAll = function() {
      if ($('.filter-badges-wrap:has(.filter-badge)').length) {
        return $('.filter-cancel-all, .filter-bar-bottom').removeClass('mzkr-d-none');
      } else {
        return $('.filter-cancel-all, .filter-bar-bottom').addClass('mzkr-d-none');
      }
    };

    ProductList.prototype.appliedFilterCount = function() {
      var appliedFilterCount;
      appliedFilterCount = $('.filter-badge').length;
      if (appliedFilterCount) {
        return $('.filter-count').text("(" + appliedFilterCount + ")");
      } else {
        return $('.filter-count').text("");
      }
    };

    ProductList.prototype.multiCheckParamsUrl = function(prevFormData) {
      var formData;
      formData = prevFormData;
      $('.multi-check-wrap').each(function() {
        var $wrap;
        $wrap = $(this);
        if ($wrap.find('> label input').is(':checked')) {
          return $('.multi-check input', $wrap).each(function() {
            var $input;
            $input = $(this);
            return formData = Object.fromEntries(Object.entries(formData).filter((function(_this) {
              return function(arg) {
                var key, value;
                key = arg[0], value = arg[1];
                return key !== $input.attr('name');
              };
            })(this)));
          });
        }
      });
      return formData;
    };

    ProductList.prototype.reloadProducts = function(toFirstPage) {
      var $brandInputSearch, $form, data, defaultSortBy, form_data, isFilteredPrice, page, param, searchVal, selectedSortBy, that, value;
      if (toFirstPage == null) {
        toFirstPage = false;
      }
      $form = $('#main-filter');
      that = this;
      form_data = $form.serializeArray();
      isFilteredPrice = this.isFilteredPrice(form_data);
      data = form_data.reduce(function(acc, x) {
        var is_custom_slider_column, is_price_column, name1;
        is_price_column = x.name === 'price_from' || x.name === 'price_to';
        is_custom_slider_column = x.name.startsWith('param_from') || x.name.startsWith('param_to');
        if (is_price_column) {
          if (isFilteredPrice) {
            acc[x.name] = x.value;
          }
        } else if (is_custom_slider_column) {
          if (that.isFilteredCustomSliderColumn(form_data, x.name)) {
            acc[x.name] = x.value;
          }
        } else if (x.name !== 'utf8') {
          if (acc[name1 = x.name] == null) {
            acc[name1] = [];
          }
          acc[x.name].push(x.value);
        }
        return acc;
      }, {});
      for (param in data) {
        value = data[param];
        if (typeof value === 'object') {
          data[param] = value.join('|');
        }
      }
      this.toFirstPage = toFirstPage;
      if (toFirstPage) {
        page = 1;
      } else {
        page = $('.paginate-pages').data('current-page');
      }
      setTimeout((function() {
        that.changePageMoveLink($('.paginate-previous-page'), page - 1);
        that.changePageMoveLink($('.paginate-next-page'), page + 1);
        return that.changePageMoveLink($('.load-next-products'), page + 1);
      }), 1);
      searchVal = $('[data-search-query]').data('search-query');
      if (searchVal) {
        data['q'] = searchVal;
        $('#global-search').val(searchVal);
      }
      defaultSortBy = $('.sort-by option[data-default]').val();
      selectedSortBy = $('.sort-by-tabs .sort-by-tab.active').attr('data-value');
      if (page > 1) {
        data['page'] = page;
      }
      if (defaultSortBy !== selectedSortBy) {
        data['sort_by'] = selectedSortBy;
      }
      if (this.current_ajax_request && this.current_ajax_request.readyState !== 4) {
        this.current_ajax_request.abort();
      }
      if (Object.keys(data).length) {
        history.pushState(null, null, location.pathname + '?' + $.param(that.multiCheckParamsUrl(data)));
      } else {
        history.pushState(null, null, location.pathname);
      }
      data['original_url'] = location.href;
      $brandInputSearch = $('.input-search-filter');
      if ($brandInputSearch.val && !that.isAjaxLoadedCheckbox) {
        $brandInputSearch.trigger('input');
      }
      this.current_ajax_request = $.ajax({
        type: 'GET',
        url: that.search_url,
        data: data,
        beforeSend: that.showLoader,
        success: that.onFilterSuccess,
        dataType: 'json'
      });
      return $('.filter-item-tooltip').tooltip('dispose');
    };

    ProductList.prototype.onFilterSuccess = function(response) {
      var addedProducts, count, elem, id, isFirstPage, isLastPage, key, label, paginate_count, ref, scrollMorePosition, technical_params, values;
      technical_params = $('.aggregation-count-for-technical-param');
      technical_params.text('0');
      technical_params.closest('label').addClass('light-gray text-crossed');
      ref = response.aggregation_counts;
      for (key in ref) {
        values = ref[key];
        for (id in values) {
          count = values[id];
          elem = $("." + ('aggregation-count-' + key + '-' + $.escapeSelector(id.replace(/\s+/g, ''))));
          elem.text(count);
          label = elem.closest('label');
          if (count < 1) {
            label.addClass('light-gray text-crossed');
          } else {
            label.removeClass('light-gray text-crossed');
          }
        }
      }
      $('.multi-check-wrap').each(function() {
        var $this;
        $this = $(this);
        if ($('.multi-check label:not(.light-gray)', $this).length === 0) {
          return $('> label', $this).addClass('light-gray text-crossed');
        } else {
          return $('> label', $this).removeClass('light-gray text-crossed');
        }
      });
      $('head #meta-prev-link, head #meta-next-link, head #meta-canonical-link').remove();
      if (response.title) {
        $('h1').html(response.title);
      }
      if (response.meta_title) {
        $('head title').text(response.meta_title);
      }
      $('head').append(response.meta_canonical);
      $('head').append(response.pagination.meta_pagination);
      if ($('.load-next-products.disabled').length) {
        addedProducts = $('<div>').append($(response.products)).find('.js-products-wrap > div');
        scrollMorePosition = window.scrollY;
        $('#filtered-products .js-products-wrap').append(addedProducts);
        $('.filter-pagination').html(response.filter_pagination);
        $('html, body').animate({
          scrollTop: scrollMorePosition
        }, 0);
        PublicUtility.FilterBanner.initFilterBanner(response.filter_banner, addedProducts);
        $('.load-next-products').removeClass('disabled');
        $('.loader-wrap').addClass('invisible');
        $('.load-next-products .spinner-border').addClass('d-none');
      } else {
        $('#filtered-products').html(response.products);
        $('.filter-pagination').html(response.filter_pagination);
        PublicUtility.FilterBanner.initFilterBanner(response.filter_banner);
        PublicUtility.ProductList.initStickyFilters(true);
      }
      this.initPaginationForNumbers();
      this.sortCheckboxes();
      PublicUtility.Layout.toolTip();
      this.initProductTilesSwiper();
      paginate_count = I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.paginate_count', {
        from: response.pagination.paginate_from_localized,
        to: response.pagination.paginate_to_localized,
        total_count: response.pagination.total_count_localized
      });
      $('.paginate-count').text(paginate_count);
      $('.js-filter-total-count').html(response.pagination.total_count_localized);
      isFirstPage = response.pagination.first_page;
      isLastPage = response.pagination.last_page || parseInt(response.pagination.total_pages_localized) === 0;
      if (isFirstPage && isLastPage) {
        $('.js-pagination-wrapper').removeClass('d-flex').addClass('d-none');
      } else {
        $('.js-pagination-wrapper').removeClass('d-none').addClass('d-flex');
      }
      $('.paginate-previous-page').attr('disabled', isFirstPage);
      $('.paginate-next-page').attr('disabled', isLastPage);
      if (isLastPage) {
        $('.load-next-products').removeClass('d-inline-flex').addClass('d-none');
      } else {
        $('.load-next-products').removeClass('d-none').addClass('d-inline-flex');
      }
      if (!this.toFirstPage) {
        new PublicUtility.Analytics('.filter-pagination');
      }
      new PublicUtility.Analytics('.analytics-scope-product-list');
      PublicUtility.WishList.initInWishList();
      PublicUtility.ProductComparison.initInProductComparison();
      return PublicUtility.Layout.initApplyCampaignCouponLink();
    };

    ProductList.initFilterToggler = function() {
      var scrollFilter, sideFilterWrap;
      scrollFilter = void 0;
      sideFilterWrap = $('.listing-filter-main-wrap');
      $(document).on('click', '.js-filter-toggler', function() {
        sideFilterWrap = $('.listing-filter-main-wrap');
        sideFilterWrap.toggleClass('filter-main-open');
        $('.filter-toggler').toggleClass('open');
        if ($('.filter-toggler').hasClass('open')) {
          scrollFilter = window.scrollY;
          setTimeout((function() {
            $('[data-nav-open]').addClass('filter-open');
            return sideFilterWrap.addClass('opened');
          }), 300);
          return $('body').addClass('listing-filter-main-open');
        } else {
          $('[data-nav-open]').removeClass('filter-open');
          $('html, body').animate({
            scrollTop: scrollFilter
          }, 0);
          $('body').removeClass('listing-filter-main-open');
          return sideFilterWrap.removeClass('opened');
        }
      });
      return $(window).resize(function() {
        var windowWidth;
        windowWidth = window.innerWidth;
        if (windowWidth > 768) {
          if ($('.filter-toggler').hasClass('open')) {
            $('.listing-filter-main-wrap').removeClass('filter-main-open');
            $('.filter-toggler').removeClass('open');
            $('[data-nav-open]').removeClass('filter-open');
            $('body').removeClass('listing-filter-main-open');
            return $('.listing-filter-main-wrap').removeClass('opened');
          }
        }
      });
    };

    ProductList.prototype.initPriceSlider = function() {
      var $priceFrom, $priceSlider, $priceTo, debounceTimeout, maxPrice, minPrice, previousPriceFrom, previousPriceTo, priceRange, priceSlider, that;
      that = this;
      $priceSlider = $('.price-slider');
      if (!$priceSlider.length) {
        return;
      }
      priceSlider = $priceSlider[0];
      $priceFrom = $('#price_from');
      $priceTo = $('#price_to');
      minPrice = parseInt($priceSlider.data('slider-min'));
      maxPrice = parseInt($priceSlider.data('slider-max'));
      previousPriceFrom = parseInt($priceFrom.val());
      previousPriceTo = parseInt($priceTo.val());
      if (minPrice === maxPrice) {
        minPrice -= maxPrice;
      }
      priceRange = {
        'min': minPrice,
        'max': maxPrice
      };
      noUiSlider.create(priceSlider, {
        start: [parseFloat($priceFrom.val()), parseFloat($priceTo.val())],
        connect: true,
        range: priceRange,
        step: 1,
        keyboardMultiplier: 50,
        handleAttributes: [
          {
            'aria-label': I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.min_price')
          }, {
            'aria-label': I18n.t('js.public.cms.sitemap_nodes.filter_sitemap_nodes.show.filter.max_price')
          }
        ],
        format: {
          to: function(value) {
            return Math.round(value);
          },
          from: function(value) {
            return Math.round(value);
          }
        }
      });
      priceSlider.noUiSlider.on('slide', function(values, handle) {
        $priceFrom.val(values[0]);
        return $priceTo.val(values[1]);
      });
      $priceFrom.on('change', function(e) {
        var $this, maxVal, minVal, value;
        e.stopPropagation();
        clearTimeout(window.priceSliderTimeout);
        $this = $(this);
        value = parseFloat($this.val());
        minVal = parseFloat($this.attr('min'));
        maxVal = parseFloat($this.attr('max'));
        if (value < minVal) {
          $this.val(minVal);
        }
        if (value > maxVal) {
          $this.val(maxVal);
        }
        return window.priceSliderTimeout = setTimeout((function() {
          return priceSlider.noUiSlider.set([value, null]);
        }), 300);
      });
      $priceTo.on('change', function(e) {
        var $this, maxVal, minVal, value;
        e.stopPropagation();
        clearTimeout(window.priceSliderTimeout);
        $this = $(this);
        value = parseFloat($this.val());
        minVal = parseFloat($this.attr('min'));
        maxVal = parseFloat($this.attr('max'));
        if (value < minVal) {
          $this.val(minVal);
        }
        if (value > maxVal) {
          $this.val(maxVal);
        }
        return window.priceSliderTimeout = setTimeout((function() {
          return priceSlider.noUiSlider.set([null, value]);
        }), 300);
      });
      debounceTimeout = null;
      priceSlider.noUiSlider.on('set', function(values, handle) {
        clearTimeout(debounceTimeout);
        return debounceTimeout = setTimeout(function() {
          var actualFromPrice, actualToPrice, badge, badgeText, fromPrice, toPrice;
          actualFromPrice = parseFloat(values[0]);
          actualToPrice = parseFloat(values[1]);
          $priceFrom.val(parseFloat(values[0]));
          $priceTo.val(parseFloat(values[1]));
          if (actualFromPrice === minPrice && actualToPrice === maxPrice) {
            $('.cancel-price-slider').addClass('d-none');
            $(".filter-badge-price").remove();
          } else {
            fromPrice = I18n.toCurrency(values[0], {
              precision: 0,
              unit: I18n.filter_currency,
              format: I18n.t('js.number.currency.format').format,
              delimiter: ' '
            });
            toPrice = I18n.toCurrency(values[1], {
              precision: 0,
              unit: I18n.filter_currency,
              format: I18n.t('js.number.currency.format').format,
              delimiter: ' '
            });
            $('[data-filter-value="price-badge"]').remove();
            badgeText = that.buildBadgeText($priceSlider, fromPrice + " - " + toPrice);
            badge = '<button type="button" class="filter-badge filter-badge-price" data-filter-value="price-badge"><div>' + badgeText + '</div><div class="cancel-x-xs"></div></button>';
            $('.filter-badges-wrap').append(badge);
            that.appliedFilterCount();
            $('.filter-badge-price').click(function() {
              priceSlider.noUiSlider.set([minPrice, maxPrice]);
              if ($(this).siblings().length === 0) {
                $('[data-target="#' + $(this).data('filter-group') + '"]').next().addClass('d-none');
                $('.filter-cancel-all').addClass('mzkr-d-none');
              }
              $(this).remove();
              if (that.allowReload) {
                return that.reloadProducts(true);
              }
            });
            $('.cancel-price-slider').removeClass('d-none');
          }
          if (!(previousPriceFrom === actualFromPrice && previousPriceTo === actualToPrice)) {
            previousPriceFrom = actualFromPrice;
            previousPriceTo = actualToPrice;
            PublicUtility.ProductList.showCancelAll();
            if (that.allowReload) {
              return that.reloadProducts();
            }
          }
        }, 200);
      });
      priceSlider.noUiSlider.set([parseFloat($priceFrom.val()), parseFloat($priceTo.val())]);
      return $('.cancel-price-slider').click(function() {
        priceSlider.noUiSlider.set([minPrice, maxPrice]);
        return that.appliedFilterCount();
      });
    };

    ProductList.prototype.init$customSlider = function() {
      var that;
      that = this;
      return $('.custom-slider').each(function() {
        var $customSlider, $fieldFrom, $fieldTo, customSlider, debounceTimeout, maxValue, minValue, previousFromValue, previousToValue, valueRange;
        $customSlider = $(this);
        customSlider = $customSlider[0];
        minValue = parseInt($customSlider.data('slider-min'));
        maxValue = parseInt($customSlider.data('slider-max'));
        $fieldFrom = $('#' + $.escapeSelector($customSlider.data('hidden-field-from-id')));
        $fieldTo = $('#' + $.escapeSelector($customSlider.data('hidden-field-to-id')));
        previousFromValue = parseInt($fieldFrom.val());
        previousToValue = parseInt($fieldTo.val());
        if (minValue === maxValue) {
          minValue -= maxValue;
        }
        valueRange = {
          'min': minValue,
          'max': maxValue
        };
        noUiSlider.create(customSlider, {
          start: [parseFloat($fieldFrom.val()), parseFloat($fieldTo.val())],
          connect: true,
          range: valueRange,
          step: 1,
          format: {
            to: function(value) {
              return Math.round(value);
            },
            from: function(value) {
              return Math.round(value);
            }
          }
        });
        customSlider.noUiSlider.on('slide', function(values, handle) {
          $fieldFrom.val(values[0]);
          return $fieldTo.val(values[1]);
        });
        $fieldFrom.on('change', function(e) {
          var $this, maxVal, minVal, value;
          e.stopPropagation();
          clearTimeout(window.priceSliderTimeout);
          $this = $(this);
          value = parseFloat($this.val());
          minVal = parseFloat($this.attr('min'));
          maxVal = parseFloat($this.attr('max'));
          if (value < minVal) {
            $this.val(minVal);
          }
          if (value > maxVal) {
            $this.val(maxVal);
          }
          return window.priceSliderTimeout = setTimeout((function() {
            return customSlider.noUiSlider.set([value, null]);
          }), 300);
        });
        $fieldTo.on('change', function(e) {
          var $this, maxVal, minVal, value;
          e.stopPropagation();
          clearTimeout(window.priceSliderTimeout);
          $this = $(this);
          value = parseFloat($this.val());
          minVal = parseFloat($this.attr('min'));
          maxVal = parseFloat($this.attr('max'));
          if (value < minVal) {
            $this.val(minVal);
          }
          if (value > maxVal) {
            $this.val(maxVal);
          }
          return window.priceSliderTimeout = setTimeout((function() {
            return customSlider.noUiSlider.set([null, value]);
          }), 300);
        });
        debounceTimeout = null;
        customSlider.noUiSlider.on('set', function(values, handle) {
          clearTimeout(debounceTimeout);
          return debounceTimeout = setTimeout(function() {
            var actualFromValue, actualToValue, badge, fromValue, sliderName, toValue;
            actualFromValue = parseFloat(values[0]);
            actualToValue = parseFloat(values[1]);
            $fieldFrom.val(parseFloat(values[0]));
            $fieldTo.val(parseFloat(values[1]));
            if (actualFromValue === minValue && actualToValue === maxValue) {
              $customSlider.parents('.collapse').prev().find('.fa-times-circle').addClass('d-none');
              $('[data-filter-value="' + $customSlider.data('hidden-field-from-id') + '"]').remove();
            } else {
              fromValue = values[0];
              toValue = values[1];
              sliderName = $customSlider.data('slider-name');
              $('[data-filter-value="' + $customSlider.data('hidden-field-from-id') + '"]').remove();
              badge = '<div class="filter-badge" data-filter-value="' + $customSlider.data('hidden-field-from-id') + '"><div>' + sliderName + " " + fromValue + " - " + toValue + '</div><div class="cancel-x-xs"></div></div>';
              $('.filter-badges-wrap').append(badge);
              that.appliedFilterCount();
              $('[data-filter-value="' + $customSlider.data('hidden-field-from-id') + '"]').click(function() {
                customSlider.noUiSlider.set([minValue, maxValue]);
                if ($(this).siblings().length === 0) {
                  $('[data-target="#' + $(this).data('filter-group') + '"]').next().addClass('d-none');
                  $customSlider.parents('.collapse').prev().find('.fa-times-circle').addClass('d-none');
                }
                $(this).remove();
                if (that.allowReload) {
                  return that.reloadProducts(true);
                }
              });
              $customSlider.parents('.collapse').prev().find('.fa-times-circle').removeClass('d-none');
            }
            if (!(previousFromValue === actualFromValue && previousToValue === actualToValue)) {
              previousFromValue = actualFromValue;
              previousToValue = actualToValue;
              PublicUtility.ProductList.showCancelAll();
              if (that.allowReload) {
                return that.reloadProducts(true);
              }
            }
          }, 200);
        });
        customSlider.noUiSlider.set([parseFloat(previousFromValue), parseFloat(previousToValue)]);
        return $($customSlider.parents('.collapse').prev().find('.fa-times-circle')).click(function() {
          customSlider.noUiSlider.set([minValue, maxValue]);
          return that.appliedFilterCount();
        });
      });
    };

    ProductList.prototype.checkIndeterminate = function() {
      return $('.multi-check-wrap').each((function(_this) {
        return function(index, element) {
          var $parentCheckbox, $this, checkedChildren, children;
          $this = $(element);
          children = $('.multi-check', $this).children().length;
          checkedChildren = $('.multi-check input[type="checkbox"]:checked', $this).length;
          $parentCheckbox = $this.find('> .mzkr-checkbox input[type="checkbox"]');
          if (checkedChildren === children) {
            return $parentCheckbox.prop({
              indeterminate: false,
              checked: true
            });
          } else if (checkedChildren === 0) {
            return $parentCheckbox.prop({
              indeterminate: false,
              checked: false
            });
          } else {
            return $parentCheckbox.prop({
              indeterminate: true,
              checked: false
            });
          }
        };
      })(this));
    };

    ProductList.prototype.buildBadgeText = function(elem, value) {
      var badgeText, groupName;
      groupName = elem.closest("[data-group-name]").data('group-name');
      badgeText = '';
      if (groupName) {
        badgeText += "<strong>" + groupName + "</strong>: ";
      }
      return badgeText += value;
    };

    ProductList.prototype.initResetFilter = function() {
      var badgeClick, badgeClickCheck, that;
      that = this;
      $('.multi-check-wrap').each(function() {
        var $this;
        $this = $(this);
        if ($('.multi-check label:not(.light-gray)', $this).length === 0) {
          return $('> label', $this).addClass('light-gray text-crossed');
        } else {
          return $('> label', $this).removeClass('light-gray text-crossed');
        }
      });
      badgeClickCheck = function() {
        var badgeMultiCheck;
        badgeMultiCheck = $('.filter-badges-wrap .filter-badge[data-filter-value*="multicheck"]');
        badgeMultiCheck.off('click.multi');
        return badgeMultiCheck.on('click.multi', function() {
          return that.checkIndeterminate();
        });
      };
      badgeClickCheck();
      $('.multi-check input[type="checkbox"]').on('change', function() {
        that.checkIndeterminate();
        return badgeClickCheck();
      });
      badgeClick = function() {
        return $('.badge-input').on('click', function() {
          var $this, dataFilterGroup, filterCheckboxValue, targetCheck;
          $this = $(this);
          filterCheckboxValue = $this.data("filter-value").toString();
          dataFilterGroup = $this.data('filter-group');
          targetCheck = $("[id='" + dataFilterGroup + "'] input[type=checkbox][data-filter-checkbox='" + (filterCheckboxValue.replace(/"/g, '\\"')) + "']");
          targetCheck.prop('checked', false);
          PublicUtility.ProductList.handleCheckboxChange(targetCheck);
          if ($this.siblings().length === 0) {
            $('[data-target="#' + $this.data('filter-group') + '"]').next().addClass('d-none');
          } else if ($("[data-filter-group=" + $this.data('filter-group') + "]").length === 1) {
            $('[data-target="#' + $this.data('filter-group') + '"]').next().addClass('d-none');
          }
          if (targetCheck.parents('.multi-check-wrap').length && !targetCheck.parents('.multi-check').length) {
            targetCheck.parents('.multi-check-wrap').find('.multi-check input[type="checkbox"]').prop('checked', false);
          }
          $this.remove();
          that.appliedFilterCount();
          PublicUtility.ProductList.showCancelAll();
          that.reloadProducts(true);
          return that.checkIndeterminate();
        });
      };
      $('.listing-filter-main input[type=checkbox]:checked').each(function() {
        var $this, badge, badgeText, filterCheckboxData;
        $this = $(this);
        filterCheckboxData = $this.data('filter-checkbox').toString();
        if (!$this.parent().parent().hasClass('multi-check-wrap')) {
          $this.parents('.collapse').prev().find('.fa-times-circle').removeClass('d-none');
          PublicUtility.ProductList.showCancelAll();
          badgeText = that.buildBadgeText($this, $this.prev().text().split('(')[0]);
          badge = $('<button type="button" class="filter-badge badge-input" data-filter-value="' + that.htmlSafeQuoteMarks(filterCheckboxData) + '" data-filter-group="' + $this.parents('.collapse').attr('id') + '"><div>' + badgeText + '</div><div class="cancel-x-xs"></div></button>');
          $('.filter-badges-wrap').append(badge);
          that.appliedFilterCount();
          $(".badge-input").off('click');
          return badgeClick();
        }
      });
      $('.cancel-filter-group').on('click', function() {
        var $this;
        $this = $(this);
        $this.parent().next().find('input[type=checkbox]').each(function() {
          $(this).prop({
            indeterminate: false,
            checked: false
          });
          return PublicUtility.ProductList.handleCheckboxChange($(this));
        });
        $('.filter-badge[data-filter-group="' + $this.parent().next().attr('id') + '"]').each(function() {
          return $(this).remove();
        });
        $this.addClass('d-none');
        PublicUtility.ProductList.showCancelAll();
        that.appliedFilterCount();
        if (that.allowReload) {
          return that.reloadProducts(true);
        }
      });
      $('.listing-filter-main').on('click', '.mzkr-checkbox a', function(e) {
        e.preventDefault();
        return $(this).parent('.mzkr-checkbox').find('input').trigger('click');
      });
      $('.listing-filter-main').on('click', '.mzkr-checkbox input', function() {
        var $this;
        $this = $(this);
        return setTimeout((function() {
          var badge, badgeText, dataFilterGroup, filterCheckboxData;
          filterCheckboxData = $this.data('filter-checkbox').toString();
          dataFilterGroup = $this.parents('.collapse').attr('id');
          if ($this.is(':checked') && !$this.parent().parent().hasClass('multi-check-wrap')) {
            badgeText = that.buildBadgeText($this, $this.prev().text().split('(')[0]);
            badge = $('<button type="button" class="filter-badge badge-input" data-filter-value="' + that.htmlSafeQuoteMarks(filterCheckboxData) + '" data-filter-group="' + dataFilterGroup + '"><div>' + badgeText + '</div><div class="cancel-x-xs"></div></button>');
            $('.filter-badges-wrap').append(badge);
            $(".badge-input").off('click');
            PublicUtility.ProductList.showCancelAll();
            badgeClick();
            badgeClickCheck();
            that.appliedFilterCount();
          } else {
            $("[data-filter-group='" + dataFilterGroup + "'][data-filter-value='" + (filterCheckboxData.replace(/"/g, '\\"')) + "']").remove();
          }
          if ($this.parents('[class*="scroll-box"]').find('input:checked').length) {
            $this.parents('.collapse').prev().find('.fa-times-circle').removeClass('d-none');
            return PublicUtility.ProductList.showCancelAll();
          } else {
            $this.parents('.collapse').prev().find('.fa-times-circle').addClass('d-none');
            return PublicUtility.ProductList.showCancelAll();
          }
        }), 0);
      });
      $('.multi-check-wrap > .mzkr-checkbox input[type="checkbox"]').each(function() {
        var $this;
        $this = $(this);
        if ($this.is(':checked')) {
          return $('.multi-check input[type="checkbox"]:not(:checked)', $this.parents('.multi-check-wrap')).each(function() {
            var $input, badge, badgeText, filterCheckboxData;
            $input = $(this);
            filterCheckboxData = $input.data('filter-checkbox').toString();
            $input.prop('checked', true);
            badgeText = that.buildBadgeText($input, $input.prev().text().split('(')[0]);
            badge = '<button type="button" class="filter-badge badge-input" data-filter-value="' + that.htmlSafeQuoteMarks(filterCheckboxData) + '" data-filter-group="' + $input.parents('.collapse').attr('id') + '"><div>' + badgeText + '</div><div class="cancel-x-xs"></div></button>';
            $('.filter-badges-wrap').append(badge);
            $(".badge-input").off('click');
            return badgeClick();
          });
        }
      });
      $('.multi-check-wrap > .mzkr-checkbox input[type="checkbox"]').on('change', function() {
        var $this;
        $this = $(this);
        badgeClickCheck();
        if ($this.is(':checked')) {
          $('.multi-check input[type="checkbox"]:not(:checked)', $this.parents('.multi-check-wrap')).each(function() {
            var $input, badge, badgeText, filterCheckboxData;
            $input = $(this);
            filterCheckboxData = $input.data('filter-checkbox').toString();
            $input.prop('checked', true);
            badgeText = that.buildBadgeText($input, $input.prev().text().split('(')[0]);
            badge = '<div class="filter-badge badge-input" data-filter-value="' + that.htmlSafeQuoteMarks(filterCheckboxData) + '" data-filter-group="' + $input.parents('.collapse').attr('id') + '"><div>' + badgeText + '</div><div class="cancel-x-xs"></div></div>';
            $('.filter-badges-wrap').append(badge);
            $(".badge-input").off('click');
            return badgeClick();
          });
        } else {
          $('.multi-check input[type="checkbox"]', $this.parents('.multi-check-wrap')).each(function() {
            var $input, filterCheckboxData;
            $input = $(this);
            filterCheckboxData = $input.data('filter-checkbox').toString();
            $input.prop('checked', false);
            return $('[data-filter-value="' + filterCheckboxData + '"]').remove();
          });
        }
        that.appliedFilterCount();
        return PublicUtility.ProductList.showCancelAll();
      });
      return $('#main-filter-container').on('click', '.filter-cancel-all, .empty-listing-cancel-all', function() {
        $('.filter-badge').remove();
        that.allowReload = false;
        return setTimeout((function() {
          $('.filter-count').text("");
          $('.listing-filter-main .fa-times-circle').trigger('click');
          PublicUtility.ProductList.showCancelAll();
          that.allowReload = true;
          return that.reloadProducts(true);
        }), 0);
      });
    };

    ProductList.initBoughtAt = function() {
      var now;
      now = moment();
      return $('.bought-at').each(function() {
        var $this, date, dateCompatible, roundedTime, t, time;
        $this = $(this);
        t = $this.data("bought-at").split(/[- :]/);
        date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
        dateCompatible = new Date(date);
        time = now.diff(moment(dateCompatible), 'minutes');
        roundedTime = Math.round(time);
        if (roundedTime === 0) {
          return $this.html(I18n.t('js.public.bought_ago.now'));
        } else if (time < 60) {
          return $this.html(I18n.t('js.public.bought_ago.minutes_ago', {
            count: roundedTime
          }));
        } else if (time < 1440) {
          return $this.html(I18n.t('js.public.bought_ago.hours_ago', {
            count: Math.round(time / 60)
          }));
        } else {
          return $this.html(I18n.t('js.public.bought_ago.days_ago', {
            count: Math.round(time / 60 / 24)
          }));
        }
      });
    };

    ProductList.updateTiles = function() {
      var $tilesContainer, brand, brandInfo, ref, results, that;
      that = ProductList;
      $tilesContainer = $('.js-brands-search-tiles-wrap');
      $tilesContainer.empty();
      if ($('.js-ajax-filter-checkbox:checked').length) {
        ref = that.checkedBrands;
        results = [];
        for (brand in ref) {
          brandInfo = ref[brand];
          results.push($tilesContainer.append("<button type=\"button\" class=\"filter-badge filter-badge-sm cursor-pointer\" data-brand=\"" + brand + "\">" + brandInfo.original + "<div class=\"cancel-x-xs\"></div></button>"));
        }
        return results;
      } else {
        return $tilesContainer.parents('.collapse').prev().find('.cancel-filter-group').addClass('d-none');
      }
    };

    ProductList.handleCheckboxChange = function($input) {
      var input, originalBrand, that;
      that = this;
      input = $input ? $($input)[0] : this;
      if (input.checked) {
        originalBrand = $($input).parents('.mzkr-checkbox').find('.products-count').parent('span').contents().get(0).nodeValue;
        that.checkedBrands[input.value] = {
          parsed: input.value,
          original: originalBrand
        };
      } else {
        delete that.checkedBrands[input.value];
      }
      return PublicUtility.ProductList.updateTiles();
    };

    ProductList.initFilterSearch = function() {
      var $ajaxSearchBrand, $form, activeRequests, form_data, generateCheckboxHTML, getBrandName, getbrandId, handleInputChange, initializeCheckboxesAndTiles, normalizeDiacritics, parseBrandName, that;
      $form = $('#main-filter');
      that = ProductList;
      that.filterSearchTimeout = void 0;
      that.checkedBrands = {};
      form_data = $form.serializeArray();
      activeRequests = 0;
      $ajaxSearchBrand = $('[data-ajax-search-brand-path]');
      parseBrandName = function(brand) {
        var parsedBrand;
        parsedBrand = brand.replace(/-/g, ' ');
        parsedBrand = parsedBrand.toLowerCase();
        parsedBrand = parsedBrand.charAt(0).toUpperCase() + parsedBrand.slice(1);
        return parsedBrand;
      };
      getBrandName = function(brand) {
        if (typeof brand === 'string') {
          return parseBrandName(brand);
        } else {
          return brand.name;
        }
      };
      getbrandId = function(brand) {
        if (typeof brand === 'string') {
          return brand;
        } else {
          return brand.id;
        }
      };
      generateCheckboxHTML = function(brand, checked) {
        var brandId, brandName, checkedAttr;
        brandName = getBrandName(brand);
        brandId = getbrandId(brand);
        checkedAttr = checked ? 'checked' : '';
        return "<label class=\"mzkr-checkbox " + (brand.count === 0 ? 'light-gray text-crossed' : '') + "\">\n  <span>" + brandName + " <span class=\"products-count\">" + (brand.count === 0 || brand.count ? '(' + brand.count + ')' : '') + "</span></span>\n  <input type=\"checkbox\" name=\"brands\" id=\"brands_" + brandId + "\" value=\"" + brandId + "\" data-filter-checkbox=\"" + brandId + "\" data-default-position=\"1\" data-gtmevent-click=\"{&quot;id&quot;:&quot;filter_checkbox&quot;,&quot;info&quot;:&quot;" + brandId + "&quot;}\" class=\"js-ajax-filter-checkbox\" " + checkedAttr + ">\n  <span class=\"checkmark\"></span>\n</label>";
      };
      handleInputChange = function() {
        var $searchInput, $searchItems, searchText;
        $searchInput = $(this);
        if ($searchInput.data('ajax-search-brand-path')) {
          clearTimeout(that.filterSearchTimeout);
          that.filterSearchTimeout = setTimeout(function() {
            var current_data;
            activeRequests += 1;
            $('.js-brands-filter-loader').removeClass('mzkr-d-none');
            $searchInput.siblings('.checkbox-wrap').addClass('mzkr-d-none');
            $form = $('#main-filter');
            that.filterSearchTimeout = void 0;
            form_data = $form.serializeArray();
            current_data = form_data.slice();
            current_data.push({
              name: 'term',
              value: normalizeDiacritics($searchInput.val().toLowerCase())
            });
            $('.mzkr-checkbox .js-ajax-filter-checkbox:checked').each(function() {
              var originalBrand;
              originalBrand = $(this).parents('.mzkr-checkbox').find('.products-count').parent('span').contents().get(0).nodeValue;
              return that.checkedBrands[this.value] = {
                parsed: this.value,
                original: originalBrand
              };
            });
            PublicUtility.ProductList.updateTiles();
            return $.ajax({
              type: "GET",
              data: current_data,
              url: $searchInput.data('ajax-search-brand-path'),
              dataType: "json",
              success: function(data) {
                var $checkboxWrap, $checkedBrands, $newCheckboxes, $selectedBrands, checkboxes;
                checkboxes = '';
                $.each(data.brands, function(index, brand) {
                  var checked;
                  checked = that.checkedBrands[getbrandId(brand)] ? true : false;
                  return checkboxes += generateCheckboxHTML(brand, checked);
                });
                activeRequests -= 1;
                if (activeRequests === 0) {
                  $checkboxWrap = $searchInput.siblings('.checkbox-wrap');
                  $checkedBrands = $checkboxWrap.find('.js-ajax-filter-checkbox:checked');
                  $selectedBrands = $checkboxWrap.next('.js-brands-selected');
                  if ($checkedBrands.length) {
                    $selectedBrands.append($checkedBrands);
                  }
                  $newCheckboxes = $(checkboxes).find('input:checked');
                  $newCheckboxes.each(function() {
                    return $selectedBrands.find("input[value='" + ($(this).attr('value')) + "']").remove();
                  });
                  $checkboxWrap.html(checkboxes).removeClass('mzkr-d-none');
                  $('.js-brands-filter-loader').addClass('mzkr-d-none');
                  return PublicUtility.ProductList.updateTiles();
                }
              }
            });
          }, 500);
          return;
        }
        if (!$searchInput.data('ajax-search-brand-path')) {
          searchText = normalizeDiacritics($searchInput.val().toLowerCase());
          $searchItems = $searchInput.siblings('.checkbox-wrap').find('.mzkr-checkbox');
          return $searchItems.each(function() {
            var $this, itemText;
            itemText = normalizeDiacritics($(this).text().toLowerCase());
            $this = $(this);
            if (itemText.indexOf(searchText) === -1) {
              return $this.hide();
            } else {
              return $this.show();
            }
          });
        }
      };
      normalizeDiacritics = function(text) {
        var normalizedText;
        normalizedText = text.normalize('NFD');
        return normalizedText.replace(/[\u0300-\u036f]/g, '');
      };
      initializeCheckboxesAndTiles = function(that) {
        var $brands;
        if ($ajaxSearchBrand.length) {
          $brands = $('.js-ajax-filter-checkbox:checked');
          return $brands.each(function() {
            var $brand, brandName;
            $brand = $(this);
            brandName = $brand.parents('.mzkr-checkbox').find('.products-count').parent('span').contents().get(0).nodeValue;
            return that.checkedBrands[$brand.val()] = {
              parsed: $brand.val(),
              original: brandName
            };
          });
        }
      };
      $(document).on('change', '.mzkr-checkbox .js-ajax-filter-checkbox, .js-brands-selected .js-ajax-filter-checkbox', function(event) {
        return PublicUtility.ProductList.handleCheckboxChange(event.target);
      });
      $(document).on('click', '.js-brands-search-tiles-wrap > .filter-badge', function() {
        var $this, dataBrand;
        $this = $(this);
        dataBrand = $this.data('brand');
        $("[data-filter-value='" + dataBrand + "']").remove();
        PublicUtility.ProductList.showCancelAll();
        $(".select-brand input[value='" + dataBrand + "']").prop('checked', false).trigger('change');
        $(".js-brands-selected input[value='" + dataBrand + "']").prop('checked', false).trigger('change').remove();
        return PublicUtility.ProductList.updateTiles();
      });
      $('.input-search-filter').on('input', handleInputChange);
      return initializeCheckboxesAndTiles(that);
    };

    ProductList.prototype.initSortBy = function() {
      var element, that;
      that = this;
      element = $(".listing-filter-bar");
      $('.sort-by').on('change', function() {
        var sorted;
        sorted = $(this).val();
        $(document).find('.sort-by').each(function() {
          $(this).val(sorted);
          return $(this).trigger('change.select2');
        });
        $('.sort-by-tab[data-value="' + sorted + '"]').addClass('active').siblings('.sort-by-tab').removeClass('active');
        return that.reloadProducts(true);
      });
      $('.sort-by').on('select2:select', function(e) {
        if ($(this).parents('.col-12.filter-bottom').length > 0) {
          return that.scrollToElement(element);
        }
      });
      return $('.sort-by-tab').on('click', function() {
        var sortedTab;
        sortedTab = $(this).attr('data-value');
        $('.sort-by').val(sortedTab).trigger('change');
        return $(this).addClass('active').siblings('.sort-by-tab').removeClass('active');
      });
    };

    ProductList.prototype.initPagination = function() {
      var element, that;
      that = this;
      element = $(".listing-filter-bar");
      $('.paginate-next-page').on('click', function(e) {
        e.preventDefault();
        that.changePage(+1, null);
        return that.scrollToElement(element);
      });
      $('.paginate-previous-page').on('click', function(e) {
        e.preventDefault();
        that.changePage(-1, null);
        return that.scrollToElement(element);
      });
      return that.initPaginationForNumbers();
    };

    ProductList.prototype.initPaginationForNumbers = function() {
      var element, that;
      that = this;
      element = $(".listing-filter-bar");
      return $('.js-go-to-page, .js-current-page').on('click', function(e) {
        e.preventDefault();
        that.changePage(0, $(this).data('page-number'));
        return that.scrollToElement(element);
      });
    };

    ProductList.prototype.changePageMoveLink = function(element, goToPage) {
      return setTimeout((function() {
        return element.attr('href', location.href.replace(/page=\d+/, 'page=' + goToPage));
      }), 1);
    };

    ProductList.prototype.changePage = function(step, pageNumber) {
      var goToPage;
      if (step === 0) {
        goToPage = pageNumber;
      } else {
        goToPage = parseInt($('.paginate-pages').data('current-page'));
        goToPage += step;
      }
      $('.paginate-pages').data('current-page', goToPage);
      return this.reloadProducts();
    };

    ProductList.prototype.showLoader = function() {
      $('.loader-wrap').removeClass('invisible');
      return $('.sticky-column').stick_in_parent({
        offset_top: 100
      });
    };

    ProductList.prototype.scrollToElement = function(element) {
      var elementHeight, navHeight, offset, windowHeight;
      navHeight = $('.mzkr-nav-wrap').height();
      elementHeight = element.height();
      windowHeight = $(window).height();
      if ($(window).width() < 769) {
        offset = Math.min(elementHeight, windowHeight) - navHeight + element.offset().top - 80;
      } else {
        offset = Math.min(elementHeight, windowHeight) - navHeight + element.offset().top - 130;
      }
      return $('html, body').animate({
        scrollTop: offset
      }, 500);
    };

    ProductList.prototype.initShowMore = function() {
      var that;
      that = this;
      $('.load-next-products').on('click', function(e) {
        var current_page;
        e.preventDefault();
        $(this).addClass('disabled');
        $(this).find('.spinner-border').removeClass('d-none');
        current_page = parseInt($('.paginate-pages').data('current-page'));
        current_page += 1;
        $('.paginate-pages').data('current-page', current_page);
        return that.reloadProducts();
      });
      if ($('.paginate-next-page').prop('disabled')) {
        return $('.load-next-products').removeClass('d-inline-flex').addClass('d-none');
      }
    };

    ProductList.prototype.sortCheckboxes = function() {
      return $('.checkbox-wrap .mzkr-checkbox').each(function() {
        var position, positionOffset;
        positionOffset = $(this).hasClass('text-crossed') ? 10000 : 0;
        position = parseInt($(this).find('input').data('default-position')) + positionOffset;
        $(this).css('--order', position);
        return $(this).parent().attr('data-order', true);
      });
    };

    ProductList.prototype.htmlSafeQuoteMarks = function(value) {
      return value.replace('"', '&quot;').replace("'", '&apos;');
    };

    ProductList.initStickyFilters = function(update) {
      if (update == null) {
        update = false;
      }
      if ($('.sticky-listing-filter').length) {
        if (update) {
          return ProductList.stickyProductFilter.updateSticky();
        }
        return ProductList.stickyProductFilter = new StickySidebar('.sticky-listing-filter', {
          topSpacing: 144,
          bottomSpacing: 0,
          containerSelector: '.sticky-listing-container',
          innerWrapperSelector: '.sticky-listing-filter__inner',
          resizeSensor: true,
          minWidth: 991
        });
      }
    };

    ProductList.prototype.initScrollTo = function(element) {
      return $(element).on('click', function(e) {
        var navOffset, target;
        e.preventDefault();
        target = $(this).attr('href');
        navOffset = $('.mzkr-nav-wrap').height();
        return $('html, body').animate({
          scrollTop: $(target).offset().top - navOffset
        }, 500);
      });
    };

    ProductList.prototype.scrollToLastVisitedProduct = function() {
      var $lastVisitedProduct, lastVisitedProductCode, navHeight, performance, productHeight, productOffsetTop, scrollTop, windowHeight;
      performance = window.performance.getEntriesByType('navigation')[0];
      if (performance && performance.type === 'back_forward') {
        lastVisitedProductCode = sessionStorage.getItem('last_visited_product');
        if (lastVisitedProductCode) {
          $lastVisitedProduct = $(".product-list .product-tile[data-product-code=\"" + lastVisitedProductCode + "\"]");
          if ($lastVisitedProduct.length) {
            productOffsetTop = $lastVisitedProduct.offset().top;
            productHeight = $lastVisitedProduct.outerHeight();
            windowHeight = $(window).height();
            scrollTop = $(window).scrollTop();
            navHeight = $('.mzkr-nav').outerHeight();
            if (productOffsetTop + productHeight <= scrollTop + navHeight || productOffsetTop >= scrollTop + windowHeight) {
              return $('html, body').animate({
                scrollTop: productOffsetTop - navHeight
              }, 300);
            }
          }
        }
      }
    };

    ProductList.getSearchParams = function() {
      var params, queryString, searchParams;
      queryString = window.location.search;
      params = new URLSearchParams(queryString);
      searchParams = {};
      params.forEach(function(value, key) {
        if (searchParams[key]) {
          if (Array.isArray(searchParams[key])) {
            return searchParams[key].push(value);
          } else {
            return searchParams[key] = [searchParams[key], value];
          }
        } else {
          return searchParams[key] = value;
        }
      });
      return searchParams;
    };

    ProductList.stickyFilterBtn = function() {
      var $filterBtn, $productList, $window, productHeight, productOffsetTop, stickFilterBtn;
      $window = $(window);
      $filterBtn = $('.js-sticky-filter-toggler');
      $productList = $('#filtered-products');
      if (!($filterBtn.length && $productList.length)) {
        return;
      }
      productOffsetTop = $productList.offset().top;
      productHeight = $productList.height();
      stickFilterBtn = function() {
        var isFixed, scrollTop;
        scrollTop = $window.scrollTop();
        isFixed = scrollTop > productOffsetTop && scrollTop < productOffsetTop + (productHeight - 200);
        return $filterBtn.toggleClass('js-sticky-filter-toggler-fixed', isFixed);
      };
      return $window.on('scroll', function() {
        if ($window.width() < 992) {
          return stickFilterBtn();
        }
      });
    };

    ProductList.prototype.initProductTilesSwiper = function() {
      var $tileSwiper, initSwiper, observer;
      $tileSwiper = $('.tile-swiper');
      if (!$tileSwiper.length) {
        return;
      }
      initSwiper = function(swiper) {
        var $productTile, $swiper, showNextImageOnHover, swiperInstance;
        $swiper = $(swiper);
        showNextImageOnHover = $swiper.data('show-next-image-on-hover') && $(window).width() > 767;
        new Swiper(swiper, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 4,
          effect: showNextImageOnHover ? 'fade' : 'slide',
          fadeEffect: showNextImageOnHover ? {
            crossFade: true
          } : void 0,
          lazyPreloaderClass: 'tile-image-loader',
          lazyPreloadPrevNext: 0,
          navigation: {
            enabled: false,
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
            disabledClass: 'disabled',
            hiddenClass: 'invisible',
            lockClass: 'mzkr-d-none'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            hiddenClass: 'mzkr-d-none',
            lockClass: 'mzkr-d-none'
          },
          breakpoints: {
            768: {
              navigation: {
                enabled: true
              }
            }
          }
        });
        if (showNextImageOnHover) {
          $productTile = $swiper.closest('.product-tile');
          swiperInstance = $swiper[0].swiper;
          $productTile.on('mouseenter', function() {
            return swiperInstance.slideToLoop(1, 400, false);
          });
          return $productTile.on('mouseleave', function() {
            return swiperInstance.slideToLoop(0, 400, false);
          });
        }
      };
      observer = new IntersectionObserver(function(entries) {
        return entries.forEach(function(entry) {
          var tileSwiper;
          if (!entry.isIntersecting) {
            return;
          }
          tileSwiper = entry.target;
          if (!tileSwiper.swiper) {
            initSwiper(tileSwiper);
          }
          return observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '100px'
      });
      return $tileSwiper.each(function() {
        return observer.observe($(this)[0]);
      });
    };

    return ProductList;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.ProductQuestions = (function() {
    function ProductQuestions() {}

    ProductQuestions.reactionsInit = function(scope) {
      if (scope == null) {
        scope = document;
      }
      return $(scope).find('.reaction-link').off('click').on('click', function(event) {
        var $recaptchaInputSource, $recaptchaInputTarget, $recaptchaWrapper, questionId, reactionType;
        $recaptchaWrapper = $('#products-question-reaction-recaptcha');
        $recaptchaInputSource = $recaptchaWrapper.find("[name='g-recaptcha-response']");
        $recaptchaInputTarget = $(this).closest('form').find("[name='g-recaptcha-response']");
        questionId = $(this).closest('.reaction').attr('data-question-id');
        reactionType = $(this).attr('data-reaction-type');
        $recaptchaWrapper.attr('data-question-id', questionId);
        $recaptchaWrapper.attr('data-reaction-type', reactionType);
        return $recaptchaInputTarget.val($recaptchaInputSource.val());
      });
    };

    ProductQuestions.reactionsRecaptchaCallback = function() {
      var $wrapper, questionId, reactionType;
      $wrapper = $('#products-question-reaction-recaptcha');
      reactionType = $wrapper.attr('data-reaction-type');
      questionId = $wrapper.attr('data-question-id');
      return $("#reaction-" + questionId + " ." + reactionType + "ReactionBtn").click();
    };

    return ProductQuestions;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.Profile = (function() {
    function Profile() {
      return this;
    }

    Profile.checkProfile = function() {
      if ($('.invalid-feedback').length) {
        $('.invalid-feedback').each(function() {
          return $(this).parents('.collapse').collapse('show');
        });
        return $('html, body').animate({
          scrollTop: $('.invalid-feedback').offset().top - 200
        }, 500);
      }
    };

    return Profile;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Search = (function() {
    Search.prototype.timer = null;

    Search.prototype.searchIsOpened = false;

    function Search() {
      this.scrollY = 0;
      this.offset = 0;
      this.searchOpen = $('.search-dropdown, .search-backdrop');
      this.globalSearch = $('#global-search');
      this.globalSearchWrapper = $('#global-search-results-wrapper');
      this.syncDocumentHeight();
      this.init();
      this.openSearchListeners();
      this.hideSearchListeners();
      this.checkSearchInputVal();
      return this;
    }

    Search.prototype.init = function() {
      var that;
      that = this;
      if (!this.globalSearch.length) {
        return;
      }
      $('.js-open-keyboard').click(function(e) {
        return e.preventDefault();
      });
      $('.js-nav-search-clear').click(function() {
        $('#global-search').val('').trigger('input').focus();
        return $('.mzkr-nav__search-right-controls').addClass('mzkr-d-none');
      });
      if (window.disableSearchReq) {
        return;
      }
      return this.globalSearch.on('keyup focus', function(e) {
        if (e.key !== "Escape") {
          if ((that.current_search_ajax != null) || e.which === 13) {
            if ($(this).val()) {
              that.current_search_ajax.abort();
            }
          }
          if (e.which !== 13) {
            if (that.timer) {
              clearTimeout(that.timer);
            }
            return that.timer = setTimeout((function() {
              return that.search(e);
            }), 200);
          }
        }
      });
    };

    Search.prototype.syncDocumentHeight = function() {
      var syncHeight;
      syncHeight = function() {
        return document.documentElement.style.setProperty('--window-inner-height', window.innerHeight + "px");
      };
      return window.addEventListener('resize', syncHeight);
    };

    Search.openSearch = function() {
      var $seachBar, paddingTop, scrollY, that;
      $seachBar = $('.mzkr-nav__search-bar');
      that = this;
      this.searchIsOpened = false;
      if (!this.searchIsOpened) {
        that.searchIsOpened = true;
        scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = "-" + scrollY + "px";
        $seachBar.addClass('mzkr-nav__search-bar--no-transition');
        if (window.innerWidth > 768) {
          paddingTop = $('#global-search').offset().top - $(window).scrollTop();
          $seachBar.css('padding-top', paddingTop);
        }
        $seachBar.addClass('mzkr-nav__search-bar--open');
        $('.mzkr-nav-wrap').removeClass('nav-up');
        PublicUtility.Layout.focusTrap($('.mzkr-nav__search-bar')[0]).activate();
        if (window.autoComplete) {
          window.autoComplete[0].Reposition();
        }
        $('.search-backdrop').addClass('search-open');
        return document.getElementById("global-search").focus();
      }
    };

    Search.prototype.search = function(event) {
      var value;
      value = $('#global-search').val();
      if (window.disableSearchReq) {
        return;
      }
      if (value.length < 2) {
        return;
      }
      $('.search-dropdown .fa-spinner').removeClass('d-none');
      return this.current_search_ajax = $.get({
        url: Routes.autocomplete_search_index_path(),
        data: {
          q: value
        },
        success: this.processSearch,
        dataType: 'json'
      });
    };

    Search.prototype.processSearch = function(data, status) {
      var base, base1, category, i, j, k, len, len1, len2, ref, ref1, ref2, search_results;
      $('.search-dropdown .fa-spinner').addClass('d-none');
      if (status !== 'success') {
        return;
      }
      search_results = '';
      ref = data['exact_matches'];
      for (i = 0, len = ref.length; i < len; i++) {
        category = ref[i];
        if (data[category]['total_count'] !== 0) {
          search_results += PublicUtility.Search.sitemapNodeResultCategory(category, data[category]['results']);
        }
      }
      ref1 = ['brands', 'pages'];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        category = ref1[j];
        if (!(typeof (base = data['exact_matches']).includes === "function" ? base.includes(category) : void 0)) {
          if (data[category]['total_count'] !== 0) {
            search_results += PublicUtility.Search.sitemapNodeResultCategory(category, data[category]['results']);
          }
        }
      }
      search_results += PublicUtility.Search.productResultCategory(data['products']);
      ref2 = ['categories', 'system_nodes'];
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        category = ref2[k];
        if (!(typeof (base1 = data['exact_matches']).includes === "function" ? base1.includes(category) : void 0)) {
          if (data[category]['total_count'] !== 0) {
            search_results += PublicUtility.Search.sitemapNodeResultCategory(category, data[category]['results']);
          }
        }
      }
      $('#global-search-results').html(search_results);
      if ($('.search-open').hasClass('search-open')) {
        return $('#global-search-results-wrapper').show();
      }
    };

    Search.sitemapNodeResultCategory = function(category, results) {
      var html_list, i, len, result;
      html_list = "<h5 class='font-weight-semi-bold bg-white-gray'>" + (I18n.t("js.public.search.result_types." + category)) + "</h5>";
      for (i = 0, len = results.length; i < len; i++) {
        result = results[i];
        html_list += "<a href='" + result.url + "' class='font-weight-bold pl-3 py-2 py-sm-1'>\n  " + (result.alt_name || result.name) + "\n</a>";
      }
      return html_list;
    };

    Search.productResultCategory = function(products) {
      var html_list, i, len, product, product_price, ref;
      html_list = "<h5 class='font-weight-semi-bold bg-white-gray'>" + (I18n.t("js.public.search.result_types.products")) + " (" + products.total_count + " " + (I18n.t('js.public.search.result_types.result_count')) + ")</h5>";
      ref = products['results'];
      for (i = 0, len = ref.length; i < len; i++) {
        product = ref[i];
        if (product.is_ask_price === false) {
          product_price = I18n.toCurrency(product.price_with_vat, {
            precision: 2,
            unit: I18n.currency,
            format: '%n %u'
          });
        } else {
          product_price = '';
        }
        html_list += "<a href='" + product.url + "' class='search-result py-1 px-1 px-md-3'>\n  <div class='search-img img-contain'>\n    <img src='" + product.icon_base + "' alt='" + product.name + "' srcset='" + product.icon_base + ", " + product.icon + " 2x'/>\n  </div>\n  <p class='pr-2 flex-grow-1'><strong class='gray'>" + product.name + "</strong></p>\n  <p class='text-nowrap'>" + product_price + "</p>\n</a>";
      }
      return html_list;
    };

    Search.hideSearch = function() {
      var scrollY, spinner, that;
      if (Search.searchIsOpened) {
        that = Search;
        Search.searchOpen = $('.search-dropdown, .search-backdrop');
        Search.globalSearchWrapper = $('#global-search-results-wrapper');
        spinner = $('.search-dropdown .fa-spinner');
        Search.searchIsOpened = false;
        scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({
          top: parseInt(scrollY || '0') * -1,
          left: 0,
          behavior: 'instant'
        });
        $('.mzkr-nav__search-bar').removeAttr('style');
        $('.mzkr-nav__search-bar').removeClass('mzkr-nav__search-bar--open');
        setTimeout((function() {
          return $('.mzkr-nav__search-bar').removeClass('mzkr-nav__search-bar--no-transition');
        }), 300);
        Search.globalSearchWrapper.hide();
        Search.searchOpen.removeClass('search-open');
        $('#global-search').blur();
        spinner.addClass('d-none');
        if ($('.mzkr-nav-wrap').hasClass('nav-collapsed')) {
          $('.mzkr-nav-wrap').addClass('nav-up');
          $('.nav-top-banner').addClass('nav-top-banner-hidden');
        }
        if (window.disableSearchReq) {
          return;
        }
        if (that.current_search_ajax != null) {
          return that.current_search_ajax.abort();
        }
      }
    };

    Search.prototype.checkSearchInputVal = function() {
      var checkSearchVal;
      if (!$('.mzkr-nav__search-bar').length) {
        return;
      }
      checkSearchVal = function($input) {
        if ($input.val().length > 0) {
          $('.mzkr-nav__search-right-controls').removeClass('mzkr-d-none');
          return $input.addClass('no-bg');
        } else if ($input.val().length > 0) {
          return $input.addClass('no-bg');
        } else {
          $('.mzkr-nav__search-right-controls').addClass('mzkr-d-none');
          return $input.removeClass('no-bg');
        }
      };
      this.globalSearch.on('input', function() {
        var $this;
        $this = $(this);
        return checkSearchVal($this);
      });
      return checkSearchVal(this.globalSearch);
    };

    Search.prototype.openSearchListeners = function() {
      var that;
      that = this;
      return $('.search-toggler').mouseup(function(event) {
        event.preventDefault();
        that.searchOpen.addClass('search-open');
        PublicUtility.Search.openSearch();
        return $('#global-search').trigger('mouseup');
      });
    };

    Search.prototype.hideSearchListeners = function() {
      $('.js-nav-search-close, .search-backdrop, .mzkr-nav__search-button').on('click', function() {
        window.autoComplete[0].Close();
        return PublicUtility.Search.hideSearch();
      });
      $(document).on('click', '.luigi-ac-close', function() {
        window.autoComplete[0].Close();
        return PublicUtility.Search.hideSearch();
      });
      $(document).on('click', '.luigi-ac-button', function() {
        window.autoComplete[0].Close();
        return PublicUtility.Search.hideSearch();
      });
      this.globalSearchWrapper.click(function(e) {
        if ($(e.target).is('a')) {
          window.autoComplete[0].Close();
          return PublicUtility.Search.hideSearch();
        }
      });
      return $(document).on('keyup', function(e) {
        var windowWidth;
        windowWidth = window.innerWidth;
        if ((windowWidth > 768 && e.key === "Escape") || (e.which === 13 && $('.mzkr-nav__search-bar').hasClass('mzkr-nav__search-bar--open'))) {
          window.autoComplete[0].Close();
          return PublicUtility.Search.hideSearch();
        }
      });
    };

    return Search;

  })();

}).call(this);
(function() {
  window.Utility || (window.Utility = {});

  Utility.SearchDeliveryPoints = (function() {
    function SearchDeliveryPoints() {
      this.lunr = null;
    }

    SearchDeliveryPoints.prototype.initLunr = function(deliveryPoints) {
      return this.lunr = lunr(function() {
        this.pipeline.remove(lunr.stemmer);
        this.ref('code');
        this.field('city');
        this.field('street');
        this.field('place');
        return deliveryPoints.forEach((function(point) {
          var indexPoint;
          indexPoint = {};
          indexPoint.city = ASCIIFolder.fold(point.city);
          indexPoint.street = ASCIIFolder.fold(point.street);
          indexPoint.place = ASCIIFolder.fold(point.place);
          indexPoint.code = point.code;
          return this.add(indexPoint);
        }), this);
      });
    };

    return SearchDeliveryPoints;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Select = (function() {
    function Select() {
      return this;
    }

    Select.ajaxSelect = function(selector, url, options) {
      var ajax_calls, cacheBoxOptions, defaultOptions, isMultiple, minimumInputLength, modalOptions, pageLimit, preselected_values;
      minimumInputLength = typeof selector.data('minimumInputLength') === 'undefined' ? 3 : selector.data('minimumInputLength');
      pageLimit = 10;
      options = typeof options !== 'undefined' ? options : {};
      isMultiple = typeof options.multiple !== 'undefined' && options.multiple === true;
      defaultOptions = {
        minimumInputLength: minimumInputLength,
        placeholder: I18n.t('js.select2.placeholder'),
        allowClear: true,
        language: {
          noResults: function() {
            return I18n.t('js.select2.no_results');
          },
          inputTooShort: function() {
            return I18n.t('js.select2.input_too_short', {
              length: minimumInputLength
            });
          },
          errorLoading: function() {
            return I18n.t('js.select2.error_loading');
          },
          searching: function() {
            return I18n.t('js.select2.searching');
          }
        },
        width: '100%',
        tags: !!$(selector).data('ajax-allow-new'),
        ajax: {
          url: url,
          dataType: 'json',
          quietMillis: 100,
          delay: 250,
          data: function(params) {
            var ajaxData, userData;
            userData = {};
            if (typeof selector.data('ajax-data') === 'function') {
              userData = selector.data('ajax-data')();
            }
            ajaxData = {
              query: params.term,
              page_limit: pageLimit,
              page: params.page || 1
            };
            return $.extend({}, ajaxData, userData);
          },
          processResults: function(data, params) {
            var more;
            params.page = params.page || 1;
            more = params.page * pageLimit < data.total;
            return {
              results: data.results,
              pagination: {
                more: more
              }
            };
          }
        },
        escapeMarkup: function(m) {
          return m;
        }
      };
      $.extend(true, options, defaultOptions);
      modalOptions = {
        dropdownParent: $('#modal-container .mzrk-modal__content')
      };
      cacheBoxOptions = {
        dropdownParent: $('.cache-box')
      };
      if ($(selector).closest('#modal-container').length) {
        $.extend(true, options, modalOptions);
      }
      if ($(selector).parents('.cache-box').length) {
        $.extend(true, options, cacheBoxOptions);
      }
      $(selector).select2(options);
      if ($(selector).data('ajax-value')) {
        preselected_values = $(selector).data('ajax-value').toString().split(',');
        ajax_calls = [];
        $.each(preselected_values, function(key, value) {
          var url_address;
          if (value !== '') {
            url_address = typeof url === 'function' ? url() : url;
            return ajax_calls.push($.ajax(url_address, {
              dataType: 'json',
              data: {
                item_id: value
              },
              success: function(data) {
                return $(selector).data('select2').trigger('select', {
                  data: data
                });
              }
            }));
          }
        });
        $.when.apply($, ajax_calls).then(function() {
          return $(selector).trigger('ajax-select-initialized');
        });
      }
      return PublicUtility.Select.fixEnter(selector);
    };

    Select.fixEnter = function(elements) {
      return $(elements).each(function() {
        var $this, select2;
        $this = $(this);
        select2 = $this.data('select2');
        if (select2) {
          return select2.listeners['keypress'].push(function(e) {
            if (e.which === 13 && select2.isOpen()) {
              select2.close();
              return $this.closest('form').submit();
            }
          });
        }
      });
    };

    return Select;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.LoadSentry = (function() {
    function LoadSentry() {}

    LoadSentry.initSentry = function() {
      var enableSentryClient, integrations;
      enableSentryClient = 'true';
      if (enableSentryClient === 'true' && !Sentry.getClient()) {
        integrations = [Sentry.browserTracingIntegration()];
        Sentry.init({
          dsn: 'https://afffba1acccd305d9d0759f4dfb17ffd@sentry.muzmuz.tech/3',
          integrations: integrations,
          replaysSessionSampleRate: 0,
          replaysOnErrorSampleRate: 0.3,
          tracesSampleRate: 0.3,
          environment: 'production',
          release: '2025.9.4',
          ignoreErrors: ['Script error.', 'TypeError: undefined is not an object (evaluating \'webkit.messageHandlers.contextMenuMessageHandler.postMessage\')', 'TypeError: null is not an object (evaluating \'minimasedBadge.removeAttribute\')', 'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target', 'Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type', 'Non-Error exception captured with keys: currentTarget, detail, isTrusted, target', 'Non-Error promise rejection captured with value: undefined', 'top.GLOBALS', 'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', 'Can\'t find variable: ZiteReader', 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose', 'fb_xd_fragment', 'bmi_SafeAddOnload', 'EBCallBackMessageReceived', 'conduitPage', 'Failed to fetch', 'Cannot read properties of undefined (reading \'settings\')', 'undefined is not an object (evaluating \'_this.templateState.settings\')', 'TypeError: t is undefined'],
          denyUrls: [/graph\.facebook\.com/i, /connect\.facebook\.net\/en_US\/all\.js/i, /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i, /extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i, /127\.0\.0\.1:4001\/isrunning/i, /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i]
        });
        Sentry.setUser(document.querySelector('body').dataset.sentry);
        return window.Sentry = Sentry;
      }
    };

    return LoadSentry;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.SimilarProducts = (function() {
    function SimilarProducts() {}

    SimilarProducts.initCompareSimilarProducts = function() {
      var checkSimilarScroll, firstItem, lastItem, wrapElement;
      wrapElement = $('.compare-similar-wrap');
      $('[data-toggle="tooltip"]', wrapElement).tooltip();
      checkSimilarScroll = function() {
        var $scrollLeft, $scrollWidth, $width;
        $width = wrapElement.outerWidth();
        $scrollWidth = wrapElement[0].scrollWidth;
        $scrollLeft = wrapElement.scrollLeft();
        if ($scrollWidth - $width === $scrollLeft) {
          $('[data-compare-prev]').removeClass('d-none');
          $('[data-compare-next]').addClass('d-none');
        }
        if ($scrollLeft === 0) {
          $('[data-compare-prev]').addClass('d-none');
          return $('[data-compare-next]').removeClass('d-none');
        }
      };
      if (wrapElement.length) {
        wrapElement.scroll(function() {
          return checkSimilarScroll();
        });
        firstItem = $('.col-2', wrapElement).first();
        lastItem = $('.col-2', wrapElement).last();
        if (wrapElement[0].scrollWidth > wrapElement.outerWidth()) {
          checkSimilarScroll();
        }
        $(window).resize(function() {
          if (wrapElement[0].scrollWidth > wrapElement.outerWidth()) {
            return checkSimilarScroll();
          } else {
            $('[data-compare-prev]').addClass('d-none');
            return $('[data-compare-next]').addClass('d-none');
          }
        });
        $('[data-compare-prev]').click(function() {
          return wrapElement.animate({
            scrollLeft: firstItem.position().left
          }, 400);
        });
        return $('[data-compare-next]').click(function() {
          return wrapElement.animate({
            scrollLeft: lastItem.position().left
          }, 400);
        });
      }
    };

    return SimilarProducts;

  })();

}).call(this);
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.WebpushNotification = (function() {
    function WebpushNotification() {
      this.viewCounter();
      PublicUtility.WebpushNotification.initServiceWorker();
    }

    WebpushNotification.initServiceWorker = function() {
      var cookieBarPresent, isNavFull;
      this.enableWebpush = $('body').is('[data-webpush]');
      this.browserSupport = 'serviceWorker' in navigator && 'PushManager' in window;
      this.notificationSupport = 'Notification' in window;
      cookieBarPresent = $('.consent-box').length;
      isNavFull = !$('.body-is-nav-simple').length;
      if (!(this.enableWebpush && this.browserSupport && !cookieBarPresent && isNavFull && this.notificationSupport)) {
        return null;
      }
      return registerServiceWorker();
    };

    WebpushNotification.prototype.viewCounter = function() {
      var cookiesViewCount;
      cookiesViewCount = Cookies.get('total_page_views_count');
      if (cookiesViewCount) {
        cookiesViewCount = parseInt(cookiesViewCount) + 1;
      } else {
        cookiesViewCount = 1;
      }
      return Cookies.set('total_page_views_count', cookiesViewCount, {
        secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
      });
    };

    return WebpushNotification;

  })();

}).call(this);
let swRegistration = null;

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function registerServiceWorker() {
  let cookiePageViews = parseInt(Cookies.get('total_page_views_count'));
  let cookieRefreshDate = Cookies.get('wp_repeat_timestamp');
  let currentDate = new Date();

  if (
    Notification.permission !== 'denied' &&
    ((cookiePageViews === 10 && !cookieRefreshDate) ||
      (cookieRefreshDate && currentDate >= new Date(parseInt(cookieRefreshDate))))
  ) {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(function (registration) {
        swRegistration = registration;

        resubscribeOldRegistration();
        swRegistration.pushManager.getSubscription().then(function (subscription) {
          if (subscription === null) {
            subscribeUser();
          }
        });
      })
      .catch(function (error) {});
  } else if (cookiePageViews > 10 && !cookieRefreshDate) {
    rememberLater();
  }
}

function resubscribeOldRegistration() {
  let reSubscribe = false;
  let newSubscription = Cookies.get('wp_new_subscriber');

  swRegistration.pushManager
    .getSubscription()
    .then(function (subscription) {
      if (!newSubscription && subscription && subscription.endpoint) {
        persistedEndpoint(subscription.endpoint).then(function (result) {
          if (!result) {
            reSubscribe = true;

            subscription.unsubscribe().then(function () {
              if (reSubscribe && Notification.permission === 'granted') {
                subscribeUser();
              }
            });
          } else {
            Cookies.set('wp_new_subscriber', true, {
              secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie(),
            });
          }
        });
      }
    })
    .catch(function (error) {});
}

function rememberLater() {
  let nextDate = new Date();
  let twoWeekInMilliseconds = 14 * 24 * 60 * 60 * 1000;

  nextDate.setTime(nextDate.getTime() + twoWeekInMilliseconds);
  Cookies.set('wp_repeat_timestamp', nextDate.getTime(), {
    secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie(),
  });
}

function subscribeUser() {
  const applicationServerKey = urlB64ToUint8Array(window.wpKey);

  swRegistration.pushManager
    .subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey,
    })
    .then(function (subscription) {
      updateSubscriptionOnServer(subscription)
        .then(function () {
          Cookies.set('wp_new_subscriber', true, {
            secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie(),
          });
          Cookies.remove('wp_repeat_timestamp');
        })
        .catch(function (error) {
          console.log('Failed to subscribe the user: ', error);
        });
    })
    .catch(function (error) {
      console.log('Failed to subscribe the user: ', error);
    });
}

function updateSubscriptionOnServer(subscription) {
  const bodyElement = document.querySelector('body');
  const apiUrl =
    window.location.protocol +
    '//' +
    window.location.host +
    Routes.api_webpush_subscriptions_path();
  let dataObject;
  let webpush_subscription;

  dataObject = { data: JSON.parse(JSON.stringify(subscription)) };
  dataObject['locale_code'] = bodyElement.dataset.locale;

  webpush_subscription = { webpush_subscription: dataObject };

  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(webpush_subscription),
  })
    .then(function (response) {
      if (!response.ok) {
        let message = 'Bad status code from server. Status code: ' + response.status;

        throw new Error(message);
      }

      return response.json();
    })
    .then(function (responseData) {
      if (!(responseData.data && responseData.data.status === 'success')) {
        let message = 'Bad response from server. ';

        if (responseData.data) {
          message += JSON.stringify(responseData.data);
        }

        throw new Error(message);
      }
    });
}

function persistedEndpoint(endpoint) {
  const apiUrl =
    window.location.protocol +
    '//' +
    window.location.host +
    Routes.check_api_webpush_subscriptions_path();

  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ endpoint: endpoint }),
  })
    .then(function (response) {
      if (!response.ok) {
        let message = 'Bad status code from server. Status code: ' + response.status;

        throw new Error(message);
      }

      return response.json();
    })
    .then(function (responseData) {
      return responseData.data && responseData.data.status === 'success';
    })
    .catch(function (error) {
      return true;
    });
};
(function() {
  window.PublicUtility || (window.PublicUtility = {});

  PublicUtility.Widgets = (function() {
    var removeWidget, updateRecommendationsAriaData;

    function Widgets() {}

    Widgets.loadWidgetProducts = function(path, $scope, page, sliderLoaded) {
      var renderData;
      if ($scope == null) {
        $scope = document;
      }
      if (page == null) {
        page = 1;
      }
      if (sliderLoaded == null) {
        sliderLoaded = false;
      }
      renderData = function(data, $elem, sliderLoaded) {
        var $swiperEl, $widgetProductsTarget, $widgetTab, minProductsInWidget, ref, slides, swiper;
        if (sliderLoaded) {
          $swiperEl = $elem.find('.swiper-widget').first();
          $swiperEl.parents('.js-widget-wrapper').data('load-next-page', $(data.products).find('.js-widget-wrapper').data('load-next-page'));
          swiper = (ref = $swiperEl[0]) != null ? ref.swiper : void 0;
          if ($(data.products).find('.product-tile').length) {
            slides = $(data.products).find('.product-tile').get();
            swiper.appendSlide(slides);
            swiper.update();
            $elem.data('loading-in-progress', false);
            $('.swiper-button-next', $elem).removeClass('loading');
          }
        } else {
          $widgetProductsTarget = $elem;
          $widgetProductsTarget.attr('data-scroll-load-loaded', true);
          $widgetTab = $widgetProductsTarget.closest('.widget-tabs').find("[href='#" + data.widget_node_id_hash + "']");
          minProductsInWidget = 5;
          if ($(data.products).find('.product-tile').length >= minProductsInWidget) {
            $widgetProductsTarget.html(data.products);
            $widgetProductsTarget.siblings('.js-widgets-link-more').removeClass('d-none');
            $widgetTab.removeClass('mzkr-d-none');
            PublicUtility.Carousel.initWidgetCarousel($widgetProductsTarget);
          } else {
            if ($widgetTab.hasClass('widget-tab--active')) {
              $widgetTab.removeClass('widget-tab--active');
              $widgetTab.next('.widget-tab').trigger('click');
            }
            $widgetProductsTarget.remove();
          }
        }
        if ($('.js-order-widget-wrapper').length) {
          App.ClientOrders.orderStickySidebar.updateSticky();
        }
        PublicUtility.Layout.initApplyCampaignCouponLink();
        return new PublicUtility.Analytics('[data-target-node-id-hash="' + data.widget_node_id_hash + '"]');
      };
      return $.ajax({
        type: 'GET',
        url: path,
        data: {
          page: page,
          per: $scope.data('per-page')
        },
        dataType: 'json',
        success: function(data) {
          var $elem, i, len, ref, results, subData;
          if (data) {
            PublicUtility.Layout.toolTip();
            if (data.multi_search) {
              if (data.multi_search.length > 0) {
                ref = data.multi_search;
                results = [];
                for (i = 0, len = ref.length; i < len; i++) {
                  subData = ref[i];
                  $elem = $('[data-target-node-id-hash="' + subData.widget_node_id_hash + '"]');
                  results.push(renderData(subData, $elem, sliderLoaded));
                }
                return results;
              } else {
                return removeWidget(path);
              }
            } else {
              return renderData(data, $scope, sliderLoaded);
            }
          } else {
            return removeWidget(path);
          }
        }
      });
    };

    Widgets.loadWidgetRecommendationsProducts = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          var $widgetProductsTarget;
          if (data && data.widget_node_id_hash && data.products.length) {
            $widgetProductsTarget = $('[data-target-node-id-hash="' + data.widget_node_id_hash + '"]').first();
            $widgetProductsTarget.html(data.products);
            PublicUtility.Carousel.initRecomendedCarousel($widgetProductsTarget);
            PublicUtility.Layout.deferLuigisScan('#product_recommended_annotation_' + data.widget_node_id_hash, '#product_recommended_results_' + data.widget_node_id_hash);
            PublicUtility.Layout.toolTip();
            PublicUtility.Layout.initApplyCampaignCouponLink();
            updateRecommendationsAriaData($widgetProductsTarget);
            if ($('.js-order-widget-wrapper').length) {
              return App.ClientOrders.orderStickySidebar.updateSticky();
            }
          } else {
            return removeWidget(path);
          }
        }
      });
    };

    Widgets.loadWidgetRecommendationsSitemapNodes = function(path) {
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'json',
        success: function(data) {
          var $widgetSitemapNodesTarget;
          if (data && data.widget_node_id_hash && data.sitemap_nodes.length) {
            $widgetSitemapNodesTarget = $('[data-target-node-id-hash="' + data.widget_node_id_hash + '"]').first();
            $widgetSitemapNodesTarget.html(data.sitemap_nodes);
            PublicUtility.Layout.deferLuigisScan('#sitemap_nodes_recommended_annotation_' + data.widget_node_id_hash, '#sitemap_nodes_recommended_results_' + data.widget_node_id_hash);
            updateRecommendationsAriaData($widgetSitemapNodesTarget);
            if ($('.js-order-widget-wrapper').length) {
              return App.ClientOrders.orderStickySidebar.updateSticky();
            }
          } else {
            return removeWidget(path);
          }
        }
      });
    };

    Widgets.widgetCarouselEvent = function(swiper, $wrapper, eventType) {
      var $multiSearchWrapper, nextLoadedItems, nextPage, pagesCount, path, slidesPerView, totalCount;
      nextPage = $('.js-widget-wrapper', $wrapper).data('load-next-page');
      pagesCount = $('.js-widget-wrapper', $wrapper).data('total-pages');
      totalCount = $('.js-widget-wrapper', $wrapper).data('total-count');
      path = $wrapper.data('multi-search-load-path') || $wrapper.data('dynamic-load-path') || $wrapper.data('scroll-load-path');
      nextLoadedItems = $wrapper.find('.swiper-slide-visible').last().nextAll().length;
      $multiSearchWrapper = $($wrapper.data('multi-search-selector'));
      slidesPerView = swiper.slidesPerViewDynamic();
      if (eventType === 'init') {
        if ($multiSearchWrapper.length) {
          pagesCount *= 2;
          $('.js-widget-wrapper', $wrapper).data('total-pages', pagesCount);
          nextPage += 1;
          return $('.js-widget-wrapper', $wrapper).data('load-next-page', nextPage);
        } else {
          if (slidesPerView > 3) {
            return PublicUtility.Widgets.loadWidgetProducts(path, $wrapper, nextPage, true);
          }
        }
      } else if (slidesPerView >= (nextLoadedItems - slidesPerView)) {
        if (swiper.slides.length >= totalCount) {
          return $('.swiper-button-next', $wrapper).addClass('all-products-loaded');
        } else if (!$wrapper.data('loading-in-progress')) {
          $('.swiper-button-next', $wrapper).addClass('loading');
          PublicUtility.Widgets.loadWidgetProducts(path, $wrapper, nextPage, true);
          return $wrapper.data('loading-in-progress', true);
        }
      }
    };

    Widgets.initWidgetTabs = function() {
      return $('.widget-tab').on('click', function(e) {
        var target;
        e.preventDefault();
        target = $(this).attr('href');
        $(this).addClass('widget-tab--active').siblings().removeClass('widget-tab--active');
        $(target).addClass('widget-tab__content--active').siblings().removeClass('widget-tab__content--active');
        return $(window).scroll();
      });
    };

    Widgets.initWidgetBrands = function() {
      var loadMoreBtn;
      loadMoreBtn = $('.js-load-brands');
      return loadMoreBtn.on('click', function() {
        $('.widget-brands').addClass('widget-brands--rolled-out');
        return loadMoreBtn.fadeOut(800, function() {
          return $(this).remove();
        });
      });
    };

    updateRecommendationsAriaData = function(elem) {
      var $ariaWrapper, $section;
      $ariaWrapper = elem.find('.aria-wrapper');
      $section = $ariaWrapper.closest('section');
      if ($ariaWrapper.attr('data-aria-label')) {
        $section.attr('aria-label', $ariaWrapper.attr('data-aria-label'));
        $section.removeAttr('aria-labelledby');
      }
      if ($ariaWrapper.attr('data-aria-labelledby')) {
        $section.attr('aria-labelledby', $ariaWrapper.attr('data-aria-labelledby'));
        $section.removeAttr('aria-label');
      }
      return $ariaWrapper.remove();
    };

    removeWidget = function(path) {
      var widgetNavigationItem, widgetParent, widgetParentId, wrapper;
      wrapper = $('[data-scroll-load-path="' + path + '"]');
      if (!wrapper.length) {
        wrapper = $('[data-dynamic-load-path="' + path + '"]');
      }
      widgetParent = wrapper.parents('.widget-main-wrapper');
      widgetParentId = widgetParent.attr('id');
      widgetParent.remove();
      widgetNavigationItem = $('a[href="#' + widgetParentId + '"]').parents('.mzkr-sidebar-menu__item');
      if (widgetNavigationItem.length) {
        widgetNavigationItem.remove();
        return App.ClientOrders.orderStickySidebar.updateSticky();
      }
    };

    return Widgets;

  })();

}).call(this);
(function() {
  var localStorageWishListsKey,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  window.PublicUtility || (window.PublicUtility = {});

  localStorageWishListsKey = 'wish_lists';

  PublicUtility.WishList = (function() {
    var fetchDataToLocalStorage;

    function WishList() {}

    WishList.initInWishList = function(scope) {
      var $dataElement, _, currentWishListsData, initialized, product, productBasketItem, productInWishlist, productList, productsCodes, ref, storage, wishListId, wishListsProducts, wlProductsStorage, wlProductsStorageData;
      if (scope == null) {
        scope = document;
      }
      if (!$('[data-current-wish-lists]').length) {
        return;
      }
      try {
        storage = window.localStorage;
      } catch (error) {
        _ = error;
        storage = false;
      }
      if (!storage) {
        return;
      }
      $dataElement = $('[data-current-wish-lists]');
      initialized = parseInt($dataElement.attr('data-initialized') || 0);
      if (!initialized) {
        fetchDataToLocalStorage(storage);
      }
      $dataElement.attr('data-initialized', 1);
      try {
        wlProductsStorage = JSON.parse(storage.getItem(localStorageWishListsKey)) || {};
      } catch (error) {
        _ = error;
        wlProductsStorage = {};
      }
      wlProductsStorageData = wlProductsStorage['data'];
      product = $(scope).find('.container[data-product-code]');
      productBasketItem = $(scope).find('.shop-product-tile[data-product-code]');
      currentWishListsData = Object.keys(JSON.parse($dataElement.attr('data-current-wish-lists')) || {});
      if (!product.length) {
        product = $(scope).find('[data-wish-list-product]');
      }
      productList = $(scope).find('[data-wish-and-buy] .product-tile');
      if (wlProductsStorageData && (product.length || productList.length || productBasketItem.length)) {
        productInWishlist = [];
        try {
          wishListsProducts = wlProductsStorageData;
        } catch (error) {
          _ = error;
          wishListsProducts = {};
        }
        for (wishListId in wishListsProducts) {
          productsCodes = wishListsProducts[wishListId];
          if (productsCodes.length) {
            if (currentWishListsData) {
              if (currentWishListsData.indexOf(wishListId) >= 0) {
                productInWishlist.push.apply(productInWishlist, productsCodes);
              }
            }
          }
        }
        if (product.length) {
          if (ref = product.data('product-code'), indexOf.call(productInWishlist, ref) >= 0) {
            PublicUtility.WishList.addToWishList(product);
          }
        }
        if (productBasketItem.length) {
          productBasketItem.each(function() {
            var element, productCodes;
            element = $(this);
            productCodes = element.data('product-codes');
            if (productCodes) {
              return productCodes.forEach(function(item) {
                if (indexOf.call(productInWishlist, item) >= 0) {
                  return PublicUtility.WishList.addToWishList(element);
                }
              });
            }
          });
        }
        if (productList.length) {
          productList.each(function() {
            var element, productCodes;
            element = $(this);
            productCodes = element.data('product-codes');
            if (productCodes) {
              return productCodes.forEach(function(item) {
                if (indexOf.call(productInWishlist, item) >= 0) {
                  return PublicUtility.WishList.addToWishList(element);
                }
              });
            }
          });
        }
      }
      return $('.wish-list-in-detail').on('click', function(e) {
        var $elem;
        e.preventDefault();
        e.stopImmediatePropagation();
        $elem = $(this);
        if (!$elem.hasClass('disabled')) {
          $elem.addClass('disabled');
          return $.ajax({
            url: $elem.attr('data-href'),
            type: $elem.attr('data-method'),
            dataType: 'script',
            success: function() {
              return $elem.removeClass('disabled');
            }
          });
        }
      });
    };

    WishList.addToWishList = function(wishElement) {
      var hrefAttr, isBasket, isProductDetail, removeTranslationText, removeTranslationTextBasket, wishListIcon, wishListLink;
      wishListLink = wishElement.find('.wish-list-link');
      wishListIcon = wishElement.find('.wish-list-icon');
      removeTranslationText = I18n.t('js.public.shop.wish_list_items.remove_from_wish_list');
      removeTranslationTextBasket = I18n.t('js.public.shop.baskets.show.remove_from_wish_list');
      isProductDetail = wishListLink.hasClass('wish-list-in-detail');
      isBasket = wishListLink.hasClass('wish-list-in-basket');
      hrefAttr = 'href';
      if (isProductDetail) {
        hrefAttr = 'data-href';
      }
      wishListLink.closest('.wrapper').addClass('product-wish-active');
      wishListIcon.closest('.wrapper').addClass('product-wish-active');
      wishListLink.attr('title', removeTranslationText).attr('data-method', 'delete').attr(hrefAttr, Routes.shop_wish_list_items_destroy_by_code_path({
        product_code: wishElement.data('product-code'),
        destroy_all: true
      }));
      if (wishListLink.hasClass('in-group-selector') || isProductDetail) {
        $('span', wishListLink).html(removeTranslationText);
        wishListLink.attr('data-disable-with', removeTranslationText);
      }
      if (isBasket) {
        $('span', wishListLink).html(removeTranslationTextBasket);
        wishListLink.attr('data-disable-with', removeTranslationTextBasket);
      }
      if (isProductDetail) {
        return wishListLink.removeClass('wishlist-add').addClass('wishlist-remove');
      }
    };

    WishList.removeFromWishList = function(wishElement) {
      var addTranslationText, addTranslationTextBasket, hrefAttr, isBasket, isProductDetail, wishListIcon, wishListLink;
      wishListLink = wishElement.find('.wish-list-link');
      wishListIcon = wishElement.find('.wish-list-icon');
      addTranslationText = I18n.t('js.public.shop.wish_list_items.add_to_wish_list');
      addTranslationTextBasket = I18n.t('js.public.shop.baskets.show.insert_into_wish_list');
      isProductDetail = wishListLink.hasClass('wish-list-in-detail');
      isBasket = wishListLink.hasClass('wish-list-in-basket');
      hrefAttr = 'href';
      if (isProductDetail) {
        hrefAttr = 'data-href';
      }
      wishListLink.closest('.wrapper').removeClass('product-wish-active');
      wishListIcon.closest('.wrapper').removeClass('product-wish-active');
      wishListLink.attr('title', addTranslationText).attr('data-method', 'post').attr(hrefAttr, Routes.shop_wish_list_items_path({
        product_code: wishElement.data('product-code')
      }));
      if (wishListLink.hasClass('in-group-selector') || isProductDetail) {
        $('span', wishListLink).html(addTranslationText);
        wishListLink.attr('data-disable-with', addTranslationText);
      }
      if (isBasket) {
        $('span', wishListLink).html(addTranslationTextBasket);
        wishListLink.attr('data-disable-with', addTranslationTextBasket);
      }
      if (isProductDetail) {
        return wishListLink.removeClass('wishlist-remove').addClass('wishlist-add');
      }
    };

    WishList.manageLocalStorage = function(action, productCode, wishListId, identifier) {
      var $dataElement, _, productIndexInWishList, storage, wlCurrentProductsStorageData, wlProductsStorage, wlProductsStorageData;
      try {
        storage = window.localStorage;
      } catch (error) {
        _ = error;
        storage = false;
      }
      if (!storage) {
        return;
      }
      fetchDataToLocalStorage(storage);
      wlProductsStorage = JSON.parse(storage.getItem(localStorageWishListsKey)) || {};
      wlProductsStorageData = wlProductsStorage['data'] || {};
      wlCurrentProductsStorageData = wlProductsStorageData[wishListId] || [];
      productIndexInWishList = wlCurrentProductsStorageData.indexOf(productCode);
      $dataElement = $('[data-current-wish-lists]');
      if (action === 'create') {
        wlCurrentProductsStorageData.push(productCode);
      } else {
        wlCurrentProductsStorageData.splice(productIndexInWishList, 1);
      }
      if (wlCurrentProductsStorageData.length) {
        wlProductsStorageData[wishListId] = wlCurrentProductsStorageData;
        storage.setItem(localStorageWishListsKey, JSON.stringify({
          data: wlProductsStorageData,
          identifier: identifier
        }));
        return $dataElement.attr('data-identifier', identifier);
      } else {
        delete wlProductsStorageData[wishListId];
        if (Object.keys(wlProductsStorageData).length) {
          storage.setItem(localStorageWishListsKey, JSON.stringify({
            data: wlProductsStorageData,
            identifier: identifier
          }));
          return $dataElement.attr('data-identifier', identifier);
        } else {
          return storage.removeItem(localStorageWishListsKey);
        }
      }
    };

    fetchDataToLocalStorage = function(storage, initial) {
      return setTimeout((function() {
        var $dataElement, content, count, currentIdentifier, e, storageIdentifier;
        try {
          content = JSON.parse(storage.getItem(localStorageWishListsKey)) || {};
          $dataElement = $('[data-current-wish-lists]');
          count = parseInt($dataElement.attr('data-count') || 0);
          currentIdentifier = $dataElement.attr('data-identifier');
          storageIdentifier = (content || {})['identifier'];
          if ((!content || (content && currentIdentifier !== storageIdentifier)) && count > 0) {
            return $.ajax({
              url: Routes.fetch_storage_data_shop_wish_lists_path(),
              type: 'get',
              success: function(data) {
                return storage.setItem(localStorageWishListsKey, JSON.stringify(data));
              }
            });
          } else if (content && count === 0) {
            return storage.removeItem(localStorageWishListsKey);
          }
        } catch (error) {
          e = error;
          return console.error('Failed to parse JSON: ', storage.getItem(localStorageWishListsKey));
        }
      }), 100);
    };

    return WishList;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientShipAddresses = (function(superClass) {
    extend(ClientShipAddresses, superClass);

    function ClientShipAddresses() {
      this.index = bind(this.index, this);
      return ClientShipAddresses.__super__.constructor.apply(this, arguments);
    }

    ClientShipAddresses.prototype.index = function() {
      new PublicUtility.CustomerNavigation();
      return this.initAddressRadioInput();
    };

    ClientShipAddresses.prototype.initAddressRadioInput = function() {
      return $('[data-input-type="radio_ship_is_default"]').on('click', function() {
        return $(this).find('[data-input-type="input_ship_is_default"]').prop('checked', true);
      });
    };

    return ClientShipAddresses;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientCoupons = (function(superClass) {
    extend(ClientCoupons, superClass);

    function ClientCoupons() {
      this.index = bind(this.index, this);
      return ClientCoupons.__super__.constructor.apply(this, arguments);
    }

    ClientCoupons.prototype.index = function() {
      new PublicUtility.CustomerNavigation();
      return PublicUtility.Layout.setCouponsPageCookies();
    };

    return ClientCoupons;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientCustomersChangeEmailRequests = (function(superClass) {
    extend(ClientCustomersChangeEmailRequests, superClass);

    function ClientCustomersChangeEmailRequests() {
      this.create = bind(this.create, this);
      return ClientCustomersChangeEmailRequests.__super__.constructor.apply(this, arguments);
    }

    ClientCustomersChangeEmailRequests.prototype.create = function() {
      var element;
      Utility.Profile.checkProfile();
      element = $('#new_client_customer_change_email_form').find('.verification-method');
      if (element.length) {
        return element.removeClass('d-none');
      }
    };

    return ClientCustomersChangeEmailRequests;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientCustomersChangeMobileRequests = (function(superClass) {
    extend(ClientCustomersChangeMobileRequests, superClass);

    function ClientCustomersChangeMobileRequests() {
      this.create = bind(this.create, this);
      return ClientCustomersChangeMobileRequests.__super__.constructor.apply(this, arguments);
    }

    ClientCustomersChangeMobileRequests.prototype.create = function() {
      var element;
      Utility.Profile.checkProfile();
      element = $('#new_client_customer_change_mobile_form').find('.verification-method');
      if (element.length) {
        return element.removeClass('d-none');
      }
    };

    return ClientCustomersChangeMobileRequests;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesClaimDamages = (function(superClass) {
    extend(ClientDisputesClaimDamages, superClass);

    function ClientDisputesClaimDamages() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.update = bind(this.update, this);
      this.edit = bind(this.edit, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return ClientDisputesClaimDamages.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesClaimDamages.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.checkSelectedOrderItem();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimDamages.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimDamages.prototype.edit = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initWrappingDamageFields();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimDamages.prototype.update = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initWrappingDamageFields();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimDamages.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimDamages.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesClaimDamages;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesClaimFunctionalities = (function(superClass) {
    extend(ClientDisputesClaimFunctionalities, superClass);

    function ClientDisputesClaimFunctionalities() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.update = bind(this.update, this);
      this.edit = bind(this.edit, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return ClientDisputesClaimFunctionalities.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesClaimFunctionalities.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.checkboxAsRadio();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.checkSelectedOrderItem();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimFunctionalities.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.checkboxAsRadio();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disableCollapsedInputs();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimFunctionalities.prototype.edit = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimFunctionalities.prototype.update = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimFunctionalities.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimFunctionalities.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesClaimFunctionalities;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesClaimMissingProducts = (function(superClass) {
    extend(ClientDisputesClaimMissingProducts, superClass);

    function ClientDisputesClaimMissingProducts() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.update = bind(this.update, this);
      this.edit = bind(this.edit, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return ClientDisputesClaimMissingProducts.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesClaimMissingProducts.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.checkSelectedOrderItem();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimMissingProducts.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimMissingProducts.prototype.edit = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimMissingProducts.prototype.update = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimMissingProducts.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimMissingProducts.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesClaimMissingProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesClaimUndeliveredOrders = (function(superClass) {
    extend(ClientDisputesClaimUndeliveredOrders, superClass);

    function ClientDisputesClaimUndeliveredOrders() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this["new"] = bind(this["new"], this);
      return ClientDisputesClaimUndeliveredOrders.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesClaimUndeliveredOrders.prototype["new"] = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimUndeliveredOrders.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimUndeliveredOrders.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesClaimUndeliveredOrders;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesClaimWrongProducts = (function(superClass) {
    extend(ClientDisputesClaimWrongProducts, superClass);

    function ClientDisputesClaimWrongProducts() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.update = bind(this.update, this);
      this.edit = bind(this.edit, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return ClientDisputesClaimWrongProducts.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesClaimWrongProducts.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.checkSelectedOrderItem();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimWrongProducts.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimWrongProducts.prototype.edit = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimWrongProducts.prototype.update = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimWrongProducts.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesClaimWrongProducts.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesClaimWrongProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputes = (function(superClass) {
    extend(ClientDisputes, superClass);

    function ClientDisputes() {
      this.disputes_crossroad = bind(this.disputes_crossroad, this);
      this.crossroad = bind(this.crossroad, this);
      this.index = bind(this.index, this);
      return ClientDisputes.__super__.constructor.apply(this, arguments);
    }

    ClientDisputes.prototype.index = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputes.prototype.crossroad = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputes.prototype.disputes_crossroad = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputes;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientDisputesReturns = (function(superClass) {
    extend(ClientDisputesReturns, superClass);

    function ClientDisputesReturns() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.update = bind(this.update, this);
      this.edit = bind(this.edit, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      this.index = bind(this.index, this);
      return ClientDisputesReturns.__super__.constructor.apply(this, arguments);
    }

    ClientDisputesReturns.prototype.index = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.checkSelectedOrderItem();
      Utility.Disputes.checkboxSelected();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.checkboxSelected();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype.edit = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.pickupAddress();
      Utility.Disputes.copyAddressFields();
      Utility.Disputes.customerTypeOptions();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype.update = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.pickupAddress();
      Utility.Disputes.copyAddressFields();
      Utility.Disputes.customerTypeOptions();
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientDisputesReturns.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientDisputesReturns;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientOrdersItems = (function(superClass) {
    extend(ClientOrdersItems, superClass);

    function ClientOrdersItems() {
      this.index = bind(this.index, this);
      return ClientOrdersItems.__super__.constructor.apply(this, arguments);
    }

    ClientOrdersItems.prototype.index = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientOrdersItems;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientOrders = (function(superClass) {
    extend(ClientOrders, superClass);

    function ClientOrders() {
      this.index = bind(this.index, this);
      this.show = bind(this.show, this);
      return ClientOrders.__super__.constructor.apply(this, arguments);
    }

    ClientOrders.prototype.show = function() {
      new PublicUtility.CustomerNavigation();
      this.initDisputesButtons();
      this.initDisputesForm();
      this.initStickyDisputes();
      this.initOrderPaymenCountdown();
      this.initOrderPaymenCancelCountdown();
      this.initPaymentQrCode();
      this.initScrollToDigitalLicenses();
      this.initOpenProductService();
      App.PublicProducts.initProductDocumentsToggle();
      App.PublicOrderProductReviews.initOrderProductReviewsModal();
      App.ClientOrders.initOrderTopLinks();
      App.ClientOrders.initStickySidebar();
      Mzkr.HorizontalScroll.init('.status-process', true);
      return PublicUtility.DynamicContentLoader.loadContentInScope();
    };

    ClientOrders.prototype.index = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientOrders.prototype.initDisputesButtons = function() {
      return $("#dispute_form input[type='checkbox'][name='order_item_id']").on('change', function() {
        var countChecked;
        countChecked = $("#dispute_form input[type='checkbox'][name='order_item_id']:checked").length;
        return $('[data-dispute-form-button]').each(function() {
          var button, disabled, ref;
          button = $(this);
          disabled = (ref = button.data('default-disabled')) != null ? ref : {
            "true": false
          };
          if (button.data('min-order-items')) {
            if (countChecked < button.data('min-order-items')) {
              disabled || (disabled = true);
            }
          }
          if (button.data('max-order-items')) {
            if (countChecked > button.data('max-order-items')) {
              disabled || (disabled = true);
            }
          }
          if (disabled) {
            return $(this).addClass('disabled');
          } else {
            return $(this).removeClass('disabled');
          }
        });
      });
    };

    ClientOrders.prototype.initDisputesForm = function() {
      return $('[data-dispute-form-button]').on('click', function(e) {
        var orderItemIds;
        e.preventDefault();
        if (!$(this).hasClass('disabled')) {
          orderItemIds = $.map($("#dispute_form input[type='checkbox'][name='order_item_id']:checked"), function(element) {
            return $(element).val();
          });
          return $.ajax({
            type: "GET",
            url: $(this).data('path'),
            dataType: "script",
            data: {
              order_item_ids: orderItemIds
            }
          });
        }
      });
    };

    ClientOrders.prototype.initStickyDisputes = function() {
      var stickDisputes;
      stickDisputes = function() {
        var $disputeAnchor, $disputeBar, disputeBarHeight, disputesPosition;
        $disputeAnchor = $('.js-dispute-anchor');
        if ($disputeAnchor.length) {
          disputesPosition = $disputeAnchor.offset().top;
          $disputeBar = $('.disputes-bar');
          disputeBarHeight = $disputeBar.outerHeight();
          if (($(window).scrollTop() - disputeBarHeight - 18) > (disputesPosition - $(window).height())) {
            return $disputeBar.removeClass('fixed').removeClass('d-none').css('top', disputesPosition);
          } else if (($(window).scrollTop() + $(window).outerHeight() - 200) > $('.order-items').offset().top) {
            return $disputeBar.addClass('fixed').removeClass('d-none').removeAttr('style');
          } else {
            return $disputeBar.removeClass('fixed').css('top', disputesPosition);
          }
        } else {
          return $(window).off('scroll.stickDisputes');
        }
      };
      stickDisputes();
      return $(window).on('scroll.stickDisputes', function() {
        return stickDisputes();
      });
    };

    ClientOrders.prototype.initOrderPaymenCountdown = function() {
      var $btnPayOrder, $changePaymentBtn, $paymentCountDown, counter, that;
      that = this;
      if ($('.pay_button_info_message').length && $('#btn-pay').length) {
        $paymentCountDown = $('.js-payment-countdown');
        $changePaymentBtn = $('.js-change-payment');
        counter = 6;
        $btnPayOrder = $('#btn-pay');
        if ($(".pay_button_info_message[data-show-pay-countdown='true']").length) {
          window.countDownInterval = setInterval((function() {
            counter--;
            $paymentCountDown.text(I18n.t('js.client.orders.redirected_to_payment', {
              counter: counter
            }));
            if (counter === 0) {
              $paymentCountDown.html('');
              $('.js-payment-cancel-countdown').removeClass('d-none');
              that.initOrderPaymenCancelCountdown();
              if ($btnPayOrder.attr('type') === "submit" || $btnPayOrder.attr('href') === '#') {
                $btnPayOrder.click();
              } else if ($btnPayOrder.data('remote')) {
                $.ajax({
                  type: 'GET',
                  url: $btnPayOrder.attr('href'),
                  dataType: 'script',
                  xhrFields: {
                    withCredentials: true
                  },
                  success: function(data) {
                    return data;
                  }
                });
              } else if ($btnPayOrder.attr('href').length > 0) {
                window.location.href = $btnPayOrder.attr('href');
              }
              return clearInterval(window.countDownInterval);
            }
          }), 1000);
          $btnPayOrder.click(function() {
            clearInterval(window.countDownInterval);
            $paymentCountDown.html('');
            $('.js-payment-cancel-countdown').removeClass('d-none');
            return that.initOrderPaymenCancelCountdown();
          });
          if ($changePaymentBtn.length) {
            return $changePaymentBtn.click(function() {
              clearInterval(window.countDownInterval);
              $paymentCountDown.html('');
              $('.js-payment-cancel-countdown').removeClass('d-none');
              return that.initOrderPaymenCancelCountdown();
            });
          }
        }
      }
    };

    ClientOrders.prototype.initPaymentQrCode = function() {
      return new Utility.Payments.PublicShopPaymentQrCodes().extractPaymentQrCode();
    };

    ClientOrders.prototype.initScrollToDigitalLicenses = function() {
      var hash, heightOfHead;
      hash = window.location.hash;
      if (hash.length === 0) {
        return;
      }
      if (hash !== '#order-items') {
        return;
      }
      heightOfHead = $('.mzkr-nav-wrap').height();
      return $("html, body").animate({
        scrollTop: $(hash).offset().top - heightOfHead
      });
    };

    ClientOrders.prototype.initOpenProductService = function() {
      var orderIdHash, orderItemId, price, serviceButton, serviceIdHash, servicePath, urlParams;
      urlParams = new URLSearchParams(window.location.search);
      orderIdHash = urlParams.get('order_id_hash');
      orderItemId = urlParams.get('order_item_id');
      price = urlParams.get('price');
      serviceIdHash = urlParams.get('service_id_hash');
      if (!(orderIdHash && orderItemId && serviceIdHash && price)) {
        return;
      }
      servicePath = Routes.new_service_request_path({
        'params': {
          order_id_hash: orderIdHash,
          order_item_id: orderItemId,
          price: price,
          service_id_hash: serviceIdHash
        }
      });
      serviceButton = document.querySelector("[href='" + servicePath + "']");
      if (!serviceButton) {
        return;
      }
      setTimeout(function() {
        return serviceButton.scrollIntoView(false);
      }, 100);
      return serviceButton.click();
    };

    ClientOrders.prototype.initOrderPaymenCancelCountdown = function() {
      var $cancelOrderBtn, $changePaymentBtn, $paymentCancelCountDown, cancelPaymentCountdown, countDown, date, dateCompatible, end_time, minute, second, t;
      if ($('.pay_button_info_message').length && $('#btn-pay').length) {
        $paymentCancelCountDown = $('.js-payment-cancel-countdown:not(.d-none)');
        $changePaymentBtn = $('.js-change-payment');
        $cancelOrderBtn = $('.js-cancel-order');
        if ($paymentCancelCountDown.length) {
          second = 1000;
          minute = second * 60;
          end_time = $paymentCancelCountDown.data('cancel-countdown');
          t = end_time.split(/[- :]/);
          date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
          dateCompatible = new Date(date);
          countDown = new Date(dateCompatible);
          return cancelPaymentCountdown = setInterval((function() {
            var distance, minutes, now, seconds;
            now = (new Date).getTime();
            distance = countDown - now;
            minutes = Math.floor(distance / minute);
            seconds = Math.floor(distance / second);
            $paymentCancelCountDown.find('.minutes').text(minutes + 1);
            if (seconds === 0) {
              $paymentCancelCountDown.find('.minutes-desc, .minutes').hide();
            }
            if (seconds <= 0) {
              $changePaymentBtn.remove();
              $cancelOrderBtn.remove();
              $('.js-payment-info').remove();
              $('.js-canceled-payment-info').removeClass('d-none');
              clearInterval(cancelPaymentCountdown);
              return clearInterval(window.countDownInterval);
            } else {
              return $paymentCancelCountDown.removeClass('invisible');
            }
          }), second);
        }
      }
    };

    ClientOrders.initOrderTopLinks = function() {
      return $('.top-order-link').on('click', function(e) {
        var navOffset, stickySidebarHeight, stickySidebarOffset, target;
        e.preventDefault();
        target = $(this).attr('href');
        navOffset = $('.mzkr-nav').outerHeight();
        stickySidebarHeight = 56;
        stickySidebarOffset = $(window).width() < 1400 ? stickySidebarHeight : 0;
        return $('html, body').animate({
          scrollTop: $(target).offset().top - (navOffset + stickySidebarOffset + 25)
        });
      });
    };

    ClientOrders.initStickySidebar = function() {
      var menuItems, menuTrigger, scrollspyOffset, setActiveItem, sidebarOffset, that, topSpacing, windowWidth;
      that = ClientOrders;
      if (!document.body.contains(document.querySelector('.mzkr-sidebar-menu'))) {
        return;
      }
      windowWidth = window.innerWidth;
      topSpacing = windowWidth < 768 ? 48 : windowWidth < 992 ? 68 : 76;
      sidebarOffset = windowWidth < 1400 ? 156 : 0;
      scrollspyOffset = 200;
      ClientOrders.orderStickySidebar = new StickySidebar('.mzkr-sticky-sidebar', {
        topSpacing: topSpacing,
        containerSelector: '.mzkr-sidebar-container',
        innerWrapperSelector: '.mzkr-sidebar__inner',
        resizeSensor: false
      });
      menuTrigger = document.querySelectorAll('.mzkr-sidebar-menu__trigger');
      menuItems = document.querySelectorAll('.mzkr-sidebar-menu__item a');
      menuTrigger.forEach(function(trigger) {
        return trigger.addEventListener('click', function(e) {
          e.preventDefault();
          return trigger.parentElement.classList.toggle('mzkr-sidebar-menu--open');
        });
      });
      setActiveItem = function() {
        if (document.querySelectorAll('.mzkr-sidebar-menu__item--active').length === 0 && window.innerWidth < 1400) {
          return document.getElementsByClassName('mzkr-sidebar-menu__item')[0].classList.add('mzkr-sidebar-menu__item--active');
        }
      };
      menuItems.forEach(function(item) {
        return item.addEventListener('click', function(e) {
          var itemTarget, itemTargetId;
          e.preventDefault();
          item.closest('.mzkr-sidebar-menu').classList.remove('mzkr-sidebar-menu--open');
          itemTargetId = item.getAttribute('href');
          itemTarget = document.querySelector(itemTargetId);
          return window.scroll(0, (itemTarget.offsetTop - topSpacing) - (sidebarOffset / 2));
        });
      });
      window.addEventListener('load', function() {
        var onLoadTarget, onLoadTargetId;
        setActiveItem();
        if (window.location.hash) {
          onLoadTargetId = window.location.hash;
          onLoadTarget = document.querySelector(onLoadTargetId);
          return window.scroll(0, (onLoadTarget.offsetTop - topSpacing) - (sidebarOffset / 2));
        }
      });
      window.addEventListener('resize', function() {
        App.ClientOrders.orderStickySidebar.updateSticky();
        return setActiveItem();
      });
      return Mzkr.ScrollSpy.init('[id^="order-detail"], [id^="widget-"]', '.mzkr-sidebar-menu__item', 'mzkr-sidebar-menu__item--active', scrollspyOffset);
    };

    return ClientOrders;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientProfiles = (function(superClass) {
    extend(ClientProfiles, superClass);

    function ClientProfiles() {
      this.update_password = bind(this.update_password, this);
      this.update = bind(this.update, this);
      this.show = bind(this.show, this);
      return ClientProfiles.__super__.constructor.apply(this, arguments);
    }

    ClientProfiles.prototype.show = function() {
      this.changeCustomerChangeRequest();
      return new PublicUtility.CustomerNavigation();
    };

    ClientProfiles.prototype.update = function() {
      Utility.Profile.checkProfile();
      return new PublicUtility.CustomerNavigation();
    };

    ClientProfiles.prototype.update_password = function() {
      Utility.Profile.checkProfile();
      return new PublicUtility.CustomerNavigation();
    };

    ClientProfiles.prototype.changeCustomerChangeRequest = function() {
      new PublicUtility.CustomerNavigation();
      return $('#client_customer_change_mobile_form_mobile, #client_customer_change_email_form_email').keyup(function() {
        var element;
        element = $(this).closest('form').find('.verification-method');
        if (element.length) {
          return element.removeClass('d-none');
        }
      });
    };

    return ClientProfiles;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientProfileDetails = (function(superClass) {
    extend(ClientProfileDetails, superClass);

    function ClientProfileDetails() {
      this.update = bind(this.update, this);
      this.show = bind(this.show, this);
      return ClientProfileDetails.__super__.constructor.apply(this, arguments);
    }

    ClientProfileDetails.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientProfileDetails.prototype.update = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientProfileDetails;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientReceipts = (function(superClass) {
    extend(ClientReceipts, superClass);

    function ClientReceipts() {
      this.show = bind(this.show, this);
      return ClientReceipts.__super__.constructor.apply(this, arguments);
    }

    ClientReceipts.prototype.show = function() {
      return App.ClientOrders.initStickySidebar();
    };

    return ClientReceipts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.ClientWatchDogs = (function(superClass) {
    extend(ClientWatchDogs, superClass);

    function ClientWatchDogs() {
      this.archived = bind(this.archived, this);
      this.index = bind(this.index, this);
      return ClientWatchDogs.__super__.constructor.apply(this, arguments);
    }

    ClientWatchDogs.prototype.index = function() {
      return new PublicUtility.CustomerNavigation();
    };

    ClientWatchDogs.prototype.archived = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return ClientWatchDogs;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsPages = (function(superClass) {
    extend(PublicCmsPages, superClass);

    function PublicCmsPages() {
      this.show = bind(this.show, this);
      return PublicCmsPages.__super__.constructor.apply(this, arguments);
    }

    PublicCmsPages.prototype.show = function() {
      return PublicUtility.Layout.initGallerySlider();
    };

    return PublicCmsPages;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesBlogFolderSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesBlogFolderSitemapNode, superClass);

    function PublicCmsSitemapNodesBlogFolderSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesBlogFolderSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesBlogFolderSitemapNode.prototype.show = function() {
      PublicUtility.FilterPagination.handlePaginate();
      return PublicUtility.FilterPagination.handleCategories();
    };

    return PublicCmsSitemapNodesBlogFolderSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesBlogPageSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesBlogPageSitemapNode, superClass);

    function PublicCmsSitemapNodesBlogPageSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesBlogPageSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesBlogPageSitemapNode.prototype.show = function() {
      return PublicUtility.DynamicContentLoader.loadContentInScope();
    };

    return PublicCmsSitemapNodesBlogPageSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesConcertFolderSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesConcertFolderSitemapNode, superClass);

    function PublicCmsSitemapNodesConcertFolderSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesConcertFolderSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesConcertFolderSitemapNode.prototype.show = function() {
      PublicUtility.FilterPagination.handlePaginate();
      PublicUtility.FilterPagination.handleCategories();
      return PublicUtility.FilterPagination.handleFilters();
    };

    return PublicCmsSitemapNodesConcertFolderSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesConcertPageSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesConcertPageSitemapNode, superClass);

    function PublicCmsSitemapNodesConcertPageSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesConcertPageSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesConcertPageSitemapNode.prototype.show = function() {
      PublicUtility.DynamicContentLoader.loadContentInScope();
      return this.readMoreShortDesc();
    };

    PublicCmsSitemapNodesConcertPageSitemapNode.prototype.readMoreShortDesc = function() {
      return $('.js-desc-read-more').on('click', function(e) {
        var $content;
        $content = $('.content');
        if ($content.data('has-short-desc')) {
          $content.addClass('show').animate({
            maxHeight: $content.prop('scrollHeight')
          }, 100, function() {
            return $content.css('max-height', 'none');
          });
          return $(this).addClass('hide');
        } else {
          return $('html, body').animate({
            scrollTop: $('#description').offset().top - 100
          }, 200, 'linear');
        }
      });
    };

    return PublicCmsSitemapNodesConcertPageSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesCouponSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesCouponSitemapNode, superClass);

    function PublicCmsSitemapNodesCouponSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesCouponSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesCouponSitemapNode.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicCmsSitemapNodesCouponSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesDynamicNodesAndProducts = (function(superClass) {
    extend(PublicCmsSitemapNodesDynamicNodesAndProducts, superClass);

    function PublicCmsSitemapNodesDynamicNodesAndProducts() {
      return PublicCmsSitemapNodesDynamicNodesAndProducts.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesDynamicNodesAndProducts.init = function(data, wrapper) {
      var $filterWrapper, $nodesProductsWrapper, $wrapper, widnowWidth;
      if (data == null) {
        data = {};
      }
      $wrapper = wrapper;
      $wrapper.find('.spinner-wrapper').addClass('d-none');
      $nodesProductsWrapper = $wrapper.find('.nodes-and-products-wrapper');
      $nodesProductsWrapper.on('click', '.node-tile', function() {
        var $thisParent, activeSiblings, activeTopPosition, productsWrapperHeight;
        $thisParent = $(this).parent($nodesProductsWrapper);
        if ($thisParent.hasClass('active')) {
          $thisParent.removeClass('active');
          return $nodesProductsWrapper.css('margin-bottom', 0);
        } else {
          $thisParent.addClass('active').siblings($nodesProductsWrapper).removeClass('active');
          productsWrapperHeight = $thisParent.find('.products-wrapper').outerHeight(true);
          $nodesProductsWrapper.css('margin-bottom', 0);
          $thisParent.css('margin-bottom', productsWrapperHeight + 24);
          activeTopPosition = $thisParent.position().top;
          activeSiblings = $nodesProductsWrapper.filter(function() {
            return $(this).position().top === activeTopPosition;
          });
          return activeSiblings.css('margin-bottom', productsWrapperHeight + 24);
        }
      });
      widnowWidth = $(window).width();
      $(window).resize(function() {
        if (widnowWidth !== $(window).width()) {
          $nodesProductsWrapper.removeClass('active').css('margin-bottom', 0);
          return widnowWidth = $(window).width();
        }
      });
      $filterWrapper = $wrapper.find('.filter-wrapper');
      if ($filterWrapper.length) {
        $filterWrapper.find('input.input-price-from').val(data.minPrice);
        $filterWrapper.find('input.input-price-to').val(data.maxPrice);
        if (!$filterWrapper.data('initFilterCalled')) {
          this.initFilter($wrapper);
          return $filterWrapper.data('initFilterCalled', true);
        }
      }
    };

    PublicCmsSitemapNodesDynamicNodesAndProducts.initFilter = function(wrapper) {
      var $filterFields, $filterWrapper, $priceFrom, $priceSlider, $priceTo, $wrapper, maxPrice, minPrice, path, previousPriceFrom, previousPriceTo, priceRange, priceSlider, showSpinner, that, upadteData;
      that = PublicCmsSitemapNodesDynamicNodesAndProducts;
      $wrapper = wrapper;
      $priceFrom = $wrapper.find('.input-price-from');
      $priceTo = $wrapper.find('.input-price-to');
      $priceSlider = $wrapper.find('.price-slider');
      minPrice = $priceFrom.val();
      maxPrice = $priceTo.val();
      $priceSlider.attr('data-slider-min', minPrice);
      $priceSlider.attr('data-slider-max', maxPrice);
      priceSlider = $priceSlider[0];
      path = $wrapper.attr('data-dynamic-load-path') || $wrapper.attr('data-scroll-load-path');
      $filterWrapper = $wrapper.find('.filter-wrapper');
      $filterFields = $filterWrapper.find('input.input-price-from, input.input-price-to');
      $filterWrapper.removeClass('d-none');
      showSpinner = function() {
        $wrapper.find('.content-wrapper').html('');
        return $wrapper.find('.spinner-wrapper').removeClass('d-none');
      };
      upadteData = function() {
        var params;
        params = {};
        $filterFields.each(function() {
          return params[$(this).attr('id')] = $(this).val();
        });
        return that.loadData(path, {
          filter: params
        });
      };
      $filterFields.on('change', function() {
        showSpinner();
        return upadteData();
      });
      previousPriceFrom = parseInt($priceFrom.val());
      previousPriceTo = parseInt($priceTo.val());
      if (minPrice === maxPrice) {
        minPrice -= maxPrice;
      }
      priceRange = {
        'min': parseFloat(minPrice),
        'max': parseFloat(maxPrice)
      };
      noUiSlider.create(priceSlider, {
        start: [parseFloat($priceFrom.val()), parseFloat($priceTo.val())],
        connect: true,
        range: priceRange,
        step: 1,
        format: {
          to: function(value) {
            return Math.round(value);
          },
          from: function(value) {
            return Math.round(value);
          }
        }
      });
      priceSlider.noUiSlider.on('update', function(values, handle) {
        $priceFrom.val(values[0]);
        return $priceTo.val(values[1]);
      });
      $priceFrom.on('change', function(e) {
        var value;
        e.stopPropagation();
        clearTimeout(window.priceSliderTimeout);
        value = this.value;
        return window.priceSliderTimeout = setTimeout((function() {
          return priceSlider.noUiSlider.set([value, null]);
        }), 300);
      });
      $priceTo.on('change', function(e) {
        var value;
        e.stopPropagation();
        clearTimeout(window.priceSliderTimeout);
        value = this.value;
        return window.priceSliderTimeout = setTimeout((function() {
          return priceSlider.noUiSlider.set([null, value]);
        }), 300);
      });
      return priceSlider.noUiSlider.on('set', function(values, handle) {
        var actualFromPrice, actualToPrice;
        actualFromPrice = parseFloat(values[0]);
        actualToPrice = parseFloat(values[1]);
        showSpinner();
        return upadteData();
      });
    };

    PublicCmsSitemapNodesDynamicNodesAndProducts.loadData = function(path, params) {
      if (params == null) {
        params = {};
      }
      return $.ajax({
        type: 'GET',
        url: path,
        dataType: 'script',
        data: params
      });
    };

    return PublicCmsSitemapNodesDynamicNodesAndProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesFilterSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesFilterSitemapNode, superClass);

    function PublicCmsSitemapNodesFilterSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesFilterSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesFilterSitemapNode.prototype.show = function() {
      var search_url;
      search_url = Routes.search_cms_filter_sitemap_node_path($('#main-filter-container').data('sitemap-node-id-hash'));
      PublicUtility.DynamicContentLoader.loadContentInScope();
      PublicUtility.FilterBanner.initFilterBanner();
      new PublicUtility.ProductList(search_url);
      PublicUtility.WishList.initInWishList();
      PublicUtility.ProductComparison.initInProductComparison();
      return PublicUtility.Widgets.initWidgetBrands();
    };

    return PublicCmsSitemapNodesFilterSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesFolderSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesFolderSitemapNode, superClass);

    function PublicCmsSitemapNodesFolderSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesFolderSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesFolderSitemapNode.prototype.show = function() {
      var faqAccordionToggle, menuItems, menuTrigger, mzkrStickySidebar, navTopBanner, navTopBannerHeight, navWrap, scrollspyOffset, sidebarOffset, topSpacing;
      PublicUtility.DynamicContentLoader.loadContentInScope();
      new PublicUtility.CustomerNavigation();
      if (!document.body.contains(document.querySelector('.mzkr-sidebar-menu'))) {
        return;
      }
      navWrap = document.querySelectorAll('.mzkr-nav-wrap')[0];
      navTopBanner = navWrap.querySelector('.nav-top-banner');
      navTopBannerHeight = navTopBanner ? navTopBanner.offsetHeight : 0;
      topSpacing = navWrap.offsetHeight - navTopBannerHeight;
      sidebarOffset = window.innerWidth < 1400 ? 56 : 0;
      scrollspyOffset = window.innerWidth < 1400 ? 156 : 100;
      mzkrStickySidebar = new StickySidebar('.mzkr-sticky-sidebar', {
        topSpacing: topSpacing,
        containerSelector: '.mzkr-sidebar-container',
        innerWrapperSelector: '.mzkr-sidebar__inner',
        resizeSensor: false
      });
      faqAccordionToggle = document.querySelectorAll('.js-mzkr-accordion-toggle');
      faqAccordionToggle.forEach(function(accordion) {
        return accordion.addEventListener('click', function() {
          return setTimeout((function() {
            mzkrStickySidebar.updateSticky();
          }), 300);
        });
      });
      menuTrigger = document.querySelectorAll('.mzkr-sidebar-menu__trigger');
      menuItems = document.querySelectorAll('.mzkr-sidebar-menu__item a');
      menuTrigger.forEach(function(trigger) {
        return trigger.addEventListener('click', function(e) {
          e.preventDefault();
          return trigger.parentElement.classList.toggle('mzkr-sidebar-menu--open');
        });
      });
      menuItems.forEach(function(item) {
        return item.addEventListener('click', function(e) {
          var itemTarget, itemTargetId;
          e.preventDefault();
          item.closest('.mzkr-sidebar-menu').classList.remove('mzkr-sidebar-menu--open');
          itemTargetId = item.getAttribute('href');
          itemTarget = document.querySelector(itemTargetId);
          return window.scroll(0, (itemTarget.offsetTop - topSpacing) - sidebarOffset);
        });
      });
      window.addEventListener('load', function() {
        var onLoadTarget, onLoadTargetId;
        if (window.location.hash) {
          onLoadTargetId = window.location.hash;
          onLoadTarget = document.querySelector(onLoadTargetId);
          return window.scroll(0, (onLoadTarget.offsetTop - topSpacing) - sidebarOffset);
        }
      });
      return Mzkr.ScrollSpy.init('.scrollspy-section', '.mzkr-sidebar-menu__item', 'mzkr-sidebar-menu__item--active', scrollspyOffset);
    };

    return PublicCmsSitemapNodesFolderSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesHomeSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesHomeSitemapNode, superClass);

    function PublicCmsSitemapNodesHomeSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesHomeSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesHomeSitemapNode.prototype.show = function() {
      PublicUtility.DynamicContentLoader.loadContentInScope();
      return PublicUtility.Widgets.initWidgetBrands();
    };

    return PublicCmsSitemapNodesHomeSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesPageSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesPageSitemapNode, superClass);

    function PublicCmsSitemapNodesPageSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesPageSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesPageSitemapNode.prototype.show = function() {
      PublicUtility.Layout.initGallerySlider();
      return new PublicUtility.CustomerNavigation();
    };

    return PublicCmsSitemapNodesPageSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesProductQuestions = (function(superClass) {
    extend(PublicCmsSitemapNodesProductQuestions, superClass);

    function PublicCmsSitemapNodesProductQuestions() {
      this.index = bind(this.index, this);
      return PublicCmsSitemapNodesProductQuestions.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesProductQuestions.prototype.index = function() {
      return App.PublicProductsProductQuestions.init();
    };

    return PublicCmsSitemapNodesProductQuestions;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  App.PublicCmsSitemapNodesProductSitemapNode = (function() {
    function PublicCmsSitemapNodesProductSitemapNode() {
      this.show = bind(this.show, this);
    }

    PublicCmsSitemapNodesProductSitemapNode.prototype.show = function() {
      (new App.PublicProducts).show();
      if ($('.archived-bstock-product-modal').length > 0) {
        return Mzkr.Modal.show('.archived-bstock-product-modal');
      }
    };

    return PublicCmsSitemapNodesProductSitemapNode;

  })();

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesTestimonialSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesTestimonialSitemapNode, superClass);

    function PublicCmsSitemapNodesTestimonialSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesTestimonialSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesTestimonialSitemapNode.prototype.show = function() {
      return PublicUtility.FilterPagination.handlePaginate();
    };

    return PublicCmsSitemapNodesTestimonialSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicCmsSitemapNodesCouponsSitemapNode = (function(superClass) {
    extend(PublicCmsSitemapNodesCouponsSitemapNode, superClass);

    function PublicCmsSitemapNodesCouponsSitemapNode() {
      this.show = bind(this.show, this);
      return PublicCmsSitemapNodesCouponsSitemapNode.__super__.constructor.apply(this, arguments);
    }

    PublicCmsSitemapNodesCouponsSitemapNode.prototype.show = function() {
      new PublicUtility.CustomerNavigation();
      return PublicUtility.Layout.setCouponsPageCookies();
    };

    return PublicCmsSitemapNodesCouponsSitemapNode;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesClaimDamages = (function(superClass) {
    extend(PublicDisputesClaimDamages, superClass);

    function PublicDisputesClaimDamages() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesClaimDamages.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesClaimDamages.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initWrappingDamageFields();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimDamages.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initWrappingDamageFields();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.showCustomerRegistrationBanner();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimDamages.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimDamages.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesClaimDamages;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesClaimFunctionalities = (function(superClass) {
    extend(PublicDisputesClaimFunctionalities, superClass);

    function PublicDisputesClaimFunctionalities() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesClaimFunctionalities.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesClaimFunctionalities.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByDocumentType();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.checkboxAsRadio();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.copyOfDeliveryAddressFields();
      Utility.Disputes.initReceiptFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimFunctionalities.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.initFieldsByDocumentType();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.checkboxAsRadio();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.copyOfDeliveryAddressFields();
      Utility.Disputes.initReceiptFields();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.showCustomerRegistrationBanner();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimFunctionalities.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimFunctionalities.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesClaimFunctionalities;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesClaimMissingProducts = (function(superClass) {
    extend(PublicDisputesClaimMissingProducts, superClass);

    function PublicDisputesClaimMissingProducts() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesClaimMissingProducts.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesClaimMissingProducts.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimMissingProducts.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.showCustomerRegistrationBanner();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimMissingProducts.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimMissingProducts.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesClaimMissingProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesClaimUndeliveredOrders = (function(superClass) {
    extend(PublicDisputesClaimUndeliveredOrders, superClass);

    function PublicDisputesClaimUndeliveredOrders() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesClaimUndeliveredOrders.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesClaimUndeliveredOrders.prototype["new"] = function() {
      Utility.Disputes.loadDisputeOrderItems();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimUndeliveredOrders.prototype.create = function() {
      Utility.Disputes.loadDisputeOrderItems();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimUndeliveredOrders.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimUndeliveredOrders.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesClaimUndeliveredOrders;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesClaimWrongProducts = (function(superClass) {
    extend(PublicDisputesClaimWrongProducts, superClass);

    function PublicDisputesClaimWrongProducts() {
      this.thank_you = bind(this.thank_you, this);
      this.show = bind(this.show, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesClaimWrongProducts.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesClaimWrongProducts.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimWrongProducts.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.disableCollapsedInputs();
      Utility.Disputes.collapseOnCheckboxChange();
      Utility.Disputes.collapseMultipleCheckboxes();
      Utility.Disputes.disputeItemsChangeListener();
      Utility.Disputes.initFieldsByRefundMethod();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.copyOfAddressFields();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.showCustomerRegistrationBanner();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimWrongProducts.prototype.show = function() {
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesClaimWrongProducts.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesClaimWrongProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicDisputesReturns = (function(superClass) {
    extend(PublicDisputesReturns, superClass);

    function PublicDisputesReturns() {
      this.thank_you = bind(this.thank_you, this);
      this.create = bind(this.create, this);
      this["new"] = bind(this["new"], this);
      return PublicDisputesReturns.__super__.constructor.apply(this, arguments);
    }

    PublicDisputesReturns.prototype["new"] = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.checkboxSelected();
      Utility.Disputes.initIbanCalculator();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesReturns.prototype.create = function() {
      Utility.Disputes.handleUploadFileBlobs();
      Utility.Disputes.loadDisputeOrderItems();
      Utility.Disputes.checkboxSelected();
      Utility.Disputes.initIbanCalculator();
      Utility.Disputes.calculateImportPriceOnItemEdit();
      Utility.Disputes.initPackagePiskupDatepicker();
      Utility.Disputes.pickupAddress();
      Utility.Disputes.copyAddressFields();
      Utility.Disputes.customerTypeOptions();
      Utility.Disputes.showCustomerRegistrationBanner();
      return new PublicUtility.CustomerNavigation();
    };

    PublicDisputesReturns.prototype.thank_you = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicDisputesReturns;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicNotificationSettings = (function(superClass) {
    extend(PublicNotificationSettings, superClass);

    function PublicNotificationSettings() {
      this.show = bind(this.show, this);
      return PublicNotificationSettings.__super__.constructor.apply(this, arguments);
    }

    PublicNotificationSettings.prototype.show = function() {
      App.PublicNotificationSettings.notificationSwitch();
      return new PublicUtility.CustomerNavigation();
    };

    PublicNotificationSettings.notificationSwitch = function() {
      var that;
      that = this;
      return $('#notification-settings-form input').click(function() {
        var input_name;
        input_name = $(this).data('inputName');
        if ($(this).is(':checked')) {
          return that.changeInputValue(input_name, 'true');
        } else {
          return that.changeInputValue(input_name, 'false');
        }
      });
    };

    PublicNotificationSettings.changeInputValue = function(input_name, value) {
      var form;
      form = document.querySelector('#notification-settings-form form');
      $("[data-field-name='" + input_name + "_field']").val(value);
      Rails.fire(form, 'submit');
      return true;
    };

    return PublicNotificationSettings;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicOrderProductReviews = (function(superClass) {
    var editReview, initStickyBar, reviewValidation;

    extend(PublicOrderProductReviews, superClass);

    function PublicOrderProductReviews() {
      this.create = bind(this.create, this);
      return PublicOrderProductReviews.__super__.constructor.apply(this, arguments);
    }

    PublicOrderProductReviews.prototype.create = function() {
      return App.PublicOrderProductReviews.init();
    };

    PublicOrderProductReviews.init = function() {
      reviewValidation();
      editReview();
      return initStickyBar();
    };

    PublicOrderProductReviews.initOrderProductReviewsModal = function() {
      var $wrapper, idHash, url, urlParams;
      urlParams = new URLSearchParams(window.location.search);
      $wrapper = $("#order-product-reviews-wrapper");
      url = $wrapper.attr('data-order-product-reviews-path');
      idHash = $wrapper.attr('data-id-hash');
      if (urlParams.has('order_product_reviews')) {
        return $.ajax({
          type: 'GET',
          url: url,
          dataType: 'script',
          data: {
            catalog_product_id_hash: urlParams.get('catalog_product_id_hash'),
            score: urlParams.get('score'),
            token: urlParams.get('token'),
            id_hash: idHash
          }
        });
      }
    };

    reviewValidation = function() {
      var $form, allRated, ignoredText, rated, that, toFill;
      $.fn.isInViewport = function() {
        var elementBottom, elementTop, viewportBottom, viewportTop;
        elementTop = $(this).offset().top;
        elementBottom = elementTop + $(this).outerHeight();
        viewportTop = $(window).scrollTop();
        viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };
      that = this;
      $form = $('.form-product-review');
      rated = false;
      ignoredText = false;
      allRated = false;
      toFill = [];
      $('.star', $form).click(function() {
        var $this;
        $this = $(this);
        if (!$this.closest('.js-stars').hasClass('disabled')) {
          $('.js-order-review-textarea', $(this).closest('.js-rating-wrap')).removeClass('d-none');
          return $('input[type=submit]', $form).prop('disabled', false);
        }
      });
      $('.js-order-review-textarea textarea').bind('input propertychange', function() {
        return $('input[type=submit]', $form).prop('disabled', false);
      });
      if ($('.js-stars:not(.disabled) .star.selected', $form).length) {
        return $('input[type=submit]', $form).prop('disabled', false);
      }
    };

    editReview = function() {
      return $('.js-edit-review').click(function() {
        var $ratingWrap, $this;
        $this = $(this);
        $ratingWrap = $this.closest('.js-rating-wrap');
        $this.hide();
        $('.js-stars', $ratingWrap).removeClass('disabled').addClass('cursor-pointer');
        return $('.js-order-review-text, .js-order-review-textarea', $ratingWrap).toggleClass('d-none');
      });
    };

    initStickyBar = function() {
      var stickyBar;
      stickyBar = function() {
        var $stickyBar, $stickyBarAnchor, stickyBarPosition;
        $stickyBarAnchor = $('.js-sticky-bar-anchor');
        if ($stickyBarAnchor.length) {
          stickyBarPosition = $stickyBarAnchor.offset().top;
          $stickyBar = $('.sticky-bar');
          if (($(window).scrollTop() + $(window).outerHeight()) < stickyBarPosition) {
            return $stickyBar.addClass('fixed').removeClass('d-none').removeAttr('style');
          } else {
            return $stickyBar.removeClass('fixed').addClass('d-none');
          }
        } else {
          return $(window).off('scroll.stickyBar');
        }
      };
      stickyBar();
      return $(window).on('scroll.stickyBar', function() {
        return stickyBar();
      });
    };

    return PublicOrderProductReviews;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicProductsProductComparisons = (function(superClass) {
    extend(PublicProductsProductComparisons, superClass);

    function PublicProductsProductComparisons() {
      this.handleRemoveProductComparisonItem = bind(this.handleRemoveProductComparisonItem, this);
      this.show = bind(this.show, this);
      return PublicProductsProductComparisons.__super__.constructor.apply(this, arguments);
    }

    PublicProductsProductComparisons.prototype.show = function() {
      this.initProductComparisonShow();
      this.handleRemoveProductComparisonItem();
      return new PublicUtility.CustomerNavigation();
    };

    PublicProductsProductComparisons.prototype.initProductComparisonShow = function() {
      return PublicUtility.WishList.initInWishList();
    };

    PublicProductsProductComparisons.prototype.handleRemoveProductComparisonItem = function() {
      return $('.remove-product-comparison-item').each(function() {
        return $(this).on('click', function() {
          var productCode, productComparisonIdHash;
          productCode = $(this).attr('data-product-code');
          productComparisonIdHash = $(this).attr('data-product-comparison-id-hash');
          return PublicUtility.ProductComparison.manageLocalStorage('destroy', productCode, productComparisonIdHash, 'reset');
        });
      });
    };

    return PublicProductsProductComparisons;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.PublicProducts = (function(superClass) {
    extend(PublicProducts, superClass);

    function PublicProducts() {
      this.system_show = bind(this.system_show, this);
      this.show = bind(this.show, this);
      return PublicProducts.__super__.constructor.apply(this, arguments);
    }

    PublicProducts.prototype.show = function() {
      return this.initProductShow();
    };

    PublicProducts.prototype.system_show = function() {
      return this.initProductShow();
    };

    PublicProducts.prototype.initProductShow = function() {
      if (!$('.container-product').length) {
        return;
      }
      PublicUtility.DynamicContentLoader.loadContentInScope();
      this.initStoreSelection();
      this.initLightGallery();
      this.initBstockLightGallery();
      this.discountTimer();
      this.selectReserve();
      this.openTabs();
      this.openHashTab();
      this.giftVoucherInput();
      this.tableWrap();
      this.setShipAndDeliveryDate();
      this.extraGiftButton();
      this.initVoucherPicker();
      this.initDefaultDescription();
      this.initGoToTechnicalComparison();
      this.stickyInit();
      this.addToBasketQuantity();
      this.initStickyAddToCart();
      this.initLoadProductSet();
      this.initStickyProductTabs();
      this.setupTranslationLink();
      this.saveLastVisitedProduct();
      this.productVideo();
      this.productAudioAssets();
      this.initProductDocumentsModal();
      App.PublicProducts.initProductReviewsFilterBar();
      PublicUtility.Layout.disableOnClick('.product-order-box .btn-add-to-cart, .product-order-box .apply-campaign-coupon a');
      App.PublicShopBaskets.initPpBtn();
      return App.PublicShopBaskets.initAdyenExpressCheckouts();
    };

    PublicProducts.initProductReviewsFilterBar = function(onlySortRefresh) {
      var callAjax, reviewsWrapper;
      if (onlySortRefresh == null) {
        onlySortRefresh = false;
      }
      callAjax = function(elem) {
        var filterScore, sort, sortSelect;
        filterScore = elem.find('#reviews-filter-sort-score').val();
        sortSelect = elem.find('#reviews-sort');
        if ((filterScore !== 'all') && sortSelect.val().startsWith('score')) {
          sort = sortSelect.find('option').first().val();
        } else {
          sort = sortSelect.val();
        }
        return $.ajax({
          type: 'GET',
          dataType: 'script',
          data: {
            filter: {
              score: filterScore
            },
            only_with_text: elem.find('#reviews-filter-only-with-text').is(':checked'),
            sort: sort
          },
          url: elem.data('url')
        });
      };
      reviewsWrapper = $('#reviews');
      reviewsWrapper.find('#reviews-sort').on('change', function() {
        return callAjax(reviewsWrapper);
      });
      if (!onlySortRefresh) {
        reviewsWrapper.find('#reviews-filter-sort-score, #reviews-filter-only-with-text').on('change', function() {
          return callAjax(reviewsWrapper);
        });
        return reviewsWrapper.find('.score-filter').on('click', function() {
          return $('#reviews-filter-sort-score').val($(this).attr('data-score')).trigger('change');
        });
      }
    };

    PublicProducts.prototype.initLoadProductSet = function() {
      var url, wrapper;
      wrapper = $('#product-set-info');
      if (!wrapper.length) {
        return;
      }
      url = wrapper.data('fetch-url');
      return $.ajax({
        type: 'GET',
        dataType: 'script',
        url: url,
        success: function() {
          return setTimeout((function() {
            return $('.go-to-params').click(function() {
              return App.PublicProducts.openAndScrollToTab('#description', false, 70);
            });
          }), 100);
        }
      });
    };

    PublicProducts.prototype.initLightGallery = function() {
      var lightGalleryInitialized, ls, setupLightSlider, windowWidth;
      ls = null;
      lightGalleryInitialized = false;
      setupLightSlider = function() {
        var galleryItemsCount, lsCountSetting;
        galleryItemsCount = $('#lightgallery li').length;
        lsCountSetting = galleryItemsCount > 1;
        ls = $('#lightgallery').lightSlider({
          gallery: lsCountSetting,
          pager: lsCountSetting,
          item: 1,
          loop: lsCountSetting,
          mode: 'fade',
          speed: 200,
          thumbItem: 4,
          slideMargin: 5,
          enableDrag: true,
          currentPagerPosition: 'left',
          controls: false,
          addClass: 'slider-product',
          responsive: [
            {
              breakpoint: 991,
              settings: {
                gallery: false,
                pager: lsCountSetting,
                controls: lsCountSetting,
                mode: 'slide'
              }
            }
          ],
          onSliderLoad: function(el) {
            var $thumbsGallery, $thumbsGalleryNext, $thumbsGalleryPrev, updateScrollButtons;
            if (!lightGalleryInitialized) {
              lightGallery(el[0], {
                licenseKey: '8143C7FF-57394905-8AF26CB6-CF2E6A99',
                plugins: [lgThumbnail, lgZoom, lgVideo],
                selector: '#lightgallery .lslide',
                addClass: 'product-gallery',
                loadYoutubeThumbnail: true,
                backdropDuration: 200,
                youtubeThumbSize: 0,
                videoAutoplay: true,
                autoplayFirstVideo: true,
                download: false,
                toggleThumb: true,
                thumbWidth: 95,
                thumbHeight: '66px',
                thumbMargin: 8,
                appendCounterTo: '.lg-components',
                closeOnTap: false,
                iframeMaxWidth: '820px',
                iframeMaxHeight: '170px',
                iframeHeight: '100%',
                mobileSettings: {
                  controls: true,
                  showCloseIcon: true,
                  thumbWidth: 60,
                  thumbHeight: '42px',
                  thumbMargin: 4
                },
                strings: {
                  closeGallery: I18n.t('js.public.products.light_gallery.closeGallery'),
                  toggleMaximize: I18n.t('js.public.products.light_gallery.toggleMaximize'),
                  previousSlide: I18n.t('js.public.products.light_gallery.previousSlide'),
                  nextSlide: I18n.t('js.public.products.light_gallery.nextSlide'),
                  download: I18n.t('js.public.products.light_gallery.download'),
                  playVideo: I18n.t('js.public.products.light_gallery.playVideo'),
                  mediaLoadingFailed: I18n.t('js.public.products.light_gallery.mediaLoadingFailed')
                },
                zoomPluginStrings: {
                  viewActualSize: I18n.t('js.public.products.light_gallery.viewActualSize'),
                  zoomIn: I18n.t('js.public.products.light_gallery.zoomIn'),
                  zoomOut: I18n.t('js.public.products.light_gallery.zoomOut')
                }
              });
              el[0].addEventListener('lgAfterOpen', function() {
                return setTimeout((function() {
                  return $('.product-gallery .lg-inner').css('pointer-events', 'auto');
                }), 500);
              });
              el[0].addEventListener('lgAfterClose', function() {
                return setTimeout((function() {
                  return $('.product-gallery .lg-inner').css('pointer-events', 'none');
                }), 500);
              });
            }
            lightGalleryInitialized = true;
            $('#lightgallery').removeClass('invisible gallery-uninitialized');
            $('.product-placeholder-image').addClass('d-none');
            setTimeout((function() {
              $('.lightSlider li.audio').each(function(index, el) {
                var galleryThumbItem, itemIndex, sliderThumbItem;
                if ($(el).hasClass('clone') && $(el).hasClass('left')) {
                  return;
                }
                itemIndex = $(el).index();
                $(el).prevAll('.clone').each(function() {
                  return itemIndex -= 1;
                });
                sliderThumbItem = $('.lSPager li').eq(itemIndex);
                galleryThumbItem = $('.product-gallery .lg-thumb .lg-thumb-item').eq(itemIndex);
                if (sliderThumbItem.length > 0) {
                  sliderThumbItem.find('a').addClass('audio');
                }
                if (galleryThumbItem.length > 0) {
                  return galleryThumbItem.addClass('audio');
                }
              });
              $('.lSPager a > img[src*="youtube"], .lg-thumb .lg-thumb-item > img[src*="youtube"]').parent().addClass('video');
              $('.lSPager a > img[src*="ytimg"], .lg-thumb .lg-thumb-item > img[src*="ytimg"]').parent().addClass('video');
              return $('.lSPager a > img[src*="vimeo"], .lg-thumb .lg-thumb-item > img[src*="vimeo"]').parent().addClass('video vimeo');
            }), 500);
            $thumbsGallery = $('.lSGallery');
            $thumbsGalleryPrev = $('.thumbs-gallery-prev');
            $thumbsGalleryNext = $('.thumbs-gallery-next');
            updateScrollButtons = function() {
              var thumbsGalleryNextClickHandler, thumbsGalleryNextToggle, thumbsGalleryPrevClickHandler, thumbsGalleryPrevToggle, windowWidth;
              windowWidth = $(window).width();
              if ((991 < windowWidth && windowWidth < 1400)) {
                thumbsGalleryPrevToggle = $thumbsGallery.scrollLeft() > 0;
                thumbsGalleryNextToggle = $thumbsGallery.scrollLeft() < $thumbsGallery.prop('scrollWidth') - $thumbsGallery.prop('clientWidth');
                thumbsGalleryPrevClickHandler = function() {
                  return $thumbsGallery.animate({
                    scrollLeft: '-=' + $thumbsGallery.width()
                  }, 300);
                };
                thumbsGalleryNextClickHandler = function() {
                  return $thumbsGallery.animate({
                    scrollLeft: '+=' + $thumbsGallery.width()
                  }, 300);
                };
              } else if (windowWidth > 1399) {
                thumbsGalleryPrevToggle = $thumbsGallery.scrollTop() > 0;
                thumbsGalleryNextToggle = $thumbsGallery.scrollTop() < $thumbsGallery.prop('scrollHeight') - $thumbsGallery.prop('clientHeight');
                thumbsGalleryPrevClickHandler = function() {
                  return $thumbsGallery.animate({
                    scrollTop: '-=' + $thumbsGallery.height()
                  }, 300);
                };
                thumbsGalleryNextClickHandler = function() {
                  return $thumbsGallery.animate({
                    scrollTop: '+=' + $thumbsGallery.height()
                  }, 300);
                };
              }
              $thumbsGalleryPrev.toggle(thumbsGalleryPrevToggle);
              $thumbsGalleryNext.toggle(thumbsGalleryNextToggle);
              $thumbsGalleryPrev.off('click').on('click', thumbsGalleryPrevClickHandler);
              return $thumbsGalleryNext.off('click').on('click', thumbsGalleryNextClickHandler);
            };
            $(window).on('resize', updateScrollButtons);
            $thumbsGallery.on('scroll', updateScrollButtons);
            return updateScrollButtons();
          }
        }, setTimeout((function() {
          var isTouchDevice;
          ls.refresh();
          isTouchDevice = indexOf.call(document.documentElement, 'ontouchstart') >= 0;
          return $('.slider-product .lSGallery a').on('click', function(event) {
            if (event.originalEvent && !isTouchDevice) {
              return $('.lightSlider li.active').trigger('click');
            }
          });
        }), 500));
        return $('.slider-product').on('mouseover', '.lSGallery a', function() {
          return $(this).trigger('click');
        });
      };
      windowWidth = $(window).width();
      $(window).resize(function() {
        var resizedWidth;
        resizedWidth = $(window).width();
        if (windowWidth !== resizedWidth) {
          if (ls) {
            if (ls != null) {
              ls.destroy();
            }
          }
          setupLightSlider();
          return windowWidth = resizedWidth;
        }
      });
      return setupLightSlider();
    };

    PublicProducts.prototype.initBstockLightGallery = function() {
      lightGallery(document.getElementById('bstock-lightgallery'), {
        licenseKey: '8143C7FF-57394905-8AF26CB6-CF2E6A99',
        plugins: [lgThumbnail, lgZoom],
        addClass: 'product-gallery',
        backdropDuration: 200,
        download: false,
        toggleThumb: true,
        thumbWidth: 95,
        thumbHeight: '66px',
        thumbMargin: 8,
        appendCounterTo: '.lg-components',
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          thumbWidth: 60,
          thumbHeight: '42px',
          thumbMargin: 4
        }
      });
      return $('.open-bstock-gallery').click(function() {
        return $('#bstock-lightgallery li:first-child').trigger("click");
      });
    };

    PublicProducts.prototype.discountTimer = function() {
      var countDown, date, dateCompatible, day, end_time, hour, minute, second, t, time_counter, x;
      time_counter = $('.time-counter');
      if (time_counter.length) {
        second = 1000;
        minute = second * 60;
        hour = minute * 60;
        day = hour * 24;
        end_time = time_counter.data('end-time');
        t = end_time.split(/[- :]/);
        date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
        dateCompatible = new Date(date);
        countDown = new Date(dateCompatible);
        return x = setInterval((function() {
          var days, distance, hours, minutes, now;
          now = (new Date).getTime();
          distance = countDown - now;
          days = Math.floor(distance / day);
          hours = Math.floor(distance % day / hour);
          minutes = Math.floor(distance % hour / minute);
          time_counter.find('.days').text(days);
          time_counter.find('.hours').text(hours);
          time_counter.find('.minutes').text(minutes);
          if (days === 0) {
            time_counter.find('.days-desc, .days').hide();
          }
          if (days === 0 && hours === 0) {
            time_counter.find('.hours-desc, .hours').hide();
          }
          if (days <= 0 && hours <= 0 && minutes <= 0) {
            return time_counter.addClass('invisible');
          } else {
            return time_counter.removeClass('invisible');
          }
        }), second);
      }
    };

    PublicProducts.prototype.selectReserve = function() {
      var reservation_button, textFormat;
      textFormat = function(classSettings) {
        if (classSettings == null) {
          classSettings = null;
        }
        return function(state) {
          if (!state.id) {
            return state.text;
          }
          return $("<span class=\"" + (classSettings ? classSettings : '') + "\"><span class=\"fa fa-" + state.element.dataset.classes + " pr-1\"></span>" + state.text + "</span>");
        };
      };
      $('.select-reserve').select2({
        templateResult: textFormat('p-sm'),
        templateSelection: textFormat(),
        placeholder: I18n.t('js.public.products.show.tabs.choose_store'),
        allowClear: true,
        minimumResultsForSearch: 2e308,
        width: '100%'
      });
      reservation_button = $('.reservation-btn');
      $('.select-reserve').on('select2:select', function(e) {
        var selected_item, slected_classes, store_id;
        selected_item = $(this).find('option:selected');
        slected_classes = selected_item.data('classes');
        store_id = selected_item.data('store-id');
        Cookies.set('info_panel_store_id', store_id, {
          expires: 365,
          secure: new PublicUtility.CookiesWrapper().shouldBeSecureCookie()
        });
        $('.select2-reserve').find('.select2-selection__rendered').prepend('<span class="fa fa-' + slected_classes + ' pr-1"></span>');
        $('#setting_store_id').val(store_id);
        return reservation_button.prop('disabled', false);
      });
      return $('.select-reserve').on('select2:unselecting', function(e) {
        return reservation_button.prop('disabled', true);
      });
    };

    PublicProducts.prototype.initStoreSelection = function() {
      var reservation_button, select_item, store_id, store_select;
      store_id = Cookies.get('info_panel_store_id');
      reservation_button = $('.reservation-btn');
      select_item = $("[data-store-id='" + store_id + "']");
      if (store_id && select_item.length && select_item.data('store-count') > 0) {
        store_select = $('.select-reserve');
        store_select.val(select_item.val());
        store_select.trigger('change.select2');
        $('#setting_store_id').val(store_id);
        return reservation_button.prop('disabled', false);
      }
    };

    PublicProducts.prototype.openTabs = function() {
      var that;
      that = this;
      $('.go-to-rating').click(function() {
        return App.PublicProducts.openAndScrollToTab('#reviews');
      });
      if ($('#product-questions').length) {
        $('.go-to-product-questions').click(function() {
          return App.PublicProducts.openAndScrollToTab('#product-questions');
        });
      }
      $('.go-to-params').click(function() {
        return App.PublicProducts.openAndScrollToTab('#description', false, 70);
      });
      $('.js-open-set').click(function() {
        return App.PublicProducts.openAndScrollToTab('#sets', true);
      });
      return $('.js-open-user-set').click(function() {
        App.PublicProducts.openAndScrollToTab('#sets', true);
        return setTimeout(function() {
          return $('html, body').animate({
            scrollTop: $('#user-set-content').offset().top - 100
          }, 200, 'linear');
        }, 400);
      });
    };

    PublicProducts.prototype.setupTranslationLink = function() {
      var translatedTexts;
      translatedTexts = {};
      $(document).on('click', '.show_original_review_btn', (function(_this) {
        return function(event) {
          var button, originalTextClassName, translatedTextClassName;
          event.preventDefault();
          button = $(event.currentTarget);
          translatedTextClassName = button.data('translated-text-class-name');
          originalTextClassName = button.data('original-text-class-name');
          $("." + translatedTextClassName).hide();
          $("." + originalTextClassName).removeClass('d-none').show();
          return $("." + originalTextClassName + " .text_value").show();
        };
      })(this));
      return $(document).on('click', '.translate_review_btn', (function(_this) {
        return function(event) {
          var button, errorClassName, handleAjaxSuccess, objectIdHash, originalTextClassName, showTranslatedText, translatedText, translatedTextClassName, url;
          showTranslatedText = function(originalTextClass, translatedTextClass, text) {
            $("." + originalTextClass).addClass('d-none');
            $("." + translatedTextClass).removeClass('d-none').show();
            return $("." + translatedTextClass + " .text_value").empty().html(text).show();
          };
          handleAjaxSuccess = function(response, translatedTexts, objectIdHash) {
            var translatedText;
            translatedText = response.translated_text;
            translatedTexts[objectIdHash] = translatedText;
            return showTranslatedText(originalTextClassName, translatedTextClassName, translatedText);
          };
          event.preventDefault();
          button = $(event.currentTarget);
          translatedTextClassName = button.data('translated-text-class-name');
          originalTextClassName = button.data('original-text-class-name');
          translatedText = button.data('translated-review');
          url = button.data('url');
          errorClassName = button.data('error-class-name');
          objectIdHash = button.data('object-id-hash');
          if (translatedTexts[objectIdHash] != null) {
            translatedText = translatedTexts[objectIdHash];
          }
          if ((translatedText != null) && translatedText.trim() !== '') {
            return showTranslatedText(originalTextClassName, translatedTextClassName, translatedText);
          } else {
            return $.ajax({
              url: url,
              type: 'GET',
              success: function(response) {
                return handleAjaxSuccess(response, translatedTexts, objectIdHash);
              },
              error: function(xhr, status, error) {
                return $("." + errorClassName).removeClass('d-none').show();
              }
            });
          }
        };
      })(this));
    };

    PublicProducts.prototype.openHashTab = function() {
      var tabHash, that;
      that = this;
      tabHash = window.location.hash;
      if (tabHash) {
        return App.PublicProducts.openAndScrollToTab(tabHash);
      }
    };

    PublicProducts.prototype.giftVoucherInput = function() {
      var giftVoucherForm, inputGift, maxPrice, minPrice, multiplier;
      giftVoucherForm = $('.gift-voucher-form');
      inputGift = giftVoucherForm.find('.input-voucher');
      if (inputGift.length) {
        minPrice = inputGift.data('min-price');
        maxPrice = inputGift.data('max-price');
        multiplier = inputGift.data('multiplier');
        return inputGift.change(function() {
          var val;
          val = inputGift.val();
          if ((val <= maxPrice) && (val >= minPrice) && (val % multiplier === 0)) {
            inputGift.addClass('is-valid');
            inputGift.removeClass('is-invalid');
            giftVoucherForm.find('.btn-buy').removeAttr('disabled', 'disabled');
            return giftVoucherForm.find('.to-validate').removeClass('red');
          } else {
            inputGift.removeClass('is-valid');
            inputGift.addClass('is-invalid');
            giftVoucherForm.find('.btn-buy').attr('disabled', 'disabled');
            return giftVoucherForm.find('.to-validate').addClass('red');
          }
        });
      }
    };

    PublicProducts.reviewValidation = function() {
      var $form, allRated, ignoredText, rated, that, toFill, validate;
      that = this;
      $form = $('.form-product-review');
      rated = false;
      ignoredText = false;
      allRated = false;
      toFill = [];
      $('.star', $form).click(function() {
        return $('input[type=submit]', $form).prop('disabled', false);
      });
      $('textarea', $form).focusout(function() {
        if ($(this).val() !== '') {
          return $('input[type=submit]', $form).prop('disabled', false);
        } else if ($(this).val() === '' && $('.star.selected').length < 1) {
          return $('input[type=submit]', $form).prop('disabled', true);
        }
      });
      validate = function(element, multiple) {
        var verify;
        rated = true;
        $('.rating-lines .invalid-feedback', element).remove();
        $('.rating-lines > div', element).removeClass('invalid-row');
        $('.rating-lines input', element).each(function() {
          var $this;
          $this = $(this);
          if ($this.val() <= 1) {
            rated = false;
            $('.rating-lines', element).addClass('was-validated');
            $this.parents().eq(1).addClass('invalid-row');
            return $this.after("<div class='invalid-feedback d-none'> " + I18n.t('js.public.product_reviews.rate_stars') + "</div>");
          }
        });
        that.addClasses();
        if (!rated) {
          return false;
        } else if (($('textarea', element).val() === '') && !ignoredText && rated && !multiple) {
          verify = $('.verify');
          verify.removeClass('d-none');
          verify.html(I18n.t('js.public.product_reviews.verify_text'));
          $($form).find('input[type=submit]').val(I18n.t('js.public.product_reviews.send'));
          ignoredText = true;
          return false;
        }
      };
      return $form.submit(function(event) {
        var ignore, textareaParent, verify;
        if ($('.rating-fill', $form).length > 1) {
          toFill = [];
          ignore = !$('.verify').hasClass('d-none');
          textareaParent = void 0;
          $('.rating-fill', $form).each(function(index) {
            var filledNoStars, ratingWrap, unrated;
            ratingWrap = $(this);
            unrated = false;
            rated = false;
            filledNoStars = false;
            $('.rating-lines input', ratingWrap).each(function() {
              if ($(this).val() <= 1) {
                unrated = true;
              }
              if ($('textarea', ratingWrap).val() !== '') {
                filledNoStars = true;
              }
              if ($(this).val() > 0) {
                return rated = true;
              }
            });
            if (!unrated && rated) {
              toFill.push(false);
              if ($('textarea', ratingWrap).val() === '') {
                textareaParent = ratingWrap;
              }
            }
            if ((unrated && rated) || (filledNoStars && unrated)) {
              toFill.push(true);
              validate(ratingWrap, true);
              allRated = false;
              return true;
            } else if (unrated && rated || rated) {
              validate(ratingWrap, true);
              return true;
            }
          });
          if (($('textarea', textareaParent).val() === '') && $('.verify').hasClass('d-none') && !toFill.includes(true)) {
            verify = $('.verify');
            verify.removeClass('d-none');
            verify.html(I18n.t('js.public.product_reviews.verify_text'));
            $($form).find('input[type=submit]').val(I18n.t('js.public.product_reviews.send'));
            allRated = false;
          } else if (!$('.verify').hasClass('d-none') && !toFill.includes(true)) {
            allRated = true;
          } else if (($('textarea', textareaParent).val() !== '') && !toFill.includes(true)) {
            allRated = true;
          }
          return allRated;
          return event.preventDefault();
        } else {
          return validate($('.rating-fill', $form), false);
          return event.preventDefault();
        }
      });
    };

    PublicProducts.addClasses = function() {
      $('.rating-lines > div').css({
        'padding-bottom': '0'
      });
      return $('.invalid-feedback').each(function() {
        var $this;
        $this = $(this);
        $this.parents().eq(1).addClass('invalid-row');
        return setTimeout((function() {
          $this.removeClass('d-none');
          return $this.parents().eq(1).css({
            'padding-bottom': $this.height()
          });
        }), 1);
      });
    };

    PublicProducts.prototype.tableWrap = function() {
      $('.collapse-section > table').wrap('<div></div>');
      return $('.collapse-section table').parent('div').addClass('table-responsive');
    };

    PublicProducts.productCollapsibleContent = function(elements, collapseTreshold) {
      if (collapseTreshold == null) {
        collapseTreshold = 600;
      }
      return $(elements).each(function(index, element) {
        var $element, collapsibleOnMobile, elementHeight;
        $element = $(element);
        elementHeight = $element.innerHeight();
        if (isNaN(elementHeight)) {
          return;
        }
        collapsibleOnMobile = $element.hasClass('collapsible-mobile');
        if (elementHeight > collapseTreshold && (window.innerWidth >= 768 || collapsibleOnMobile)) {
          $element.addClass('collapse');
          $element.css('height', collapseTreshold + 'px');
          $element.next('.card-show-more').removeClass('mzkr-d-none');
        } else if (elementHeight > collapseTreshold && window.innerWidth < 768) {
          $element.removeClass('collapse');
          $element.css('height', 'auto');
          $element.next('.card-show-more').addClass('mzkr-d-none');
        }
        $element.next('.card-show-more').click(function() {
          var collapsibleSection, fullHeight, show_less, show_more;
          collapsibleSection = $(this).prev($element);
          if (collapsibleSection.hasClass('collapse') && !collapsibleSection.hasClass('show')) {
            collapsibleSection.collapse('show');
            fullHeight = collapsibleSection[0].scrollHeight + 'px';
            collapsibleSection.css('height', fullHeight);
            setTimeout(function() {
              return collapsibleSection.css('height', 'auto');
            }, 300);
          } else {
            collapsibleSection.collapse('hide');
            collapsibleSection.css('height', collapseTreshold + 'px');
          }
          show_more = I18n.t('js.public.products.show.show_more');
          show_less = I18n.t('js.public.products.show.show_less');
          return $(this).text(function(i, old) {
            if (old === show_less) {
              return show_more;
            } else {
              return show_less;
            }
          });
        });
        $element.on('show.bs.collapse', function(e) {
          return e.stopPropagation();
        });
        return $element.on('hide.bs.collapse', function(e) {
          return $('html, body').animate({
            scrollTop: $element.offset().top - 220
          }, 200, 'linear');
        });
      });
    };

    PublicProducts.openAndScrollToTab = function(hash, openCollapsible, offset) {
      var $target, collapse;
      if (openCollapsible == null) {
        openCollapsible = false;
      }
      if (offset == null) {
        offset = 0;
      }
      $target = $(hash);
      if ($target.length) {
        if (window.innerWidth < 768) {
          collapse = $target.find('.collapse');
          if (collapse.length) {
            collapse.collapse('show');
            if (collapse.hasClass('show')) {
              return $('html, body').animate({
                scrollTop: collapse.offset().top - 60
              }, 200, 'linear');
            }
          }
        } else {
          $('html, body').animate({
            scrollTop: ($target.offset().top - 100) - offset
          }, 200, 'linear');
          if (openCollapsible === true) {
            if (!$target.find('.card-inner').hasClass('show')) {
              return $target.find('.card-show-more').trigger('click');
            }
          }
        }
      }
    };

    PublicProducts.prototype.setShipAndDeliveryDate = function() {
      var $deliveryInfoText, $productDeliveryDate, $productShipDate, currentDate, cutTimeAndInfoSettings, deliveryDate, deliveryMoment, formattedDate, htmlText, originalCurrentDate, shipAndDeliverDates, shipDate, shipMoment, showDeliveryInfo, showDeliveryInfoText, showShippingInfo, tomorrow, translateText;
      shipAndDeliverDates = $('[data-ship-and-delivery-dates]');
      cutTimeAndInfoSettings = $('[data-ship-and-delivery-cut-time]');
      if (shipAndDeliverDates.length && cutTimeAndInfoSettings.length) {
        currentDate = new Date(cutTimeAndInfoSettings.data('date-current'));
        if (cutTimeAndInfoSettings.data('ship-delivery-enable-cut-time') || (currentDate.valueOf() > (new Date(shipAndDeliverDates.data('current-cache-date'))).valueOf())) {
          shipDate = shipAndDeliverDates.data('ship-date-after-cut-time');
          deliveryDate = shipAndDeliverDates.data('delivery-date-after-cut-time');
        } else {
          shipDate = shipAndDeliverDates.data('current-ship-date');
          deliveryDate = shipAndDeliverDates.data('current-delivery-date');
        }
        showShippingInfo = cutTimeAndInfoSettings.data('show-shipping-info');
        showDeliveryInfo = cutTimeAndInfoSettings.data('show-delivery-info');
        showDeliveryInfoText = cutTimeAndInfoSettings.data('show-delivery-info-text') && cutTimeAndInfoSettings.data('delivery-info-text').length;
        $productShipDate = $('[data-product-ship-date]');
        $productDeliveryDate = $('[data-product-delivery-date]');
        $deliveryInfoText = $('[data-delivery-info-text]');
        if (shipDate && deliveryDate) {
          if (showShippingInfo) {
            translateText = '';
            htmlText = '';
            if (currentDate.valueOf() === (new Date(shipDate)).valueOf()) {
              translateText = 'js.public.products.show.shipping.today_html';
            }
            currentDate.setDate(currentDate.getDate() + 1);
            if (currentDate.valueOf() === (new Date(shipDate)).valueOf()) {
              translateText = 'js.public.products.show.shipping.tomorrow_html';
            }
            if (translateText.length) {
              htmlText += I18n.t(translateText);
            } else {
              shipMoment = moment(shipDate, 'YYYY-MM-DD');
              formattedDate = shipMoment.format('dddd D.M.');
              htmlText += I18n.t('js.public.products.show.shipping.date_html', {
                date: formattedDate
              });
            }
            if (showDeliveryInfo || showDeliveryInfoText) {
              htmlText += ',&nbsp;';
            }
            $productShipDate.html(htmlText);
          } else {
            $productShipDate.remove();
          }
          if (showDeliveryInfo) {
            htmlText = '';
            originalCurrentDate = new Date(cutTimeAndInfoSettings.data('date-current'));
            tomorrow = new Date(originalCurrentDate);
            tomorrow.setDate(tomorrow.getDate() + 1);
            if (tomorrow.valueOf() === (new Date(deliveryDate)).valueOf()) {
              htmlText += I18n.t('js.public.products.show.delivery.tomorrow_html');
            } else {
              deliveryMoment = moment(deliveryDate, 'YYYY-MM-DD');
              formattedDate = deliveryMoment.format('dddd D.M.');
              htmlText += I18n.t('js.public.products.show.delivery.date_html', {
                date: formattedDate
              });
            }
            if (showDeliveryInfoText) {
              htmlText += ',&nbsp;';
            }
            $productDeliveryDate.html(htmlText);
          } else {
            $productDeliveryDate.remove();
          }
        }
        if (showDeliveryInfoText) {
          $deliveryInfoText.html(cutTimeAndInfoSettings.data('delivery-info-text'));
        } else {
          $deliveryInfoText.remove();
        }
        if (!showShippingInfo && !showDeliveryInfo && !showDeliveryInfoText) {
          return shipAndDeliverDates.remove();
        }
      }
    };

    PublicProducts.prototype.extraGiftButton = function() {
      var addClassStyle, availableProductPriceForGift, basketExtraGiftIds, basketExtraGiftText, basketHasItems, basketItemType, basketPrice, btn, disabled, extraGiftButton, extraGiftInfo, extraGiftProductInBasket, productPrice, removeClassStyle;
      extraGiftButton = $('[data-extra-gift-button]');
      extraGiftInfo = $('[data-extra-gift-info]');
      if (extraGiftButton.length && extraGiftInfo.length) {
        basketHasItems = extraGiftInfo.data('extra-gift-basket-has-items');
        if (!basketHasItems) {
          return null;
        }
        basketPrice = extraGiftInfo.data('extra-gift-basket-price');
        extraGiftProductInBasket = extraGiftInfo.data('extra-gift-product-in-basket');
        basketExtraGiftIds = extraGiftInfo.data('extra-gift-basket-gifts');
        productPrice = extraGiftButton.data('extra-gift-product-price');
        availableProductPriceForGift = (productPrice - basketPrice) <= 0;
        basketExtraGiftText = '';
        basketItemType = '';
        addClassStyle = 'btn-green';
        removeClassStyle = '';
        disabled = false;
        if (basketExtraGiftIds.length && extraGiftProductInBasket) {
          basketExtraGiftText = I18n.t('js.public.products.show.gift_in_basket');
          addClassStyle = 'btn-blue gift-in-basket';
          removeClassStyle = 'btn-green btn-green-outline';
          disabled = true;
        }
        if (availableProductPriceForGift) {
          basketItemType = 'basket';
          if (!basketExtraGiftText.length && basketExtraGiftIds.length > 0) {
            basketExtraGiftText = I18n.t('js.public.products.show.change_gift');
          }
        }
        if (basketExtraGiftText.length) {
          btn = $('[data-extra-gift-button-to-basket]');
          btn.val(basketExtraGiftText).removeClass('btn-green').addClass(addClassStyle).removeClass(removeClassStyle).prop('disabled', disabled).attr('data-disable-with', basketExtraGiftText);
        }
        if (basketItemType.length) {
          return $('[data-extra-gift-basket-item-type]').val(basketItemType);
        }
      }
    };

    PublicProducts.prototype.initVoucherPicker = function() {
      var voucherWrap;
      voucherWrap = $('.tile-woucher-wrap');
      if (voucherWrap.length) {
        return $('.tile-woucher-price').click(function() {
          voucherWrap.find('.tile-woucher-price.selected').removeClass('selected');
          $(this).addClass('selected');
          $('.input-voucher').val($(this).data('value')).trigger('change');
          $('.gift-voucher-input').addClass('d-none');
          if ($(this).hasClass('voucher-other')) {
            return $('.gift-voucher-input').removeClass('d-none');
          }
        });
      }
    };

    PublicProducts.prototype.initDefaultDescription = function() {
      var defaultDescriptionInfo, defaultDescriptionLink;
      defaultDescriptionInfo = $('.default-description-info');
      defaultDescriptionLink = defaultDescriptionInfo.find('.show-default-description');
      if (defaultDescriptionLink.length) {
        return defaultDescriptionLink.click(function() {
          var defaultDescriptionTarget;
          event.preventDefault();
          defaultDescriptionTarget = defaultDescriptionLink.data('description-target');
          $('[data-description="default"]').removeClass('d-none');
          return defaultDescriptionInfo.remove();
        });
      }
    };

    PublicProducts.prototype.initGoToTechnicalComparison = function() {
      return $('.js-go-to-technical-params').click(function() {
        return $('html, body').animate({
          scrollTop: $('#product_detail_recommendations').offset().top - 50
        }, 500);
      });
    };

    PublicProducts.prototype.stickyInit = function() {
      if ($('.sticky-product-gallery').innerHeight() !== $('.sticky-product-gallery').parent().innerHeight()) {
        $('.sticky-product-gallery').stick_in_parent({
          offset_top: 100
        });
      }
      if ($('.js-sticky-in-parent').innerHeight() !== $('.js-sticky-in-parent').parent().innerHeight()) {
        return $('.js-sticky-in-parent').stick_in_parent({
          offset_top: 84
        });
      }
    };

    PublicProducts.disableQuantityBtn = function() {
      var currentVal, maxVal, minVal;
      currentVal = parseInt($('.js-input-quantity').val());
      minVal = parseInt($('.js-input-quantity').attr('min') + 1);
      maxVal = parseInt($('.js-input-quantity').attr('max'));
      if (currentVal === minVal) {
        $('.quantity-remove').addClass('disabled');
      } else {
        $('.quantity-remove').removeClass('disabled');
      }
      if (currentVal === maxVal) {
        return $('.quantity-add').addClass('disabled');
      } else {
        return $('.quantity-add').removeClass('disabled');
      }
    };

    PublicProducts.prototype.addToBasketQuantity = function() {
      var $quantityChangeBtn;
      $quantityChangeBtn = $('.js-add-to-basket-quantity-change');
      setTimeout(function() {
        return App.PublicProducts.disableQuantityBtn();
      }, 10);
      $quantityChangeBtn.parent().find('.js-input-quantity').on('change', function() {
        var $quantityButtons, $this, changedVal, isFound;
        $this = $(this);
        changedVal = $this.val();
        if (changedVal > 0 && changedVal < parseInt($this.attr('max'))) {
          $('#public_shop_basket_item_form_quantity').val(changedVal);
          $quantityButtons = $quantityChangeBtn.closest('.js-quantity-discount-wrap').find('[data-quantity-span]');
          isFound = false;
          return $quantityButtons.each(function() {
            var $discountWrap, $originalPrice, $originalPriceBeforeDiscount, $originaldiscountPercentage, $quantityButton, percentageDiscount, priceWithoutDiscount;
            $quantityButton = $(this);
            $originalPrice = $('[data-original-price]');
            $originalPriceBeforeDiscount = $('[data-original-price-before-discount]');
            $discountWrap = $('.js-discount-wrap');
            if ($quantityButton.data('quantity-span')[0] <= changedVal && $quantityButton.data('quantity-span')[1] >= changedVal && !isFound) {
              $originalPrice.text($quantityButton.data('quantity-price'));
              $discountWrap.removeClass('mzkr-d-none').addClass('mzkr-d-flex');
              $discountWrap.find('.js-price-without-discount').text($originalPrice.data('original-price'));
              priceWithoutDiscount = $originalPriceBeforeDiscount.length ? $originalPriceBeforeDiscount.data('original-price-before-discount-value') : $originalPrice.data('original-price-value');
              percentageDiscount = Math.round((priceWithoutDiscount - $quantityButton.data('quantity-price-value')) / priceWithoutDiscount * 100);
              $discountWrap.find('.js-discount-percentage').text("- " + percentageDiscount + " % ");
              if ($quantityButton.next('[data-quantity-span]').length) {
                $quantityButtons.addClass('d-none');
                $quantityButton.next('[data-quantity-span]').removeClass('d-none');
                return isFound = true;
              } else {
                $quantityButtons.addClass('d-none');
                return $quantityButtons.last().removeClass('d-none');
              }
            } else if (!isFound) {
              $originaldiscountPercentage = $discountWrap.find('[data-original-discount-percentage]');
              if (!$originaldiscountPercentage.length) {
                $discountWrap.removeClass('mzkr-d-flex').addClass('mzkr-d-none');
              } else {
                $originaldiscountPercentage.html($originaldiscountPercentage.data('original-discount-percentage'));
              }
              $originalPrice.text($originalPrice.data('original-price'));
              $quantityButtons.addClass('d-none');
              return $quantityButtons.first().removeClass('d-none');
            }
          });
        } else if (changedVal >= parseInt($this.attr('max'))) {
          $('#public_shop_basket_item_form_quantity').val(parseInt($this.attr('max')));
          return $this.val(parseInt($this.attr('max')));
        } else {
          return $this.val('1');
        }
      });
      return $('.js-add-to-basket-quantity-change').click(function() {
        var $quantityInput, $this, newQuantity;
        $this = $(this);
        $quantityInput = $this.parent().find('.js-input-quantity');
        if ($this.data('quantity') === 'add') {
          newQuantity = parseInt($quantityInput.val()) + 1;
          $quantityInput.val(newQuantity);
          $quantityInput.trigger('change');
        } else if ($this.data('quantity') === 'remove') {
          newQuantity = parseInt($quantityInput.val()) - 1;
          $quantityInput.val(newQuantity);
          $quantityInput.trigger('change');
        }
        return App.PublicProducts.disableQuantityBtn();
      });
    };

    PublicProducts.prototype.initStickyAddToCart = function() {
      var $window, stickAddToCart;
      stickAddToCart = function() {
        var $window, stickyOffsetTop;
        $window = $(window);
        if ($('.product-order-box .product-price').length) {
          stickyOffsetTop = $('.product-order-box .product-price').offset().top;
        } else {
          stickyOffsetTop = $('.product-order-box').offset().top;
        }
        if ($window.scrollTop() > (stickyOffsetTop + $('.product-order-box .btn-buy-wrap').height()) && $window.scrollTop() < ($('footer').offset().top - $window.height())) {
          $('.js-sticky-order-box').addClass('js-sticky-order-box-fixed');
          $('#daktela-web .dw-button, .bought-banner').addClass('sticky-offset');
          return $('.exp-weblayer-dialog, .exp-weblayer-dialog-muz-muz, .exp-weblayer-dialog-fixed-bottom').addClass('offset-bottom');
        } else {
          $('.js-sticky-order-box').removeClass('js-sticky-order-box-fixed');
          $('#daktela-web .dw-button, .bought-banner').removeClass('sticky-offset');
          return $('.exp-weblayer-dialog, .exp-weblayer-dialog-muz-muz, .exp-weblayer-dialog-fixed-bottom').removeClass('offset-bottom');
        }
      };
      if ($('.js-sticky-order-box').length) {
        setTimeout(function() {
          return stickAddToCart();
        }, 300);
        $window = $(window);
        $window.scroll(function() {
          return stickAddToCart();
        });
        return $window.resize(function() {
          return stickAddToCart();
        });
      }
    };

    PublicProducts.loadJavascriptFile = function(url, loadHook) {
      var promise, script;
      script = document.createElement('script');
      promise = new Promise(function(resolve, reject) {
        script.addEventListener('load', function(event) {
          loadHook();
          resolve('loaded');
        });
      });
      script.src = url;
      script.async = true;
      script.crossorigin = 'anonymous';
      document.getElementsByTagName('script')[0].parentNode.appendChild(script);
      return promise;
    };

    PublicProducts.prototype.initStickyProductTabs = function() {
      var lastScrollTop, scrollToActiveTab, stickProductTabs, tabsHorizontalScroll, tabsScrollOffset;
      Mzkr.ScrollSpy.init('.product-accordion .card', '.product-tabs .nav-item', 'active', 200);
      tabsHorizontalScroll = Mzkr.HorizontalScroll.init('.product-tabs .mzkr-horizontal-scroll', false);
      lastScrollTop = 0;
      scrollToActiveTab = function() {
        var $activeTab, container;
        $activeTab = $('.product-tabs .nav-item.active');
        if ($activeTab.length) {
          container = $('.product-tabs .mzkr-horizontal-scroll__inner');
          return container.scrollLeft($activeTab.offset().left - container.offset().left + container.scrollLeft() - (container.width() / 2) + ($activeTab.width() / 2));
        }
      };
      tabsScrollOffset = 100;
      stickProductTabs = function() {
        var $productTabs, scrollTop;
        scrollTop = $(window).scrollTop();
        $productTabs = $('.product-tabs');
        if ($productTabs.length && $(window).width() > 767) {
          if (scrollTop > $productTabs.offset().top) {
            $productTabs.addClass('product-tabs-fixed');
            tabsHorizontalScroll.updateHorizontalScroll();
            if (scrollTop > lastScrollTop && scrollTop > $productTabs.offset().top + 250) {
              $('body').addClass('body-product-tabs-fixed');
            } else if (scrollTop + $(window).height() < $(document).height()) {
              $('body').removeClass('body-product-tabs-fixed');
            }
            lastScrollTop = scrollTop;
            return scrollToActiveTab();
          } else {
            $productTabs.removeClass('product-tabs-fixed');
            $('body').removeClass('body-product-tabs-fixed');
            return tabsHorizontalScroll.updateHorizontalScroll();
          }
        }
      };
      $('.product-tabs .nav-link').on('click', function(event) {
        var currentScrollTop, target, targetScrollTop;
        event.preventDefault();
        target = $(this).attr('href');
        currentScrollTop = $(window).scrollTop();
        targetScrollTop = $(target).offset().top;
        tabsScrollOffset = targetScrollTop < currentScrollTop ? 160 : 86;
        return $('html, body').animate({
          scrollTop: targetScrollTop - tabsScrollOffset
        }, 200, 'linear');
      });
      $(window).scroll(function() {
        return stickProductTabs();
      });
      return $('#accordion-product').on('shown.bs.collapse', function(e) {
        var $target, targetScrollTop;
        $target = $(e.target);
        if ($target.length && !$target.hasClass('card-inner')) {
          targetScrollTop = $target.parents('.card').offset().top;
          return $('html, body').animate({
            scrollTop: targetScrollTop - 48
          }, 100, 'linear');
        }
      });
    };

    PublicProducts.positionAlternativesProducts = function() {
      var $alternativesProducts, $alternativesProductsWrapper;
      $alternativesProducts = $('.js-alternatives-products');
      $alternativesProductsWrapper = $('.js-alternatives-products-wrap');
      if ($alternativesProducts.length) {
        $alternativesProductsWrapper.find('.widget-slider-loader').remove();
        $alternativesProducts.appendTo('.js-alternatives-products-wrap');
        return PublicUtility.Layout.initApplyCampaignCouponLink();
      } else {
        $alternativesProductsWrapper.find('.widget-slider-loader').remove();
        return $alternativesProductsWrapper.css('min-height', 0);
      }
    };

    PublicProducts.positionComplementsProducts = function() {
      var $complementsProducts, $complementsProductsWrapper;
      $complementsProducts = $('.js-complements-products');
      $complementsProductsWrapper = $('.js-complements-products-wrap');
      if ($complementsProducts.length) {
        $complementsProductsWrapper.find('.widget-slider-loader').remove();
        $complementsProducts.appendTo('.js-complements-products-wrap');
        return PublicUtility.Layout.initApplyCampaignCouponLink();
      } else {
        $complementsProductsWrapper.find('.widget-slider-loader').remove();
        return $complementsProductsWrapper.css('min-height', 0);
      }
    };

    PublicProducts.prototype.saveLastVisitedProduct = function() {
      var productCode;
      productCode = $('.container-product').data('product-code');
      if (productCode && (typeof sessionStorage !== "undefined" && sessionStorage !== null)) {
        return sessionStorage.setItem('last_visited_product', productCode);
      }
    };

    PublicProducts.prototype.productVideo = function() {
      $('.video-container').on('click', function() {
        var $this, iframe, videoLink;
        $this = $(this);
        videoLink = $this.data('embed-link');
        iframe = "<iframe allow=\"autoplay\" width=\"100%\" height=\"100%\" src=\"" + videoLink + "?&autoplay=1&mute=1\" frameborder=\"0\" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen\"></iframe>";
        $this.css('max-width', '100%').append(iframe);
        if (!$('#description .card-inner').hasClass('show')) {
          return $('#description .card-show-more').trigger('click');
        }
      });
      $('.js-scroll-to-video').on('click', function() {
        var $container, $containerCollapse;
        $container = $('#description');
        if (window.innerWidth < 768) {
          $containerCollapse = $container.find('.collapse');
          if ($containerCollapse.length) {
            $containerCollapse.collapse('show');
          }
        }
        if (!$container.find('.card-inner').hasClass('show')) {
          $container.find('.card-show-more').trigger('click');
        }
        return $('html, body').animate({
          scrollTop: $('#product-videos').offset().top - 100
        }, 200);
      });
      return $('.js-open-video-gallery').on('click', function() {
        return $('#lightgallery .lslide.video').eq(3).trigger('click');
      });
    };

    PublicProducts.prototype.productAudioAssets = function() {
      $('.audio-container').on('click', function() {
        var $this, audioLink, iframe;
        $this = $(this);
        audioLink = $this.data('embed-link');
        iframe = "<iframe allow=\"autoplay\" width=\"100%\" height=\"100%\" src=\"" + audioLink + "\" frameborder=\"0\"></iframe>";
        return $this.css('max-width', '100%').append(iframe);
      });
      $('.js-scroll-to-audio').on('click', function() {
        var $container, $containerCollapse;
        $container = $('#description');
        if (window.innerWidth < 768) {
          $containerCollapse = $container.find('.collapse');
          if ($containerCollapse.length) {
            $containerCollapse.collapse('show');
          }
        }
        if (!$container.find('.card-inner').hasClass('show')) {
          $container.find('.card-show-more').trigger('click');
        }
        return $('html, body').animate({
          scrollTop: $('#product-audio-assets').offset().top - 100
        }, 200);
      });
      return $('.js-open-audio-gallery').on('click', function() {
        return $('#lightgallery .lslide.audio').eq(3).trigger('click');
      });
    };

    PublicProducts.prototype.initProductDocumentsModal = function() {
      var $manuals, $modal, lastLoginStatus, updateModalContent;
      $modal = $('#product-documents-modal');
      $manuals = $('#product-manuals');
      if ($modal.length && $manuals.length) {
        updateModalContent = function() {
          if (Cookies.get('muziker_logged_in')) {
            if (!$manuals.data('content-loaded')) {
              return $.ajax({
                type: 'GET',
                dataType: 'script',
                url: $manuals.data('product-documents-path'),
                success: function() {
                  return $manuals.data('content-loaded', true);
                }
              });
            }
          } else {
            $('#product-manuals-content').html('<p class="mzkr-text-md mzkr-mb-4">' + $manuals.data('login-required-text') + '</p>');
            return $manuals.data('content-loaded', false);
          }
        };
        lastLoginStatus = Cookies.get('muziker_logged_in');
        $(window).on('focus', function() {
          var currentLoginStatus;
          currentLoginStatus = Cookies.get('muziker_logged_in');
          if (currentLoginStatus !== lastLoginStatus) {
            lastLoginStatus = currentLoginStatus;
            return updateModalContent();
          }
        });
        return $modal.on('onMzkrModalShow', function() {
          return updateModalContent();
        });
      }
    };

    PublicProducts.initProductDocumentsToggle = function() {
      return $('.mzkr-toggle-btn').on('click', function(e) {
        var $target, targetId;
        targetId = $(this).data('target');
        $target = $(targetId);
        if ($target.hasClass('d-none')) {
          $target.removeClass('d-none');
          return $(this).text(I18n.t('js.public.products.show.show_less'));
        } else {
          $target.addClass('d-none');
          return $(this).text(I18n.t('js.public.products.show.show_more'));
        }
      });
    };

    return PublicProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicSearch = (function(superClass) {
    extend(PublicSearch, superClass);

    function PublicSearch() {
      this.index = bind(this.index, this);
      return PublicSearch.__super__.constructor.apply(this, arguments);
    }

    PublicSearch.prototype.index = function() {
      var search_url;
      if ($('[data-external-search]').length) {
        window.appScriptLoaded = 1;
        if (window.loadLB) {
          PublicUtility.ExternalSearch.loadComponents();
        }
        return PublicUtility.ProductList.initFilterToggler();
      } else {
        search_url = Routes.search_search_index_path({
          q: $('#main-filter-container').data('q')
        });
        return new PublicUtility.ProductList(search_url);
      }
    };

    return PublicSearch;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicShopBasketItems = (function(superClass) {
    extend(PublicShopBasketItems, superClass);

    function PublicShopBasketItems() {
      this.show = bind(this.show, this);
      return PublicShopBasketItems.__super__.constructor.apply(this, arguments);
    }

    PublicShopBasketItems.prototype.show = function() {
      App.PublicShopBaskets.initPpBtn();
      App.PublicShopBaskets.initAdyenExpressCheckouts();
      PublicUtility.DynamicContentLoader.loadContentInScope();
      this.initStickyControls();
      this.initLuigisScan();
      return PublicUtility.Layout.disableOnClick('.continue-to-basket-btn');
    };

    PublicShopBasketItems.prototype.initStickyControls = function() {
      var $window, stickControls;
      stickControls = function() {
        var $window, controlsWrapPosition;
        if (!$('.basket-items-controls').length) {
          return;
        }
        controlsWrapPosition = $('.basket-items-controls-wrap').offset().top;
        $window = $(window);
        if ($window.scrollTop() > (controlsWrapPosition - $window.height())) {
          $('.basket-items-controls').removeClass('basket-items-controls-fixed');
        } else {
          $('.basket-items-controls').addClass('basket-items-controls-fixed');
        }
        if ($window.scrollTop() > (controlsWrapPosition - $window.height())) {
          return $('.basket-items-controls-fixed').css('bottom', '-80px');
        } else {
          return $('.basket-items-controls-fixed').css('bottom', '0');
        }
      };
      setTimeout(function() {
        return stickControls();
      }, 300);
      $window = $(window);
      $window.scroll(function() {
        return stickControls();
      });
      return $window.resize(function() {
        return stickControls();
      });
    };

    PublicShopBasketItems.prototype.initLuigisScan = function() {
      return PublicUtility.Layout.deferLuigisScan('#product_recommended_annotation', '#product_recommended_results');
    };

    return PublicShopBasketItems;

  })(App.Base);

}).call(this);
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicShopBaskets = (function(superClass) {
    extend(PublicShopBaskets, superClass);

    function PublicShopBaskets() {
      return PublicShopBaskets.__super__.constructor.apply(this, arguments);
    }

    PublicShopBaskets.initExpeditedInParts = function() {
      return $('#expedited_in_parts').change(function() {
        var path;
        path = $(this).data('path');
        return $.ajax({
          data: {
            expedited_in_parts: $(this).prop('checked')
          },
          type: 'POST',
          url: path
        });
      });
    };

    PublicShopBaskets.initRemoveBasketItem = function() {
      return $('.js-cancel-product').click(function() {
        $(this).addClass('disabled');
        return $(this).parents('.shop-product-tile').addClass('is-canceling');
      });
    };

    PublicShopBaskets.initClubPointsCheckbox = function() {
      var that;
      that = this;
      return $('#club_points_checkbox').change(function() {
        return $.ajax({
          type: 'POST',
          url: Routes.apply_club_points_shop_basket_path(),
          data: {
            apply_club_points: this.checked
          },
          dataType: 'html',
          success: function(data) {
            return $('#basket_content').html(data);
          }
        });
      });
    };

    PublicShopBaskets.initPpBtn = function() {
      var $paypalScriptElement, paypalSrc, renderPpBtn;
      if (!$('#paypal-button-container').length) {
        return;
      }
      renderPpBtn = function() {
        var ref;
        $('#paypal-button-container').html('');
        if ((ref = window.paypalBtnHash) != null) {
          ref.style = $('#paypal-button-container').data('paypal-button-style');
        }
        return paypal.Buttons(window.paypalBtnHash).render('#paypal-button-container');
      };
      if (typeof paypal === 'undefined') {
        $paypalScriptElement = $('#paypalScript');
        paypalSrc = $('#paypalScript').attr('data-src');
        $paypalScriptElement.attr('src', paypalSrc);
        return $paypalScriptElement.on('load', function() {
          return renderPpBtn();
        });
      } else {
        return renderPpBtn();
      }
    };

    PublicShopBaskets.initAdyenExpressCheckouts = function() {
      if (($('#ecs-google-pay-container').length > 0) || ($('#ecs-apple-pay-container').length > 0)) {
        return window.loadAdyenWebComponents();
      }
    };

    return PublicShopBaskets;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  App.PublicShopCustomerDetails = (function(superClass) {
    extend(PublicShopCustomerDetails, superClass);

    function PublicShopCustomerDetails() {
      this.confirm = bind(this.confirm, this);
      this.show = bind(this.show, this);
      return PublicShopCustomerDetails.__super__.constructor.apply(this, arguments);
    }

    PublicShopCustomerDetails.prototype.show = function() {
      this.customerTypeOptions();
      this.shipAddress();
      this.clubOption();
      this.nameAutofill();
      this.changeShipAddress();
      this.initShipCountryArea();
      this.initPageReloadButton();
      this.initCountrySelector();
      this.showAlertLongAddress();
      this.collapseFormField();
      this.fillExistingEmail();
      return new PublicUtility.Basket();
    };

    PublicShopCustomerDetails.prototype.confirm = function() {
      this.customerTypeOptions();
      this.shipAddress();
      this.clubOption();
      this.nameAutofill();
      this.changeShipAddress();
      this.initShipCountryArea();
      this.initPageReloadButton();
      this.initCountrySelector();
      this.showAlertLongAddress();
      this.collapseFormField();
      this.fillExistingEmail();
      return new PublicUtility.Basket();
    };

    PublicShopCustomerDetails.prototype.customerTypeOptions = function() {
      var customerTypes, differentShipBillCheckbox, that, vatPayer, vat_payer_allow_ship_address;
      that = this;
      customerTypes = $('[data-customer-types]');
      if (customerTypes.length) {
        vatPayer = $('[data-vat-payer]');
        vat_payer_allow_ship_address = vatPayer.data('countries-allow-ship-address');
        if (vatPayer.length) {
          that.vatPayerFields(vatPayer);
          vatPayer.change(function() {
            return that.vatPayerFields($(this));
          });
        }
        if ($('[data-customer-type]:checked').val() === 'private_person') {
          $('[data-company-fields]').hide();
          $('[data-additional-ship-address]').hide();
        } else {
          $('[data-company-fields]').show();
        }
        return $('[data-customer-type]').change(function() {
          var ref;
          if (this.value === 'private_person') {
            $('[data-company-fields]').slideUp(300);
            return $('[data-additional-ship-address]').hide();
          } else {
            $('[data-company-fields]').slideDown(300);
            if (vatPayer.is(':checked') && (ref = vatPayer.data('country-code'), indexOf.call(vat_payer_allow_ship_address, ref) < 0)) {
              return $('[data-additional-ship-address]').show();
            }
          }
        });
      } else {
        differentShipBillCheckbox = $('[data-show-ship-address] [type="checkbox"]');
        return that.showShipAddressWarning(differentShipBillCheckbox);
      }
    };

    PublicShopCustomerDetails.prototype.vatPayerFields = function(vatPayer) {
      var data_ship_address, differentShipBillCheckbox, ref, ref1, ref2, ref3, that, vat_payer_allow_ship_address, vat_payer_required_tax_code_in_countries;
      that = this;
      vat_payer_required_tax_code_in_countries = vatPayer.data('vat-payer-required-tax-code-in-countries');
      vat_payer_allow_ship_address = vatPayer.data('countries-allow-ship-address');
      differentShipBillCheckbox = $('[data-show-ship-address] [type="checkbox"]');
      if (vatPayer.is(':checked')) {
        $('[data-vat-code]').slideDown(300);
        $("[data-vat-code] :input").prop("disabled", false);
        if (ref = vatPayer.data('country-code'), indexOf.call(vat_payer_allow_ship_address, ref) < 0) {
          $('[data-additional-ship-address]').show();
        }
        if (ref1 = vatPayer.data('country-code'), indexOf.call(vat_payer_required_tax_code_in_countries, ref1) >= 0) {
          $('[data-tax-code]').siblings('label').addClass('required');
        }
      } else {
        $('[data-vat-code]').slideUp(300);
        $("[data-vat-code] :input").prop("disabled", true);
        if (ref2 = vatPayer.data('country-code'), indexOf.call(vat_payer_allow_ship_address, ref2) < 0) {
          $('[data-additional-ship-address]').hide();
          data_ship_address = $('[data-show-ship-address]');
          if (data_ship_address.length) {
            data_ship_address.show();
            that.shipAddressFields(data_ship_address.find('[type="checkbox"]'));
          }
        }
        if (ref3 = vatPayer.data('country-code'), indexOf.call(vat_payer_required_tax_code_in_countries, ref3) >= 0) {
          $('[data-tax-code]').siblings('label').removeClass('required');
        }
      }
      return that.showShipAddressWarning(differentShipBillCheckbox);
    };

    PublicShopCustomerDetails.prototype.shipAddress = function() {
      var differentShipBillCheckbox, that;
      that = this;
      differentShipBillCheckbox = $('[data-show-ship-address] [type="checkbox"]');
      if (differentShipBillCheckbox.length) {
        that.shipAddressFields(differentShipBillCheckbox);
        return differentShipBillCheckbox.change(function() {
          return that.shipAddressFields($(this));
        });
      }
    };

    PublicShopCustomerDetails.prototype.shipAddressFields = function(e) {
      if (e.is(':checked')) {
        return $('[data-bill-address]').slideDown({
          duration: 300,
          progress: function() {
            return $('.sticky-column').trigger('sticky_kit:recalc');
          }
        });
      } else {
        return $('[data-bill-address]').slideUp({
          duration: 300,
          progress: function() {
            return $('.sticky-column').trigger('sticky_kit:recalc');
          }
        });
      }
    };

    PublicShopCustomerDetails.prototype.clubOption = function() {
      var clubCheckbox, that;
      that = this;
      clubCheckbox = $("[data-club='true']");
      if (clubCheckbox.length) {
        that.passwordFields(clubCheckbox);
      }
      return $("[data-club]").change(function() {
        return that.passwordFields(clubCheckbox);
      });
    };

    PublicShopCustomerDetails.prototype.passwordFields = function(e) {
      if (e.is(':checked')) {
        $('[data-password-fields]').slideDown(300);
        $('#public_shop_customer_details_form_password').removeAttr("disabled", "disabled");
        return $('#public_shop_customer_details_form_password_confirmation').removeAttr("disabled", "disabled");
      } else {
        $('[data-password-fields]').slideUp(300);
        $('#public_shop_customer_details_form_password').attr("disabled", "disabled");
        return $('#public_shop_customer_details_form_password_confirmation').attr("disabled", "disabled");
      }
    };

    PublicShopCustomerDetails.prototype.nameAutofill = function() {
      var billCity, billCountryArea, billStreet, billZipCode, city, contactFirstName, contactLastName, countryArea, firstName, lastName, street, zipCode;
      firstName = $('#public_shop_customer_details_form_contact_first_name');
      lastName = $('#public_shop_customer_details_form_contact_last_name');
      street = $('#public_shop_customer_details_form_ship_street');
      city = $('#public_shop_customer_details_form_ship_city');
      zipCode = $('#public_shop_customer_details_form_ship_zip_code');
      countryArea = $('#public_shop_customer_details_form_ship_country_area_id');
      contactFirstName = $('#public_shop_customer_details_form_first_name');
      contactLastName = $('#public_shop_customer_details_form_last_name');
      billStreet = $('#public_shop_customer_details_form_bill_street');
      billCity = $('#public_shop_customer_details_form_bill_city');
      billZipCode = $('#public_shop_customer_details_form_bill_zip_code');
      billCountryArea = $('#public_shop_customer_details_form_bill_country_area_id');
      firstName.change(function() {
        if (contactFirstName.val().length === 0) {
          return contactFirstName.val(firstName.val());
        }
      });
      lastName.change(function() {
        if (contactLastName.val().length === 0) {
          return contactLastName.val(lastName.val());
        }
      });
      street.change(function() {
        if (billStreet.val().length === 0) {
          return billStreet.val(street.val());
        }
      });
      city.change(function() {
        if (billCity.val().length === 0) {
          return billCity.val(city.val());
        }
      });
      zipCode.change(function() {
        if (billZipCode.val().length === 0) {
          return billZipCode.val(zipCode.val());
        }
      });
      return countryArea.change(function() {
        if (billCountryArea.val().length === 0) {
          return billCountryArea.val(countryArea.val()).trigger('change');
        }
      });
    };

    PublicShopCustomerDetails.prototype.initShipCountryArea = function() {
      var bill_country_area, ship_country_area;
      ship_country_area = $('[data-ship-data="ship_country_area_id"]');
      bill_country_area = $('#public_shop_customer_details_form_bill_country_area_id');
      if (ship_country_area.length > 0) {
        ship_country_area.trigger('change');
      }
      if (bill_country_area.length > 0) {
        bill_country_area.trigger('change');
      }
      ship_country_area.on('change.select2', function(e) {
        var shipCountryAreaEvent;
        shipCountryAreaEvent = new CustomEvent('ship-country-area-change', {
          bubbles: true,
          detail: e
        });
        return this.dispatchEvent(shipCountryAreaEvent);
      });
      return bill_country_area.on('change.select2', function(e) {
        var billCountryAreaEvent;
        billCountryAreaEvent = new CustomEvent('bill-country-area-change', {
          bubbles: true,
          detail: e
        });
        return this.dispatchEvent(billCountryAreaEvent);
      });
    };

    PublicShopCustomerDetails.prototype.changeShipAddress = function() {
      return $('[data-ship-data="customer_ship_address"] a[data-ship-data="option"]').on('click', function(e) {
        var contactFirstName, contactLastName, contactMobile, contactMobileHidden, contactPhone, selected_option;
        e.preventDefault();
        selected_option = $(this);
        contactFirstName = selected_option.data('ship-contact-first-name');
        contactLastName = selected_option.data('ship-contact-last-name');
        contactPhone = selected_option.data('ship-contact-phone');
        if (typeof contactFirstName !== 'undefined') {
          $('[data-ship-data="contact_first_name"]').val(contactFirstName).focus().blur();
        }
        if (typeof contactLastName !== 'undefined') {
          $('[data-ship-data="contact_last_name"]').val(contactLastName).focus().blur();
        }
        if (typeof contactPhone !== 'undefined') {
          contactMobile = $('[data-ship-data="mobile"]');
          contactMobile.val(contactPhone).focus().blur();
          contactMobileHidden = $('[name="' + contactMobile.attr('name') + '"]');
          contactMobileHidden.val(contactPhone);
        }
        $('[data-ship-data="street"]').val(selected_option.data('ship-street')).focus().blur();
        $('[data-ship-data="street_note"]').val(selected_option.data('ship-street-note')).focus().blur();
        $('[data-ship-data="zip_code"]').val(selected_option.data('ship-zip-code')).focus().blur();
        $('[data-ship-data="city"]').val(selected_option.data('ship-city')).focus().blur();
        return $('[data-ship-data="ship_country_area_id"]').val(selected_option.data('ship-country-area-id')).trigger('change');
      });
    };

    PublicShopCustomerDetails.prototype.initPageReloadButton = function() {
      return $('[data-ship-data="administration_button"]').on('click', function(e) {
        return $('[data-ship-data="reload_button"]').removeClass('d-none');
      });
    };

    PublicShopCustomerDetails.prototype.initCountrySelector = function() {
      if ($('[data-country-selector="customer-details"]').length) {
        $('#bill_country').val($('[data-country-selector="customer-details"] option:selected').text());
        return $('[data-country-selector="customer-details"]').change(function() {
          return $('#bill_country').val($('option:selected', this).text());
        });
      }
    };

    PublicShopCustomerDetails.prototype.showShipAddressWarning = function(checkbox) {
      return checkbox.change(function() {
        if (checkbox.is(':checked')) {
          return $('[data-show-ship-address-warning]').slideUp({
            duration: 300,
            progress: function() {
              return $('.sticky-column').trigger('sticky_kit:recalc');
            }
          });
        } else {
          return $('[data-show-ship-address-warning]').slideDown({
            duration: 300,
            progress: function() {
              return $('.sticky-column').trigger('sticky_kit:recalc');
            }
          });
        }
      });
    };

    PublicShopCustomerDetails.prototype.showAlertLongAddress = function() {
      var $streetName, maxStreetNameLength;
      $streetName = $('#public_shop_customer_details_form_ship_street');
      maxStreetNameLength = 35;
      if (!$streetName.length) {
        return;
      }
      if ($streetName.val().length > maxStreetNameLength) {
        $('.js-ship-street-alert').removeClass('mzkr-d-none');
      }
      return $streetName.change(function() {
        if (this.value.length > maxStreetNameLength) {
          return $('.js-ship-street-alert').removeClass('mzkr-d-none');
        } else {
          return $('.js-ship-street-alert').addClass('mzkr-d-none');
        }
      });
    };

    PublicShopCustomerDetails.prototype.collapseFormField = function() {
      return $('.js-form-collapse-wrap').each(function() {
        var $input, inputVal;
        $input = $(this).find('input');
        inputVal = $input.val();
        if (inputVal.trim() !== '') {
          return $input.parents('.collapse').collapse('show');
        }
      });
    };

    PublicShopCustomerDetails.prototype.fillExistingEmail = function() {
      return $('#email-exists').on('click', '.mzkr-modal-open-trigger', function() {
        var existingEmail;
        existingEmail = $('#public_shop_customer_details_form_email').val();
        $('#modal_customer_email').val(existingEmail);
        return $('#login-modal').on('onMzkrModalShown', function() {
          return $('#modal_customer_password').focus();
        });
      });
    };

    return PublicShopCustomerDetails;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicOrders = (function(superClass) {
    extend(PublicOrders, superClass);

    function PublicOrders() {
      this.find = bind(this.find, this);
      this.show = bind(this.show, this);
      return PublicOrders.__super__.constructor.apply(this, arguments);
    }

    PublicOrders.prototype.show = function() {
      Mzkr.HorizontalScroll.init('.status-process', true);
      PublicUtility.DynamicContentLoader.loadContentInScope();
      App.ClientOrders.initOrderTopLinks();
      App.ClientOrders.initStickySidebar();
      return App.PublicOrderProductReviews.initOrderProductReviewsModal();
    };

    PublicOrders.prototype.find = function() {
      return new PublicUtility.CustomerNavigation();
    };

    return PublicOrders;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicShopWishLists = (function(superClass) {
    extend(PublicShopWishLists, superClass);

    function PublicShopWishLists() {
      this.handleUpdateName = bind(this.handleUpdateName, this);
      this.handleChangeList = bind(this.handleChangeList, this);
      this.handleRemoveWishListItem = bind(this.handleRemoveWishListItem, this);
      this.show = bind(this.show, this);
      return PublicShopWishLists.__super__.constructor.apply(this, arguments);
    }

    PublicShopWishLists.prototype.show = function() {
      Utility.BasketItem.quantityChange();
      PublicUtility.Layout.restrictInputCharacters();
      this.handleChangeList();
      this.handleUpdateName();
      this.handleRemoveWishListItem();
      return new PublicUtility.CustomerNavigation();
    };

    PublicShopWishLists.prototype.handleRemoveWishListItem = function() {
      return $('.remove-wish-list-item').each(function() {
        return $(this).on('click', function() {
          var productCode, wishListIdHash;
          productCode = $(this).attr('data-product-code');
          wishListIdHash = $(this).attr('data-wish-list-id-hash');
          return PublicUtility.WishList.manageLocalStorage('destroy', productCode, wishListIdHash, 'reset');
        });
      });
    };

    PublicShopWishLists.prototype.handleChangeList = function() {
      return $('li.dropdown-item').each(function() {
        return $(this).on('click', function() {
          var initialId;
          initialId = $('.wishlist-list ul').attr('data-initial-id');
          if (initialId !== $(this).attr('data-id')) {
            return window.location.href = $(this).attr('data-url');
          }
        });
      });
    };

    PublicShopWishLists.prototype.handleUpdateName = function() {
      $('.wishlist-name button').on('click', function() {
        return $('.wishlist-name input').focus();
      });
      return $('.wishlist-name input').on('change', function() {
        var _this;
        _this = $(this);
        return $.ajax({
          data: {
            shop_wish_list: {
              name: _this.val()
            }
          },
          type: 'PATCH',
          url: _this.data('update-url'),
          success: function(data) {
            var dropdownItem, initialId, status, text;
            status = null;
            if (data.status === 200) {
              status = 'success';
              initialId = $('.wishlist-list ul').attr('data-initial-id');
              dropdownItem = $(".wishlist-list .dropdown-item[data-id='" + initialId + "']");
              text = _this.val() + ' (' + dropdownItem.attr('data-count') + ')';
              dropdownItem.html(text);
              $('.current-wish-list').html(text);
              _this.attr('data-old-value', _this.val());
            } else {
              status = 'danger';
              _this.val(_this.attr('data-old-value'));
            }
            return $('#alerts-container').html("<div class='container'>" + "<div class='alert alert-" + status + "'>" + "<a class='close' data-dismiss='alert' href='#'>×</a>" + data.message + "</div>" + "</div>");
          }
        });
      });
    };

    return PublicShopWishLists;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicSitemaps = (function(superClass) {
    extend(PublicSitemaps, superClass);

    function PublicSitemaps() {
      this.show = bind(this.show, this);
      return PublicSitemaps.__super__.constructor.apply(this, arguments);
    }

    PublicSitemaps.prototype.show = function() {
      return PublicUtility.Layout.initGallerySlider();
    };

    return PublicSitemaps;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicSmsNotifications = (function(superClass) {
    extend(PublicSmsNotifications, superClass);

    function PublicSmsNotifications() {
      this.show = bind(this.show, this);
      return PublicSmsNotifications.__super__.constructor.apply(this, arguments);
    }

    PublicSmsNotifications.prototype.show = function() {
      return $('#cancel_sms_subscription').click(function() {
        return $('[data-loader] .loader-wrap').removeClass('invisible');
      });
    };

    return PublicSmsNotifications;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.PublicUserSetProducts = (function(superClass) {
    extend(PublicUserSetProducts, superClass);

    function PublicUserSetProducts() {
      this.show = bind(this.show, this);
      return PublicUserSetProducts.__super__.constructor.apply(this, arguments);
    }

    PublicUserSetProducts.prototype.show = function() {
      this.initOpenAccessoriesTab();
      return this.initStickySidebar();
    };

    PublicUserSetProducts.prototype.initOpenAccessoriesTab = function() {
      return $('.js-open-accessories-tab').click(function(e) {
        var scrollOffset, target;
        e.preventDefault();
        target = $(this).attr('href');
        scrollOffset = window.innerWidth < 992 ? 60 : 140;
        $(target).tab('show');
        return $('html, body').animate({
          scrollTop: $('.accessories-title').offset().top - scrollOffset
        }, 300);
      });
    };

    PublicUserSetProducts.prototype.initStickySidebar = function() {
      var $navTopBanner, $navWrap, navTopBannerHeight, topSpacing, usersetStickySidebar;
      $navWrap = $('.mzkr-nav-wrap');
      $navTopBanner = $navWrap.find('.nav-top-banner');
      navTopBannerHeight = $navTopBanner.length ? $navTopBanner.outerHeight() : 0;
      topSpacing = $navWrap.outerHeight() - navTopBannerHeight;
      usersetStickySidebar = new StickySidebar('.userset-sticky-sidebar', {
        topSpacing: topSpacing,
        bottomSpacing: 0,
        containerSelector: '.userset-sidebar-container',
        innerWrapperSelector: '.userset-sidebar-inner',
        resizeSensor: false
      });
      $('.userset-menu .nav-link').on('shown.bs.tab', function() {
        return usersetStickySidebar.updateSticky();
      });
      $('.userset-menu-trigger').click(function() {
        return $('.userset-menu').toggleClass('userset-menu--open');
      });
      return $('.userset-menu .nav-link').click(function() {
        return $('.userset-menu').removeClass('userset-menu--open');
      });
    };

    return PublicUserSetProducts;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.CustomersRegistrations = (function(superClass) {
    extend(CustomersRegistrations, superClass);

    function CustomersRegistrations() {
      this["new"] = bind(this["new"], this);
      return CustomersRegistrations.__super__.constructor.apply(this, arguments);
    }

    CustomersRegistrations.prototype["new"] = function() {
      return PublicUtility.DynamicContentLoader.loadContentInScope();
    };

    return CustomersRegistrations;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.OnPaymentFinishedProcessor = (function(superClass) {
    extend(OnPaymentFinishedProcessor, superClass);

    OnPaymentFinishedProcessor.delayedTime = 4000;

    function OnPaymentFinishedProcessor(data) {
      this.data = data;
      this.process = bind(this.process, this);
    }

    OnPaymentFinishedProcessor.prototype.process = function() {
      var skip_action_cable_refresh, url_to_redirect;
      url_to_redirect = $('#btn-pay').data(this.data["payment_status"] + "-url");
      skip_action_cable_refresh = $('#btn-pay').data('skipActionCableRefresh');
      if (url_to_redirect === void 0) {
        url_to_redirect = $('#wait-for-notification-info').data(this.data["payment_status"] + "-url");
      }
      if (url_to_redirect === void 0) {
        return;
      }
      if (!window.location.pathname.endsWith(this.data["old_path"])) {
        console.log(window.location.pathname + " is not equal to " + this.data["old_path"], ", unable to refresh page");
        return;
      }
      if (skip_action_cable_refresh) {
        return;
      }
      return window.location.href = url_to_redirect;
    };

    return OnPaymentFinishedProcessor;

  })(App.Base);

}).call(this);
(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  App.WaitingPageProcessor = (function(superClass) {
    extend(WaitingPageProcessor, superClass);

    function WaitingPageProcessor() {
      this.isUserOnWaitingPage = bind(this.isUserOnWaitingPage, this);
      this.currentRefreshCounter = bind(this.currentRefreshCounter, this);
      this.prepareUrlToRefresh = bind(this.prepareUrlToRefresh, this);
      this.urlForReload = bind(this.urlForReload, this);
      this.setTimeoutFunction = bind(this.setTimeoutFunction, this);
      this.maxRefreshes = bind(this.maxRefreshes, this);
      this.refreshCounterToMiliseconds = bind(this.refreshCounterToMiliseconds, this);
      this.refreshCounterToSeconds = bind(this.refreshCounterToSeconds, this);
      this.refreshPage = bind(this.refreshPage, this);
      this.process = bind(this.process, this);
    }

    WaitingPageProcessor.prototype.process = function() {
      if (URLSearchParams === void 0) {
        return false;
      }
      if (this.isUserOnWaitingPage() && this.shouldDoRefresh()) {
        this.initOrderPaymentCountdown();
        return this.refreshPage();
      }
    };

    WaitingPageProcessor.prototype.refreshPage = function() {
      var that;
      if (this.currentRefreshCounter() > 0 && this.maxRefreshes()) {
        that = this;
        return setTimeout((function() {
          return that.setTimeoutFunction();
        }), this.refreshCounterToMiliseconds(this.currentRefreshCounter()));
      }
    };

    WaitingPageProcessor.prototype.shouldDoRefresh = function() {
      return $('#wait-for-notification-info').length > 0;
    };

    WaitingPageProcessor.prototype.initOrderPaymentCountdown = function() {
      var $paymentCountDown, counter, that;
      that = this;
      if ($('#wait-for-notification-info').length && this.maxRefreshes()) {
        $paymentCountDown = $('.js-payment-countdown');
        counter = this.refreshCounterToSeconds(this.currentRefreshCounter());
        return window.countDownInterval = setInterval((function() {
          counter--;
          $paymentCountDown.text(counter);
          if (counter === 0) {
            $paymentCountDown.html('');
            $('.js-payment-cancel-countdown').removeClass('d-none');
            return clearInterval(window.countDownInterval);
          }
        }), 1000);
      }
    };

    WaitingPageProcessor.prototype.refreshCounterToSeconds = function(counter) {
      if (counter <= 1) {
        return 5;
      }
      return parseInt(Math.exp(counter));
    };

    WaitingPageProcessor.prototype.refreshCounterToMiliseconds = function(counter) {
      return this.refreshCounterToSeconds(counter) * 1000;
    };

    WaitingPageProcessor.prototype.maxRefreshes = function() {
      return this.currentRefreshCounter() < 8;
    };

    WaitingPageProcessor.prototype.setTimeoutFunction = function() {
      window.location.href = this.urlForReload();
    };

    WaitingPageProcessor.prototype.urlForReload = function() {
      var refreshCounter, urlParams, urlParamsCounter;
      urlParams = new URLSearchParams(window.location.search);
      urlParamsCounter = urlParams.get('refresh_counter');
      refreshCounter = urlParamsCounter === null ? 1 : urlParamsCounter;
      refreshCounter = parseInt(refreshCounter);
      refreshCounter += 1;
      return this.prepareUrlToRefresh(refreshCounter);
    };

    WaitingPageProcessor.prototype.prepareUrlToRefresh = function(refreshCounter) {
      var newParams, params, url;
      params = new URLSearchParams(window.location.search);
      params.set('refresh_counter', refreshCounter);
      newParams = params.toString();
      url = new URL(window.location.href);
      url.search = newParams;
      return url.toString();
    };

    WaitingPageProcessor.prototype.currentRefreshCounter = function() {
      var params;
      params = new URLSearchParams(window.location.search);
      return params.get('refresh_counter') || 1;
    };

    WaitingPageProcessor.prototype.isUserOnWaitingPage = function() {
      var urlParams;
      urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('wait_for_notification') === null) {
        return false;
      } else {
        return true;
      }
    };

    return WaitingPageProcessor;

  })(App.Base);

}).call(this);
(function() {


}).call(this);
